(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vuelidate/lib/validators"), require("vuelidate"), require("vue-i18n"), require("vue"), require("moment"));
	else if(typeof define === 'function' && define.amd)
		define(["vuelidate/lib/validators", "vuelidate", "vue-i18n", , "moment"], factory);
	else if(typeof exports === 'object')
		exports["@tjip/vuejs"] = factory(require("vuelidate/lib/validators"), require("vuelidate"), require("vue-i18n"), require("vue"), require("moment"));
	else
		root["@tjip/vuejs"] = factory(root["vuelidate/lib/validators"], root["vuelidate"], root["vue-i18n"], root["Vue"], root["moment"]);
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__1abc__, __WEBPACK_EXTERNAL_MODULE__25bc__, __WEBPACK_EXTERNAL_MODULE__85b3__, __WEBPACK_EXTERNAL_MODULE__8bbf__, __WEBPACK_EXTERNAL_MODULE_c32d__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "0100":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "014b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("e53d");
var has = __webpack_require__("07e3");
var DESCRIPTORS = __webpack_require__("8e60");
var $export = __webpack_require__("63b6");
var redefine = __webpack_require__("9138");
var META = __webpack_require__("ebfd").KEY;
var $fails = __webpack_require__("294c");
var shared = __webpack_require__("dbdb");
var setToStringTag = __webpack_require__("45f2");
var uid = __webpack_require__("62a0");
var wks = __webpack_require__("5168");
var wksExt = __webpack_require__("ccb9");
var wksDefine = __webpack_require__("6718");
var enumKeys = __webpack_require__("47ee");
var isArray = __webpack_require__("9003");
var anObject = __webpack_require__("e4ae");
var isObject = __webpack_require__("f772");
var toObject = __webpack_require__("241e");
var toIObject = __webpack_require__("36c3");
var toPrimitive = __webpack_require__("1bc3");
var createDesc = __webpack_require__("aebd");
var _create = __webpack_require__("a159");
var gOPNExt = __webpack_require__("0395");
var $GOPD = __webpack_require__("bf0b");
var $GOPS = __webpack_require__("9aa9");
var $DP = __webpack_require__("d9f6");
var $keys = __webpack_require__("c3a1");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("6abf").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("355d").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("b8e3")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("35e8")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "0293":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__("241e");
var $getPrototypeOf = __webpack_require__("53e2");

__webpack_require__("ce7e")('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0395":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("36c3");
var gOPN = __webpack_require__("6abf").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "04bd":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "0584":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "061b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("fa99");

/***/ }),

/***/ "062e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlPercentComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d61b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlPercentComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlPercentComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlPercentComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "07e3":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "0a49":
/***/ (function(module, exports, __webpack_require__) {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
var ctx = __webpack_require__("9b43");
var IObject = __webpack_require__("626a");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var asc = __webpack_require__("cd1c");
module.exports = function (TYPE, $create) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  var create = $create || asc;
  return function ($this, callbackfn, that) {
    var O = toObject($this);
    var self = IObject(O);
    var f = ctx(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
    var val, res;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      val = self[index];
      res = f(val, index, O);
      if (TYPE) {
        if (IS_MAP) result[index] = res;   // map
        else if (res) switch (TYPE) {
          case 3: return true;             // some
          case 5: return val;              // find
          case 6: return index;            // findIndex
          case 2: result.push(val);        // filter
        } else if (IS_EVERY) return false; // every
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
  };
};


/***/ }),

/***/ "0a55":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupNumberComponent_scss_vue_type_style_index_0_id_34ad71b1_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4e33");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupNumberComponent_scss_vue_type_style_index_0_id_34ad71b1_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupNumberComponent_scss_vue_type_style_index_0_id_34ad71b1_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupNumberComponent_scss_vue_type_style_index_0_id_34ad71b1_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0c44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupDateComponent_scss_vue_type_style_index_0_id_e0d9f486_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("987f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupDateComponent_scss_vue_type_style_index_0_id_e0d9f486_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupDateComponent_scss_vue_type_style_index_0_id_e0d9f486_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupDateComponent_scss_vue_type_style_index_0_id_e0d9f486_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "0f66":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDropdownComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("4cbb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDropdownComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDropdownComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDropdownComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "0fc9":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("3a38");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "10a7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDateComponent_scss_vue_type_style_index_0_id_51ec0f78_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("af58");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDateComponent_scss_vue_type_style_index_0_id_51ec0f78_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDateComponent_scss_vue_type_style_index_0_id_51ec0f78_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDateComponent_scss_vue_type_style_index_0_id_51ec0f78_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1169":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("2d95");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "11e9":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("52a7");
var createDesc = __webpack_require__("4630");
var toIObject = __webpack_require__("6821");
var toPrimitive = __webpack_require__("6a99");
var has = __webpack_require__("69a8");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("9e1e") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "1654":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__("71c1")(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__("30f1")(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),

/***/ "166d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlSearchComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("04bd");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlSearchComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlSearchComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlSearchComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1691":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "1715":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlPercentComponent_scss_vue_type_style_index_0_id_95191cf0_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2d0b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlPercentComponent_scss_vue_type_style_index_0_id_95191cf0_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlPercentComponent_scss_vue_type_style_index_0_id_95191cf0_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlPercentComponent_scss_vue_type_style_index_0_id_95191cf0_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1793":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioButtonComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5154");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioButtonComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioButtonComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioButtonComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "1991":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var invoke = __webpack_require__("31f4");
var html = __webpack_require__("fab2");
var cel = __webpack_require__("230e");
var global = __webpack_require__("7726");
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__("2d95")(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),

/***/ "1aad":
/***/ (function(module, exports) {

// Generated by CoffeeScript 1.12.7
(function() {
  var zeros;

  module.exports = function(num, n) {
    var frac, int, neg, ref;
    if (n === 0) {
      return num;
    }
    ref = ('' + num).split('.'), int = ref[0], frac = ref[1];
    int || (int = '0');
    frac || (frac = '0');
    neg = (int[0] === '-' ? '-' : '');
    if (neg) {
      int = int.slice(1);
    }
    if (n > 0) {
      if (n > frac.length) {
        frac += zeros(n - frac.length);
      }
      int += frac.slice(0, n);
      frac = frac.slice(n);
    } else {
      n = n * -1;
      if (n > int.length) {
        int = (zeros(n - int.length)) + int;
      }
      frac = int.slice(n * -1) + frac;
      int = int.slice(0, n * -1);
    }
    while (int[0] === '0') {
      int = int.slice(1);
    }
    while (frac[frac.length - 1] === '0') {
      frac = frac.slice(0, -1);
    }
    return neg + (int || '0') + (frac.length ? '.' + frac : '');
  };

  zeros = function(n) {
    return new Array(n + 1).join('0');
  };

}).call(this);


/***/ }),

/***/ "1abc":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1abc__;

/***/ }),

/***/ "1bc3":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("f772");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "1cb7":
/***/ (function(module, exports, __webpack_require__) {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
var gOPD = __webpack_require__("bf0b");
var getPrototypeOf = __webpack_require__("53e2");
var has = __webpack_require__("07e3");
var $export = __webpack_require__("63b6");
var isObject = __webpack_require__("f772");
var anObject = __webpack_require__("e4ae");

function get(target, propertyKey /* , receiver */) {
  var receiver = arguments.length < 3 ? target : arguments[2];
  var desc, proto;
  if (anObject(target) === receiver) return target[propertyKey];
  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
    ? desc.value
    : desc.get !== undefined
      ? desc.get.call(receiver)
      : undefined;
  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
}

$export($export.S, 'Reflect', { get: get });


/***/ }),

/***/ "1df8":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__("63b6");
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__("ead6").set });


/***/ }),

/***/ "1ec9":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("f772");
var document = __webpack_require__("e53d").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "1fa8":
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__("cb7c");
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "241e":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("25eb");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "2430":
/***/ (function(module, exports, __webpack_require__) {

!function(e,r){ true?r(exports):undefined}(this,function(e){"use strict";function r(e,r){for(var a=0;a<r.length;a++){var n=r[a];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var a=function(){function e(r,a,n,u){!function(e,r){if(!(e instanceof r))throw new TypeError("Cannot call a class as a function")}(this,e),this.language=r,this.months=a,this.monthsAbbr=n,this.days=u,this.rtl=!1,this.ymd=!1,this.yearSuffix=""}var a,n,u;return a=e,(n=[{key:"language",get:function(){return this._language},set:function(e){if("string"!=typeof e)throw new TypeError("Language must be a string");this._language=e}},{key:"months",get:function(){return this._months},set:function(e){if(12!==e.length)throw new RangeError("There must be 12 months for ".concat(this.language," language"));this._months=e}},{key:"monthsAbbr",get:function(){return this._monthsAbbr},set:function(e){if(12!==e.length)throw new RangeError("There must be 12 abbreviated months for ".concat(this.language," language"));this._monthsAbbr=e}},{key:"days",get:function(){return this._days},set:function(e){if(7!==e.length)throw new RangeError("There must be 7 days for ".concat(this.language," language"));this._days=e}}])&&r(a.prototype,n),u&&r(a,u),e}(),n=new a("Afrikaans",["Januarie","Februarie","Maart","April","Mei","Junie","Julie","Augustus","September","Oktober","November","Desember"],["Jan","Feb","Mrt","Apr","Mei","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["So.","Ma.","Di.","Wo.","Do.","Vr.","Sa."]),u=new a("Arabic",["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],["يناير","فبراير","مارس","أبريل","مايو","يونيو","يوليو","أغسطس","سبتمبر","أكتوبر","نوڤمبر","ديسمبر"],["أحد","إثنين","ثلاثاء","أربعاء","خميس","جمعة","سبت"]);u.rtl=!0;var i=new a("Bulgarian",["Януари","Февруари","Март","Април","Май","Юни","Юли","Август","Септември","Октомври","Ноември","Декември"],["Ян","Фев","Мар","Апр","Май","Юни","Юли","Авг","Сеп","Окт","Ное","Дек"],["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]),t=new a("Bosnian",["Januar","Februar","Mart","April","Maj","Juni","Juli","Avgust","Septembar","Oktobar","Novembar","Decembar"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]),o=new a("Catalan",["Gener","Febrer","Març","Abril","Maig","Juny","Juliol","Agost","Setembre","Octubre","Novembre","Desembre"],["Gen","Feb","Mar","Abr","Mai","Jun","Jul","Ago","Set","Oct","Nov","Des"],["Diu","Dil","Dmr","Dmc","Dij","Div","Dis"]),s=new a("Czech",["leden","únor","březen","duben","květen","červen","červenec","srpen","září","říjen","listopad","prosinec"],["led","úno","bře","dub","kvě","čer","čec","srp","zář","říj","lis","pro"],["ne","po","út","st","čt","pá","so"]),b=new a("Danish",["Januar","Februar","Marts","April","Maj","Juni","Juli","August","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],["Sø","Ma","Ti","On","To","Fr","Lø"]),l=new a("German",["Januar","Februar","März","April","Mai","Juni","Juli","August","September","Oktober","November","Dezember"],["Jan","Feb","Mär","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],["So.","Mo.","Di.","Mi.","Do.","Fr.","Sa."]),m=new a("Estonian",["Jaanuar","Veebruar","Märts","Aprill","Mai","Juuni","Juuli","August","September","Oktoober","November","Detsember"],["Jaan","Veebr","Märts","Apr","Mai","Juuni","Juuli","Aug","Sept","Okt","Nov","Dets"],["P","E","T","K","N","R","L"]),M=new a("Greek",["Ιανουάριος","Φεβρουάριος","Μάρτιος","Απρίλιος","Μάϊος","Ιούνιος","Ιούλιος","Αύγουστος","Σεπτέμβριος","Οκτώβριος","Νοέμβριος","Δεκέμβριος"],["Ιαν","Φεβ","Μαρ","Απρ","Μαι","Ιουν","Ιουλ","Αυγ","Σεπ","Οκτ","Νοε","Δεκ"],["Κυρ","Δευ","Τρι","Τετ","Πεμ","Παρ","Σαβ"]),p=new a("English",["January","February","March","April","May","June","July","August","September","October","November","December"],["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"],["Sun","Mon","Tue","Wed","Thu","Fri","Sat"]),J=new a("Spanish",["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"],["Ene","Feb","Mar","Abr","May","Jun","Jul","Ago","Sep","Oct","Nov","Dic"],["Dom","Lun","Mar","Mié","Jue","Vie","Sáb"]),g=new a("Persian",["فروردین","اردیبهشت","خرداد","تیر","مرداد","شهریور","مهر","آبان","آذر","دی","بهمن","اسفند"],["فرو","ارد","خرد","تیر","مرد","شهر","مهر","آبا","آذر","دی","بهم","اسف"],["یکشنبه","دوشنبه","سه‌شنبه","چهارشنبه","پنجشنبه","جمعه","شنبه"]),S=new a("Finnish",["tammikuu","helmikuu","maaliskuu","huhtikuu","toukokuu","kesäkuu","heinäkuu","elokuu","syyskuu","lokakuu","marraskuu","joulukuu"],["tammi","helmi","maalis","huhti","touko","kesä","heinä","elo","syys","loka","marras","joulu"],["su","ma","ti","ke","to","pe","la"]),c=new a("Faroese",["Januar","Februar","Mars","Apríl","Mai","Juni","Juli","August","Septembur","Oktobur","Novembur","Desembur"],["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["Sun","Mán","Týs","Mik","Hós","Frí","Ley"]),A=new a("French",["Janvier","Février","Mars","Avril","Mai","Juin","Juillet","Août","Septembre","Octobre","Novembre","Décembre"],["Jan","Fév","Mar","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"],["Dim","Lun","Mar","Mer","Jeu","Ven","Sam"]),v=new a("Georgia",["იანვარი","თებერვალი","მარტი","აპრილი","მაისი","ივნისი","ივლისი","აგვისტო","სექტემბერი","ოქტომბერი","ნოემბერი","დეკემბერი"],["იან","თებ","მარ","აპრ","მაი","ივნ","ივლ","აგვ","სექ","ოქტ","ნოე","დეკ"],["კვი","ორშ","სამ","ოთხ","ხუთ","პარ","შაბ"]),h=new a("Galician",["Xaneiro","Febreiro","Marzo","Abril","Maio","Xuño","Xullo","Agosto","Setembro","Outubro","Novembro","Decembro"],["Xan","Feb","Mar","Abr","Mai","Xuñ","Xul","Ago","Set","Out","Nov","Dec"],["Dom","Lun","Mar","Mér","Xov","Ven","Sáb"]),k=new a("Hebrew",["ינואר","פברואר","מרץ","אפריל","מאי","יוני","יולי","אוגוסט","ספטמבר","אוקטובר","נובמבר","דצמבר"],["ינו","פבר","מרץ","אפר","מאי","יונ","יול","אוג","ספט","אוק","נוב","דצמ"],["א","ב","ג","ד","ה","ו","ש"]);k.rtl=!0;var w=new a("Croatian",["Siječanj","Veljača","Ožujak","Travanj","Svibanj","Lipanj","Srpanj","Kolovoz","Rujan","Listopad","Studeni","Prosinac"],["Sij","Velj","Ožu","Tra","Svi","Lip","Srp","Kol","Ruj","Lis","Stu","Pro"],["Ned","Pon","Uto","Sri","Čet","Pet","Sub"]),D=new a("Hungarian",["Január","Február","Március","Április","Május","Június","Július","Augusztus","Szeptember","Október","November","December"],["Jan","Febr","Márc","Ápr","Máj","Jún","Júl","Aug","Szept","Okt","Nov","Dec"],["Vas","Hét","Ke","Sze","Csü","Pén","Szo"]),f=new a("Indonesian",["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"],["Jan","Feb","Mar","Apr","Mei","Jun","Jul","Agu","Sep","Okt","Nov","Des"],["Min","Sen","Sel","Rab","Kam","Jum","Sab"]),N=new a("Icelandic",["Janúar","Febrúar","Mars","Apríl","Maí","Júní","Júlí","Ágúst","September","Október","Nóvember","Desember"],["Jan","Feb","Mars","Apr","Maí","Jún","Júl","Ágú","Sep","Okt","Nóv","Des"],["Sun","Mán","Þri","Mið","Fim","Fös","Lau"]),O=new a("Italian",["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"],["Gen","Feb","Mar","Apr","Mag","Giu","Lug","Ago","Set","Ott","Nov","Dic"],["Dom","Lun","Mar","Mer","Gio","Ven","Sab"]),j=new a("Japanese",["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],["1月","2月","3月","4月","5月","6月","7月","8月","9月","10月","11月","12月"],["日","月","火","水","木","金","土"]);j.yearSuffix="年",j.ymd=!0;var F=new a("Kazakh",["Қаңтар","Ақпан","Наурыз","Сәуір","Мамыр","Маусым","Шілде","Тамыз","Қыркүйек","Қазан","Қараша","Желтоқсан"],["Қаң","Ақп","Нау","Сәу","Мам","Мау","Шіл","Там","Қыр","Қаз","Қар","Жел"],["Жк","Дй","Сй","Ср","Бй","Жм","Сн"]),d=new a("Korean",["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],["1월","2월","3월","4월","5월","6월","7월","8월","9월","10월","11월","12월"],["일","월","화","수","목","금","토"]);d.yearSuffix="년",d.ymd=!0;var T=new a("Luxembourgish",["Januar","Februar","Mäerz","Abrëll","Mee","Juni","Juli","August","September","Oktober","November","Dezember"],["Jan","Feb","Mäe","Abr","Mee","Jun","Jul","Aug","Sep","Okt","Nov","Dez"],["So.","Mé.","Dë.","Më.","Do.","Fr.","Sa."]),y=new a("Lithuanian",["Sausis","Vasaris","Kovas","Balandis","Gegužė","Birželis","Liepa","Rugpjūtis","Rugsėjis","Spalis","Lapkritis","Gruodis"],["Sau","Vas","Kov","Bal","Geg","Bir","Lie","Rugp","Rugs","Spa","Lap","Gru"],["Sek","Pir","Ant","Tre","Ket","Pen","Šeš"]);y.ymd=!0;var z=new a("Latvian",["Janvāris","Februāris","Marts","Aprīlis","Maijs","Jūnijs","Jūlijs","Augusts","Septembris","Oktobris","Novembris","Decembris"],["Jan","Feb","Mar","Apr","Mai","Jūn","Jūl","Aug","Sep","Okt","Nov","Dec"],["Sv","Pr","Ot","Tr","Ce","Pk","Se"]),L=new a("Macedonian",["Јануари","Февруари","Март","Април","Мај","Јуни","Јули","Август","Септември","Октомври","Ноември","Декември"],["Јан","Фев","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Ное","Дек"],["Нед","Пон","Вто","Сре","Чет","Пет","Саб"]),P=new a("Mongolia",["1 дүгээр сар","2 дугаар сар","3 дугаар сар","4 дүгээр сар","5 дугаар сар","6 дугаар сар","7 дугаар сар","8 дугаар сар","9 дүгээр сар","10 дугаар сар","11 дүгээр сар","12 дугаар сар"],["1-р сар","2-р сар","3-р сар","4-р сар","5-р сар","6-р сар","7-р сар","8-р сар","9-р сар","10-р сар","11-р сар","12-р сар"],["Ня","Да","Мя","Лх","Пү","Ба","Бя"]);P.ymd=!0;var G=new a("Norwegian Bokmål",["Januar","Februar","Mars","April","Mai","Juni","Juli","August","September","Oktober","November","Desember"],["Jan","Feb","Mar","Apr","Mai","Jun","Jul","Aug","Sep","Okt","Nov","Des"],["Sø","Ma","Ti","On","To","Fr","Lø"]),C=new a("Dutch",["januari","februari","maart","april","mei","juni","juli","augustus","september","oktober","november","december"],["jan","feb","mrt","apr","mei","jun","jul","aug","sep","okt","nov","dec"],["zo","ma","di","wo","do","vr","za"]),K=new a("Polish",["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],["Sty","Lut","Mar","Kwi","Maj","Cze","Lip","Sie","Wrz","Paź","Lis","Gru"],["Nd","Pn","Wt","Śr","Czw","Pt","Sob"]),R=new a("Brazilian",["Janeiro","Fevereiro","Março","Abril","Maio","Junho","Julho","Agosto","Setembro","Outubro","Novembro","Dezembro"],["Jan","Fev","Mar","Abr","Mai","Jun","Jul","Ago","Set","Out","Nov","Dez"],["Dom","Seg","Ter","Qua","Qui","Sex","Sab"]),E=new a("Romanian",["Ianuarie","Februarie","Martie","Aprilie","Mai","Iunie","Iulie","August","Septembrie","Octombrie","Noiembrie","Decembrie"],["Ian","Feb","Mar","Apr","Mai","Iun","Iul","Aug","Sep","Oct","Noi","Dec"],["D","L","Ma","Mi","J","V","S"]),V=new a("Russian",["Январь","Февраль","Март","Апрель","Май","Июнь","Июль","Август","Сентябрь","Октябрь","Ноябрь","Декабрь"],["Янв","Февр","Март","Апр","Май","Июнь","Июль","Авг","Сент","Окт","Нояб","Дек"],["Вс","Пн","Вт","Ср","Чт","Пт","Сб"]),_=new a("Slovakian",["január","február","marec","apríl","máj","jún","júl","august","september","október","november","december"],["jan","feb","mar","apr","máj","jún","júl","aug","sep","okt","nov","dec"],["ne","po","ut","st","št","pi","so"]),x=new a("Sloveian",["Januar","Februar","Marec","April","Maj","Junij","Julij","Avgust","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Tor","Sre","Čet","Pet","Sob"]),I=new a("Serbian in Cyrillic script",["Јануар","Фебруар","Март","Април","Мај","Јун","Јул","Август","Септембар","Октобар","Новембар","Децембар"],["Јан","Феб","Мар","Апр","Мај","Јун","Јул","Авг","Сеп","Окт","Нов","Дец"],["Нед","Пон","Уто","Сре","Чет","Пет","Суб"]),B=new a("Serbian",["Januar","Februar","Mart","April","Maj","Jun","Jul","Avgust","Septembar","Oktobar","Novembar","Decembar"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Avg","Sep","Okt","Nov","Dec"],["Ned","Pon","Uto","Sre","Čet","Pet","Sub"]),H=new a("Swedish",["Januari","Februari","Mars","April","Maj","Juni","Juli","Augusti","September","Oktober","November","December"],["Jan","Feb","Mar","Apr","Maj","Jun","Jul","Aug","Sep","Okt","Nov","Dec"],["Sön","Mån","Tis","Ons","Tor","Fre","Lör"]),X=new a("Thai",["มกราคม","กุมภาพันธ์","มีนาคม","เมษายน","พฤษภาคม","มิถุนายน","กรกฎาคม","สิงหาคม","กันยายน","ตุลาคม","พฤศจิกายน","ธันวาคม"],["ม.ค.","ก.พ.","มี.ค.","เม.ย.","พ.ค.","มิ.ย.","ก.ค.","ส.ค.","ก.ย.","ต.ค.","พ.ย.","ธ.ค."],["อา","จ","อ","พ","พฤ","ศ","ส"]),U=new a("Turkish",["Ocak","Şubat","Mart","Nisan","Mayıs","Haziran","Temmuz","Ağustos","Eylül","Ekim","Kasım","Aralık"],["Oca","Şub","Mar","Nis","May","Haz","Tem","Ağu","Eyl","Eki","Kas","Ara"],["Paz","Pzt","Sal","Çar","Per","Cum","Cmt"]),W=new a("Ukraine",["Січень","Лютий","Березень","Квітень","Травень","Червень","Липень","Серпень","Вересень","Жовтень","Листопад","Грудень"],["Січ","Лют","Бер","Квіт","Трав","Чер","Лип","Серп","Вер","Жовт","Лист","Груд"],["Нд","Пн","Вт","Ср","Чт","Пт","Сб"]),Q=new a("Urdu",["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],["جنوری","فروری","مارچ","اپریل","مئی","جون","جولائی","اگست","سپتمبر","اکتوبر","نومبر","دسمبر"],["اتوار","پیر","منگل","بدھ","جمعرات","جمعہ","ہفتہ"]);Q.rtl=!0;var Y=new a("Vietnamese",["Tháng 1","Tháng 2","Tháng 3","Tháng 4","Tháng 5","Tháng 6","Tháng 7","Tháng 8","Tháng 9","Tháng 10","Tháng 11","Tháng 12"],["T 01","T 02","T 03","T 04","T 05","T 06","T 07","T 08","T 09","T 10","T 11","T 12"],["CN","Thứ 2","Thứ 3","Thứ 4","Thứ 5","Thứ 6","Thứ 7"]),q=new a("Chinese",["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],["一月","二月","三月","四月","五月","六月","七月","八月","九月","十月","十一月","十二月"],["日","一","二","三","四","五","六"]);q.yearSuffix="年";var Z=new a("Chinese_HK",["壹月","贰月","叁月","肆月","伍月","陆月","柒月","捌月","玖月","拾月","拾壹月","拾贰月"],["壹月","贰月","叁月","肆月","伍月","陆月","柒月","捌月","玖月","拾月","拾壹月","拾贰月"],["日","壹","贰","叁","肆","伍","陆"]);Z.yearSuffix="年",e.af=n,e.ar=u,e.bg=i,e.bs=t,e.ca=o,e.cs=s,e.da=b,e.de=l,e.ee=m,e.el=M,e.en=p,e.es=J,e.fa=g,e.fi=S,e.fo=c,e.fr=A,e.ge=v,e.gl=h,e.he=k,e.hr=w,e.hu=D,e.id=f,e.is=N,e.it=O,e.ja=j,e.kk=F,e.ko=d,e.lb=T,e.lt=y,e.lv=z,e.mk=L,e.mn=P,e.nbNO=G,e.nl=C,e.pl=K,e.ptBR=R,e.ro=E,e.ru=V,e.sk=_,e.slSI=x,e.sr=B,e.srCYRL=I,e.sv=H,e.th=X,e.tr=U,e.uk=W,e.ur=Q,e.vi=Y,e.zh=q,e.zhHK=Z,Object.defineProperty(e,"__esModule",{value:!0})});


/***/ }),

/***/ "25b0":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1df8");
module.exports = __webpack_require__("584a").Object.setPrototypeOf;


/***/ }),

/***/ "25bc":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__25bc__;

/***/ }),

/***/ "25eb":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "264e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlSearchComponent_scss_vue_type_style_index_0_id_eaa91e14_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c075");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlSearchComponent_scss_vue_type_style_index_0_id_eaa91e14_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlSearchComponent_scss_vue_type_style_index_0_id_eaa91e14_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlSearchComponent_scss_vue_type_style_index_0_id_eaa91e14_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "268f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("fde4");

/***/ }),

/***/ "27ee":
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__("23c6");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var Iterators = __webpack_require__("84f2");
module.exports = __webpack_require__("8378").getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),

/***/ "28a5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isRegExp = __webpack_require__("aae3");
var anObject = __webpack_require__("cb7c");
var speciesConstructor = __webpack_require__("ebd6");
var advanceStringIndex = __webpack_require__("0390");
var toLength = __webpack_require__("9def");
var callRegExpExec = __webpack_require__("5f1b");
var regexpExec = __webpack_require__("520a");
var fails = __webpack_require__("79e5");
var $min = Math.min;
var $push = [].push;
var $SPLIT = 'split';
var LENGTH = 'length';
var LAST_INDEX = 'lastIndex';
var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
__webpack_require__("214f")('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
    ''[$SPLIT](/.?/)[LENGTH]
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(this);
      if (separator === undefined && limit === 0) return [];
      // If `separator` is not a regex, use native split
      if (!isRegExp(separator)) return $split.call(string, separator, limit);
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy[LAST_INDEX];
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
          lastLength = match[0][LENGTH];
          lastLastIndex = lastIndex;
          if (output[LENGTH] >= splitLimit) break;
        }
        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
      }
      if (lastLastIndex === string[LENGTH]) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
    };
  // Chakra, V8
  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
    };
  } else {
    internalSplit = $split;
  }

  return [
    // `String.prototype.split` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = defined(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (regexp, limit) {
      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (SUPPORTS_Y ? 'y' : 'g');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = SUPPORTS_Y ? q : 0;
        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
        var e;
        if (
          z === null ||
          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
});


/***/ }),

/***/ "294c":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2be4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d0b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2ef0":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports =  true && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
      return _;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else {}
}.call(this));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba"), __webpack_require__("62e4")(module)))

/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "30f1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("b8e3");
var $export = __webpack_require__("63b6");
var redefine = __webpack_require__("9138");
var hide = __webpack_require__("35e8");
var Iterators = __webpack_require__("481b");
var $iterCreate = __webpack_require__("8f60");
var setToStringTag = __webpack_require__("45f2");
var getPrototypeOf = __webpack_require__("53e2");
var ITERATOR = __webpack_require__("5168")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "319b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCurrencyComponent_scss_vue_type_style_index_0_id_53ef32dc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5998");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCurrencyComponent_scss_vue_type_style_index_0_id_53ef32dc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCurrencyComponent_scss_vue_type_style_index_0_id_53ef32dc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCurrencyComponent_scss_vue_type_style_index_0_id_53ef32dc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "31f4":
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "32fc":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("e53d").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "335c":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("6b4c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "33a4":
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__("84f2");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),

/***/ "355d":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "35e8":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("d9f6");
var createDesc = __webpack_require__("aebd");
module.exports = __webpack_require__("8e60") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "36b1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioGroupComponent_scss_vue_type_style_index_0_id_1e0250bc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c3ec");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioGroupComponent_scss_vue_type_style_index_0_id_1e0250bc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioGroupComponent_scss_vue_type_style_index_0_id_1e0250bc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioGroupComponent_scss_vue_type_style_index_0_id_1e0250bc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "36c3":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("335c");
var defined = __webpack_require__("25eb");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "37c8":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("2b4c");


/***/ }),

/***/ "3846":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags()
if (__webpack_require__("9e1e") && /./g.flags != 'g') __webpack_require__("86cc").f(RegExp.prototype, 'flags', {
  configurable: true,
  get: __webpack_require__("0bfb")
});


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "3989":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "3a38":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "3a72":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var LIBRARY = __webpack_require__("2d00");
var wksExt = __webpack_require__("37c8");
var defineProperty = __webpack_require__("86cc").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "3b2b":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var inheritIfRequired = __webpack_require__("5dbc");
var dP = __webpack_require__("86cc").f;
var gOPN = __webpack_require__("9093").f;
var isRegExp = __webpack_require__("aae3");
var $flags = __webpack_require__("0bfb");
var $RegExp = global.RegExp;
var Base = $RegExp;
var proto = $RegExp.prototype;
var re1 = /a/g;
var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
var CORRECT_NEW = new $RegExp(re1) !== re1;

if (__webpack_require__("9e1e") && (!CORRECT_NEW || __webpack_require__("79e5")(function () {
  re2[__webpack_require__("2b4c")('match')] = false;
  // RegExp constructor can alter flags and IsRegExp works correct with @@match
  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
}))) {
  $RegExp = function RegExp(p, f) {
    var tiRE = this instanceof $RegExp;
    var piRE = isRegExp(p);
    var fiU = f === undefined;
    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
      : inheritIfRequired(CORRECT_NEW
        ? new Base(piRE && !fiU ? p.source : p, f)
        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
      , tiRE ? this : proto, $RegExp);
  };
  var proxy = function (key) {
    key in $RegExp || dP($RegExp, key, {
      configurable: true,
      get: function () { return Base[key]; },
      set: function (it) { Base[key] = it; }
    });
  };
  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
  proto.constructor = $RegExp;
  $RegExp.prototype = proto;
  __webpack_require__("2aba")(global, 'RegExp', $RegExp);
}

__webpack_require__("7a56")('RegExp');


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "454f":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("46a7");
var $Object = __webpack_require__("584a").Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "45f2":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("d9f6").f;
var has = __webpack_require__("07e3");
var TAG = __webpack_require__("5168")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "46a7":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("63b6");
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__("8e60"), 'Object', { defineProperty: __webpack_require__("d9f6").f });


/***/ }),

/***/ "47ee":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("c3a1");
var gOPS = __webpack_require__("9aa9");
var pIE = __webpack_require__("355d");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "481b":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "4910":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1cb7");
module.exports = __webpack_require__("584a").Reflect.get;


/***/ }),

/***/ "4917":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toLength = __webpack_require__("9def");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");

// @@match logic
__webpack_require__("214f")('match', 1, function (defined, MATCH, $match, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = defined(this);
      var fn = regexp == undefined ? undefined : regexp[MATCH];
      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
    function (regexp) {
      var res = maybeCallNative($match, regexp, this);
      if (res.done) return res.value;
      var rx = anObject(regexp);
      var S = String(this);
      if (!rx.global) return regExpExec(rx, S);
      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = String(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ "4a59":
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__("9b43");
var call = __webpack_require__("1fa8");
var isArrayIter = __webpack_require__("33a4");
var anObject = __webpack_require__("cb7c");
var toLength = __webpack_require__("9def");
var getIterFn = __webpack_require__("27ee");
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),

/***/ "4aa6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("dc62");

/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "4cbb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "4d16":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("25b0");

/***/ }),

/***/ "4e33":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5005":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "50ed":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "5154":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5168":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("dbdb")('wks');
var uid = __webpack_require__("62a0");
var Symbol = __webpack_require__("e53d").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "51cc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlTextComponent_scss_vue_type_style_index_0_id_6ca3bab5_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("a07f");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlTextComponent_scss_vue_type_style_index_0_id_6ca3bab5_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlTextComponent_scss_vue_type_style_index_0_id_6ca3bab5_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlTextComponent_scss_vue_type_style_index_0_id_6ca3bab5_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "53e2":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("07e3");
var toObject = __webpack_require__("241e");
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "551c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__("2d00");
var global = __webpack_require__("7726");
var ctx = __webpack_require__("9b43");
var classof = __webpack_require__("23c6");
var $export = __webpack_require__("5ca1");
var isObject = __webpack_require__("d3f4");
var aFunction = __webpack_require__("d8e8");
var anInstance = __webpack_require__("f605");
var forOf = __webpack_require__("4a59");
var speciesConstructor = __webpack_require__("ebd6");
var task = __webpack_require__("1991").set;
var microtask = __webpack_require__("8079")();
var newPromiseCapabilityModule = __webpack_require__("a5b8");
var perform = __webpack_require__("9c80");
var userAgent = __webpack_require__("a25f");
var promiseResolve = __webpack_require__("bcaa");
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__("2b4c")('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__("dcbc")($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__("7f20")($Promise, PROMISE);
__webpack_require__("7a56")(PROMISE);
Wrapper = __webpack_require__("8378")[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__("5cc5")(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5559":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("dbdb")('keys');
var uid = __webpack_require__("62a0");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "5817":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5957");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "584a":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "5957":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5998":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5b4e":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("36c3");
var toLength = __webpack_require__("b447");
var toAbsoluteIndex = __webpack_require__("0fc9");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "5c68":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5cc5":
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__("2b4c")('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),

/***/ "5d58":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("d8d6");

/***/ }),

/***/ "5dbc":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var setPrototypeOf = __webpack_require__("8b97").set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),

/***/ "5dc5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "611c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "62a0":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "62e4":
/***/ (function(module, exports) {

module.exports = function(module) {
	if (!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if (!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),

/***/ "63b6":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var ctx = __webpack_require__("d864");
var hide = __webpack_require__("35e8");
var has = __webpack_require__("07e3");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "6574":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxGroupComponent_scss_vue_type_style_index_0_id_299ed434_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("7b13");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxGroupComponent_scss_vue_type_style_index_0_id_299ed434_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxGroupComponent_scss_vue_type_style_index_0_id_299ed434_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxGroupComponent_scss_vue_type_style_index_0_id_299ed434_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6676":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupSearchComponent_scss_vue_type_style_index_0_id_25a1239d_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8893");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupSearchComponent_scss_vue_type_style_index_0_id_25a1239d_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupSearchComponent_scss_vue_type_style_index_0_id_25a1239d_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupSearchComponent_scss_vue_type_style_index_0_id_25a1239d_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "6718":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("e53d");
var core = __webpack_require__("584a");
var LIBRARY = __webpack_require__("b8e3");
var wksExt = __webpack_require__("ccb9");
var defineProperty = __webpack_require__("d9f6").f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "67ab":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("ca5a")('meta');
var isObject = __webpack_require__("d3f4");
var has = __webpack_require__("69a8");
var setDesc = __webpack_require__("86cc").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("79e5")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "67bb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("f921");

/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "68c5":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "69d3":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6718")('asyncIterator');


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "6abf":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("e6f3");
var hiddenKeys = __webpack_require__("1691").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "6b4c":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "6b54":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__("3846");
var anObject = __webpack_require__("cb7c");
var $flags = __webpack_require__("0bfb");
var DESCRIPTORS = __webpack_require__("9e1e");
var TO_STRING = 'toString';
var $toString = /./[TO_STRING];

var define = function (fn) {
  __webpack_require__("2aba")(RegExp.prototype, TO_STRING, fn, true);
};

// 21.2.5.14 RegExp.prototype.toString()
if (__webpack_require__("79e5")(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
  define(function toString() {
    var R = anObject(this);
    return '/'.concat(R.source, '/',
      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
  });
// FF44- RegExp#toString has a wrong name
} else if ($toString.name != TO_STRING) {
  define(function toString() {
    return $toString.call(this);
  });
}


/***/ }),

/***/ "6b8b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "6c1c":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("c367");
var global = __webpack_require__("e53d");
var hide = __webpack_require__("35e8");
var Iterators = __webpack_require__("481b");
var TO_STRING_TAG = __webpack_require__("5168")('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),

/***/ "6dff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCurrencyComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8e11");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCurrencyComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCurrencyComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCurrencyComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "71c1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("3a38");
var defined = __webpack_require__("25eb");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__("9e1e");
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),

/***/ "74c0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupTextComponent_scss_vue_type_style_index_0_id_13a05323_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("d7d2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupTextComponent_scss_vue_type_style_index_0_id_13a05323_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupTextComponent_scss_vue_type_style_index_0_id_13a05323_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupTextComponent_scss_vue_type_style_index_0_id_13a05323_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7514":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
var $export = __webpack_require__("5ca1");
var $find = __webpack_require__("0a49")(5);
var KEY = 'find';
var forced = true;
// Shouldn't skip holes
if (KEY in []) Array(1)[KEY](function () { forced = false; });
$export($export.P + $export.F * forced, 'Array', {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});
__webpack_require__("9c6c")(KEY);


/***/ }),

/***/ "765d":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("6718")('observable');


/***/ }),

/***/ "76c6":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "794b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("8e60") && !__webpack_require__("294c")(function () {
  return Object.defineProperty(__webpack_require__("1ec9")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "79aa":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7a56":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__("7726");
var dP = __webpack_require__("86cc");
var DESCRIPTORS = __webpack_require__("9e1e");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),

/***/ "7ab0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupRadioGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ffba");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupRadioGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupRadioGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupRadioGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "7b13":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "7bbc":
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__("6821");
var gOPN = __webpack_require__("9093").f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),

/***/ "7e90":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("d9f6");
var anObject = __webpack_require__("e4ae");
var getKeys = __webpack_require__("c3a1");

module.exports = __webpack_require__("8e60") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "7f7f":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc").f;
var FProto = Function.prototype;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// 19.2.4.2 name
NAME in FProto || __webpack_require__("9e1e") && dP(FProto, NAME, {
  configurable: true,
  get: function () {
    try {
      return ('' + this).match(nameRE)[1];
    } catch (e) {
      return '';
    }
  }
});


/***/ }),

/***/ "8079":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var macrotask = __webpack_require__("1991").set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__("2d95")(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.9' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "8436":
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "8527":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "85b3":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__85b3__;

/***/ }),

/***/ "85f2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("454f");

/***/ }),

/***/ "85fe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ObserveVisibility; });
/* unused harmony export install */
function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function processOptions(value) {
  var options;

  if (typeof value === 'function') {
    // Simple options (callback-only)
    options = {
      callback: value
    };
  } else {
    // Options object
    options = value;
  }

  return options;
}
function throttle(callback, delay) {
  var timeout;
  var lastState;
  var currentArgs;

  var throttled = function throttled(state) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    currentArgs = args;
    if (timeout && state === lastState) return;
    lastState = state;
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      callback.apply(void 0, [state].concat(_toConsumableArray(currentArgs)));
      timeout = 0;
    }, delay);
  };

  throttled._clear = function () {
    clearTimeout(timeout);
  };

  return throttled;
}
function deepEqual(val1, val2) {
  if (val1 === val2) return true;

  if (_typeof(val1) === 'object') {
    for (var key in val1) {
      if (!deepEqual(val1[key], val2[key])) {
        return false;
      }
    }

    return true;
  }

  return false;
}

var VisibilityState =
/*#__PURE__*/
function () {
  function VisibilityState(el, options, vnode) {
    _classCallCheck(this, VisibilityState);

    this.el = el;
    this.observer = null;
    this.frozen = false;
    this.createObserver(options, vnode);
  }

  _createClass(VisibilityState, [{
    key: "createObserver",
    value: function createObserver(options, vnode) {
      var _this = this;

      if (this.observer) {
        this.destroyObserver();
      }

      if (this.frozen) return;
      this.options = processOptions(options);

      this.callback = function (result, entry) {
        _this.options.callback(result, entry);

        if (result && _this.options.once) {
          _this.frozen = true;

          _this.destroyObserver();
        }
      }; // Throttle


      if (this.callback && this.options.throttle) {
        this.callback = throttle(this.callback, this.options.throttle);
      }

      this.oldResult = undefined;
      this.observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];

        if (_this.callback) {
          // Use isIntersecting if possible because browsers can report isIntersecting as true, but intersectionRatio as 0, when something very slowly enters the viewport.
          var result = entry.isIntersecting && entry.intersectionRatio >= _this.threshold;
          if (result === _this.oldResult) return;
          _this.oldResult = result;

          _this.callback(result, entry);
        }
      }, this.options.intersection); // Wait for the element to be in document

      vnode.context.$nextTick(function () {
        if (_this.observer) {
          _this.observer.observe(_this.el);
        }
      });
    }
  }, {
    key: "destroyObserver",
    value: function destroyObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      } // Cancel throttled call


      if (this.callback && this.callback._clear) {
        this.callback._clear();

        this.callback = null;
      }
    }
  }, {
    key: "threshold",
    get: function get() {
      return this.options.intersection && this.options.intersection.threshold || 0;
    }
  }]);

  return VisibilityState;
}();

function bind(el, _ref, vnode) {
  var value = _ref.value;
  if (!value) return;

  if (typeof IntersectionObserver === 'undefined') {
    console.warn('[vue-observe-visibility] IntersectionObserver API is not available in your browser. Please install this polyfill: https://github.com/w3c/IntersectionObserver/tree/master/polyfill');
  } else {
    var state = new VisibilityState(el, value, vnode);
    el._vue_visibilityState = state;
  }
}

function update(el, _ref2, vnode) {
  var value = _ref2.value,
      oldValue = _ref2.oldValue;
  if (deepEqual(value, oldValue)) return;
  var state = el._vue_visibilityState;

  if (!value) {
    unbind(el);
    return;
  }

  if (state) {
    state.createObserver(value, vnode);
  } else {
    bind(el, {
      value: value
    }, vnode);
  }
}

function unbind(el) {
  var state = el._vue_visibilityState;

  if (state) {
    state.destroyObserver();
    delete el._vue_visibilityState;
  }
}

var ObserveVisibility = {
  bind: bind,
  update: update,
  unbind: unbind
};

function install(Vue) {
  Vue.directive('observe-visibility', ObserveVisibility);
  /* -- Add more components here -- */
}
/* -- Plugin definition & Auto-install -- */

/* You shouldn't have to modify the code below */
// Plugin

var plugin = {
  // eslint-disable-next-line no-undef
  version: "0.4.4",
  install: install
};

var GlobalVue = null;

if (typeof window !== 'undefined') {
  GlobalVue = window.Vue;
} else if (typeof global !== 'undefined') {
  GlobalVue = global.Vue;
}

if (GlobalVue) {
  GlobalVue.use(plugin);
}

/* unused harmony default export */ var _unused_webpack_default_export = (plugin);


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")))

/***/ }),

/***/ "8663":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "8893":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8a81":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__("7726");
var has = __webpack_require__("69a8");
var DESCRIPTORS = __webpack_require__("9e1e");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var META = __webpack_require__("67ab").KEY;
var $fails = __webpack_require__("79e5");
var shared = __webpack_require__("5537");
var setToStringTag = __webpack_require__("7f20");
var uid = __webpack_require__("ca5a");
var wks = __webpack_require__("2b4c");
var wksExt = __webpack_require__("37c8");
var wksDefine = __webpack_require__("3a72");
var enumKeys = __webpack_require__("d4c0");
var isArray = __webpack_require__("1169");
var anObject = __webpack_require__("cb7c");
var isObject = __webpack_require__("d3f4");
var toObject = __webpack_require__("4bf8");
var toIObject = __webpack_require__("6821");
var toPrimitive = __webpack_require__("6a99");
var createDesc = __webpack_require__("4630");
var _create = __webpack_require__("2aeb");
var gOPNExt = __webpack_require__("7bbc");
var $GOPD = __webpack_require__("11e9");
var $GOPS = __webpack_require__("2621");
var $DP = __webpack_require__("86cc");
var $keys = __webpack_require__("0d58");
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__("9093").f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__("52a7").f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__("2d00")) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__("32e9")($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ "8b97":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("d3f4");
var anObject = __webpack_require__("cb7c");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("9b43")(Function.call, __webpack_require__("11e9").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "8bbf":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8bbf__;

/***/ }),

/***/ "8e11":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "8e60":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("294c")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "8f60":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__("a159");
var descriptor = __webpack_require__("aebd");
var setToStringTag = __webpack_require__("45f2");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("35e8")(IteratorPrototype, __webpack_require__("5168")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "8feb":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("4910");

/***/ }),

/***/ "9003":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__("6b4c");
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),

/***/ "9029":
/***/ (function(module, exports) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var UAParser = __webpack_require__(1);

var _require = __webpack_require__(3),
    BROWSER_TYPES = _require.BROWSER_TYPES,
    OS_TYPES = _require.OS_TYPES,
    DEVICE_TYPES = _require.DEVICE_TYPES,
    defaultData = _require.defaultData;

var UA = new UAParser();

var browser = UA.getBrowser();
var device = UA.getDevice();
var engine = UA.getEngine();
var os = UA.getOS();
var ua = UA.getUA();

var CHROME = BROWSER_TYPES.CHROME,
    CHROMIUM = BROWSER_TYPES.CHROMIUM,
    IE = BROWSER_TYPES.IE,
    INTERNET_EXPLORER = BROWSER_TYPES.INTERNET_EXPLORER,
    OPERA = BROWSER_TYPES.OPERA,
    FIREFOX = BROWSER_TYPES.FIREFOX,
    SAFARI = BROWSER_TYPES.SAFARI,
    EDGE = BROWSER_TYPES.EDGE,
    YANDEX = BROWSER_TYPES.YANDEX,
    MOBILE_SAFARI = BROWSER_TYPES.MOBILE_SAFARI;
var MOBILE = DEVICE_TYPES.MOBILE,
    TABLET = DEVICE_TYPES.TABLET,
    SMART_TV = DEVICE_TYPES.SMART_TV,
    BROWSER = DEVICE_TYPES.BROWSER,
    WEARABLE = DEVICE_TYPES.WEARABLE,
    CONSOLE = DEVICE_TYPES.CONSOLE;
var ANDROID = OS_TYPES.ANDROID,
    WINDOWS_PHONE = OS_TYPES.WINDOWS_PHONE,
    IOS = OS_TYPES.IOS;


var checkType = function checkType(type) {
  switch (type) {
    case MOBILE:
      return { isMobile: true };
    case TABLET:
      return { isTablet: true };
    case SMART_TV:
      return { isSmartTV: true };
    case CONSOLE:
      return { isConsole: true };
    case WEARABLE:
      return { isWearable: true };
    case BROWSER:
      return { isBrowser: true };
    default:
      return defaultData;
  }
};

var broPayload = function broPayload(isBrowser, browser, engine, os, ua) {
  return {
    isBrowser: isBrowser,
    browserMajorVersion: browser.major,
    browserFullVersion: browser.version,
    browserName: browser.name,
    engineName: engine.name || false,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var mobilePayload = function mobilePayload(type, device, os, ua) {
  return _extends({}, type, {
    vendor: device.vendor,
    model: device.model,
    os: os.name,
    osVersion: os.version,
    ua: ua
  });
};

var stvPayload = function stvPayload(isSmartTV, engine, os, ua) {
  return {
    isSmartTV: isSmartTV,
    engineName: engine.name,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var consolePayload = function consolePayload(isConsole, engine, os, ua) {
  return {
    isConsole: isConsole,
    engineName: engine.name,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var wearPayload = function wearPayload(isWearable, engine, os, ua) {
  return {
    isWearable: isWearable,
    engineName: engine.name,
    engineVersion: engine.version,
    osName: os.name,
    osVersion: os.version,
    userAgent: ua
  };
};

var isMobileType = function isMobileType() {
  return device.type === MOBILE;
};
var isTabletType = function isTabletType() {
  return device.type === TABLET;
};

var isMobileAndTabletType = function isMobileAndTabletType() {
  switch (device.type) {
    case MOBILE:
    case TABLET:
      return true;
    default:
      return false;
  }
};

var isSmartTVType = function isSmartTVType() {
  return device.type === SMART_TV;
};
var isBrowserType = function isBrowserType() {
  return device.type === BROWSER;
};
var isWearableType = function isWearableType() {
  return device.type === WEARABLE;
};
var isConsoleType = function isConsoleType() {
  return device.type === CONSOLE;
};
var isAndroidType = function isAndroidType() {
  return os.name === ANDROID;
};
var isWinPhoneType = function isWinPhoneType() {
  return os.name === WINDOWS_PHONE;
};
var isIOSType = function isIOSType() {
  return os.name === IOS;
};
var isChromeType = function isChromeType() {
  return browser.name === CHROME;
};
var isFirefoxType = function isFirefoxType() {
  return browser.name === FIREFOX;
};
var isChromiumType = function isChromiumType() {
  return browser.name === CHROMIUM;
};
var isEdgeType = function isEdgeType() {
  return browser.name === EDGE;
};
var isYandexType = function isYandexType() {
  return browser.name === YANDEX;
};
var isSafariType = function isSafariType() {
  return browser.name === SAFARI || browser.name === MOBILE_SAFARI;
};

var isMobileSafariType = function isMobileSafariType() {
  return browser.name === MOBILE_SAFARI;
};
var isOperaType = function isOperaType() {
  return browser.name === OPERA;
};
var isIEType = function isIEType() {
  return browser.name === INTERNET_EXPLORER || browser.name === IE;
};

var getBrowserFullVersion = function getBrowserFullVersion() {
  return browser.major;
};
var getBrowserVersion = function getBrowserVersion() {
  return browser.version;
};
var getOsVersion = function getOsVersion() {
  return os.version ? os.version : "none";
};
var getOsName = function getOsName() {
  return os.name ? os.name : "none";
};
var getBrowserName = function getBrowserName() {
  return browser.name;
};
var getMobileVendor = function getMobileVendor() {
  return device.vendor ? device.vendor : "none";
};
var getMobileModel = function getMobileModel() {
  return device.model ? device.model : "none";
};
var getEngineName = function getEngineName() {
  return engine.name;
};
var getEngineVersion = function getEngineVersion() {
  return engine.version;
};
var getUseragent = function getUseragent() {
  return ua;
};
var getDeviceType = function getDeviceType() {
  return device.type;
};

var isSmartTV = isSmartTVType();
var isConsole = isConsoleType();
var isWearable = isWearableType();
var isMobileSafari = isMobileSafariType();
var isChromium = isChromiumType();
var isMobile = isMobileAndTabletType();
var isMobileOnly = isMobileType();
var isTablet = isTabletType();
var isBrowser = isBrowserType();
var isAndroid = isAndroidType();
var isWinPhone = isWinPhoneType();
var isIOS = isIOSType();
var isChrome = isChromeType();
var isFirefox = isFirefoxType();
var isSafari = isSafariType();
var isOpera = isOperaType();
var isIE = isIEType();
var osVersion = getOsVersion();
var osName = getOsName();
var fullBrowserVersion = getBrowserFullVersion();
var browserVersion = getBrowserVersion();
var browserName = getBrowserName();
var mobileVendor = getMobileVendor();
var mobileModel = getMobileModel();
var engineName = getEngineName();
var engineVersion = getEngineVersion();
var getUA = getUseragent();
var isEdge = isEdgeType();
var isYandex = isYandexType();
var deviceType = getDeviceType();

var type = checkType(device.type);

function deviceDetect() {
  var isBrowser = type.isBrowser,
      isMobile = type.isMobile,
      isTablet = type.isTablet,
      isSmartTV = type.isSmartTV,
      isConsole = type.isConsole,
      isWearable = type.isWearable;

  if (isBrowser) {
    return broPayload(isBrowser, browser, engine, os, ua);
  }

  if (isSmartTV) {
    return stvPayload(isSmartTV, engine, os, ua);
  }

  if (isConsole) {
    return consolePayload(isConsole, engine, os, ua);
  }

  if (isMobile) {
    return mobilePayload(type, device, os, ua);
  }

  if (isTablet) {
    return mobilePayload(type, device, os, ua);
  }

  if (isWearable) {
    return wearPayload(isWearable, engine, os, ua);
  }
};

module.exports = {
  deviceDetect: deviceDetect,
  isSmartTV: isSmartTV,
  isConsole: isConsole,
  isWearable: isWearable,
  isMobileSafari: isMobileSafari,
  isChromium: isChromium,
  isMobile: isMobile,
  isMobileOnly: isMobileOnly,
  isTablet: isTablet,
  isBrowser: isBrowser,
  isAndroid: isAndroid,
  isWinPhone: isWinPhone,
  isIOS: isIOS,
  isChrome: isChrome,
  isFirefox: isFirefox,
  isSafari: isSafari,
  isOpera: isOpera,
  isIE: isIE,
  osVersion: osVersion,
  osName: osName,
  fullBrowserVersion: fullBrowserVersion,
  browserVersion: browserVersion,
  browserName: browserName,
  mobileVendor: mobileVendor,
  mobileModel: mobileModel,
  engineName: engineName,
  engineVersion: engineVersion,
  getUA: getUA,
  isEdge: isEdge,
  isYandex: isYandex,
  deviceType: deviceType
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * UAParser.js v0.7.18
 * Lightweight JavaScript-based User-Agent string parser
 * https://github.com/faisalman/ua-parser-js
 *
 * Copyright © 2012-2016 Faisal Salman <fyzlman@gmail.com>
 * Dual licensed under GPLv2 or MIT
 */
(function(window,undefined){"use strict";var LIBVERSION="0.7.18",EMPTY="",UNKNOWN="?",FUNC_TYPE="function",UNDEF_TYPE="undefined",OBJ_TYPE="object",STR_TYPE="string",MAJOR="major",MODEL="model",NAME="name",TYPE="type",VENDOR="vendor",VERSION="version",ARCHITECTURE="architecture",CONSOLE="console",MOBILE="mobile",TABLET="tablet",SMARTTV="smarttv",WEARABLE="wearable",EMBEDDED="embedded";var util={extend:function(regexes,extensions){var margedRegexes={};for(var i in regexes){if(extensions[i]&&extensions[i].length%2===0){margedRegexes[i]=extensions[i].concat(regexes[i])}else{margedRegexes[i]=regexes[i]}}return margedRegexes},has:function(str1,str2){if(typeof str1==="string"){return str2.toLowerCase().indexOf(str1.toLowerCase())!==-1}else{return false}},lowerize:function(str){return str.toLowerCase()},major:function(version){return typeof version===STR_TYPE?version.replace(/[^\d\.]/g,"").split(".")[0]:undefined},trim:function(str){return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,"")}};var mapper={rgx:function(ua,arrays){var i=0,j,k,p,q,matches,match;while(i<arrays.length&&!matches){var regex=arrays[i],props=arrays[i+1];j=k=0;while(j<regex.length&&!matches){matches=regex[j++].exec(ua);if(!!matches){for(p=0;p<props.length;p++){match=matches[++k];q=props[p];if(typeof q===OBJ_TYPE&&q.length>0){if(q.length==2){if(typeof q[1]==FUNC_TYPE){this[q[0]]=q[1].call(this,match)}else{this[q[0]]=q[1]}}else if(q.length==3){if(typeof q[1]===FUNC_TYPE&&!(q[1].exec&&q[1].test)){this[q[0]]=match?q[1].call(this,match,q[2]):undefined}else{this[q[0]]=match?match.replace(q[1],q[2]):undefined}}else if(q.length==4){this[q[0]]=match?q[3].call(this,match.replace(q[1],q[2])):undefined}}else{this[q]=match?match:undefined}}}}i+=2}},str:function(str,map){for(var i in map){if(typeof map[i]===OBJ_TYPE&&map[i].length>0){for(var j=0;j<map[i].length;j++){if(util.has(map[i][j],str)){return i===UNKNOWN?undefined:i}}}else if(util.has(map[i],str)){return i===UNKNOWN?undefined:i}}return str}};var maps={browser:{oldsafari:{version:{"1.0":"/8",1.2:"/1",1.3:"/3","2.0":"/412","2.0.2":"/416","2.0.3":"/417","2.0.4":"/419","?":"/"}}},device:{amazon:{model:{"Fire Phone":["SD","KF"]}},sprint:{model:{"Evo Shift 4G":"7373KT"},vendor:{HTC:"APA",Sprint:"Sprint"}}},os:{windows:{version:{ME:"4.90","NT 3.11":"NT3.51","NT 4.0":"NT4.0",2000:"NT 5.0",XP:["NT 5.1","NT 5.2"],Vista:"NT 6.0",7:"NT 6.1",8:"NT 6.2",8.1:"NT 6.3",10:["NT 6.4","NT 10.0"],RT:"ARM"}}}};var regexes={browser:[[/(opera\smini)\/([\w\.-]+)/i,/(opera\s[mobiletab]+).+version\/([\w\.-]+)/i,/(opera).+version\/([\w\.]+)/i,/(opera)[\/\s]+([\w\.]+)/i],[NAME,VERSION],[/(opios)[\/\s]+([\w\.]+)/i],[[NAME,"Opera Mini"],VERSION],[/\s(opr)\/([\w\.]+)/i],[[NAME,"Opera"],VERSION],[/(kindle)\/([\w\.]+)/i,/(lunascape|maxthon|netfront|jasmine|blazer)[\/\s]?([\w\.]*)/i,/(avant\s|iemobile|slim|baidu)(?:browser)?[\/\s]?([\w\.]*)/i,/(?:ms|\()(ie)\s([\w\.]+)/i,/(rekonq)\/([\w\.]*)/i,/(chromium|flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark)\/([\w\.-]+)/i],[NAME,VERSION],[/(trident).+rv[:\s]([\w\.]+).+like\sgecko/i],[[NAME,"IE"],VERSION],[/(edge|edgios|edgea)\/((\d+)?[\w\.]+)/i],[[NAME,"Edge"],VERSION],[/(yabrowser)\/([\w\.]+)/i],[[NAME,"Yandex"],VERSION],[/(puffin)\/([\w\.]+)/i],[[NAME,"Puffin"],VERSION],[/((?:[\s\/])uc?\s?browser|(?:juc.+)ucweb)[\/\s]?([\w\.]+)/i],[[NAME,"UCBrowser"],VERSION],[/(comodo_dragon)\/([\w\.]+)/i],[[NAME,/_/g," "],VERSION],[/(micromessenger)\/([\w\.]+)/i],[[NAME,"WeChat"],VERSION],[/(qqbrowserlite)\/([\w\.]+)/i],[NAME,VERSION],[/(QQ)\/([\d\.]+)/i],[NAME,VERSION],[/m?(qqbrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(BIDUBrowser)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(2345Explorer)[\/\s]?([\w\.]+)/i],[NAME,VERSION],[/(MetaSr)[\/\s]?([\w\.]+)/i],[NAME],[/(LBBROWSER)/i],[NAME],[/xiaomi\/miuibrowser\/([\w\.]+)/i],[VERSION,[NAME,"MIUI Browser"]],[/;fbav\/([\w\.]+);/i],[VERSION,[NAME,"Facebook"]],[/headlesschrome(?:\/([\w\.]+)|\s)/i],[VERSION,[NAME,"Chrome Headless"]],[/\swv\).+(chrome)\/([\w\.]+)/i],[[NAME,/(.+)/,"$1 WebView"],VERSION],[/((?:oculus|samsung)browser)\/([\w\.]+)/i],[[NAME,/(.+(?:g|us))(.+)/,"$1 $2"],VERSION],[/android.+version\/([\w\.]+)\s+(?:mobile\s?safari|safari)*/i],[VERSION,[NAME,"Android Browser"]],[/(chrome|omniweb|arora|[tizenoka]{5}\s?browser)\/v?([\w\.]+)/i],[NAME,VERSION],[/(dolfin)\/([\w\.]+)/i],[[NAME,"Dolphin"],VERSION],[/((?:android.+)crmo|crios)\/([\w\.]+)/i],[[NAME,"Chrome"],VERSION],[/(coast)\/([\w\.]+)/i],[[NAME,"Opera Coast"],VERSION],[/fxios\/([\w\.-]+)/i],[VERSION,[NAME,"Firefox"]],[/version\/([\w\.]+).+?mobile\/\w+\s(safari)/i],[VERSION,[NAME,"Mobile Safari"]],[/version\/([\w\.]+).+?(mobile\s?safari|safari)/i],[VERSION,NAME],[/webkit.+?(gsa)\/([\w\.]+).+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[[NAME,"GSA"],VERSION],[/webkit.+?(mobile\s?safari|safari)(\/[\w\.]+)/i],[NAME,[VERSION,mapper.str,maps.browser.oldsafari.version]],[/(konqueror)\/([\w\.]+)/i,/(webkit|khtml)\/([\w\.]+)/i],[NAME,VERSION],[/(navigator|netscape)\/([\w\.-]+)/i],[[NAME,"Netscape"],VERSION],[/(swiftfox)/i,/(icedragon|iceweasel|camino|chimera|fennec|maemo\sbrowser|minimo|conkeror)[\/\s]?([\w\.\+]+)/i,/(firefox|seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([\w\.-]+)$/i,/(mozilla)\/([\w\.]+).+rv\:.+gecko\/\d+/i,/(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir)[\/\s]?([\w\.]+)/i,/(links)\s\(([\w\.]+)/i,/(gobrowser)\/?([\w\.]*)/i,/(ice\s?browser)\/v?([\w\._]+)/i,/(mosaic)[\/\s]([\w\.]+)/i],[NAME,VERSION]],cpu:[[/(?:(amd|x(?:(?:86|64)[_-])?|wow|win)64)[;\)]/i],[[ARCHITECTURE,"amd64"]],[/(ia32(?=;))/i],[[ARCHITECTURE,util.lowerize]],[/((?:i[346]|x)86)[;\)]/i],[[ARCHITECTURE,"ia32"]],[/windows\s(ce|mobile);\sppc;/i],[[ARCHITECTURE,"arm"]],[/((?:ppc|powerpc)(?:64)?)(?:\smac|;|\))/i],[[ARCHITECTURE,/ower/,"",util.lowerize]],[/(sun4\w)[;\)]/i],[[ARCHITECTURE,"sparc"]],[/((?:avr32|ia64(?=;))|68k(?=\))|arm(?:64|(?=v\d+;))|(?=atmel\s)avr|(?:irix|mips|sparc)(?:64)?(?=;)|pa-risc)/i],[[ARCHITECTURE,util.lowerize]]],device:[[/\((ipad|playbook);[\w\s\);-]+(rim|apple)/i],[MODEL,VENDOR,[TYPE,TABLET]],[/applecoremedia\/[\w\.]+ \((ipad)/],[MODEL,[VENDOR,"Apple"],[TYPE,TABLET]],[/(apple\s{0,1}tv)/i],[[MODEL,"Apple TV"],[VENDOR,"Apple"]],[/(archos)\s(gamepad2?)/i,/(hp).+(touchpad)/i,/(hp).+(tablet)/i,/(kindle)\/([\w\.]+)/i,/\s(nook)[\w\s]+build\/(\w+)/i,/(dell)\s(strea[kpr\s\d]*[\dko])/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(kf[A-z]+)\sbuild\/.+silk\//i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/(sd|kf)[0349hijorstuw]+\sbuild\/.+silk\//i],[[MODEL,mapper.str,maps.device.amazon.model],[VENDOR,"Amazon"],[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);.+(apple)/i],[MODEL,VENDOR,[TYPE,MOBILE]],[/\((ip[honed|\s\w*]+);/i],[MODEL,[VENDOR,"Apple"],[TYPE,MOBILE]],[/(blackberry)[\s-]?(\w+)/i,/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[\s_-]?([\w-]*)/i,/(hp)\s([\w\s]+\w)/i,/(asus)-?(\w+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/\(bb10;\s(\w+)/i],[MODEL,[VENDOR,"BlackBerry"],[TYPE,MOBILE]],[/android.+(transfo[prime\s]{4,10}\s\w+|eeepc|slider\s\w+|nexus 7|padfone)/i],[MODEL,[VENDOR,"Asus"],[TYPE,TABLET]],[/(sony)\s(tablet\s[ps])\sbuild\//i,/(sony)?(?:sgp.+)\sbuild\//i],[[VENDOR,"Sony"],[MODEL,"Xperia Tablet"],[TYPE,TABLET]],[/android.+\s([c-g]\d{4}|so[-l]\w+)\sbuild\//i],[MODEL,[VENDOR,"Sony"],[TYPE,MOBILE]],[/\s(ouya)\s/i,/(nintendo)\s([wids3u]+)/i],[VENDOR,MODEL,[TYPE,CONSOLE]],[/android.+;\s(shield)\sbuild/i],[MODEL,[VENDOR,"Nvidia"],[TYPE,CONSOLE]],[/(playstation\s[34portablevi]+)/i],[MODEL,[VENDOR,"Sony"],[TYPE,CONSOLE]],[/(sprint\s(\w+))/i],[[VENDOR,mapper.str,maps.device.sprint.vendor],[MODEL,mapper.str,maps.device.sprint.model],[TYPE,MOBILE]],[/(lenovo)\s?(S(?:5000|6000)+(?:[-][\w+]))/i],[VENDOR,MODEL,[TYPE,TABLET]],[/(htc)[;_\s-]+([\w\s]+(?=\))|\w+)*/i,/(zte)-(\w*)/i,/(alcatel|geeksphone|lenovo|nexian|panasonic|(?=;\s)sony)[_\s-]?([\w-]*)/i],[VENDOR,[MODEL,/_/g," "],[TYPE,MOBILE]],[/(nexus\s9)/i],[MODEL,[VENDOR,"HTC"],[TYPE,TABLET]],[/d\/huawei([\w\s-]+)[;\)]/i,/(nexus\s6p)/i],[MODEL,[VENDOR,"Huawei"],[TYPE,MOBILE]],[/(microsoft);\s(lumia[\s\w]+)/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/[\s\(;](xbox(?:\sone)?)[\s\);]/i],[MODEL,[VENDOR,"Microsoft"],[TYPE,CONSOLE]],[/(kin\.[onetw]{3})/i],[[MODEL,/\./g," "],[VENDOR,"Microsoft"],[TYPE,MOBILE]],[/\s(milestone|droid(?:[2-4x]|\s(?:bionic|x2|pro|razr))?:?(\s4g)?)[\w\s]+build\//i,/mot[\s-]?(\w*)/i,/(XT\d{3,4}) build\//i,/(nexus\s6)/i],[MODEL,[VENDOR,"Motorola"],[TYPE,MOBILE]],[/android.+\s(mz60\d|xoom[\s2]{0,2})\sbuild\//i],[MODEL,[VENDOR,"Motorola"],[TYPE,TABLET]],[/hbbtv\/\d+\.\d+\.\d+\s+\([\w\s]*;\s*(\w[^;]*);([^;]*)/i],[[VENDOR,util.trim],[MODEL,util.trim],[TYPE,SMARTTV]],[/hbbtv.+maple;(\d+)/i],[[MODEL,/^/,"SmartTV"],[VENDOR,"Samsung"],[TYPE,SMARTTV]],[/\(dtv[\);].+(aquos)/i],[MODEL,[VENDOR,"Sharp"],[TYPE,SMARTTV]],[/android.+((sch-i[89]0\d|shw-m380s|gt-p\d{4}|gt-n\d+|sgh-t8[56]9|nexus 10))/i,/((SM-T\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,TABLET]],[/smart-tv.+(samsung)/i],[VENDOR,[TYPE,SMARTTV],MODEL],[/((s[cgp]h-\w+|gt-\w+|galaxy\snexus|sm-\w[\w\d]+))/i,/(sam[sung]*)[\s-]*(\w+-?[\w-]*)/i,/sec-((sgh\w+))/i],[[VENDOR,"Samsung"],MODEL,[TYPE,MOBILE]],[/sie-(\w*)/i],[MODEL,[VENDOR,"Siemens"],[TYPE,MOBILE]],[/(maemo|nokia).*(n900|lumia\s\d+)/i,/(nokia)[\s_-]?([\w-]*)/i],[[VENDOR,"Nokia"],MODEL,[TYPE,MOBILE]],[/android\s3\.[\s\w;-]{10}(a\d{3})/i],[MODEL,[VENDOR,"Acer"],[TYPE,TABLET]],[/android.+([vl]k\-?\d{3})\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,TABLET]],[/android\s3\.[\s\w;-]{10}(lg?)-([06cv9]{3,4})/i],[[VENDOR,"LG"],MODEL,[TYPE,TABLET]],[/(lg) netcast\.tv/i],[VENDOR,MODEL,[TYPE,SMARTTV]],[/(nexus\s[45])/i,/lg[e;\s\/-]+(\w*)/i,/android.+lg(\-?[\d\w]+)\s+build/i],[MODEL,[VENDOR,"LG"],[TYPE,MOBILE]],[/android.+(ideatab[a-z0-9\-\s]+)/i],[MODEL,[VENDOR,"Lenovo"],[TYPE,TABLET]],[/linux;.+((jolla));/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/((pebble))app\/[\d\.]+\s/i],[VENDOR,MODEL,[TYPE,WEARABLE]],[/android.+;\s(oppo)\s?([\w\s]+)\sbuild/i],[VENDOR,MODEL,[TYPE,MOBILE]],[/crkey/i],[[MODEL,"Chromecast"],[VENDOR,"Google"]],[/android.+;\s(glass)\s\d/i],[MODEL,[VENDOR,"Google"],[TYPE,WEARABLE]],[/android.+;\s(pixel c)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,TABLET]],[/android.+;\s(pixel xl|pixel)\s/i],[MODEL,[VENDOR,"Google"],[TYPE,MOBILE]],[/android.+;\s(\w+)\s+build\/hm\1/i,/android.+(hm[\s\-_]*note?[\s_]*(?:\d\w)?)\s+build/i,/android.+(mi[\s\-_]*(?:one|one[\s_]plus|note lte)?[\s_]*(?:\d?\w?)[\s_]*(?:plus)?)\s+build/i,/android.+(redmi[\s\-_]*(?:note)?(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,MOBILE]],[/android.+(mi[\s\-_]*(?:pad)(?:[\s_]*[\w\s]+))\s+build/i],[[MODEL,/_/g," "],[VENDOR,"Xiaomi"],[TYPE,TABLET]],[/android.+;\s(m[1-5]\snote)\sbuild/i],[MODEL,[VENDOR,"Meizu"],[TYPE,TABLET]],[/android.+a000(1)\s+build/i,/android.+oneplus\s(a\d{4})\s+build/i],[MODEL,[VENDOR,"OnePlus"],[TYPE,MOBILE]],[/android.+[;\/]\s*(RCT[\d\w]+)\s+build/i],[MODEL,[VENDOR,"RCA"],[TYPE,TABLET]],[/android.+[;\/\s]+(Venue[\d\s]{2,7})\s+build/i],[MODEL,[VENDOR,"Dell"],[TYPE,TABLET]],[/android.+[;\/]\s*(Q[T|M][\d\w]+)\s+build/i],[MODEL,[VENDOR,"Verizon"],[TYPE,TABLET]],[/android.+[;\/]\s+(Barnes[&\s]+Noble\s+|BN[RT])(V?.*)\s+build/i],[[VENDOR,"Barnes & Noble"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s+(TM\d{3}.*\b)\s+build/i],[MODEL,[VENDOR,"NuVision"],[TYPE,TABLET]],[/android.+;\s(k88)\sbuild/i],[MODEL,[VENDOR,"ZTE"],[TYPE,TABLET]],[/android.+[;\/]\s*(gen\d{3})\s+build.*49h/i],[MODEL,[VENDOR,"Swiss"],[TYPE,MOBILE]],[/android.+[;\/]\s*(zur\d{3})\s+build/i],[MODEL,[VENDOR,"Swiss"],[TYPE,TABLET]],[/android.+[;\/]\s*((Zeki)?TB.*\b)\s+build/i],[MODEL,[VENDOR,"Zeki"],[TYPE,TABLET]],[/(android).+[;\/]\s+([YR]\d{2})\s+build/i,/android.+[;\/]\s+(Dragon[\-\s]+Touch\s+|DT)(\w{5})\sbuild/i],[[VENDOR,"Dragon Touch"],MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(NS-?\w{0,9})\sbuild/i],[MODEL,[VENDOR,"Insignia"],[TYPE,TABLET]],[/android.+[;\/]\s*((NX|Next)-?\w{0,9})\s+build/i],[MODEL,[VENDOR,"NextBook"],[TYPE,TABLET]],[/android.+[;\/]\s*(Xtreme\_)?(V(1[045]|2[015]|30|40|60|7[05]|90))\s+build/i],[[VENDOR,"Voice"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(LVTEL\-)?(V1[12])\s+build/i],[[VENDOR,"LvTel"],MODEL,[TYPE,MOBILE]],[/android.+[;\/]\s*(V(100MD|700NA|7011|917G).*\b)\s+build/i],[MODEL,[VENDOR,"Envizen"],[TYPE,TABLET]],[/android.+[;\/]\s*(Le[\s\-]+Pan)[\s\-]+(\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*(Trio[\s\-]*.*)\s+build/i],[MODEL,[VENDOR,"MachSpeed"],[TYPE,TABLET]],[/android.+[;\/]\s*(Trinity)[\-\s]*(T\d{3})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/android.+[;\/]\s*TU_(1491)\s+build/i],[MODEL,[VENDOR,"Rotor"],[TYPE,TABLET]],[/android.+(KS(.+))\s+build/i],[MODEL,[VENDOR,"Amazon"],[TYPE,TABLET]],[/android.+(Gigaset)[\s\-]+(Q\w{1,9})\s+build/i],[VENDOR,MODEL,[TYPE,TABLET]],[/\s(tablet|tab)[;\/]/i,/\s(mobile)(?:[;\/]|\ssafari)/i],[[TYPE,util.lowerize],VENDOR,MODEL],[/(android[\w\.\s\-]{0,9});.+build/i],[MODEL,[VENDOR,"Generic"]]],engine:[[/windows.+\sedge\/([\w\.]+)/i],[VERSION,[NAME,"EdgeHTML"]],[/(presto)\/([\w\.]+)/i,/(webkit|trident|netfront|netsurf|amaya|lynx|w3m)\/([\w\.]+)/i,/(khtml|tasman|links)[\/\s]\(?([\w\.]+)/i,/(icab)[\/\s]([23]\.[\d\.]+)/i],[NAME,VERSION],[/rv\:([\w\.]{1,9}).+(gecko)/i],[VERSION,NAME]],os:[[/microsoft\s(windows)\s(vista|xp)/i],[NAME,VERSION],[/(windows)\snt\s6\.2;\s(arm)/i,/(windows\sphone(?:\sos)*)[\s\/]?([\d\.\s\w]*)/i,/(windows\smobile|windows)[\s\/]?([ntce\d\.\s]+\w)/i],[NAME,[VERSION,mapper.str,maps.os.windows.version]],[/(win(?=3|9|n)|win\s9x\s)([nt\d\.]+)/i],[[NAME,"Windows"],[VERSION,mapper.str,maps.os.windows.version]],[/\((bb)(10);/i],[[NAME,"BlackBerry"],VERSION],[/(blackberry)\w*\/?([\w\.]*)/i,/(tizen)[\/\s]([\w\.]+)/i,/(android|webos|palm\sos|qnx|bada|rim\stablet\sos|meego|contiki)[\/\s-]?([\w\.]*)/i,/linux;.+(sailfish);/i],[NAME,VERSION],[/(symbian\s?os|symbos|s60(?=;))[\/\s-]?([\w\.]*)/i],[[NAME,"Symbian"],VERSION],[/\((series40);/i],[NAME],[/mozilla.+\(mobile;.+gecko.+firefox/i],[[NAME,"Firefox OS"],VERSION],[/(nintendo|playstation)\s([wids34portablevu]+)/i,/(mint)[\/\s\(]?(\w*)/i,/(mageia|vectorlinux)[;\s]/i,/(joli|[kxln]?ubuntu|debian|suse|opensuse|gentoo|(?=\s)arch|slackware|fedora|mandriva|centos|pclinuxos|redhat|zenwalk|linpus)[\/\s-]?(?!chrom)([\w\.-]*)/i,/(hurd|linux)\s?([\w\.]*)/i,/(gnu)\s?([\w\.]*)/i],[NAME,VERSION],[/(cros)\s[\w]+\s([\w\.]+\w)/i],[[NAME,"Chromium OS"],VERSION],[/(sunos)\s?([\w\.\d]*)/i],[[NAME,"Solaris"],VERSION],[/\s([frentopc-]{0,4}bsd|dragonfly)\s?([\w\.]*)/i],[NAME,VERSION],[/(haiku)\s(\w+)/i],[NAME,VERSION],[/cfnetwork\/.+darwin/i,/ip[honead]{2,4}(?:.*os\s([\w]+)\slike\smac|;\sopera)/i],[[VERSION,/_/g,"."],[NAME,"iOS"]],[/(mac\sos\sx)\s?([\w\s\.]*)/i,/(macintosh|mac(?=_powerpc)\s)/i],[[NAME,"Mac OS"],[VERSION,/_/g,"."]],[/((?:open)?solaris)[\/\s-]?([\w\.]*)/i,/(aix)\s((\d)(?=\.|\)|\s)[\w\.])*/i,/(plan\s9|minix|beos|os\/2|amigaos|morphos|risc\sos|openvms)/i,/(unix)\s?([\w\.]*)/i],[NAME,VERSION]]};var UAParser=function(uastring,extensions){if(typeof uastring==="object"){extensions=uastring;uastring=undefined}if(!(this instanceof UAParser)){return new UAParser(uastring,extensions).getResult()}var ua=uastring||(window&&window.navigator&&window.navigator.userAgent?window.navigator.userAgent:EMPTY);var rgxmap=extensions?util.extend(regexes,extensions):regexes;this.getBrowser=function(){var browser={name:undefined,version:undefined};mapper.rgx.call(browser,ua,rgxmap.browser);browser.major=util.major(browser.version);return browser};this.getCPU=function(){var cpu={architecture:undefined};mapper.rgx.call(cpu,ua,rgxmap.cpu);return cpu};this.getDevice=function(){var device={vendor:undefined,model:undefined,type:undefined};mapper.rgx.call(device,ua,rgxmap.device);return device};this.getEngine=function(){var engine={name:undefined,version:undefined};mapper.rgx.call(engine,ua,rgxmap.engine);return engine};this.getOS=function(){var os={name:undefined,version:undefined};mapper.rgx.call(os,ua,rgxmap.os);return os};this.getResult=function(){return{ua:this.getUA(),browser:this.getBrowser(),engine:this.getEngine(),os:this.getOS(),device:this.getDevice(),cpu:this.getCPU()}};this.getUA=function(){return ua};this.setUA=function(uastring){ua=uastring;return this};return this};UAParser.VERSION=LIBVERSION;UAParser.BROWSER={NAME:NAME,MAJOR:MAJOR,VERSION:VERSION};UAParser.CPU={ARCHITECTURE:ARCHITECTURE};UAParser.DEVICE={MODEL:MODEL,VENDOR:VENDOR,TYPE:TYPE,CONSOLE:CONSOLE,MOBILE:MOBILE,SMARTTV:SMARTTV,TABLET:TABLET,WEARABLE:WEARABLE,EMBEDDED:EMBEDDED};UAParser.ENGINE={NAME:NAME,VERSION:VERSION};UAParser.OS={NAME:NAME,VERSION:VERSION};if(typeof exports!==UNDEF_TYPE){if(typeof module!==UNDEF_TYPE&&module.exports){exports=module.exports=UAParser}exports.UAParser=UAParser}else{if("function"===FUNC_TYPE&&__webpack_require__(2)){!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return UAParser}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))}else if(window){window.UAParser=UAParser}}var $=window&&(window.jQuery||window.Zepto);if(typeof $!==UNDEF_TYPE){var parser=new UAParser;$.ua=parser.getResult();$.ua.get=function(){return parser.getUA()};$.ua.set=function(uastring){parser.setUA(uastring);var result=parser.getResult();for(var prop in result){$.ua[prop]=result[prop]}}}})(typeof window==="object"?window:this);

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {/* globals __webpack_amd_options__ */
module.exports = __webpack_amd_options__;

/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var DEVICE_TYPES = {
  MOBILE: "mobile",
  TABLET: "tablet",
  SMART_TV: "smarttv",
  CONSOLE: "console",
  WEARABLE: "wearable",
  BROWSER: undefined
};

var BROWSER_TYPES = {
  CHROME: "Chrome",
  FIREFOX: "Firefox",
  OPERA: "Opera",
  YANDEX: "Yandex",
  SAFARI: "Safari",
  INTERNET_EXPLORER: "Internet Explorer",
  EDGE: "Edge",
  CHROMIUM: "Chromium",
  IE: "IE",
  MOBILE_SAFARI: "Mobile Safari"
};

var OS_TYPES = {
  IOS: "iOS",
  ANDROID: "Android",
  WINDOWS_PHONE: "Windows Phone"
};

var defaultData = {
  isMobile: false,
  isTablet: false,
  isBrowser: false,
  isSmartTV: false,
  isConsole: false,
  isWearable: false
};

module.exports = { BROWSER_TYPES: BROWSER_TYPES, DEVICE_TYPES: DEVICE_TYPES, OS_TYPES: OS_TYPES, defaultData: defaultData };

/***/ })
/******/ ]);

/***/ }),

/***/ "9093":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__("ce10");
var hiddenKeys = __webpack_require__("e11e").concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),

/***/ "9138":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("35e8");


/***/ }),

/***/ "92f2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDateComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f9cb");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDateComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDateComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDateComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9427":
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__("63b6");
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__("a159") });


/***/ }),

/***/ "94bf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlNumberComponent_scss_vue_type_style_index_0_id_6711509e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cf0d");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlNumberComponent_scss_vue_type_style_index_0_id_6711509e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlNumberComponent_scss_vue_type_style_index_0_id_6711509e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlNumberComponent_scss_vue_type_style_index_0_id_6711509e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "987f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9949":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCurrencyComponent_scss_vue_type_style_index_0_id_4470e19e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("68c5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCurrencyComponent_scss_vue_type_style_index_0_id_4470e19e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCurrencyComponent_scss_vue_type_style_index_0_id_4470e19e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCurrencyComponent_scss_vue_type_style_index_0_id_4470e19e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9aa9":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c46":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlOptionsComponent_scss_vue_type_style_index_0_id_337cb5bb_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("6b8b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlOptionsComponent_scss_vue_type_style_index_0_id_337cb5bb_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlOptionsComponent_scss_vue_type_style_index_0_id_337cb5bb_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlOptionsComponent_scss_vue_type_style_index_0_id_337cb5bb_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9c80":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),

/***/ "9db9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCheckboxGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5dc5");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCheckboxGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCheckboxGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCheckboxGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a07f":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a159":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("e4ae");
var dPs = __webpack_require__("7e90");
var enumBugKeys = __webpack_require__("1691");
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("1ec9")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("32fc").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "a25f":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "a5b8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__("d8e8");

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ "a63e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlAddinWrapperComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("dc40");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlAddinWrapperComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlAddinWrapperComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlAddinWrapperComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "a78a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioGroupComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("acb2");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioGroupComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioGroupComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioGroupComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "aa50":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlMessagesComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("2be4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlMessagesComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlMessagesComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlMessagesComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "aac9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormHorizontalComponent_scss_vue_type_style_index_0_id_355ce998_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("f42b");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormHorizontalComponent_scss_vue_type_style_index_0_id_355ce998_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormHorizontalComponent_scss_vue_type_style_index_0_id_355ce998_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormHorizontalComponent_scss_vue_type_style_index_0_id_355ce998_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "aacc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupDropdownComponent_scss_vue_type_style_index_0_id_97ea2018_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0584");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupDropdownComponent_scss_vue_type_style_index_0_id_97ea2018_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupDropdownComponent_scss_vue_type_style_index_0_id_97ea2018_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupDropdownComponent_scss_vue_type_style_index_0_id_97ea2018_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac4d":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("3a72")('asyncIterator');


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "acb2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "ad44":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipWhenEmptyComponent_scss_vue_type_style_index_0_id_471321b9_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("3989");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipWhenEmptyComponent_scss_vue_type_style_index_0_id_471321b9_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipWhenEmptyComponent_scss_vue_type_style_index_0_id_471321b9_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipWhenEmptyComponent_scss_vue_type_style_index_0_id_471321b9_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ae21":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "aebd":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "af58":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "b447":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("3a38");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "b8e3":
/***/ (function(module, exports) {

module.exports = true;


/***/ }),

/***/ "bbf5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupStaticTextComponent_scss_vue_type_style_index_0_id_60c2ff00_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("611c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupStaticTextComponent_scss_vue_type_style_index_0_id_60c2ff00_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupStaticTextComponent_scss_vue_type_style_index_0_id_60c2ff00_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupStaticTextComponent_scss_vue_type_style_index_0_id_60c2ff00_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "bcaa":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var isObject = __webpack_require__("d3f4");
var newPromiseCapability = __webpack_require__("a5b8");

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ "be09":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "bede":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipBackdropComponent_scss_vue_type_style_index_0_id_161f3114_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("76c6");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipBackdropComponent_scss_vue_type_style_index_0_id_161f3114_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipBackdropComponent_scss_vue_type_style_index_0_id_161f3114_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipBackdropComponent_scss_vue_type_style_index_0_id_161f3114_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "bf0b":
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__("355d");
var createDesc = __webpack_require__("aebd");
var toIObject = __webpack_require__("36c3");
var toPrimitive = __webpack_require__("1bc3");
var has = __webpack_require__("07e3");
var IE8_DOM_DEFINE = __webpack_require__("794b");
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__("8e60") ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),

/***/ "bf90":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__("36c3");
var $getOwnPropertyDescriptor = __webpack_require__("bf0b").f;

__webpack_require__("ce7e")('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),

/***/ "c075":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c207":
/***/ (function(module, exports) {



/***/ }),

/***/ "c243":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDropdownComponent_scss_vue_type_style_index_0_id_4b02f81c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("cf3a");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDropdownComponent_scss_vue_type_style_index_0_id_4b02f81c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDropdownComponent_scss_vue_type_style_index_0_id_4b02f81c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlDropdownComponent_scss_vue_type_style_index_0_id_4b02f81c_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c32d":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_c32d__;

/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c367":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("8436");
var step = __webpack_require__("50ed");
var Iterators = __webpack_require__("481b");
var toIObject = __webpack_require__("36c3");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("30f1")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "c3a1":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("e6f3");
var enumBugKeys = __webpack_require__("1691");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "c3a9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupPercentComponent_scss_vue_type_style_index_0_id_246021da_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("c787");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupPercentComponent_scss_vue_type_style_index_0_id_246021da_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupPercentComponent_scss_vue_type_style_index_0_id_246021da_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupPercentComponent_scss_vue_type_style_index_0_id_246021da_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "c3ec":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c787":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ccb9":
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__("5168");


/***/ }),

/***/ "cd1c":
/***/ (function(module, exports, __webpack_require__) {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
var speciesConstructor = __webpack_require__("e853");

module.exports = function (original, length) {
  return new (speciesConstructor(original))(length);
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "ce7e":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("63b6");
var core = __webpack_require__("584a");
var fails = __webpack_require__("294c");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "cf0d":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cf3a":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "cf3d":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioButtonComponent_scss_vue_type_style_index_0_id_7d570323_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("be09");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioButtonComponent_scss_vue_type_style_index_0_id_7d570323_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioButtonComponent_scss_vue_type_style_index_0_id_7d570323_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlRadioButtonComponent_scss_vue_type_style_index_0_id_7d570323_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d4c0":
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d61b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d7d2":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "d864":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("79aa");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "d8d6":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("1654");
__webpack_require__("6c1c");
module.exports = __webpack_require__("ccb9").f('iterator');


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "d9f6":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("e4ae");
var IE8_DOM_DEFINE = __webpack_require__("794b");
var toPrimitive = __webpack_require__("1bc3");
var dP = Object.defineProperty;

exports.f = __webpack_require__("8e60") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "dbdb":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("584a");
var global = __webpack_require__("e53d");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("b8e3") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "dc40":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "dc62":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("9427");
var $Object = __webpack_require__("584a").Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),

/***/ "dcbc":
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__("2aba");
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),

/***/ "dd3f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("edfc");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupComponent_global_scss_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "e4ae":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("f772");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "e53d":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "e6f3":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("07e3");
var toIObject = __webpack_require__("36c3");
var arrayIndexOf = __webpack_require__("5b4e")(false);
var IE_PROTO = __webpack_require__("5559")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "e853":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var isArray = __webpack_require__("1169");
var SPECIES = __webpack_require__("2b4c")('species');

module.exports = function (original) {
  var C;
  if (isArray(original)) {
    C = original.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? Array : C;
};


/***/ }),

/***/ "ea4c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlStaticTextComponent_scss_vue_type_style_index_0_id_16f079cc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ae21");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlStaticTextComponent_scss_vue_type_style_index_0_id_16f079cc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlStaticTextComponent_scss_vue_type_style_index_0_id_16f079cc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlStaticTextComponent_scss_vue_type_style_index_0_id_16f079cc_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ead6":
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__("f772");
var anObject = __webpack_require__("e4ae");
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__("d864")(Function.call, __webpack_require__("bf0b").f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),

/***/ "ebd6":
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__("cb7c");
var aFunction = __webpack_require__("d8e8");
var SPECIES = __webpack_require__("2b4c")('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),

/***/ "ebfd":
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__("62a0")('meta');
var isObject = __webpack_require__("f772");
var has = __webpack_require__("07e3");
var setDesc = __webpack_require__("d9f6").f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__("294c")(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),

/***/ "edfc":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f26a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCheckboxComponent_scss_vue_type_style_index_0_id_5c37feca_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8663");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCheckboxComponent_scss_vue_type_style_index_0_id_5c37feca_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCheckboxComponent_scss_vue_type_style_index_0_id_5c37feca_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormGroupCheckboxComponent_scss_vue_type_style_index_0_id_5c37feca_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "f42b":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f605":
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "f772":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "f921":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("014b");
__webpack_require__("c207");
__webpack_require__("69d3");
__webpack_require__("765d");
module.exports = __webpack_require__("584a").Symbol;


/***/ }),

/***/ "f9cb":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fa99":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("0293");
module.exports = __webpack_require__("584a").Object.getPrototypeOf;


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fad4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlAddinWrapperComponent_scss_vue_type_style_index_0_id_6d001e8e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5005");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlAddinWrapperComponent_scss_vue_type_style_index_0_id_6d001e8e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlAddinWrapperComponent_scss_vue_type_style_index_0_id_6d001e8e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlAddinWrapperComponent_scss_vue_type_style_index_0_id_6d001e8e_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var setPublicPath_i
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/text/TjipFormControlTextComponent.vue?vue&type=template&id=6ca3bab5&scoped=true&
var TjipFormControlTextComponentvue_type_template_id_6ca3bab5_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],ref:"input",staticClass:"tjip-form-control-text form-control",class:( _obj = {'has-error': _vm.showErrors, 'has-success': _vm.isValid}, _obj[_vm.controlWidthClass] = true, _obj ),attrs:{"type":"text","name":_vm.resolvedName,"id":_vm.resolvedId,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete},domProps:{"value":(_vm.internalValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.internalValue=$event.target.value}}})}
var staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormControlTextComponent.vue?vue&type=template&id=6ca3bab5&scoped=true&

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/symbol/iterator.js
var iterator = __webpack_require__("5d58");
var iterator_default = /*#__PURE__*/__webpack_require__.n(iterator);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/symbol.js
var symbol = __webpack_require__("67bb");
var symbol_default = /*#__PURE__*/__webpack_require__.n(symbol);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js



function typeof_typeof2(obj) { if (typeof symbol_default.a === "function" && typeof iterator_default.a === "symbol") { typeof_typeof2 = function _typeof2(obj) { return typeof obj; }; } else { typeof_typeof2 = function _typeof2(obj) { return obj && typeof symbol_default.a === "function" && obj.constructor === symbol_default.a && obj !== symbol_default.a.prototype ? "symbol" : typeof obj; }; } return typeof_typeof2(obj); }

function typeof_typeof(obj) {
  if (typeof symbol_default.a === "function" && typeof_typeof2(iterator_default.a) === "symbol") {
    typeof_typeof = function _typeof(obj) {
      return typeof_typeof2(obj);
    };
  } else {
    typeof_typeof = function _typeof(obj) {
      return obj && typeof symbol_default.a === "function" && obj.constructor === symbol_default.a && obj !== symbol_default.a.prototype ? "symbol" : typeof_typeof2(obj);
    };
  }

  return typeof_typeof(obj);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn.js


function _possibleConstructorReturn(self, call) {
  if (call && (typeof_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/get-prototype-of.js
var get_prototype_of = __webpack_require__("061b");
var get_prototype_of_default = /*#__PURE__*/__webpack_require__.n(get_prototype_of);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/set-prototype-of.js
var set_prototype_of = __webpack_require__("4d16");
var set_prototype_of_default = /*#__PURE__*/__webpack_require__.n(set_prototype_of);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/getPrototypeOf.js


function getPrototypeOf_getPrototypeOf(o) {
  getPrototypeOf_getPrototypeOf = set_prototype_of_default.a ? get_prototype_of_default.a : function _getPrototypeOf(o) {
    return o.__proto__ || get_prototype_of_default()(o);
  };
  return getPrototypeOf_getPrototypeOf(o);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/create.js
var create = __webpack_require__("4aa6");
var create_default = /*#__PURE__*/__webpack_require__.n(create);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/setPrototypeOf.js

function _setPrototypeOf(o, p) {
  _setPrototypeOf = set_prototype_of_default.a || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/inherits.js


function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = create_default()(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
// CONCATENATED MODULE: ./node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

// EXTERNAL MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_ = __webpack_require__("8bbf");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_);

// CONCATENATED MODULE: ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.1.0
  * (c) 2015-present Evan You
  * @license MIT
  */


// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
var reflectionIsSupported = typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
function copyReflectionMetadata(to, from) {
    forwardMetadata(to, from);
    Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
        forwardMetadata(to.prototype, from.prototype, key);
    });
    Object.getOwnPropertyNames(from).forEach(function (key) {
        forwardMetadata(to, from, key);
    });
}
function forwardMetadata(to, from, propertyKey) {
    var metaKeys = propertyKey
        ? Reflect.getOwnMetadataKeys(from, propertyKey)
        : Reflect.getOwnMetadataKeys(from);
    metaKeys.forEach(function (metaKey) {
        var metadata = propertyKey
            ? Reflect.getOwnMetadata(metaKey, from, propertyKey)
            : Reflect.getOwnMetadata(metaKey, from);
        if (propertyKey) {
            Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
        }
        else {
            Reflect.defineMetadata(metaKey, metadata, to);
        }
    });
}

var fakeArray = { __proto__: [] };
var hasProto = fakeArray instanceof Array;
function createDecorator(factory) {
    return function (target, key, index) {
        var Ctor = typeof target === 'function'
            ? target
            : target.constructor;
        if (!Ctor.__decorators__) {
            Ctor.__decorators__ = [];
        }
        if (typeof index !== 'number') {
            index = undefined;
        }
        Ctor.__decorators__.push(function (options) { return factory(options, key, index); });
    };
}
function mixins() {
    var Ctors = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Ctors[_i] = arguments[_i];
    }
    return external_commonjs_vue_commonjs2_vue_root_Vue_default.a.extend({ mixins: Ctors });
}
function isPrimitive(value) {
    var type = typeof value;
    return value == null || (type !== 'object' && type !== 'function');
}
function warn(message) {
    if (typeof console !== 'undefined') {
        console.warn('[vue-class-component] ' + message);
    }
}

function collectDataFromConstructor(vm, Component) {
    // override _init to prevent to init as Vue instance
    var originalInit = Component.prototype._init;
    Component.prototype._init = function () {
        var _this = this;
        // proxy to actual vm
        var keys = Object.getOwnPropertyNames(vm);
        // 2.2.0 compat (props are no longer exposed as self properties)
        if (vm.$options.props) {
            for (var key in vm.$options.props) {
                if (!vm.hasOwnProperty(key)) {
                    keys.push(key);
                }
            }
        }
        keys.forEach(function (key) {
            if (key.charAt(0) !== '_') {
                Object.defineProperty(_this, key, {
                    get: function () { return vm[key]; },
                    set: function (value) { vm[key] = value; },
                    configurable: true
                });
            }
        });
    };
    // should be acquired class property values
    var data = new Component();
    // restore original _init to avoid memory leak (#209)
    Component.prototype._init = originalInit;
    // create plain data object
    var plainData = {};
    Object.keys(data).forEach(function (key) {
        if (data[key] !== undefined) {
            plainData[key] = data[key];
        }
    });
    if (false) {}
    return plainData;
}

var $internalHooks = [
    'data',
    'beforeCreate',
    'created',
    'beforeMount',
    'mounted',
    'beforeDestroy',
    'destroyed',
    'beforeUpdate',
    'updated',
    'activated',
    'deactivated',
    'render',
    'errorCaptured',
    'serverPrefetch' // 2.6
];
function componentFactory(Component, options) {
    if (options === void 0) { options = {}; }
    options.name = options.name || Component._componentTag || Component.name;
    // prototype props.
    var proto = Component.prototype;
    Object.getOwnPropertyNames(proto).forEach(function (key) {
        if (key === 'constructor') {
            return;
        }
        // hooks
        if ($internalHooks.indexOf(key) > -1) {
            options[key] = proto[key];
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(proto, key);
        if (descriptor.value !== void 0) {
            // methods
            if (typeof descriptor.value === 'function') {
                (options.methods || (options.methods = {}))[key] = descriptor.value;
            }
            else {
                // typescript decorated data
                (options.mixins || (options.mixins = [])).push({
                    data: function () {
                        var _a;
                        return _a = {}, _a[key] = descriptor.value, _a;
                    }
                });
            }
        }
        else if (descriptor.get || descriptor.set) {
            // computed properties
            (options.computed || (options.computed = {}))[key] = {
                get: descriptor.get,
                set: descriptor.set
            };
        }
    });
    (options.mixins || (options.mixins = [])).push({
        data: function () {
            return collectDataFromConstructor(this, Component);
        }
    });
    // decorate options
    var decorators = Component.__decorators__;
    if (decorators) {
        decorators.forEach(function (fn) { return fn(options); });
        delete Component.__decorators__;
    }
    // find super
    var superProto = Object.getPrototypeOf(Component.prototype);
    var Super = superProto instanceof external_commonjs_vue_commonjs2_vue_root_Vue_default.a
        ? superProto.constructor
        : external_commonjs_vue_commonjs2_vue_root_Vue_default.a;
    var Extended = Super.extend(options);
    forwardStaticMembers(Extended, Component, Super);
    if (reflectionIsSupported) {
        copyReflectionMetadata(Extended, Component);
    }
    return Extended;
}
var reservedPropertyNames = [
    // Unique id
    'cid',
    // Super Vue constructor
    'super',
    // Component options that will be used by the component
    'options',
    'superOptions',
    'extendOptions',
    'sealedOptions',
    // Private assets
    'component',
    'directive',
    'filter'
];
var shouldIgnore = {
    prototype: true,
    arguments: true,
    callee: true,
    caller: true
};
function forwardStaticMembers(Extended, Original, Super) {
    // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
    Object.getOwnPropertyNames(Original).forEach(function (key) {
        // Skip the properties that should not be overwritten
        if (shouldIgnore[key]) {
            return;
        }
        // Some browsers does not allow reconfigure built-in properties
        var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);
        if (extendedDescriptor && !extendedDescriptor.configurable) {
            return;
        }
        var descriptor = Object.getOwnPropertyDescriptor(Original, key);
        // If the user agent does not support `__proto__` or its family (IE <= 10),
        // the sub class properties may be inherited properties from the super class in TypeScript.
        // We need to exclude such properties to prevent to overwrite
        // the component options object which stored on the extended constructor (See #192).
        // If the value is a referenced value (object or function),
        // we can check equality of them and exclude it if they have the same reference.
        // If it is a primitive value, it will be forwarded for safety.
        if (!hasProto) {
            // Only `cid` is explicitly exluded from property forwarding
            // because we cannot detect whether it is a inherited property or not
            // on the no `__proto__` environment even though the property is reserved.
            if (key === 'cid') {
                return;
            }
            var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);
            if (!isPrimitive(descriptor.value) &&
                superDescriptor &&
                superDescriptor.value === descriptor.value) {
                return;
            }
        }
        // Warn if the users manually declare reserved properties
        if (false) {}
        Object.defineProperty(Extended, key, descriptor);
    });
}

function vue_class_component_esm_Component(options) {
    if (typeof options === 'function') {
        return componentFactory(options);
    }
    return function (Component) {
        return componentFactory(Component, options);
    };
}
vue_class_component_esm_Component.registerHooks = function registerHooks(keys) {
    $internalHooks.push.apply($internalHooks, keys);
};

/* harmony default export */ var vue_class_component_esm = (vue_class_component_esm_Component);


// CONCATENATED MODULE: ./node_modules/vue-property-decorator/lib/vue-property-decorator.js
/** vue-property-decorator verson 8.2.2 MIT LICENSE copyright 2019 kaorun343 */
/// <reference types='reflect-metadata'/>




/** Used for keying reactive provide/inject properties */
var reactiveInjectKey = '__reactiveInject__';
/**
 * decorator of an inject
 * @param from key
 * @return PropertyDecorator
 */
function Inject(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            componentOptions.inject[key] = options || key;
        }
    });
}
/**
 * decorator of a reactive inject
 * @param from key
 * @return PropertyDecorator
 */
function InjectReactive(options) {
    return createDecorator(function (componentOptions, key) {
        if (typeof componentOptions.inject === 'undefined') {
            componentOptions.inject = {};
        }
        if (!Array.isArray(componentOptions.inject)) {
            var fromKey_1 = !!options ? options.from || options : key;
            var defaultVal_1 = (!!options && options.default) || undefined;
            if (!componentOptions.computed)
                componentOptions.computed = {};
            componentOptions.computed[key] = function () {
                var obj = this[reactiveInjectKey];
                return obj ? obj[fromKey_1] : defaultVal_1;
            };
            componentOptions.inject[reactiveInjectKey] = reactiveInjectKey;
        }
    });
}
/**
 * decorator of a provide
 * @param key key
 * @return PropertyDecorator | void
 */
function Provide(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_1 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var rv = Object.create((typeof original_1 === 'function' ? original_1.call(this) : original_1) ||
                    null);
                for (var i in provide.managed)
                    rv[provide.managed[i]] = this[i];
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/**
 * decorator of a reactive provide
 * @param key key
 * @return PropertyDecorator | void
 */
function ProvideReactive(key) {
    return createDecorator(function (componentOptions, k) {
        var provide = componentOptions.provide;
        if (typeof provide !== 'function' || !provide.managed) {
            var original_2 = componentOptions.provide;
            provide = componentOptions.provide = function () {
                var _this = this;
                var rv = Object.create((typeof original_2 === 'function' ? original_2.call(this) : original_2) ||
                    null);
                rv[reactiveInjectKey] = {};
                var _loop_1 = function (i) {
                    rv[provide.managed[i]] = this_1[i]; // Duplicates the behavior of `@Provide`
                    Object.defineProperty(rv[reactiveInjectKey], provide.managed[i], {
                        enumerable: true,
                        get: function () { return _this[i]; },
                    });
                };
                var this_1 = this;
                for (var i in provide.managed) {
                    _loop_1(i);
                }
                return rv;
            };
            provide.managed = {};
        }
        provide.managed[k] = key || k;
    });
}
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            typeof options.type === 'undefined') {
            options.type = Reflect.getMetadata('design:type', target, key);
        }
    }
}
/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}
/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}
/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    // @ts-ignore
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}
/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, key, descriptor) {
        key = hyphenate(key);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                if (returnValue !== undefined)
                    args.unshift(returnValue);
                _this.$emit.apply(_this, [event || key].concat(args));
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(function (returnValue) {
                    emit(returnValue);
                });
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
/**
 * decorator of a ref prop
 * @param refKey the ref key defined in template
 */
function Ref(refKey) {
    return createDecorator(function (options, key) {
        options.computed = options.computed || {};
        options.computed[key] = {
            cache: false,
            get: function () {
                return this.$refs[refKey || key];
            },
        };
    });
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/define-property.js
var define_property = __webpack_require__("85f2");
var define_property_default = /*#__PURE__*/__webpack_require__.n(define_property);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js


function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;

    define_property_default()(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.function.name.js
var es6_function_name = __webpack_require__("7f7f");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormItemMixin.ts











var TjipFormItemMixin_TjipFormItemMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormItemMixin, _Vue);

  function TjipFormItemMixin() {
    _classCallCheck(this, TjipFormItemMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemMixin).apply(this, arguments));
  }

  _createClass(TjipFormItemMixin, [{
    key: "resolvedName",
    get: function get() {
      return this.name || this.ctrlId || '';
    }
  }, {
    key: "resolvedId",
    get: function get() {
      return this.ctrlId || this.name || '';
    }
  }, {
    key: "controlWidthClass",
    get: function get() {
      var w = this.controlWidth || this.defaultControlWidth;
      return "form-control-width-".concat(w);
    }
  }, {
    key: "defaultControlWidth",
    get: function get() {
      return 'content';
    }
  }]);

  return TjipFormItemMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  required: true
})], TjipFormItemMixin_TjipFormItemMixin.prototype, "name", void 0);

__decorate([Prop()], TjipFormItemMixin_TjipFormItemMixin.prototype, "ctrlId", void 0);

__decorate([Prop()], TjipFormItemMixin_TjipFormItemMixin.prototype, "disabled", void 0);

__decorate([Prop()], TjipFormItemMixin_TjipFormItemMixin.prototype, "controlWidth", void 0);

TjipFormItemMixin_TjipFormItemMixin = __decorate([vue_class_component_esm], TjipFormItemMixin_TjipFormItemMixin);

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormItemTextMixin.ts










var TjipFormItemTextMixin_TjipFormItemTextMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormItemTextMixin, _Mixins);

  function TjipFormItemTextMixin() {
    _classCallCheck(this, TjipFormItemTextMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemTextMixin).apply(this, arguments));
  }

  _createClass(TjipFormItemTextMixin, [{
    key: "defaultControlWidth",
    get: function get() {
      return 'bounded';
    }
  }]);

  return TjipFormItemTextMixin;
}(mixins(TjipFormItemMixin_TjipFormItemMixin));

__decorate([Prop()], TjipFormItemTextMixin_TjipFormItemTextMixin.prototype, "placeholder", void 0);

__decorate([Prop()], TjipFormItemTextMixin_TjipFormItemTextMixin.prototype, "maxlength", void 0);

__decorate([Prop()], TjipFormItemTextMixin_TjipFormItemTextMixin.prototype, "autocomplete", void 0);

TjipFormItemTextMixin_TjipFormItemTextMixin = __decorate([vue_class_component_esm], TjipFormItemTextMixin_TjipFormItemTextMixin);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  if (key in obj) {
    define_property_default()(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
var es7_array_includes = __webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
var es6_string_includes = __webpack_require__("2fdb");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.split.js
var es6_regexp_split = __webpack_require__("28a5");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.replace.js
var es6_regexp_replace = __webpack_require__("a481");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.to-string.js
var es6_regexp_to_string = __webpack_require__("6b54");

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("2ef0");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.promise.js
var es6_promise = __webpack_require__("551c");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
var web_dom_iterable = __webpack_require__("ac6a");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipDomObserverMixin.ts











var TjipDomObserverMixin_TjipDomObserverMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipDomObserverMixin, _Vue);

  function TjipDomObserverMixin() {
    var _this;

    _classCallCheck(this, TjipDomObserverMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipDomObserverMixin).apply(this, arguments));
    _this.observers = [];
    return _this;
  }

  _createClass(TjipDomObserverMixin, [{
    key: "observeDom",
    value: function observeDom(el, cb, options) {
      var observer = new MutationObserver(cb);
      observer.observe(el, options || {
        attributes: true,
        childList: true,
        characterData: true,
        subtree: true
      });
      this.observers.push(observer);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      lodash["forEach"](this.observers, function (observer) {
        observer.disconnect();
      });
    }
  }]);

  return TjipDomObserverMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

TjipDomObserverMixin_TjipDomObserverMixin = __decorate([vue_class_component_esm({})], TjipDomObserverMixin_TjipDomObserverMixin);

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipForwardDomEvents.ts






var TjipForwardDomEvents_TjipForwardDomEvents =
/*#__PURE__*/
function () {
  function TjipForwardDomEvents(sources, events, target) {
    _classCallCheck(this, TjipForwardDomEvents);

    this.target = target;
    this.passiveEvents = ['touchstart', 'wheel'];
    this.sources = Array.prototype.slice.call(sources);
    this.events = events.slice();
    this.cb = this.callback.bind(this);
    this.registerEvents();
  }

  _createClass(TjipForwardDomEvents, [{
    key: "destroy",
    value: function destroy() {
      this.unregisterEvents();
    }
  }, {
    key: "callback",
    value: function callback(e) {
      // this.$log.debug(this.forwardRefEventsSource, e.type, e, this);
      this.target.$emit(e.type, e);
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var _this = this;

      lodash["forEach"](this.sources, function (s) {
        lodash["forEach"](_this.events, function (e) {
          var options = {
            passive: lodash["includes"](_this.passiveEvents, e)
          };
          s.addEventListener(e, _this.cb, options);
        });
      });
    }
  }, {
    key: "unregisterEvents",
    value: function unregisterEvents() {
      var _this2 = this;

      lodash["forEach"](this.sources, function (s) {
        lodash["forEach"](_this2.events, function (e) {
          s.removeEventListener(e, _this2.cb);
        });
      });
    }
  }]);

  return TjipForwardDomEvents;
}();
// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
var es6_array_iterator = __webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
var es6_object_keys = __webpack_require__("456d");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipForwardVueEvents.ts






var TjipForwardVueEvents_TjipForwardVueEvents =
/*#__PURE__*/
function () {
  function TjipForwardVueEvents(sources, events, target) {
    _classCallCheck(this, TjipForwardVueEvents);

    this.target = target;
    this.callbacks = {};
    this.sources = sources.slice();
    this.events = events.slice();
    this.registerEvents();
  }

  _createClass(TjipForwardVueEvents, [{
    key: "destroy",
    value: function destroy() {
      this.unregisterEvents();
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var _this = this;

      lodash["forEach"](this.events, function (event) {
        _this.callbacks[event] = function () {
          for (var _len = arguments.length, a = new Array(_len), _key = 0; _key < _len; _key++) {
            a[_key] = arguments[_key];
          }

          a.unshift(event);
          this.target.$emit.apply(this.target, a);
        }.bind(_this);

        lodash["forEach"](_this.sources, function (s) {
          s.$on(event, _this.callbacks[event]);
        });
      });
    }
  }, {
    key: "unregisterEvents",
    value: function unregisterEvents() {
      var _this2 = this;

      var _loop = function _loop() {
        var event = _Object$keys[_i];

        lodash["forEach"](_this2.sources, function (s) {
          s.$off(event, _this2.callbacks[event]);
        });

        delete _this2.callbacks[event];
      };

      for (var _i = 0, _Object$keys = Object.keys(this.callbacks); _i < _Object$keys.length; _i++) {
        _loop();
      }
    }
  }]);

  return TjipForwardVueEvents;
}();
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/domEvents.ts
var domInputEvents = ['abort', 'animationcancel', 'animationend', 'animationiteration', 'auxclick', 'blur', 'cancel', 'canplay', 'canplaythrough', 'change', 'click', 'close', 'contextmenu', 'copy', 'cuechange', 'cut', 'dblclick', 'durationchange', 'ended', 'error', 'focus', 'formdata', 'gotpointercapture', 'input', 'invalid', 'keydown', 'keypress', 'keyup', 'load', 'loadeddata', 'loadedmetadata', 'loadend', 'loadstart', 'lostpointercapture', 'mousedown', 'mouseenter', 'mouseleave', 'mousemove', 'mouseout', 'mouseover', 'mouseup', 'paste', 'pause', 'play', 'pointercancel', 'pointerdown', 'pointerenter', 'pointerleave', 'pointermove', 'pointerout', 'pointerover', 'pointerup', 'reset', 'resize', 'scroll', 'select', 'selectionchange', 'selectstart', 'submit', 'touchcancel', 'touchstart', 'transitioncancel', 'transitionend', 'wheel'];
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipForwardRefEventsMixin.ts















var TjipForwardRefEventsMixin_TjipForwardRefEventsMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipForwardRefEventsMixin, _Mixins);

  function TjipForwardRefEventsMixin() {
    _classCallCheck(this, TjipForwardRefEventsMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipForwardRefEventsMixin).apply(this, arguments));
  }

  _createClass(TjipForwardRefEventsMixin, [{
    key: "mounted",
    value: function mounted() {
      var _this = this;

      this.observeDom(this.$el, function (mutations) {
        _this.registerEvents();
      });
      Promise.resolve().then(function () {
        _this.registerEvents();
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.forwardRefEventsIsDomSource) {
        this.unregisterEvents();
      }
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var sources = this.sources;

      if (!lodash["isEqual"](sources, this.registeredSources)) {
        this.unregisterEvents();

        if (this.forwardRefEventsIsDomSource) {
          this.registeredDomEvents = new TjipForwardDomEvents_TjipForwardDomEvents(sources, this.forwardRefEvents, this);
        } else {
          this.registeredVueEvents = new TjipForwardVueEvents_TjipForwardVueEvents(sources, this.forwardRefEvents, this);
        }

        this.registeredSources = sources.slice();
      }
    }
  }, {
    key: "unregisterEvents",
    value: function unregisterEvents() {
      if (this.registeredSources) {
        if (this.registeredDomEvents) {
          this.registeredDomEvents.destroy();
        }

        if (this.registeredVueEvents) {
          this.registeredVueEvents.destroy();
        }

        this.registeredSources = undefined;
      }
    }
  }, {
    key: "allDomEvents",
    get: function get() {
      return domInputEvents;
    }
  }, {
    key: "forwardRefEventsSource",
    get: function get() {
      return '';
    }
  }, {
    key: "forwardRefEventsIsDomSource",
    get: function get() {
      return true;
    }
  }, {
    key: "forwardRefEvents",
    get: function get() {
      return lodash["without"](this.allDomEvents, 'input');
    }
  }, {
    key: "forwardRefsPassiveEvents",
    get: function get() {
      return ['touchstart', 'wheel'];
    }
  }, {
    key: "sources",
    get: function get() {
      var refs = this.$refs[this.forwardRefEventsSource];
      return refs ? lodash["isArray"](refs) ? refs : [refs] : [];
    }
  }]);

  return TjipForwardRefEventsMixin;
}(mixins(TjipDomObserverMixin_TjipDomObserverMixin));

TjipForwardRefEventsMixin_TjipForwardRefEventsMixin = __decorate([vue_class_component_esm({})], TjipForwardRefEventsMixin_TjipForwardRefEventsMixin);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/form/TjipFormComponent.vue?vue&type=template&id=009edfc6&
var TjipFormComponentvue_type_template_id_009edfc6_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"tjip-form",attrs:{"novalidate":"","name":_vm.name,"autocomplete":_vm.autocomplete},on:{"submit":_vm.onSubmit,"reset":_vm.onReset,"keypress":_vm.onKeypress}},[_vm._t("default")],2)}
var TjipFormComponentvue_type_template_id_009edfc6_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFormComponent.vue?vue&type=template&id=009edfc6&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.find.js
var es6_array_find = __webpack_require__("7514");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/form/TjipFormComponent.ts?vue&type=script&lang=ts&








var TjipFormComponent_1;





var TjipFormComponentvue_type_script_lang_ts_TjipFormComponent = TjipFormComponent_1 =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormComponent, _Vue);

  function TjipFormComponent() {
    var _this;

    _classCallCheck(this, TjipFormComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormComponent).apply(this, arguments));
    _this.name = undefined;
    _this.isValid = true;
    _this.formSubmitted = false;
    return _this;
  }

  _createClass(TjipFormComponent, [{
    key: "submit",
    value: function submit() {
      this.onSubmit(new Event('submit'));
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      this.formSubmitted = true;

      if (this.errors) {
        this.touch();

        if (!this.isValid) {
          event.stopImmediatePropagation();
          event.preventDefault();
          this.$log.info('ERRORS; no submit', this.errors);
          return false;
        }
      }

      this.$emit('tjipSubmit', event);
      return true;
    }
  }, {
    key: "onKeypress",
    value: function onKeypress(event) {
      var key = event.key || String.fromCharCode(event.keyCode || event.charCode || event.which);

      if (key === 'Enter' && this.preventSubmitOnEnter) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    }
  }, {
    key: "touch",
    value: function touch() {
      this.errors.$touch();
      TjipFormComponent_1.touchRecursive(this);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.formSubmitted = false;
      this.errors.$reset();
      TjipFormComponent_1.resetRecursive(this);
    }
  }, {
    key: "onReset",
    value: function onReset(event) {
      this.reset(); // user should reset data in tjipReset event handler

      this.$emit('tjipReset', event); // prevent the default form reset behavior (clearing fields, breaks binding)

      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  }, {
    key: "watchErrors",
    value: function watchErrors() {
      var _this2 = this;

      Promise.resolve().then(function () {
        _this2.isValid = _this2.getIsValid(_this2);
      });
    }
  }, {
    key: "getIsValid",
    value: function getIsValid(comp) {
      var _this3 = this;

      var result = comp.$v ? !comp.$v.$invalid : true;

      if (result) {
        if (comp.$children) {
          result = !lodash["find"](comp.$children, function (c) {
            return !_this3.getIsValid(c);
          });
        }
      }

      return result;
    }
  }, {
    key: "submitted",
    get: function get() {
      return this.formSubmitted;
    }
  }], [{
    key: "touchRecursive",
    value: function touchRecursive(comp) {
      if (comp.$v) {
        comp.$v.$touch();
      }

      if (comp.$children) {
        lodash["forEach"](comp.$children, function (child) {
          TjipFormComponent_1.touchRecursive(child);
        });
      }
    }
  }, {
    key: "resetRecursive",
    value: function resetRecursive(comp) {
      if (comp.$v) {
        comp.$v.$reset();
      }

      if (comp.$children) {
        lodash["forEach"](comp.$children, function (child) {
          TjipFormComponent_1.resetRecursive(child);
        });
      }
    }
  }]);

  return TjipFormComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent.prototype, "name", void 0);

__decorate([Prop()], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent.prototype, "errorMode", void 0);

__decorate([Prop()], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent.prototype, "hideFormGroupMessages", void 0);

__decorate([Prop()], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop()], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent.prototype, "preventSubmitOnEnter", void 0);

__decorate([Prop()], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent.prototype, "autocomplete", void 0);

__decorate([Watch('errors', {
  deep: true
})], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent.prototype, "watchErrors", null);

TjipFormComponentvue_type_script_lang_ts_TjipFormComponent = TjipFormComponent_1 = __decorate([vue_class_component_esm], TjipFormComponentvue_type_script_lang_ts_TjipFormComponent);

/* harmony default export */ var TjipFormComponentvue_type_script_lang_ts_ = (TjipFormComponentvue_type_script_lang_ts_TjipFormComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFormComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var form_TjipFormComponentvue_type_script_lang_ts_ = (TjipFormComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFormComponent.vue





/* normalize component */

var component = normalizeComponent(
  form_TjipFormComponentvue_type_script_lang_ts_,
  TjipFormComponentvue_type_template_id_009edfc6_render,
  TjipFormComponentvue_type_template_id_009edfc6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var form_TjipFormComponent = (component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/TjipAncestorMixin.ts









var TjipAncestorMixin_TjipAncestorMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipAncestorMixin, _Vue);

  function TjipAncestorMixin() {
    _classCallCheck(this, TjipAncestorMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipAncestorMixin).apply(this, arguments));
  }

  _createClass(TjipAncestorMixin, [{
    key: "getAncestor",
    value: function getAncestor(c) {
      var cur = this.$parent;

      while (cur) {
        if (cur instanceof c) {
          // this.$log.debug('OK', this, cur);
          return cur;
        }

        cur = cur.$parent;
      } // this.$log.debug('NOT FOUND', this, null, c);


      return null;
    }
  }]);

  return TjipAncestorMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

TjipAncestorMixin_TjipAncestorMixin = __decorate([vue_class_component_esm], TjipAncestorMixin_TjipAncestorMixin);

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
var es6_string_starts_with = __webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
var es6_object_assign = __webpack_require__("f751");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/validate/TjipValidationMixin.ts











var TjipValidationMixin_1;





var TjipValidationMixin_TjipValidationMixin = TjipValidationMixin_1 =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipValidationMixin, _Vue);

  function TjipValidationMixin() {
    var _this;

    _classCallCheck(this, TjipValidationMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipValidationMixin).apply(this, arguments));
    _this.tjipVuelidateChildValidations = [];
    return _this;
  }

  _createClass(TjipValidationMixin, [{
    key: "beforeCreate",
    value: function beforeCreate() {
      //        Vue.$log.debug(!!this.$options.validations, this);
      if (this.$options.validations) {
        if (this.$v) {
          external_commonjs_vue_commonjs2_vue_root_Vue_default.a.$log.error('$v already defined!!');
        }

        this.tjipVuelidateOriginalValidations = this.$options.validations;
        this.$options.validations = TjipValidationMixin_1.getAllValidations;
      }
    }
  }, {
    key: "created",
    value: function created() {
      // this.log('created');
      if (this.tjipVuelidateOriginalValidations && this.isValidationDescendant) {
        var ancestor = this.validationAncestor;

        if (ancestor && !ancestor.$options.validations) {
          this.$log.error("Validation ancestor ".concat(ancestor.logId, " must declare (dummy/empty) validations"));
        }

        ancestor.registerChildValidation(this.modelExpression, this);
      }
    }
  }, {
    key: "beforeMount",
    value: function beforeMount() {// this.log('beforeMount');
    }
  }, {
    key: "mounted",
    value: function mounted() {// this.log('mounted');
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      // this.log('beforeDestroy');
      if (this.tjipVuelidateChildValidations && this.isValidationDescendant) {
        var ancestor = this.validationAncestor;
        ancestor.unregisterChildValidation(this.modelExpression, this);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {// this.log('destroyed');
    }
  }, {
    key: "touch",
    value: function touch(key) {
      var ndx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
      var k = key || 'value';
      var vs = TjipValidationMixin_1.getExpressionFrom$v([this.$v], k, ndx);

      lodash["forEach"](vs, function (v) {
        if (v.$touch) {
          v.$touch();
        }
      });

      var ancestor = this.validationAncestor;

      if (ancestor && this.modelExpression) {
        var newNdx = -1;

        var childVals = lodash["find"](ancestor.tjipVuelidateChildValidations, {
          expression: this.modelExpression
        });

        if (childVals) {
          newNdx = childVals.children.indexOf(this);
        }

        ancestor.touch(this.modelExpression, newNdx);
      }
    } // derived classes should return the name of the internal property that references modelExpression

  }, {
    key: "registerChildValidation",
    value: function registerChildValidation(modelExpression, child) {
      var childValidations = this.tjipVuelidateChildValidations;

      var vals = lodash["find"](childValidations, {
        expression: modelExpression
      });

      if (!vals) {
        vals = {
          expression: modelExpression,
          children: []
        };
        childValidations.push(vals);
      }

      if (vals.children.indexOf(child) < 0) {
        vals.children.push(child); // this.$log.debug(this.logId, 'register child', modelExpression, child, this);
      }
    }
  }, {
    key: "unregisterChildValidation",
    value: function unregisterChildValidation(modelExpression, child) {
      var childValidations = this.tjipVuelidateChildValidations;

      var vals = lodash["find"](childValidations, {
        expression: modelExpression
      });

      if (vals) {
        var ndx = vals.children.indexOf(child);

        if (ndx >= 0) {
          vals.children.splice(ndx, 1); // Vue.$log.debug(this.logId, 'unregister child', modelExpression, child);
        }
      }
    }
  }, {
    key: "resolveChildValidations",
    value: function resolveChildValidations(val) {
      var result = {};
      var subResult = result;
      var isArray = false;
      var i1 = 0;
      var tokens;

      if (val.expression) {
        tokens = val.expression.split('.');

        while (i1 < tokens.length) {
          var token = tokens[i1++];
          var matches = /^(.*)\[(.*)\]$/.exec(token);

          if (matches) {
            subResult = subResult[matches[1]] = {};
            isArray = true;
            break;
          } else if (!isNaN(parseInt(token, 10))) {
            isArray = true;
            break;
          }

          subResult = subResult[token] = {};
        }
      }

      lodash["forEach"](val.children, function (child, ndx) {
        var childVals = child.resolvedValidations;

        if (!lodash["isEmpty"](childVals)) {
          var localSubResult = subResult;

          if (isArray) {
            localSubResult = localSubResult[ndx] = {};
            var i2 = i1;

            while (i2 < tokens.length) {
              var _token = tokens[i2++];
              localSubResult = localSubResult[_token] = {};
            }
          }

          Object.assign(localSubResult, childVals);
        }
      });

      if (lodash["isEmpty"](subResult)) {
        return {};
      } // this.$log.debug(this.logId, val.expression, result);


      return result;
    }
  }, {
    key: "log",
    value: function log(name) {
      var ancestor = this.validationAncestor;
      this.$log.debug(name, '|', this.logId, this.modelExpression, 'ancestor validation', !!(ancestor && ancestor.$options.validations), this, this.validationAncestor, this.tjipVuelidateChildValidations.length);
    }
  }, {
    key: "descendantValuePropertyName",
    get: function get() {
      return '';
    }
  }, {
    key: "isValidationDescendant",
    get: function get() {
      return !!this.descendantValuePropertyName;
    }
  }, {
    key: "logId",
    get: function get() {
      return "".concat(this._uid, " ").concat(this.$vnode && this.$vnode.tag);
    }
  }, {
    key: "validationAncestor",
    get: function get() {
      var self = this;
      return self.$vnode && self.$vnode.context;
    }
  }, {
    key: "modelExpression",
    get: function get() {
      var ancestor = this.validationAncestor;
      var vnode = this.$vnode;
      return ancestor && ancestor.isFormItemValue ? 'value' : vnode && vnode.data && vnode.data.model && vnode.data.model.expression || undefined;
    }
  }, {
    key: "originalValidations",
    get: function get() {
      var originalValidations = this.tjipVuelidateOriginalValidations;
      var result = (typeof originalValidations === 'function' ? originalValidations.call(this) : originalValidations) || {};
      return result;
    }
  }, {
    key: "resolvedValidations",
    get: function get() {
      var _this2 = this;

      var result = {};

      lodash["forEach"](this.tjipVuelidateChildValidations, function (val) {
        lodash["merge"](result, _this2.resolveChildValidations(val));
      });

      var vals = this.originalValidations;

      lodash["merge"](result, vals);

      if (!lodash["isEmpty"](result) && this.isValidationDescendant) {
        result = result[this.descendantValuePropertyName] || {};
      } // this.$log.debug(this.logId, this.modelExpression, result, vals);


      return result;
    }
  }], [{
    key: "logGetAllValidations",
    value: function logGetAllValidations() {
      this.$log.debug(this.logId, this, this.tjipVuelidateChildValidations && this.tjipVuelidateChildValidations.length, '\n\n');
      var result = TjipValidationMixin_1.getAllValidations.apply(this);
      this.$log.debug(this.logId, result);
      return result;
    }
  }, {
    key: "getAllValidations",
    value: function getAllValidations(child) {
      var result = {};
      var ancestor = this.validationAncestor;
      var expr = this.modelExpression;

      if (ancestor && this.isValidationDescendant && expr) {
        result = TjipValidationMixin_1.getAllValidations.call(ancestor, this);
        var originalValidations = this.originalValidations;
        result = lodash["merge"]({}, originalValidations, result); // this.$log.debug(this.logId, 'ancestor vals', vals, 'original', originalValidations,
        //   'result', result, ancestor, expr, this.descendantValuePropertyName);

        if (ancestor.isValidationDescendantMixin && expr.startsWith("".concat(ancestor.descendantValuePropertyName, "."))) {
          TjipValidationMixin_1.wrapValidationFunctions(result[ancestor.descendantValuePropertyName], this, ancestor.value);
        }
      } else {
        result = this.resolvedValidations;
      }

      if (child) {
        var childVals = lodash["find"](this.tjipVuelidateChildValidations, {
          expression: child.modelExpression
        });

        if (childVals) {
          var ndx = childVals.children.indexOf(child);
          result = _defineProperty({}, child.descendantValuePropertyName, TjipValidationMixin_1.getExpression(result, child.modelExpression, ndx));
        }
      } // this.$log.debug(this.logId, result, ancestor);


      return result;
    }
  }, {
    key: "getExpression",
    value: function getExpression(root, expression, index) {
      var result = root;
      var tokens = expression.split('.');
      var i1 = 0;

      while (result && i1 < tokens.length) {
        var token = tokens[i1++];
        var matches = /^(.*)\[.*\]$/.exec(token);

        if (matches) {
          result = result[matches[1]];

          if (result) {
            result = lodash["merge"]({}, result.$each, result[index]);
          }
        } else if (!isNaN(parseInt(token, 10))) {
          result = lodash["merge"]({}, result.$each, result[index]);
        } else {
          result = result[token];
        }
      }

      return result || {};
    }
  }, {
    key: "getExpressionFrom$v",
    value: function getExpressionFrom$v(root, expression, index) {
      var result = root;

      var proceedToken = function proceedToken(token) {
        for (var i2 = result.length - 1; i2 >= 0; i2--) {
          result[i2] = result[i2][token];

          if (!result[i2]) {
            result.splice(i2, 1);
          }
        }
      };

      var proceedIndex = function proceedIndex(ndx) {
        var eachItems = [];

        for (var i3 = result.length - 1; i3 >= 0; i3--) {
          var r = result[i3];

          if (r.$each) {
            var item = r.$each[ndx];

            if (item) {
              eachItems.push(item);
            }
          }
        }

        for (var i4 = result.length - 1; i4 >= 0; i4--) {
          result[i4] = result[i4][ndx];

          if (!result[i4]) {
            result.splice(i4, 1);
          }
        }

        if (eachItems.length) {
          result.push.apply(result, eachItems);
        }
      };

      var tokens = expression.split('.');
      var i1 = 0;

      while (result.length && i1 < tokens.length) {
        var token = tokens[i1++];
        var matches = /^(.*)\[.*\]$/.exec(token);

        if (matches) {
          proceedToken(matches[1]);

          if (result) {
            proceedIndex(index);
          }
        } else {
          proceedToken(token);
        }
      }

      return result;
    }
  }, {
    key: "wrapValidationFunctions",
    value: function wrapValidationFunctions(host, vm, data) {
      for (var key in host) {
        if (host.hasOwnProperty(key)) {
          (function () {
            var fn = host[key];

            if (typeof fn === 'function') {
              host[key] = function (value) {
                return fn.call(this, value, data);
              };
            }
          })();
        }
      }
    }
  }]);

  return TjipValidationMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

TjipValidationMixin_TjipValidationMixin = TjipValidationMixin_1 = __decorate([vue_class_component_esm], TjipValidationMixin_TjipValidationMixin);

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormItemValueMixin.ts














var TjipFormItemValueMixin_TjipFormItemValueMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormItemValueMixin, _Mixins);

  function TjipFormItemValueMixin() {
    var _this;

    _classCallCheck(this, TjipFormItemValueMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemValueMixin).apply(this, arguments));
    _this.form = null;
    _this.isFormItemValue = true;
    return _this;
  }

  _createClass(TjipFormItemValueMixin, [{
    key: "mounted",
    value: function mounted() {
      this.form = this.getAncestor(form_TjipFormComponent);
    }
  }, {
    key: "forwardRefEventsSource",
    get: function get() {
      return 'input';
    }
  }, {
    key: "descendantValuePropertyName",
    get: function get() {
      return 'value';
    }
  }, {
    key: "submitted",
    get: function get() {
      return !!(this.form && this.form.submitted);
    }
  }, {
    key: "resolvedErrorMode",
    get: function get() {
      return this.errorMode || this.form && this.form.errorMode || 'touched';
    }
  }]);

  return TjipFormItemValueMixin;
}(mixins(TjipFormItemMixin_TjipFormItemMixin, TjipForwardRefEventsMixin_TjipForwardRefEventsMixin, TjipAncestorMixin_TjipAncestorMixin, TjipValidationMixin_TjipValidationMixin));

__decorate([Prop({
  required: true
})], TjipFormItemValueMixin_TjipFormItemValueMixin.prototype, "value", void 0);

__decorate([Prop()], TjipFormItemValueMixin_TjipFormItemValueMixin.prototype, "tabindex", void 0);

__decorate([Prop()], TjipFormItemValueMixin_TjipFormItemValueMixin.prototype, "errorMode", void 0);

TjipFormItemValueMixin_TjipFormItemValueMixin = __decorate([vue_class_component_esm({})], TjipFormItemValueMixin_TjipFormItemValueMixin);

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormControlValueMixin.ts











var TjipFormControlValueMixin_1;





var SELECTABLE_TYPES = /text|password|search|tel|url/;

var TjipFormControlValueMixin_TjipFormControlValueMixin = TjipFormControlValueMixin_1 =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlValueMixin, _Mixins);

  function TjipFormControlValueMixin() {
    var _this;

    _classCallCheck(this, TjipFormControlValueMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlValueMixin).apply(this, arguments));
    _this.hasFocus = false;
    _this.internalIsValid = true;
    _this.internalSyntaxInvalid = false;
    _this.viewValue = '';
    _this.keepViewValue = false;
    return _this;
  }

  _createClass(TjipFormControlValueMixin, [{
    key: "mounted",
    value: function mounted() {
      var el = this.$refs.input;

      if (el) {
        el.addEventListener('focus', this.onFocus);
        el.addEventListener('keypress', this.onKeypress);
        el.addEventListener('blur', this.onBlur);
        el.addEventListener('paste', this.onPaste);
      }

      this.resolveIsValid();
      this.updateRawValue();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      var el = this.$refs.input;

      if (el) {
        el.removeEventListener('focus', this.onFocus);
        el.removeEventListener('keypress', this.onKeypress);
        el.removeEventListener('blur', this.onBlur);
        el.removeEventListener('paste', this.onPaste);
      }
    }
  }, {
    key: "allowKey",
    value: function allowKey(key) {
      return true;
    }
  }, {
    key: "allowValue",
    value: function allowValue(value) {
      return true;
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      return this.value;
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      return {
        value: value,
        revert: false,
        invalid: false
      };
    }
  }, {
    key: "newValue",
    value: function newValue(insert) {
      var selection = this.getSelection();
      var value = this.$refs.input.value;
      return value.substring(0, selection.start) + insert + value.substring(selection.end);
    }
  }, {
    key: "getSelection",
    value: function getSelection() {
      var result = {
        text: null,
        start: 0,
        end: 0
      };
      var elm = window.document.activeElement;

      if (this.isInputControl(elm)) {
        result.start = elm.selectionStart;
        result.end = elm.selectionEnd;
        result.text = elm.value.substring(result.start, result.end);
      } else {
        var getSelection = window.getSelection;

        if (getSelection) {
          // all browsers, except IE before version 9
          var selRange = getSelection();
          result.start = 0; // todo

          result.text = selRange.toString();
          result.end = result.text.length; // todo
        } else {
          var createRange = window.document.selection.createRange;

          if (createRange) {
            // Internet Explorer
            var range = createRange();
            result.text = range.text;

            if (range && range.parentElement() === elm) {
              var len = elm.value.length;
              var normalizedValue = elm.value.replace(/\r\n/g, '\n'); // Create a working TextRange that lives only in the input

              var textInputRange = elm.createTextRange();
              textInputRange.moveToBookmark(range.getBookmark()); // Check if the start and end of the selection are at the very end
              // of the input, since moveStart/moveEnd doesn't return what we want
              // in those cases

              var endRange = elm.createTextRange();
              endRange.collapse(false);

              if (textInputRange.compareEndPoints('StartToEnd', endRange) > -1) {
                result.start = result.end = len;
              } else {
                result.start = -textInputRange.moveStart('character', -len);
                result.start += normalizedValue.slice(0, result.start).split('\n').length - 1;

                if (textInputRange.compareEndPoints('EndToEnd', endRange) > -1) {
                  result.end = len;
                } else {
                  result.end = -textInputRange.moveEnd('character', -len);
                  result.end += normalizedValue.slice(0, result.end).split('\n').length - 1;
                }
              }
            }
          }
        }
      }

      return result;
    }
  }, {
    key: "watchInvalid",
    value: function watchInvalid() {
      this.resolveIsValid();
    }
  }, {
    key: "resolveIsValid",
    value: function resolveIsValid() {
      this.internalIsValid = !(this.$v.value && this.$v.value.$invalid);
    }
  }, {
    key: "updateRawValue",
    value: function updateRawValue() {
      this.$emit('rawValue', this.internalValue);
    }
  }, {
    key: "watchInternalValue",
    value: function watchInternalValue() {
      this.updateRawValue();
    }
  }, {
    key: "onBlur",
    value: function onBlur(event) {
      this.hasFocus = false;
      this.touch();
    }
  }, {
    key: "selectFullContent",
    value: function selectFullContent(elm) {
      var _this2 = this;

      if (elm && SELECTABLE_TYPES.test(elm.type)) {
        setTimeout(function () {
          // check if still focused
          if (_this2.hasFocus) {
            elm.selectionStart = 0;
            elm.selectionEnd = elm.value.length;
            elm.focus();
          }
        });
      }
    }
  }, {
    key: "onFocus",
    value: function onFocus(event) {
      this.hasFocus = true;

      if (!this.syntaxInvalid) {
        this.viewValue = this.formatValue(this.value);
        this.selectFullContent(event.srcElement);
      }
    }
  }, {
    key: "getClipboardText",
    value: function getClipboardText(event) {
      var result = '';
      var w = window;
      var data = event && event.clipboardData;

      if (data && data.getData) {
        result = data.getData('text/plain');
      } else if (w.clipboardData && w.clipboardData.getData) {
        // IE
        result = w.clipboardData.getData('Text');
      } else if (event && event.originalEvent) {
        result = this.getClipboardText(event.originalEvent);
      }

      return result;
    }
  }, {
    key: "onKeypress",
    value: function onKeypress(ev) {
      var isNavigationKeyCode = function isNavigationKeyCode(keyCode) {
        switch (keyCode) {
          case 8: // BACKSPACE

          case 9: // TAB:

          case 13: // ENTER:

          case 33: // PAGE_UP

          case 34: // PAGE_DOWN

          case 36: // HOME

          case 35: // END

          case 37: // LEFT

          case 39: // RIGHT

          case 38: // UP

          case 40: // DOWN

          case 45: // INSERT

          case 46:
            // DELETE
            return true;
        }

        return false;
      };

      var isFunctionKeyCode = function isFunctionKeyCode(keyCode) {
        return keyCode >= 112
        /*F1*/
        && keyCode <= 123
        /*F12*/
        ;
      };

      var event = ev; // tslint:disable-next-line:deprecation

      var key = event.key || String.fromCharCode(event.keyCode || event.charCode || event.which);

      if (!(event.altKey || event.ctrlKey) && !this.allowKey(key) && // always allow Enter key for browser default handling
      key !== 'Enter' && // tslint:disable-next-line:deprecation
      !(!event.charCode
      /* FF only! */
      && (isNavigationKeyCode(event.keyCode) || isFunctionKeyCode(event.keyCode)))) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    }
  }, {
    key: "onPaste",
    value: function onPaste(event) {
      var pasteValue = this.getClipboardText(event);
      var result = this.allowValue(this.newValue(pasteValue));

      if (!result) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }

      return result;
    }
  }, {
    key: "isInputControl",
    value: function isInputControl(elem) {
      var tag;
      return elem && ((tag = elem.tagName.toLowerCase()) === 'input' || tag === 'textarea');
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.internalIsValid;
    }
  }, {
    key: "syntaxInvalid",
    get: function get() {
      return this.internalSyntaxInvalid;
    }
  }, {
    key: "internalValue",
    get: function get() {
      return this.hasFocus && this.keepViewValue || this.syntaxInvalid ? this.viewValue : this.formatValue(this.value);
    },
    set: function set(value) {
      var v = this.parseValue(value);

      if (v.revert) {
        return;
      }

      this.internalSyntaxInvalid = !lodash["isNil"](value) && !lodash["isEmpty"](value) && v.invalid;

      if (v.value !== this.value) {
        this.$emit('input', v.value);
      }

      if (!lodash["isUndefined"](v.viewValue)) {
        this.viewValue = v.viewValue;
      } else if (this.hasFocus && this.isTextElement) {
        var el = this.$refs.input;
        this.viewValue = el.value;
      } else {
        this.viewValue = '';
      }

      this.keepViewValue = this.hasFocus && !!this.viewValue && this.viewValue !== this.formatValue(v.value);
    }
  }, {
    key: "showErrors",
    get: function get() {
      if (!this.isValid) {
        switch (this.resolvedErrorMode) {
          case 'touched':
            {
              return this.$v.value && this.$v.value.$error || this.submitted;
            }

          case 'submit':
            {
              return this.submitted;
            }

          default:
            {
              return true;
            }
        }
      }

      return false;
    }
  }, {
    key: "syntaxValidatorKey",
    get: function get() {
      return 'syntax';
    }
  }, {
    key: "isTextElement",
    get: function get() {
      var el = this.$refs.input;
      return el && lodash["includes"](['text'], el.type);
    }
  }], [{
    key: "validations",
    value: function validations() {
      var _this3 = this;

      return {
        value: _defineProperty({}, this.syntaxValidatorKey, function () {
          return !_this3.syntaxInvalid;
        })
      };
    }
  }]);

  return TjipFormControlValueMixin;
}(mixins(TjipFormItemValueMixin_TjipFormItemValueMixin));

__decorate([Watch('$v.value.$invalid')], TjipFormControlValueMixin_TjipFormControlValueMixin.prototype, "watchInvalid", null);

__decorate([Watch('internalValue')], TjipFormControlValueMixin_TjipFormControlValueMixin.prototype, "watchInternalValue", null);

TjipFormControlValueMixin_TjipFormControlValueMixin = TjipFormControlValueMixin_1 = __decorate([vue_class_component_esm({
  validations: TjipFormControlValueMixin_1.validations
})], TjipFormControlValueMixin_TjipFormControlValueMixin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/text/TjipFormControlTextComponent.ts?vue&type=script&lang=ts&









var TjipFormControlTextComponentvue_type_script_lang_ts_TjipFormControlTextComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlTextComponent, _Mixins);

  function TjipFormControlTextComponent() {
    _classCallCheck(this, TjipFormControlTextComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlTextComponent).apply(this, arguments));
  }

  return TjipFormControlTextComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin));

TjipFormControlTextComponentvue_type_script_lang_ts_TjipFormControlTextComponent = __decorate([vue_class_component_esm({})], TjipFormControlTextComponentvue_type_script_lang_ts_TjipFormControlTextComponent);

/* harmony default export */ var TjipFormControlTextComponentvue_type_script_lang_ts_ = (TjipFormControlTextComponentvue_type_script_lang_ts_TjipFormControlTextComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormControlTextComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var text_TjipFormControlTextComponentvue_type_script_lang_ts_ = (TjipFormControlTextComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormControlTextComponent.scss?vue&type=style&index=0&id=6ca3bab5&scoped=true&lang=scss&
var TjipFormControlTextComponentvue_type_style_index_0_id_6ca3bab5_scoped_true_lang_scss_ = __webpack_require__("51cc");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormControlTextComponent.vue






/* normalize component */

var TjipFormControlTextComponent_component = normalizeComponent(
  text_TjipFormControlTextComponentvue_type_script_lang_ts_,
  TjipFormControlTextComponentvue_type_template_id_6ca3bab5_scoped_true_render,
  staticRenderFns,
  false,
  null,
  "6ca3bab5",
  null
  
)

/* harmony default export */ var text_TjipFormControlTextComponent = (TjipFormControlTextComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormControlTextComponent.ts









var TjipFormControlTextComponent_TjipFormControlTextComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlTextComponent, _Mixins);

  function TjipFormControlTextComponent() {
    _classCallCheck(this, TjipFormControlTextComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlTextComponent).apply(this, arguments));
  }

  return TjipFormControlTextComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin));

TjipFormControlTextComponent_TjipFormControlTextComponent = __decorate([vue_class_component_esm({})], TjipFormControlTextComponent_TjipFormControlTextComponent);

/* harmony default export */ var controls_text_TjipFormControlTextComponent = (TjipFormControlTextComponent_TjipFormControlTextComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/text/TjipFormGroupTextComponent.vue?vue&type=template&id=13a05323&scoped=true&
var TjipFormGroupTextComponentvue_type_template_id_13a05323_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-text",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-text',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete,"errorMode":_vm.errorMode,"controlWidth":_vm.controlWidth},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})]},proxy:true}],null,true)},[_vm._t("default")],2)}
var TjipFormGroupTextComponentvue_type_template_id_13a05323_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormGroupTextComponent.vue?vue&type=template&id=13a05323&scoped=true&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormGroupMixin.ts










var TjipFormGroupMixin_TjipFormGroupMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupMixin, _Mixins);

  function TjipFormGroupMixin() {
    _classCallCheck(this, TjipFormGroupMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupMixin).apply(this, arguments));
  }

  _createClass(TjipFormGroupMixin, [{
    key: "resolvedMessageLabel",
    get: function get() {
      return this.messageLabel || this.label || 'Veld';
    }
  }, {
    key: "forwardRefEventsSource",
    get: function get() {
      return 'control';
    }
  }, {
    key: "forwardRefEventsIsDomSource",
    get: function get() {
      return false;
    }
  }]);

  return TjipFormGroupMixin;
}(mixins(TjipForwardRefEventsMixin_TjipForwardRefEventsMixin));

__decorate([Prop()], TjipFormGroupMixin_TjipFormGroupMixin.prototype, "label", void 0);

__decorate([Prop()], TjipFormGroupMixin_TjipFormGroupMixin.prototype, "messageLabel", void 0);

__decorate([Prop()], TjipFormGroupMixin_TjipFormGroupMixin.prototype, "hideMessages", void 0);

__decorate([Prop()], TjipFormGroupMixin_TjipFormGroupMixin.prototype, "showSingleMessage", void 0);

TjipFormGroupMixin_TjipFormGroupMixin = __decorate([vue_class_component_esm], TjipFormGroupMixin_TjipFormGroupMixin);

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormGroupValueMixin.ts










var TjipFormGroupValueMixin_TjipFormGroupValueMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupValueMixin, _Mixins);

  function TjipFormGroupValueMixin() {
    _classCallCheck(this, TjipFormGroupValueMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupValueMixin).apply(this, arguments));
  }

  _createClass(TjipFormGroupValueMixin, [{
    key: "mounted",
    value: function mounted() {
      this.emitRawValueCallback = this.emitRawValue.bind(this);
      this.control.$on('rawValue', this.emitRawValueCallback);
      this.emitRawValue(this.control.internalValue);
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.control.$off('rawValue', this.emitRawValueCallback);
    }
  }, {
    key: "emitRawValue",
    value: function emitRawValue(value) {
      this.$emit('rawValue', value);
    }
  }, {
    key: "control",
    get: function get() {
      throw new Error('control property should be implemented by derived class');
    }
  }, {
    key: "internalValue",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      if (value !== this.value) {
        this.$emit('input', value);
      }
    }
  }]);

  return TjipFormGroupValueMixin;
}(mixins(TjipFormItemValueMixin_TjipFormItemValueMixin));

TjipFormGroupValueMixin_TjipFormGroupValueMixin = __decorate([vue_class_component_esm({
  validations: {}
})], TjipFormGroupValueMixin_TjipFormGroupValueMixin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/text/TjipFormGroupTextComponent.ts?vue&type=script&lang=ts&











var TjipFormGroupTextComponentvue_type_script_lang_ts_TjipFormGroupTextComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupTextComponent, _Mixins);

  function TjipFormGroupTextComponent() {
    _classCallCheck(this, TjipFormGroupTextComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupTextComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupTextComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupTextComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupTextComponentvue_type_script_lang_ts_TjipFormGroupTextComponent = __decorate([vue_class_component_esm({})], TjipFormGroupTextComponentvue_type_script_lang_ts_TjipFormGroupTextComponent);

/* harmony default export */ var TjipFormGroupTextComponentvue_type_script_lang_ts_ = (TjipFormGroupTextComponentvue_type_script_lang_ts_TjipFormGroupTextComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormGroupTextComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var text_TjipFormGroupTextComponentvue_type_script_lang_ts_ = (TjipFormGroupTextComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormGroupTextComponent.scss?vue&type=style&index=0&id=13a05323&scoped=true&lang=scss&
var TjipFormGroupTextComponentvue_type_style_index_0_id_13a05323_scoped_true_lang_scss_ = __webpack_require__("74c0");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormGroupTextComponent.vue






/* normalize component */

var TjipFormGroupTextComponent_component = normalizeComponent(
  text_TjipFormGroupTextComponentvue_type_script_lang_ts_,
  TjipFormGroupTextComponentvue_type_template_id_13a05323_scoped_true_render,
  TjipFormGroupTextComponentvue_type_template_id_13a05323_scoped_true_staticRenderFns,
  false,
  null,
  "13a05323",
  null
  
)

/* harmony default export */ var text_TjipFormGroupTextComponent = (TjipFormGroupTextComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/text/TjipFormGroupTextComponent.ts











var TjipFormGroupTextComponent_TjipFormGroupTextComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupTextComponent, _Mixins);

  function TjipFormGroupTextComponent() {
    _classCallCheck(this, TjipFormGroupTextComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupTextComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupTextComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupTextComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupTextComponent_TjipFormGroupTextComponent = __decorate([vue_class_component_esm({})], TjipFormGroupTextComponent_TjipFormGroupTextComponent);

/* harmony default export */ var controls_text_TjipFormGroupTextComponent = (TjipFormGroupTextComponent_TjipFormGroupTextComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/core/TjipFormGroupComponent.vue?vue&type=template&id=575f544e&
var TjipFormGroupComponentvue_type_template_id_575f544e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-group"},[_c('div',{staticClass:"form-group",class:{'has-error': _vm.showErrors, 'has-success': !_vm.hasErrors, 'disabled': _vm.disabled}},[_c('div',{staticClass:"row"},[_c('div',{class:_vm.labelClass},[_c('i',{staticStyle:{"display":"none"}},[_c('tjip-when-empty',{ref:"empty"},[_vm._t("tjip-form-label"),_vm._v("\n                        "+_vm._s(_vm.label)+"\n                    ")],2)],1),(_vm.hasLabel)?_c('label',{staticClass:"control-label",attrs:{"for":_vm.resolvedId}},[_c('tjip-when-empty',{scopedSlots:_vm._u([{key:"empty",fn:function(){return [_vm._v(_vm._s(_vm.label))]},proxy:true}],null,false,3151490147)},[_vm._t("tjip-form-label")],2)],1):_vm._e()]),_c('div',{class:_vm.controlClass},[_vm._t("tjip-form-control"),(!_vm.resolvedHideMessages)?_c('tjip-form-control-messages',{attrs:{"errors":_vm.errors,"errorMode":_vm.errorMode,"label":_vm.resolvedMessageLabel,"showSingleMessage":_vm.resolvedShowSingleMessage}},[_vm._t("default")],2):_vm._e()],2)])])])}
var TjipFormGroupComponentvue_type_template_id_575f544e_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormGroupComponent.vue?vue&type=template&id=575f544e&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/form/TjipFormHorizontalComponent.vue?vue&type=template&id=355ce998&scoped=true&
var TjipFormHorizontalComponentvue_type_template_id_355ce998_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"observe-visibility",rawName:"v-observe-visibility",value:(_vm.onVisibility),expression:"onVisibility"}],staticClass:"tjip-form-horizontal",class:{ 'form-horizontal': _vm.resolvedEnabled }},[_vm._t("default")],2)}
var TjipFormHorizontalComponentvue_type_template_id_355ce998_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFormHorizontalComponent.vue?vue&type=template&id=355ce998&scoped=true&

// EXTERNAL MODULE: ./node_modules/vue-observe-visibility/dist/vue-observe-visibility.esm.js
var vue_observe_visibility_esm = __webpack_require__("85fe");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/form/TjipFormHorizontalComponent.ts?vue&type=script&lang=ts&











var TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormHorizontalComponent, _Vue);

  function TjipFormHorizontalComponent() {
    var _this;

    _classCallCheck(this, TjipFormHorizontalComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormHorizontalComponent).apply(this, arguments));
    _this.resolvedEnabled = true;
    return _this;
  }

  _createClass(TjipFormHorizontalComponent, [{
    key: "onVisibility",
    value: function onVisibility(isVisible) {
      if (isVisible) {
        this.resolveEnabled();
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "updated",
    value: function updated() {
      this.resolveEnabled();
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.resolveEnabled();
    }
  }, {
    key: "resolveEnabled",
    value: function resolveEnabled() {
      this.resolvedEnabled = (lodash["isUndefined"](this.resolvedMinHorizontalWidth) || this.$el.offsetWidth >= this.resolvedMinHorizontalWidth) && (lodash["isUndefined"](this.enabled) || !!this.enabled);
    }
  }, {
    key: "resolveFormGroupAlign",
    value: function resolveFormGroupAlign(align) {
      return this.resolvedEnabled && align ? "text-".concat(align) : undefined;
    }
  }, {
    key: "resolvedLabelWidth",
    get: function get() {
      var w = this.labelWidth || 6;
      var result = w ? Math.max(Math.min(Math.round(w), 12), 1) : 12;
      return result;
    }
  }, {
    key: "controlWidth",
    get: function get() {
      var w = this.resolvedLabelWidth;
      return w >= 12 ? 12 : 12 - w;
    }
  }, {
    key: "labelClass",
    get: function get() {
      var align = this.resolveFormGroupAlign(this.labelAlign);
      var result = this.resolvedEnabled ? this.isAuto ? 'col' : "col-".concat(this.resolvedLabelWidth) : 'col-12';
      return align ? "".concat(result, " ").concat(align) : result;
    }
  }, {
    key: "controlClass",
    get: function get() {
      var align = this.resolveFormGroupAlign(this.controlAlign);
      var result = this.resolvedEnabled ? this.isAuto ? 'col-auto' : "col-".concat(this.controlWidth) : 'col-12';
      return align ? "".concat(result, " ").concat(align) : result;
    }
  }, {
    key: "isAuto",
    get: function get() {
      return this.labelWidth === 'auto';
    }
  }, {
    key: "resolvedMinHorizontalWidth",
    get: function get() {
      if (!this.minHorizontalWidth) {
        return 0;
      }

      var match = /^\s*([0-9]+)(em|px)?\s*$/.exec(this.minHorizontalWidth || '');

      if (match) {
        var size = parseInt(match[1], 10);

        if (match[2] === 'em') {
          size = size * parseFloat(window.getComputedStyle(this.$el).fontSize);
        }

        return size;
      } else {
        this.$log.error("Can not parse minHorizontalWidth '".concat(this.minHorizontalWidth, "'."));
        return 0;
      }
    }
  }]);

  return TjipFormHorizontalComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent.prototype, "enabled", void 0);

__decorate([Prop()], TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent.prototype, "labelWidth", void 0);

__decorate([Prop()], TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent.prototype, "minHorizontalWidth", void 0);

__decorate([Prop()], TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent.prototype, "labelAlign", void 0);

__decorate([Prop()], TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent.prototype, "controlAlign", void 0);

TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent = __decorate([vue_class_component_esm({
  directives: {
    'observe-visibility': vue_observe_visibility_esm["a" /* ObserveVisibility */]
  }
})], TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent);

/* harmony default export */ var TjipFormHorizontalComponentvue_type_script_lang_ts_ = (TjipFormHorizontalComponentvue_type_script_lang_ts_TjipFormHorizontalComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFormHorizontalComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var form_TjipFormHorizontalComponentvue_type_script_lang_ts_ = (TjipFormHorizontalComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/form/TjipFormHorizontalComponent.scss?vue&type=style&index=0&id=355ce998&scoped=true&lang=scss&
var TjipFormHorizontalComponentvue_type_style_index_0_id_355ce998_scoped_true_lang_scss_ = __webpack_require__("aac9");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/form/TjipFormHorizontalComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormHorizontalComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("ff21");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFormHorizontalComponent.vue







/* normalize component */

var TjipFormHorizontalComponent_component = normalizeComponent(
  form_TjipFormHorizontalComponentvue_type_script_lang_ts_,
  TjipFormHorizontalComponentvue_type_template_id_355ce998_scoped_true_render,
  TjipFormHorizontalComponentvue_type_template_id_355ce998_scoped_true_staticRenderFns,
  false,
  null,
  "355ce998",
  null
  
)

/* harmony default export */ var form_TjipFormHorizontalComponent = (TjipFormHorizontalComponent_component.exports);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/core/TjipFormGroupComponent.ts?vue&type=script&lang=ts&














var TjipFormGroupComponentvue_type_script_lang_ts_TjipFormGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupComponent, _Mixins);

  function TjipFormGroupComponent() {
    var _this;

    _classCallCheck(this, TjipFormGroupComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupComponent).apply(this, arguments));
    _this.hasLabel = true;
    _this.form = null;
    _this.formHorizontal = null;
    return _this;
  }

  _createClass(TjipFormGroupComponent, [{
    key: "mounted",
    value: function mounted() {
      this.form = this.getAncestor(form_TjipFormComponent);
      this.formHorizontal = this.getAncestor(form_TjipFormHorizontalComponent);
      this.whenEmpty = this.$refs.empty;
      this.whenEmpty.$on('hook:updated', this.resolveHasLabel.bind(this));
      this.resolveHasLabel();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.whenEmpty) {
        this.whenEmpty.$off('hook:updated', this.resolveHasLabel.bind(this));
      }
    }
  }, {
    key: "resolveHasLabel",
    value: function resolveHasLabel() {
      var hasLabel = !this.whenEmpty || !this.whenEmpty.isEmpty;

      if (this.hasLabel !== hasLabel) {
        this.hasLabel = hasLabel;
      }
    }
  }, {
    key: "labelClass",
    get: function get() {
      var col = this.formHorizontal && this.formHorizontal.labelClass || 'col-12';
      return "col-label ".concat(col);
    }
  }, {
    key: "controlClass",
    get: function get() {
      var col = this.formHorizontal && this.formHorizontal.controlClass || 'col-12';
      return "col-control ".concat(col);
    }
  }, {
    key: "submitted",
    get: function get() {
      return !!(this.form && this.form.submitted);
    }
  }, {
    key: "resolvedErrorMode",
    get: function get() {
      return this.errorMode || this.form && this.form.errorMode || 'touched';
    }
  }, {
    key: "resolvedHideMessages",
    get: function get() {
      return lodash["isUndefined"](this.hideMessages) ? this.form && this.form.hideFormGroupMessages || false : this.hideMessages;
    }
  }, {
    key: "resolvedShowSingleMessage",
    get: function get() {
      return lodash["isUndefined"](this.showSingleMessage) ? this.form && this.form.showSingleMessage || false : this.showSingleMessage;
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return !!(this.errors && this.errors.$invalid);
    }
  }, {
    key: "showErrors",
    get: function get() {
      if (this.hasErrors) {
        switch (this.resolvedErrorMode) {
          case 'touched':
            {
              return this.errors.$error || this.submitted;
            }

          case 'submit':
            {
              return this.submitted;
            }

          default:
            {
              return true;
            }
        }
      }

      return false;
    }
  }]);

  return TjipFormGroupComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormItemMixin_TjipFormItemMixin, TjipFormGroupMixin_TjipFormGroupMixin));

__decorate([Prop({
  required: true
})], TjipFormGroupComponentvue_type_script_lang_ts_TjipFormGroupComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormGroupComponentvue_type_script_lang_ts_TjipFormGroupComponent.prototype, "errorMode", void 0);

TjipFormGroupComponentvue_type_script_lang_ts_TjipFormGroupComponent = __decorate([vue_class_component_esm({})], TjipFormGroupComponentvue_type_script_lang_ts_TjipFormGroupComponent);

/* harmony default export */ var TjipFormGroupComponentvue_type_script_lang_ts_ = (TjipFormGroupComponentvue_type_script_lang_ts_TjipFormGroupComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormGroupComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var core_TjipFormGroupComponentvue_type_script_lang_ts_ = (TjipFormGroupComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormGroupComponent.global.scss?vue&type=style&index=0&lang=scss&
var TjipFormGroupComponent_globalvue_type_style_index_0_lang_scss_ = __webpack_require__("dd3f");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormGroupComponent.vue






/* normalize component */

var TjipFormGroupComponent_component = normalizeComponent(
  core_TjipFormGroupComponentvue_type_script_lang_ts_,
  TjipFormGroupComponentvue_type_template_id_575f544e_render,
  TjipFormGroupComponentvue_type_template_id_575f544e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var core_TjipFormGroupComponent = (TjipFormGroupComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormGroupComponent.ts














var TjipFormGroupComponent_TjipFormGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupComponent, _Mixins);

  function TjipFormGroupComponent() {
    var _this;

    _classCallCheck(this, TjipFormGroupComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupComponent).apply(this, arguments));
    _this.hasLabel = true;
    _this.form = null;
    _this.formHorizontal = null;
    return _this;
  }

  _createClass(TjipFormGroupComponent, [{
    key: "mounted",
    value: function mounted() {
      this.form = this.getAncestor(form_TjipFormComponent);
      this.formHorizontal = this.getAncestor(form_TjipFormHorizontalComponent);
      this.whenEmpty = this.$refs.empty;
      this.whenEmpty.$on('hook:updated', this.resolveHasLabel.bind(this));
      this.resolveHasLabel();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.whenEmpty) {
        this.whenEmpty.$off('hook:updated', this.resolveHasLabel.bind(this));
      }
    }
  }, {
    key: "resolveHasLabel",
    value: function resolveHasLabel() {
      var hasLabel = !this.whenEmpty || !this.whenEmpty.isEmpty;

      if (this.hasLabel !== hasLabel) {
        this.hasLabel = hasLabel;
      }
    }
  }, {
    key: "labelClass",
    get: function get() {
      var col = this.formHorizontal && this.formHorizontal.labelClass || 'col-12';
      return "col-label ".concat(col);
    }
  }, {
    key: "controlClass",
    get: function get() {
      var col = this.formHorizontal && this.formHorizontal.controlClass || 'col-12';
      return "col-control ".concat(col);
    }
  }, {
    key: "submitted",
    get: function get() {
      return !!(this.form && this.form.submitted);
    }
  }, {
    key: "resolvedErrorMode",
    get: function get() {
      return this.errorMode || this.form && this.form.errorMode || 'touched';
    }
  }, {
    key: "resolvedHideMessages",
    get: function get() {
      return lodash["isUndefined"](this.hideMessages) ? this.form && this.form.hideFormGroupMessages || false : this.hideMessages;
    }
  }, {
    key: "resolvedShowSingleMessage",
    get: function get() {
      return lodash["isUndefined"](this.showSingleMessage) ? this.form && this.form.showSingleMessage || false : this.showSingleMessage;
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return !!(this.errors && this.errors.$invalid);
    }
  }, {
    key: "showErrors",
    get: function get() {
      if (this.hasErrors) {
        switch (this.resolvedErrorMode) {
          case 'touched':
            {
              return this.errors.$error || this.submitted;
            }

          case 'submit':
            {
              return this.submitted;
            }

          default:
            {
              return true;
            }
        }
      }

      return false;
    }
  }]);

  return TjipFormGroupComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormItemMixin_TjipFormItemMixin, TjipFormGroupMixin_TjipFormGroupMixin));

__decorate([Prop({
  required: true
})], TjipFormGroupComponent_TjipFormGroupComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormGroupComponent_TjipFormGroupComponent.prototype, "errorMode", void 0);

TjipFormGroupComponent_TjipFormGroupComponent = __decorate([vue_class_component_esm({})], TjipFormGroupComponent_TjipFormGroupComponent);

/* harmony default export */ var controls_core_TjipFormGroupComponent = (TjipFormGroupComponent_TjipFormGroupComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxComponent.vue?vue&type=template&id=816ded66&scoped=true&
var TjipFormControlCheckboxComponentvue_type_template_id_816ded66_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-checkbox checkbox",class:{'has-error': _vm.showErrors, 'has-success': _vm.isValid}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],ref:"input",attrs:{"type":"checkbox","name":_vm.resolvedName,"id":_vm.resolvedId,"tabindex":_vm.tabindex,"disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.internalValue)?_vm._i(_vm.internalValue,null)>-1:(_vm.internalValue)},on:{"click":_vm.onClick,"change":function($event){var $$a=_vm.internalValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.internalValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.internalValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.internalValue=$$c}}}}),_c('label',{attrs:{"for":_vm.resolvedId}},[_c('tjip-when-empty',{scopedSlots:_vm._u([{key:"empty",fn:function(){return [_vm._v(_vm._s(_vm.label || ' '))]},proxy:true}])},[_vm._t("default")],2)],1)])}
var TjipFormControlCheckboxComponentvue_type_template_id_816ded66_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxComponent.vue?vue&type=template&id=816ded66&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxComponent.ts?vue&type=script&lang=ts&










var TjipFormControlCheckboxComponentvue_type_script_lang_ts_TjipFormControlCheckboxComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlCheckboxComponent, _Mixins);

  function TjipFormControlCheckboxComponent() {
    _classCallCheck(this, TjipFormControlCheckboxComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlCheckboxComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlCheckboxComponent, [{
    key: "onClick",
    value: function onClick() {
      if (this.$refs.input.checked) {
        this.$emit('checked');
      } else {
        this.$emit('unchecked');
      }
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      return value === this.trueValueResolved ? true : value === this.falseValueResolved ? false : undefined;
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      return {
        value: value ? this.trueValueResolved : this.falseValueResolved,
        revert: false,
        invalid: false
      };
    }
  }, {
    key: "trueValueResolved",
    get: function get() {
      return lodash["isUndefined"](this.trueValue) ? true : this.trueValue;
    }
  }, {
    key: "falseValueResolved",
    get: function get() {
      return lodash["isUndefined"](this.falseValue) ? false : this.falseValue;
    }
  }]);

  return TjipFormControlCheckboxComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin));

__decorate([Prop()], TjipFormControlCheckboxComponentvue_type_script_lang_ts_TjipFormControlCheckboxComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlCheckboxComponentvue_type_script_lang_ts_TjipFormControlCheckboxComponent.prototype, "trueValue", void 0);

__decorate([Prop()], TjipFormControlCheckboxComponentvue_type_script_lang_ts_TjipFormControlCheckboxComponent.prototype, "falseValue", void 0);

TjipFormControlCheckboxComponentvue_type_script_lang_ts_TjipFormControlCheckboxComponent = __decorate([vue_class_component_esm({})], TjipFormControlCheckboxComponentvue_type_script_lang_ts_TjipFormControlCheckboxComponent);

/* harmony default export */ var TjipFormControlCheckboxComponentvue_type_script_lang_ts_ = (TjipFormControlCheckboxComponentvue_type_script_lang_ts_TjipFormControlCheckboxComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var checkbox_TjipFormControlCheckboxComponentvue_type_script_lang_ts_ = (TjipFormControlCheckboxComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxComponent.scss?vue&type=style&index=0&id=816ded66&scoped=true&lang=scss&
var TjipFormControlCheckboxComponentvue_type_style_index_0_id_816ded66_scoped_true_lang_scss_ = __webpack_require__("fbff");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlCheckboxComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("5817");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxComponent.vue







/* normalize component */

var TjipFormControlCheckboxComponent_component = normalizeComponent(
  checkbox_TjipFormControlCheckboxComponentvue_type_script_lang_ts_,
  TjipFormControlCheckboxComponentvue_type_template_id_816ded66_scoped_true_render,
  TjipFormControlCheckboxComponentvue_type_template_id_816ded66_scoped_true_staticRenderFns,
  false,
  null,
  "816ded66",
  null
  
)

/* harmony default export */ var checkbox_TjipFormControlCheckboxComponent = (TjipFormControlCheckboxComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxComponent.ts










var TjipFormControlCheckboxComponent_TjipFormControlCheckboxComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlCheckboxComponent, _Mixins);

  function TjipFormControlCheckboxComponent() {
    _classCallCheck(this, TjipFormControlCheckboxComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlCheckboxComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlCheckboxComponent, [{
    key: "onClick",
    value: function onClick() {
      if (this.$refs.input.checked) {
        this.$emit('checked');
      } else {
        this.$emit('unchecked');
      }
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      return value === this.trueValueResolved ? true : value === this.falseValueResolved ? false : undefined;
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      return {
        value: value ? this.trueValueResolved : this.falseValueResolved,
        revert: false,
        invalid: false
      };
    }
  }, {
    key: "trueValueResolved",
    get: function get() {
      return lodash["isUndefined"](this.trueValue) ? true : this.trueValue;
    }
  }, {
    key: "falseValueResolved",
    get: function get() {
      return lodash["isUndefined"](this.falseValue) ? false : this.falseValue;
    }
  }]);

  return TjipFormControlCheckboxComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin));

__decorate([Prop()], TjipFormControlCheckboxComponent_TjipFormControlCheckboxComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlCheckboxComponent_TjipFormControlCheckboxComponent.prototype, "trueValue", void 0);

__decorate([Prop()], TjipFormControlCheckboxComponent_TjipFormControlCheckboxComponent.prototype, "falseValue", void 0);

TjipFormControlCheckboxComponent_TjipFormControlCheckboxComponent = __decorate([vue_class_component_esm({})], TjipFormControlCheckboxComponent_TjipFormControlCheckboxComponent);

/* harmony default export */ var controls_checkbox_TjipFormControlCheckboxComponent = (TjipFormControlCheckboxComponent_TjipFormControlCheckboxComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxComponent.vue?vue&type=template&id=5c37feca&scoped=true&
var TjipFormGroupCheckboxComponentvue_type_template_id_5c37feca_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-checkbox",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-checkbox',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.checkboxLabel,"tabindex":_vm.tabindex,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"trueValue":_vm.trueValue,"falseValue":_vm.falseValue},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})]},proxy:true}],null,true)},[_vm._t("default")],2)}
var TjipFormGroupCheckboxComponentvue_type_template_id_5c37feca_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxComponent.vue?vue&type=template&id=5c37feca&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxComponent.ts?vue&type=script&lang=ts&










var TjipFormGroupCheckboxComponentvue_type_script_lang_ts_TjipFormGroupCheckboxComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupCheckboxComponent, _Mixins);

  function TjipFormGroupCheckboxComponent() {
    _classCallCheck(this, TjipFormGroupCheckboxComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupCheckboxComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupCheckboxComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupCheckboxComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormGroupMixin_TjipFormGroupMixin));

__decorate([Prop()], TjipFormGroupCheckboxComponentvue_type_script_lang_ts_TjipFormGroupCheckboxComponent.prototype, "checkboxLabel", void 0);

__decorate([Prop()], TjipFormGroupCheckboxComponentvue_type_script_lang_ts_TjipFormGroupCheckboxComponent.prototype, "trueValue", void 0);

__decorate([Prop()], TjipFormGroupCheckboxComponentvue_type_script_lang_ts_TjipFormGroupCheckboxComponent.prototype, "falseValue", void 0);

TjipFormGroupCheckboxComponentvue_type_script_lang_ts_TjipFormGroupCheckboxComponent = __decorate([vue_class_component_esm({})], TjipFormGroupCheckboxComponentvue_type_script_lang_ts_TjipFormGroupCheckboxComponent);

/* harmony default export */ var TjipFormGroupCheckboxComponentvue_type_script_lang_ts_ = (TjipFormGroupCheckboxComponentvue_type_script_lang_ts_TjipFormGroupCheckboxComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var checkbox_TjipFormGroupCheckboxComponentvue_type_script_lang_ts_ = (TjipFormGroupCheckboxComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxComponent.scss?vue&type=style&index=0&id=5c37feca&scoped=true&lang=scss&
var TjipFormGroupCheckboxComponentvue_type_style_index_0_id_5c37feca_scoped_true_lang_scss_ = __webpack_require__("f26a");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxComponent.vue






/* normalize component */

var TjipFormGroupCheckboxComponent_component = normalizeComponent(
  checkbox_TjipFormGroupCheckboxComponentvue_type_script_lang_ts_,
  TjipFormGroupCheckboxComponentvue_type_template_id_5c37feca_scoped_true_render,
  TjipFormGroupCheckboxComponentvue_type_template_id_5c37feca_scoped_true_staticRenderFns,
  false,
  null,
  "5c37feca",
  null
  
)

/* harmony default export */ var checkbox_TjipFormGroupCheckboxComponent = (TjipFormGroupCheckboxComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxComponent.ts










var TjipFormGroupCheckboxComponent_TjipFormGroupCheckboxComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupCheckboxComponent, _Mixins);

  function TjipFormGroupCheckboxComponent() {
    _classCallCheck(this, TjipFormGroupCheckboxComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupCheckboxComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupCheckboxComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupCheckboxComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormGroupMixin_TjipFormGroupMixin));

__decorate([Prop()], TjipFormGroupCheckboxComponent_TjipFormGroupCheckboxComponent.prototype, "checkboxLabel", void 0);

__decorate([Prop()], TjipFormGroupCheckboxComponent_TjipFormGroupCheckboxComponent.prototype, "trueValue", void 0);

__decorate([Prop()], TjipFormGroupCheckboxComponent_TjipFormGroupCheckboxComponent.prototype, "falseValue", void 0);

TjipFormGroupCheckboxComponent_TjipFormGroupCheckboxComponent = __decorate([vue_class_component_esm({})], TjipFormGroupCheckboxComponent_TjipFormGroupCheckboxComponent);

/* harmony default export */ var controls_checkbox_TjipFormGroupCheckboxComponent = (TjipFormGroupCheckboxComponent_TjipFormGroupCheckboxComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxGroupComponent.vue?vue&type=template&id=299ed434&scoped=true&
var TjipFormControlCheckboxGroupComponentvue_type_template_id_299ed434_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-control-options',{staticClass:"tjip-form-control-checkbox-group",class:{'tjip-form-control-checkbox-group-vertical': _vm.alignVertical},attrs:{"name":_vm.name,"multiSelect":""},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var options = ref.options;
var selected = ref.selected;
var select = ref.select;
var unselect = ref.unselect;
return [_vm._l((options),function(option){return _c('tjip-form-control-checkbox',{key:option._uid,attrs:{"name":_vm.resolvedName,"ctrlId":_vm.resolvedId + option._uid,"itemValue":option.value,"value":option.selected,"tabindex":_vm.tabindex,"disabled":option.disabled},on:{"checked":function($event){return select(option)},"unchecked":function($event){return unselect(option)}}},[_c('tjip-form-control-option-content',{attrs:{"option":option}})],1)}),_vm._t("default")]}}],null,true),model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})}
var TjipFormControlCheckboxGroupComponentvue_type_template_id_299ed434_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxGroupComponent.vue?vue&type=template&id=299ed434&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxGroupComponent.ts?vue&type=script&lang=ts&








var TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_TjipFormControlCheckboxGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlCheckboxGroupComponent, _Mixins);

  function TjipFormControlCheckboxGroupComponent() {
    _classCallCheck(this, TjipFormControlCheckboxGroupComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlCheckboxGroupComponent).apply(this, arguments));
  }

  return TjipFormControlCheckboxGroupComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin));

__decorate([Prop()], TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_TjipFormControlCheckboxGroupComponent.prototype, "alignVertical", void 0);

TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_TjipFormControlCheckboxGroupComponent = __decorate([vue_class_component_esm({})], TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_TjipFormControlCheckboxGroupComponent);

/* harmony default export */ var TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_ = (TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_TjipFormControlCheckboxGroupComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxGroupComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var checkbox_TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_ = (TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxGroupComponent.scss?vue&type=style&index=0&id=299ed434&scoped=true&lang=scss&
var TjipFormControlCheckboxGroupComponentvue_type_style_index_0_id_299ed434_scoped_true_lang_scss_ = __webpack_require__("6574");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxGroupComponent.vue






/* normalize component */

var TjipFormControlCheckboxGroupComponent_component = normalizeComponent(
  checkbox_TjipFormControlCheckboxGroupComponentvue_type_script_lang_ts_,
  TjipFormControlCheckboxGroupComponentvue_type_template_id_299ed434_scoped_true_render,
  TjipFormControlCheckboxGroupComponentvue_type_template_id_299ed434_scoped_true_staticRenderFns,
  false,
  null,
  "299ed434",
  null
  
)

/* harmony default export */ var checkbox_TjipFormControlCheckboxGroupComponent = (TjipFormControlCheckboxGroupComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormControlCheckboxGroupComponent.ts








var TjipFormControlCheckboxGroupComponent_TjipFormControlCheckboxGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlCheckboxGroupComponent, _Mixins);

  function TjipFormControlCheckboxGroupComponent() {
    _classCallCheck(this, TjipFormControlCheckboxGroupComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlCheckboxGroupComponent).apply(this, arguments));
  }

  return TjipFormControlCheckboxGroupComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin));

__decorate([Prop()], TjipFormControlCheckboxGroupComponent_TjipFormControlCheckboxGroupComponent.prototype, "alignVertical", void 0);

TjipFormControlCheckboxGroupComponent_TjipFormControlCheckboxGroupComponent = __decorate([vue_class_component_esm({})], TjipFormControlCheckboxGroupComponent_TjipFormControlCheckboxGroupComponent);

/* harmony default export */ var controls_checkbox_TjipFormControlCheckboxGroupComponent = (TjipFormControlCheckboxGroupComponent_TjipFormControlCheckboxGroupComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxGroupComponent.vue?vue&type=template&id=7591312e&
var TjipFormGroupCheckboxGroupComponentvue_type_template_id_7591312e_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-checkbox-group",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-checkbox-group',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"tabindex":_vm.tabindex,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"alignVertical":_vm.alignVertical},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},[_vm._t("tjip-form-control-options")],2)]},proxy:true}],null,true)},[_vm._t("default")],2)}
var TjipFormGroupCheckboxGroupComponentvue_type_template_id_7591312e_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxGroupComponent.vue?vue&type=template&id=7591312e&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxGroupComponent.ts?vue&type=script&lang=ts&










var TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_TjipFormGroupCheckboxGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupCheckboxGroupComponent, _Mixins);

  function TjipFormGroupCheckboxGroupComponent() {
    _classCallCheck(this, TjipFormGroupCheckboxGroupComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupCheckboxGroupComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupCheckboxGroupComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupCheckboxGroupComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormGroupMixin_TjipFormGroupMixin));

__decorate([Prop()], TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_TjipFormGroupCheckboxGroupComponent.prototype, "alignVertical", void 0);

TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_TjipFormGroupCheckboxGroupComponent = __decorate([vue_class_component_esm({})], TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_TjipFormGroupCheckboxGroupComponent);

/* harmony default export */ var TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_ = (TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_TjipFormGroupCheckboxGroupComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxGroupComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var checkbox_TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_ = (TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxGroupComponent.global.scss?vue&type=style&index=0&lang=scss&
var TjipFormGroupCheckboxGroupComponent_globalvue_type_style_index_0_lang_scss_ = __webpack_require__("9db9");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxGroupComponent.vue






/* normalize component */

var TjipFormGroupCheckboxGroupComponent_component = normalizeComponent(
  checkbox_TjipFormGroupCheckboxGroupComponentvue_type_script_lang_ts_,
  TjipFormGroupCheckboxGroupComponentvue_type_template_id_7591312e_render,
  TjipFormGroupCheckboxGroupComponentvue_type_template_id_7591312e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var checkbox_TjipFormGroupCheckboxGroupComponent = (TjipFormGroupCheckboxGroupComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/checkbox/TjipFormGroupCheckboxGroupComponent.ts










var TjipFormGroupCheckboxGroupComponent_TjipFormGroupCheckboxGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupCheckboxGroupComponent, _Mixins);

  function TjipFormGroupCheckboxGroupComponent() {
    _classCallCheck(this, TjipFormGroupCheckboxGroupComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupCheckboxGroupComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupCheckboxGroupComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupCheckboxGroupComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormGroupMixin_TjipFormGroupMixin));

__decorate([Prop()], TjipFormGroupCheckboxGroupComponent_TjipFormGroupCheckboxGroupComponent.prototype, "alignVertical", void 0);

TjipFormGroupCheckboxGroupComponent_TjipFormGroupCheckboxGroupComponent = __decorate([vue_class_component_esm({})], TjipFormGroupCheckboxGroupComponent_TjipFormGroupCheckboxGroupComponent);

/* harmony default export */ var controls_checkbox_TjipFormGroupCheckboxGroupComponent = (TjipFormGroupCheckboxGroupComponent_TjipFormGroupCheckboxGroupComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/number/TjipFormGroupNumberComponent.vue?vue&type=template&id=34ad71b1&scoped=true&
var TjipFormGroupNumberComponentvue_type_template_id_34ad71b1_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-number",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-number',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete,"errorMode":_vm.errorMode,"controlWidth":_vm.controlWidth,"minimumFractionDigits":_vm.minimumFractionDigits,"maximumFractionDigits":_vm.maximumFractionDigits,"useGrouping":_vm.useGrouping,"alignLeft":_vm.alignLeft,"locale":_vm.locale},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})]},proxy:true}],null,true)},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet minimaal "+_vm._s(_vm._f("tjipNumber")(params.min,_vm.numberFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet groter dan "+_vm._s(_vm._f("tjipNumber")(params.min,_vm.numberFilterOptions))+" zijn.")]:_vm._e()]}}])}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" mag maximaal "+_vm._s(_vm._f("tjipNumber")(params.max,_vm.numberFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet kleiner dan "+_vm._s(_vm._f("tjipNumber")(params.max,_vm.numberFilterOptions))+" zijn.")]:_vm._e()]}}])})],2)}
var TjipFormGroupNumberComponentvue_type_template_id_34ad71b1_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormGroupNumberComponent.vue?vue&type=template&id=34ad71b1&scoped=true&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormItemNumberMixin.ts











var TjipFormItemNumberMixin_TjipFormItemNumberMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormItemNumberMixin, _Vue);

  function TjipFormItemNumberMixin() {
    var _this;

    _classCallCheck(this, TjipFormItemNumberMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemNumberMixin).apply(this, arguments));
    _this.defaultMinimumFractionDigits = 0;
    _this.defaultMaximumFractionDigits = 3;
    return _this;
  }

  _createClass(TjipFormItemNumberMixin, [{
    key: "resolvedMinimumFractionDigits",
    get: function get() {
      return !lodash["isUndefined"](this.minimumFractionDigits) ? this.minimumFractionDigits : !lodash["isUndefined"](this.maximumFractionDigits) ? Math.min(this.defaultMinimumFractionDigits, this.maximumFractionDigits) : this.defaultMinimumFractionDigits;
    }
  }, {
    key: "resolvedMaximumFractionDigits",
    get: function get() {
      return !lodash["isUndefined"](this.maximumFractionDigits) ? this.maximumFractionDigits : !lodash["isUndefined"](this.minimumFractionDigits) ? Math.max(this.defaultMaximumFractionDigits, this.minimumFractionDigits) : this.defaultMaximumFractionDigits;
    }
  }, {
    key: "numberFilterOptions",
    get: function get() {
      return {
        minimumFractionDigits: this.resolvedMinimumFractionDigits,
        maximumFractionDigits: this.resolvedMaximumFractionDigits,
        useGrouping: this.useGrouping,
        locale: this.locale
      };
    }
  }]);

  return TjipFormItemNumberMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormItemNumberMixin_TjipFormItemNumberMixin.prototype, "minimumFractionDigits", void 0);

__decorate([Prop()], TjipFormItemNumberMixin_TjipFormItemNumberMixin.prototype, "maximumFractionDigits", void 0);

__decorate([Prop()], TjipFormItemNumberMixin_TjipFormItemNumberMixin.prototype, "useGrouping", void 0);

__decorate([Prop()], TjipFormItemNumberMixin_TjipFormItemNumberMixin.prototype, "alignLeft", void 0);

__decorate([Prop()], TjipFormItemNumberMixin_TjipFormItemNumberMixin.prototype, "locale", void 0);

TjipFormItemNumberMixin_TjipFormItemNumberMixin = __decorate([vue_class_component_esm], TjipFormItemNumberMixin_TjipFormItemNumberMixin);

// EXTERNAL MODULE: external "moment"
var external_moment_ = __webpack_require__("c32d");
var external_moment_default = /*#__PURE__*/__webpack_require__.n(external_moment_);

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/filters/TjipMomentFilter.ts
// Vue.filter('capitalize', function (value) {
//     if (!value) return ''
//     value = value.toString()
//     return value.charAt(0).toUpperCase() + value.slice(1)
//   })

var moment = external_moment_default.a;

function tjipMomentFilter(value) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var locale = arguments.length > 2 ? arguments[2] : undefined;

  if (!value || value === '') {
    return '';
  }

  var m = moment(value);
  var loc = locale || m.locale();
  return m.isValid() ? m.locale(loc).format(format) : '';
}

/* harmony default export */ var TjipMomentFilter = (tjipMomentFilter);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/filters/TjipCurrencyFilter.ts






var defaultMinimumFractionDigits = 2;
var defaultMaximumFractionDigits = 2;

function filterUndefined(o) {
  var result = {};

  lodash["forEach"](o, function (v, k) {
    if (!lodash["isUndefined"](v)) {
      result[k] = v;
    }
  });

  return result;
}

function tjipCurrencyFilter(value, currency, currencyDisplay, minimumFractionDigits, maximumFractionDigits, locale) {
  if (lodash["isNil"](value)) {
    return '';
  }

  if (typeof value === 'number') {
    var options = arguments.length === 2 && typeof_typeof(currency) === 'object' ? lodash["omit"](currency, ['style']) : {
      currency: currency,
      currencyDisplay: currencyDisplay,
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
      locale: locale
    };

    if (options.currencyDisplay === 'none') {
      options.style = 'decimal';
      delete options.currencyDisplay;
    }

    var isInteger = lodash["includes"](['dash', 'dashes', 'zero'], options.decimalMode);

    var resolvedMinimumFractionDigits = isInteger ? 0 : !lodash["isUndefined"](options.minimumFractionDigits) ? options.minimumFractionDigits : !lodash["isUndefined"](options.maximumFractionDigits) ? Math.min(defaultMinimumFractionDigits, options.maximumFractionDigits) : defaultMinimumFractionDigits;
    var resolvedMaximumFractionDigits = isInteger ? 0 : !lodash["isUndefined"](options.maximumFractionDigits) ? options.maximumFractionDigits : !lodash["isUndefined"](options.minimumFractionDigits) ? Math.max(defaultMaximumFractionDigits, options.minimumFractionDigits) : defaultMaximumFractionDigits;
    options = Object.assign({
      style: 'currency',
      currency: 'EUR',
      currencyDisplay: 'symbol',
      useGrouping: true
    }, filterUndefined(options), {
      minimumFractionDigits: resolvedMinimumFractionDigits,
      maximumFractionDigits: resolvedMaximumFractionDigits
    }); // Use $root for i18n access
    // When routing previous pages are cached. When navigated back they are re-hydrated
    // However the $18n property is not restored !! (at least that's what I think happens)

    var vm = this.$root;
    var result = vm.$n(value, options);
    var resolvedLocale = options.locale || vm.$i18n && vm.$i18n.locale || 'en';
    var s = Intl.NumberFormat(resolvedLocale).format(1234.5);
    var decimalSeparator = s.substring(5, 6);

    switch (options.decimalMode) {
      case 'dash':
        return "".concat(result).concat(decimalSeparator, "-");

      case 'dashes':
        return "".concat(result).concat(decimalSeparator, "--");

      case 'zero':
        return "".concat(result).concat(decimalSeparator, "00");

      default:
        return result;
    }
  }

  return value;
}

/* harmony default export */ var TjipCurrencyFilter = (tjipCurrencyFilter);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/filters/TjipNumberFilter.ts




var TjipNumberFilter_defaultMinimumFractionDigits = 0;
var TjipNumberFilter_defaultMaximumFractionDigits = 3;

function TjipNumberFilter_filterUndefined(o) {
  var result = {};

  lodash["forEach"](o, function (v, k) {
    if (!lodash["isUndefined"](v)) {
      result[k] = v;
    }
  });

  return result;
}

function tjipNumberFilter(value, minimumFractionDigits, maximumFractionDigits, locale) {
  if (lodash["isNil"](value)) {
    return '';
  }

  if (typeof value === 'number') {
    var options = arguments.length === 2 && typeof_typeof(minimumFractionDigits) === 'object' ? lodash["omit"](minimumFractionDigits, ['style']) : {
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
      locale: locale
    };
    var resolvedMinimumFractionDigits = !lodash["isUndefined"](options.minimumFractionDigits) ? options.minimumFractionDigits : !lodash["isUndefined"](options.maximumFractionDigits) ? Math.min(TjipNumberFilter_defaultMinimumFractionDigits, options.maximumFractionDigits) : TjipNumberFilter_defaultMinimumFractionDigits;
    var resolvedMaximumFractionDigits = !lodash["isUndefined"](options.maximumFractionDigits) ? options.maximumFractionDigits : !lodash["isUndefined"](options.minimumFractionDigits) ? Math.max(TjipNumberFilter_defaultMaximumFractionDigits, options.minimumFractionDigits) : TjipNumberFilter_defaultMaximumFractionDigits;
    options = Object.assign({
      style: 'decimal',
      useGrouping: true
    }, TjipNumberFilter_filterUndefined(options), {
      minimumFractionDigits: resolvedMinimumFractionDigits,
      maximumFractionDigits: resolvedMaximumFractionDigits
    });
    return this.$root.$n(value, options);
  }

  return value;
}

/* harmony default export */ var TjipNumberFilter = (tjipNumberFilter);
// EXTERNAL MODULE: external "vue-i18n"
var external_vue_i18n_ = __webpack_require__("85b3");

// EXTERNAL MODULE: ./node_modules/move-decimal-point/index.js
var move_decimal_point = __webpack_require__("1aad");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/filters/TjipPercentFilter.ts






var moveDecimal = move_decimal_point;
var TjipPercentFilter_defaultMinimumFractionDigits = 0;
var TjipPercentFilter_defaultMaximumFractionDigits = 2;

function TjipPercentFilter_filterUndefined(o) {
  var result = {};

  lodash["forEach"](o, function (v, k) {
    if (!lodash["isUndefined"](v)) {
      result[k] = v;
    }
  });

  return result;
}

function tjipPercentFilter(value, minimumFractionDigits, maximumFractionDigits, baseValue, locale) {
  if (lodash["isNil"](value)) {
    return '';
  }

  if (typeof value === 'number') {
    var options = arguments.length === 2 && typeof_typeof(minimumFractionDigits) === 'object' ? lodash["omit"](minimumFractionDigits, ['style']) : {
      minimumFractionDigits: minimumFractionDigits,
      maximumFractionDigits: maximumFractionDigits,
      baseValue: baseValue,
      locale: locale
    };
    var resolvedMinimumFractionDigits = !lodash["isUndefined"](options.minimumFractionDigits) ? options.minimumFractionDigits : !lodash["isUndefined"](options.maximumFractionDigits) ? Math.min(TjipPercentFilter_defaultMinimumFractionDigits, options.maximumFractionDigits) : TjipPercentFilter_defaultMinimumFractionDigits;
    var resolvedMaximumFractionDigits = !lodash["isUndefined"](options.maximumFractionDigits) ? options.maximumFractionDigits : !lodash["isUndefined"](options.minimumFractionDigits) ? Math.max(TjipPercentFilter_defaultMaximumFractionDigits, options.minimumFractionDigits) : TjipPercentFilter_defaultMaximumFractionDigits;
    options = Object.assign({
      style: 'percent',
      baseValue: 1,
      useGrouping: true
    }, TjipPercentFilter_filterUndefined(options), {
      minimumFractionDigits: resolvedMinimumFractionDigits,
      maximumFractionDigits: resolvedMaximumFractionDigits
    });
    var decimalShift = options.baseValue === 100 ? -2 : 0;
    value = moveDecimal(value, decimalShift);
    var result = this.$root.$n(value, lodash["omit"](options, ['baseValue'])); // Vue.$log.debug(value, '->', result, options);

    return result;
  }

  return value;
}

/* harmony default export */ var TjipPercentFilter = (tjipPercentFilter);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/filters/TjipFiltersMixin.ts














var TjipFiltersMixin_TjipFiltersMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFiltersMixin, _Vue);

  function TjipFiltersMixin() {
    _classCallCheck(this, TjipFiltersMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFiltersMixin).apply(this, arguments));
  }

  _createClass(TjipFiltersMixin, [{
    key: "beforeCreate",
    value: function beforeCreate() {
      this.$options.filters = Object.assign({
        tjipCurrency: TjipCurrencyFilter.bind(this),
        tjipMoment: TjipMomentFilter.bind(this),
        tjipNumber: TjipNumberFilter.bind(this),
        tjipPercent: TjipPercentFilter.bind(this)
      }, this.$options.filters);
    }
  }]);

  return TjipFiltersMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

TjipFiltersMixin_TjipFiltersMixin = __decorate([vue_class_component_esm({})], TjipFiltersMixin_TjipFiltersMixin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/number/TjipFormGroupNumberComponent.ts?vue&type=script&lang=ts&













var TjipFormGroupNumberComponentvue_type_script_lang_ts_TjipFormGroupNumberComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupNumberComponent, _Mixins);

  function TjipFormGroupNumberComponent() {
    _classCallCheck(this, TjipFormGroupNumberComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupNumberComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupNumberComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupNumberComponent;
}(mixins(TjipFiltersMixin_TjipFiltersMixin, TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupNumberComponentvue_type_script_lang_ts_TjipFormGroupNumberComponent = __decorate([vue_class_component_esm({})], TjipFormGroupNumberComponentvue_type_script_lang_ts_TjipFormGroupNumberComponent);

/* harmony default export */ var TjipFormGroupNumberComponentvue_type_script_lang_ts_ = (TjipFormGroupNumberComponentvue_type_script_lang_ts_TjipFormGroupNumberComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormGroupNumberComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var number_TjipFormGroupNumberComponentvue_type_script_lang_ts_ = (TjipFormGroupNumberComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormGroupNumberComponent.scss?vue&type=style&index=0&id=34ad71b1&scoped=true&lang=scss&
var TjipFormGroupNumberComponentvue_type_style_index_0_id_34ad71b1_scoped_true_lang_scss_ = __webpack_require__("0a55");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormGroupNumberComponent.vue






/* normalize component */

var TjipFormGroupNumberComponent_component = normalizeComponent(
  number_TjipFormGroupNumberComponentvue_type_script_lang_ts_,
  TjipFormGroupNumberComponentvue_type_template_id_34ad71b1_scoped_true_render,
  TjipFormGroupNumberComponentvue_type_template_id_34ad71b1_scoped_true_staticRenderFns,
  false,
  null,
  "34ad71b1",
  null
  
)

/* harmony default export */ var number_TjipFormGroupNumberComponent = (TjipFormGroupNumberComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormGroupNumberComponent.ts













var TjipFormGroupNumberComponent_TjipFormGroupNumberComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupNumberComponent, _Mixins);

  function TjipFormGroupNumberComponent() {
    _classCallCheck(this, TjipFormGroupNumberComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupNumberComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupNumberComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupNumberComponent;
}(mixins(TjipFiltersMixin_TjipFiltersMixin, TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupNumberComponent_TjipFormGroupNumberComponent = __decorate([vue_class_component_esm({})], TjipFormGroupNumberComponent_TjipFormGroupNumberComponent);

/* harmony default export */ var controls_number_TjipFormGroupNumberComponent = (TjipFormGroupNumberComponent_TjipFormGroupNumberComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/number/TjipFormControlNumberComponent.vue?vue&type=template&id=6711509e&scoped=true&
var TjipFormControlNumberComponentvue_type_template_id_6711509e_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],ref:"input",staticClass:"tjip-form-control-number form-control",class:( _obj = {'align-left': _vm.alignLeft, 'has-error': _vm.showErrors, 'has-success': _vm.isValid}, _obj[_vm.controlWidthClass] = true, _obj ),attrs:{"type":"text","name":_vm.resolvedName,"id":_vm.resolvedId,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete},domProps:{"value":(_vm.internalValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.internalValue=$event.target.value}}})}
var TjipFormControlNumberComponentvue_type_template_id_6711509e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormControlNumberComponent.vue?vue&type=template&id=6711509e&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.match.js
var es6_regexp_match = __webpack_require__("4917");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.regexp.constructor.js
var es6_regexp_constructor = __webpack_require__("3b2b");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormControlNumberMixin.ts

















var TjipFormControlNumberMixin_TjipFormControlNumberMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlNumberMixin, _Mixins);

  function TjipFormControlNumberMixin() {
    var _this;

    _classCallCheck(this, TjipFormControlNumberMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlNumberMixin).apply(this, arguments));
    _this.isAllowedDecimal = false;
    return _this;
  }

  _createClass(TjipFormControlNumberMixin, [{
    key: "allowKey",
    value: function allowKey(key) {
      var allowedKeys = '1234567890';
      var minValidation = this.$v.min;

      if (lodash["isUndefined"](minValidation) || minValidation.min < 0) {
        allowedKeys += '-';
      } // if a locale's decimal separator is not a '.',
      // '.' is also allowed and converted to the proper separator
      // this allows the user to use the numeric keypad for decimal entry


      var allowedDecimals = ".".concat(this.decimalSeparator); // check

      this.isAllowedDecimal = this.allowedMaximumFractionDigits > 0 && (allowedDecimals.indexOf(key) >= 0 || // IE numpad
      key === 'Decimal' || key === 'Del');
      var insert = this.isAllowedDecimal ? key === ',' ? key : '.' : key;
      var result = (this.isAllowedDecimal || allowedKeys.indexOf(key) >= 0) && this.allowValue(this.newValue(insert)); // this.$log.debug(`'${key}': ${result}, ${this.$v.min}`);

      return result;
    }
  }, {
    key: "allowValue",
    value: function allowValue(value) {
      var decimalSep = this.decimalSeparator === '.' ? '\\.' : this.decimalSeparator;
      var thousandsSep = this.thousandsSeparator === '.' ? '\\.' : this.thousandsSeparator;
      var minValidation = this.$v.value && this.$v.value.$params && this.$v.value.$params.minValue;
      var negativeSign = lodash["isUndefined"](minValidation) || minValidation.min < 0 ? '-?' : '';
      var expr = "(?:\\d*|\\d{1,3}(".concat(thousandsSep, "\\d{3})*)"); // allow thousands separator to be used as decimal separator for locales where
      // decimal separator does not equal '.' (this allows use of NUM keypad)

      var allowedDecimalExpr = "\\d*\\.\\d{0,".concat(this.allowedMaximumFractionDigits, "}");

      if (this.allowedMaximumFractionDigits > 0) {
        expr = "".concat(expr, "(:?").concat(decimalSep, "\\d{0,").concat(this.allowedMaximumFractionDigits, "})?");

        if (this.decimalSeparator !== '.') {
          expr = "(?:".concat(expr, "|").concat(allowedDecimalExpr, ")");
        }
      }

      expr = "^".concat(negativeSign).concat(expr, "$");
      var regex = new RegExp(expr);
      var result = regex.test(value); // this.$log.debug(`allowValue '${value}': ${result}, ${regex.source}`);

      if (result && !this.isAllowedDecimal && this.decimalSeparator !== '.') {
        this.isAllowedDecimal = new RegExp(allowedDecimalExpr).test(value);
      }

      return result;
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      var result = typeof value === 'number' ? this.$n(value, this.formatOptions) : value; // this.$log.debug(value, typeof value, '->', result, this);

      return result;
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      return this.parseValueCore(value);
    }
  }, {
    key: "parseValueCore",
    value: function parseValueCore(value) {
      var val = value;

      if (!val) {
        return {
          value: undefined,
          revert: false,
          invalid: false
        };
      }

      if (this.isAllowedDecimal) {
        if (this.decimalSeparator !== '.') {
          var dotCnt = (val.match(/\./g) || []).length;

          if (dotCnt === 1) {
            val = val.replace('.', this.decimalSeparator);
          }
        }

        val = val.replace(this.thousandsSeparator, 'x').replace(this.decimalSeparator, '.');
      } else {
        val = val.replace(this.thousandsSeparator, '').replace(this.decimalSeparator, '.');
      }

      this.isAllowedDecimal = false;

      var noRevert = lodash["includes"](['.', '-', '-.'], val);

      var v = val - 0;
      var result = {
        value: noRevert ? 0 : v,
        revert: isNaN(v) && !noRevert,
        invalid: false
      };
      val = val.replace('.', this.decimalSeparator);

      if (!result.revert && value !== val) {
        result.viewValue = val;
      }

      return result;
    }
  }, {
    key: "numberFormat",
    get: function get() {
      return Intl.NumberFormat(this.resolvedLocale);
    }
  }, {
    key: "decimalSeparator",
    get: function get() {
      var s = Intl.NumberFormat(this.resolvedLocale).format(1234.5);
      return s.substring(5, 6);
    }
  }, {
    key: "thousandsSeparator",
    get: function get() {
      var s = Intl.NumberFormat(this.resolvedLocale).format(1234.5);
      return s.substring(1, 2);
    }
  }, {
    key: "allowedMaximumFractionDigits",
    get: function get() {
      return this.resolvedMaximumFractionDigits;
    }
  }, {
    key: "resolvedLocale",
    get: function get() {
      var i18n = this._i18n;
      var result = this.locale || i18n && i18n.locale || 'en';
      return result;
    }
  }, {
    key: "formatOptions",
    get: function get() {
      var result = {
        locale: this.resolvedLocale
      };
      result.minimumFractionDigits = this.resolvedMinimumFractionDigits;
      result.maximumFractionDigits = this.resolvedMaximumFractionDigits;

      if (!lodash["isUndefined"](this.useGrouping)) {
        result.useGrouping = this.useGrouping;
      }

      if (this.hasFocus) {
        result.useGrouping = false;
      }

      return result;
    }
  }]);

  return TjipFormControlNumberMixin;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin));

TjipFormControlNumberMixin_TjipFormControlNumberMixin = __decorate([vue_class_component_esm], TjipFormControlNumberMixin_TjipFormControlNumberMixin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/number/TjipFormControlNumberComponent.ts?vue&type=script&lang=ts&










var TjipFormControlNumberComponentvue_type_script_lang_ts_TjipFormControlNumberComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlNumberComponent, _Mixins);

  function TjipFormControlNumberComponent() {
    _classCallCheck(this, TjipFormControlNumberComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlNumberComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlNumberComponent, [{
    key: "mounted",
    value: function mounted() {
      this.defaultMaximumFractionDigits = this.numberFormat.resolvedOptions().maximumFractionDigits;
    }
  }, {
    key: "syntaxValidatorKey",
    get: function get() {
      return 'syntaxNumber';
    }
  }]);

  return TjipFormControlNumberComponent;
}(mixins(TjipFormControlNumberMixin_TjipFormControlNumberMixin, TjipFormItemTextMixin_TjipFormItemTextMixin));

TjipFormControlNumberComponentvue_type_script_lang_ts_TjipFormControlNumberComponent = __decorate([vue_class_component_esm({})], TjipFormControlNumberComponentvue_type_script_lang_ts_TjipFormControlNumberComponent);

/* harmony default export */ var TjipFormControlNumberComponentvue_type_script_lang_ts_ = (TjipFormControlNumberComponentvue_type_script_lang_ts_TjipFormControlNumberComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormControlNumberComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var number_TjipFormControlNumberComponentvue_type_script_lang_ts_ = (TjipFormControlNumberComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormControlNumberComponent.scss?vue&type=style&index=0&id=6711509e&scoped=true&lang=scss&
var TjipFormControlNumberComponentvue_type_style_index_0_id_6711509e_scoped_true_lang_scss_ = __webpack_require__("94bf");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormControlNumberComponent.vue






/* normalize component */

var TjipFormControlNumberComponent_component = normalizeComponent(
  number_TjipFormControlNumberComponentvue_type_script_lang_ts_,
  TjipFormControlNumberComponentvue_type_template_id_6711509e_scoped_true_render,
  TjipFormControlNumberComponentvue_type_template_id_6711509e_scoped_true_staticRenderFns,
  false,
  null,
  "6711509e",
  null
  
)

/* harmony default export */ var number_TjipFormControlNumberComponent = (TjipFormControlNumberComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/number/TjipFormControlNumberComponent.ts










var TjipFormControlNumberComponent_TjipFormControlNumberComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlNumberComponent, _Mixins);

  function TjipFormControlNumberComponent() {
    _classCallCheck(this, TjipFormControlNumberComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlNumberComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlNumberComponent, [{
    key: "mounted",
    value: function mounted() {
      this.defaultMaximumFractionDigits = this.numberFormat.resolvedOptions().maximumFractionDigits;
    }
  }, {
    key: "syntaxValidatorKey",
    get: function get() {
      return 'syntaxNumber';
    }
  }]);

  return TjipFormControlNumberComponent;
}(mixins(TjipFormControlNumberMixin_TjipFormControlNumberMixin, TjipFormItemTextMixin_TjipFormItemTextMixin));

TjipFormControlNumberComponent_TjipFormControlNumberComponent = __decorate([vue_class_component_esm({})], TjipFormControlNumberComponent_TjipFormControlNumberComponent);

/* harmony default export */ var controls_number_TjipFormControlNumberComponent = (TjipFormControlNumberComponent_TjipFormControlNumberComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/static-text/TjipFormControlStaticTextComponent.vue?vue&type=template&id=16f079cc&scoped=true&
var TjipFormControlStaticTextComponentvue_type_template_id_16f079cc_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-static-text",class:_vm.controlWidthClass,attrs:{"title":_vm.title}},[_c('tjip-when-empty',{scopedSlots:_vm._u([{key:"empty",fn:function(){return [_vm._v(_vm._s(_vm.title))]},proxy:true}])},[_vm._t("default")],2)],1)}
var TjipFormControlStaticTextComponentvue_type_template_id_16f079cc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormControlStaticTextComponent.vue?vue&type=template&id=16f079cc&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/static-text/TjipFormControlStaticTextComponent.ts?vue&type=script&lang=ts&









var TjipFormControlStaticTextComponentvue_type_script_lang_ts_TjipFormControlStaticTextComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormControlStaticTextComponent, _Vue);

  function TjipFormControlStaticTextComponent() {
    _classCallCheck(this, TjipFormControlStaticTextComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlStaticTextComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlStaticTextComponent, [{
    key: "controlWidthClass",
    get: function get() {
      var w = this.controlWidth || 'content';
      return "form-control-width-".concat(w);
    }
  }]);

  return TjipFormControlStaticTextComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormControlStaticTextComponentvue_type_script_lang_ts_TjipFormControlStaticTextComponent.prototype, "title", void 0);

__decorate([Prop()], TjipFormControlStaticTextComponentvue_type_script_lang_ts_TjipFormControlStaticTextComponent.prototype, "controlWidth", void 0);

TjipFormControlStaticTextComponentvue_type_script_lang_ts_TjipFormControlStaticTextComponent = __decorate([vue_class_component_esm({})], TjipFormControlStaticTextComponentvue_type_script_lang_ts_TjipFormControlStaticTextComponent);

/* harmony default export */ var TjipFormControlStaticTextComponentvue_type_script_lang_ts_ = (TjipFormControlStaticTextComponentvue_type_script_lang_ts_TjipFormControlStaticTextComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormControlStaticTextComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var static_text_TjipFormControlStaticTextComponentvue_type_script_lang_ts_ = (TjipFormControlStaticTextComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormControlStaticTextComponent.scss?vue&type=style&index=0&id=16f079cc&scoped=true&lang=scss&
var TjipFormControlStaticTextComponentvue_type_style_index_0_id_16f079cc_scoped_true_lang_scss_ = __webpack_require__("ea4c");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormControlStaticTextComponent.vue






/* normalize component */

var TjipFormControlStaticTextComponent_component = normalizeComponent(
  static_text_TjipFormControlStaticTextComponentvue_type_script_lang_ts_,
  TjipFormControlStaticTextComponentvue_type_template_id_16f079cc_scoped_true_render,
  TjipFormControlStaticTextComponentvue_type_template_id_16f079cc_scoped_true_staticRenderFns,
  false,
  null,
  "16f079cc",
  null
  
)

/* harmony default export */ var static_text_TjipFormControlStaticTextComponent = (TjipFormControlStaticTextComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormControlStaticTextComponent.ts









var TjipFormControlStaticTextComponent_TjipFormControlStaticTextComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormControlStaticTextComponent, _Vue);

  function TjipFormControlStaticTextComponent() {
    _classCallCheck(this, TjipFormControlStaticTextComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlStaticTextComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlStaticTextComponent, [{
    key: "controlWidthClass",
    get: function get() {
      var w = this.controlWidth || 'content';
      return "form-control-width-".concat(w);
    }
  }]);

  return TjipFormControlStaticTextComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormControlStaticTextComponent_TjipFormControlStaticTextComponent.prototype, "title", void 0);

__decorate([Prop()], TjipFormControlStaticTextComponent_TjipFormControlStaticTextComponent.prototype, "controlWidth", void 0);

TjipFormControlStaticTextComponent_TjipFormControlStaticTextComponent = __decorate([vue_class_component_esm({})], TjipFormControlStaticTextComponent_TjipFormControlStaticTextComponent);

/* harmony default export */ var controls_static_text_TjipFormControlStaticTextComponent = (TjipFormControlStaticTextComponent_TjipFormControlStaticTextComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/static-text/TjipFormGroupStaticTextComponent.vue?vue&type=template&id=60c2ff00&scoped=true&
var TjipFormGroupStaticTextComponentvue_type_template_id_60c2ff00_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-static-text",attrs:{"name":"static","label":_vm.label,"errors":undefined},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-static-text',{attrs:{"title":_vm.title,"controlWidth":_vm.controlWidth}},[_vm._t("default")],2)]},proxy:true}],null,true)})}
var TjipFormGroupStaticTextComponentvue_type_template_id_60c2ff00_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormGroupStaticTextComponent.vue?vue&type=template&id=60c2ff00&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/static-text/TjipFormGroupStaticTextComponent.ts?vue&type=script&lang=ts&








var TjipFormGroupStaticTextComponentvue_type_script_lang_ts_TjipFormGroupStaticTextComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormGroupStaticTextComponent, _Vue);

  function TjipFormGroupStaticTextComponent() {
    _classCallCheck(this, TjipFormGroupStaticTextComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupStaticTextComponent).apply(this, arguments));
  }

  return TjipFormGroupStaticTextComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormGroupStaticTextComponentvue_type_script_lang_ts_TjipFormGroupStaticTextComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormGroupStaticTextComponentvue_type_script_lang_ts_TjipFormGroupStaticTextComponent.prototype, "title", void 0);

__decorate([Prop()], TjipFormGroupStaticTextComponentvue_type_script_lang_ts_TjipFormGroupStaticTextComponent.prototype, "controlWidth", void 0);

TjipFormGroupStaticTextComponentvue_type_script_lang_ts_TjipFormGroupStaticTextComponent = __decorate([vue_class_component_esm({})], TjipFormGroupStaticTextComponentvue_type_script_lang_ts_TjipFormGroupStaticTextComponent);

/* harmony default export */ var TjipFormGroupStaticTextComponentvue_type_script_lang_ts_ = (TjipFormGroupStaticTextComponentvue_type_script_lang_ts_TjipFormGroupStaticTextComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormGroupStaticTextComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var static_text_TjipFormGroupStaticTextComponentvue_type_script_lang_ts_ = (TjipFormGroupStaticTextComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormGroupStaticTextComponent.scss?vue&type=style&index=0&id=60c2ff00&scoped=true&lang=scss&
var TjipFormGroupStaticTextComponentvue_type_style_index_0_id_60c2ff00_scoped_true_lang_scss_ = __webpack_require__("bbf5");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormGroupStaticTextComponent.vue






/* normalize component */

var TjipFormGroupStaticTextComponent_component = normalizeComponent(
  static_text_TjipFormGroupStaticTextComponentvue_type_script_lang_ts_,
  TjipFormGroupStaticTextComponentvue_type_template_id_60c2ff00_scoped_true_render,
  TjipFormGroupStaticTextComponentvue_type_template_id_60c2ff00_scoped_true_staticRenderFns,
  false,
  null,
  "60c2ff00",
  null
  
)

/* harmony default export */ var static_text_TjipFormGroupStaticTextComponent = (TjipFormGroupStaticTextComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/static-text/TjipFormGroupStaticTextComponent.ts








var TjipFormGroupStaticTextComponent_TjipFormGroupStaticTextComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormGroupStaticTextComponent, _Vue);

  function TjipFormGroupStaticTextComponent() {
    _classCallCheck(this, TjipFormGroupStaticTextComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupStaticTextComponent).apply(this, arguments));
  }

  return TjipFormGroupStaticTextComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormGroupStaticTextComponent_TjipFormGroupStaticTextComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormGroupStaticTextComponent_TjipFormGroupStaticTextComponent.prototype, "title", void 0);

__decorate([Prop()], TjipFormGroupStaticTextComponent_TjipFormGroupStaticTextComponent.prototype, "controlWidth", void 0);

TjipFormGroupStaticTextComponent_TjipFormGroupStaticTextComponent = __decorate([vue_class_component_esm({})], TjipFormGroupStaticTextComponent_TjipFormGroupStaticTextComponent);

/* harmony default export */ var controls_static_text_TjipFormGroupStaticTextComponent = (TjipFormGroupStaticTextComponent_TjipFormGroupStaticTextComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/dropdown/TjipFormControlDropdownComponent.vue?vue&type=template&id=4b02f81c&scoped=true&
var TjipFormControlDropdownComponentvue_type_template_id_4b02f81c_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-control-options',{staticClass:"tjip-form-control-dropdown form-control",class:( _obj = {
        'has-error': _vm.showErrors,
        'has-success': _vm.isValid,
        'focus-within': _vm.hasFocusWithin }, _obj[_vm.controlWidthClass] = true, _obj ),attrs:{"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var options = ref.options;
        var selected = ref.selected;
return [_c('b-dropdown',{ref:"dropdown",attrs:{"split":_vm.splitButton,"disabled":_vm.disabled,"dropup":_vm.dropUp,"dropleft":_vm.dropLeft,"dropright":_vm.dropRight,"no-flip":_vm.noFlip,"variant":"outline-base"},scopedSlots:_vm._u([{key:"button-content",fn:function(){return [_c('div',{staticClass:"dropdown-caption"},[_c('tjip-when-empty',{scopedSlots:_vm._u([{key:"empty",fn:function(){return [_vm._v(_vm._s(_vm.resolvedPlaceholder))]},proxy:true}],null,true)},[_c('tjip-form-control-option-content',{attrs:{"option":selected,"slotName":"button-display"}})],1)],1)]},proxy:true}],null,true)},_vm._l((options),function(option){return _c('b-dropdown-item',{key:option._uid,attrs:{"active":option.selected,"disabled":option.disabled},on:{"click":function($event){return option.select($event)}}},[_c('tjip-form-control-option-content',{attrs:{"option":option}})],1)}),1),_vm._t("default")]}}],null,true),model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})}
var TjipFormControlDropdownComponentvue_type_template_id_4b02f81c_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormControlDropdownComponent.vue?vue&type=template&id=4b02f81c&scoped=true&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormItemDropdownMixin.ts









var TjipFormItemDropdownMixin_TjipFormItemDropdownMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormItemDropdownMixin, _Vue);

  function TjipFormItemDropdownMixin() {
    _classCallCheck(this, TjipFormItemDropdownMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemDropdownMixin).apply(this, arguments));
  }

  return TjipFormItemDropdownMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormItemDropdownMixin_TjipFormItemDropdownMixin.prototype, "placeholder", void 0);

__decorate([Prop()], TjipFormItemDropdownMixin_TjipFormItemDropdownMixin.prototype, "splitButton", void 0);

__decorate([Prop()], TjipFormItemDropdownMixin_TjipFormItemDropdownMixin.prototype, "noFlip", void 0);

__decorate([Prop()], TjipFormItemDropdownMixin_TjipFormItemDropdownMixin.prototype, "dropUp", void 0);

__decorate([Prop()], TjipFormItemDropdownMixin_TjipFormItemDropdownMixin.prototype, "dropLeft", void 0);

__decorate([Prop()], TjipFormItemDropdownMixin_TjipFormItemDropdownMixin.prototype, "dropRight", void 0);

TjipFormItemDropdownMixin_TjipFormItemDropdownMixin = __decorate([vue_class_component_esm], TjipFormItemDropdownMixin_TjipFormItemDropdownMixin);

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/form/TjipInitialFocusComponent.vue?vue&type=template&id=4585cd70&
var TjipInitialFocusComponentvue_type_template_id_4585cd70_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-initial-focus"},[_vm._t("default")],2)}
var TjipInitialFocusComponentvue_type_template_id_4585cd70_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipInitialFocusComponent.vue?vue&type=template&id=4585cd70&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFocusableItem.ts



var TjipFocusableItem_TjipFocusableItem =
/*#__PURE__*/
function () {
  function TjipFocusableItem(element) {
    _classCallCheck(this, TjipFocusableItem);

    this.element = element;
  }

  _createClass(TjipFocusableItem, [{
    key: "isVisible",
    value: function isVisible() {
      return !!(this.element.offsetWidth || this.element.offsetHeight || this.element.getClientRects().length);
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      return this.element.disabled;
    }
  }, {
    key: "isTabStop",
    value: function isTabStop() {
      var tabindex = this.element.getAttribute('tabindex');
      return !tabindex || parseInt(tabindex, 10) >= 0;
    }
  }, {
    key: "canFocus",
    value: function canFocus() {
      return !this.isDisabled() && this.isVisible() && this.isTabStop();
    }
  }, {
    key: "isCheckedRadio",
    value: function isCheckedRadio(radio) {
      return this.element.name === radio.element.name && this.element.checked;
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.canFocus()) {
        this.element.focus();

        if (this.isAnyText) {
          this.element.select();
        }
      }
    }
  }, {
    key: "isRadio",
    get: function get() {
      return this.element.type === 'radio';
    }
  }, {
    key: "isFile",
    get: function get() {
      return this.element.type === 'file';
    }
  }, {
    key: "isText",
    get: function get() {
      return this.element.type === 'text';
    }
  }, {
    key: "isPassword",
    get: function get() {
      return this.element.type === 'password';
    }
  }, {
    key: "isAnyText",
    get: function get() {
      return this.isFile || this.isText || this.isPassword;
    }
  }]);

  return TjipFocusableItem;
}();
// EXTERNAL MODULE: ./node_modules/mobile-device-detect/dist/index.js
var dist = __webpack_require__("9029");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/tjipFocusService.ts











var tjipFocusService_TjipFocusService =
/*#__PURE__*/
function () {
  function TjipFocusService() {
    _classCallCheck(this, TjipFocusService);

    this.initWatchFocusWithinDone = false;
    this.focusWithinWatches = [];
  }

  _createClass(TjipFocusService, [{
    key: "focus",
    value: function focus(nativeElement) {
      var focusMobileInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var items = this.selfFocusableItem(nativeElement) || this.getFocusableItems(nativeElement);
      return this.focusFirstItem(items, focusMobileInput);
    }
  }, {
    key: "watchFocusWithin",
    value: function watchFocusWithin(nativeElement, cb) {
      var _this = this;

      this.initWatchFocusWithin();
      var data = {
        target: nativeElement,
        cb: cb,
        focused: false
      };
      this.focusWithinWatches.push(data);

      var result = function result() {
        lodash["remove"](_this.focusWithinWatches, data);
      };

      return result;
    }
  }, {
    key: "initWatchFocusWithin",
    value: function initWatchFocusWithin() {
      if (this.initWatchFocusWithinDone) {
        return;
      }

      window.document.body.addEventListener('focus', this.onFocus.bind(this), {
        capture: true
      });
      window.document.body.addEventListener('blur', this.onBlur.bind(this), {
        capture: true
      });
      this.initWatchFocusWithinDone = true;
    }
  }, {
    key: "onFocus",
    value: function onFocus(e) {
      var _this2 = this;

      lodash["forEach"](this.focusWithinWatches, function (w) {
        if (!w.focused && _this2.isAncestor(w.target, e.srcElement)) {
          w.focused = true;
          w.cb(w.focused, e);
        }
      });
    }
  }, {
    key: "onBlur",
    value: function onBlur(e) {
      var _this3 = this;

      lodash["forEach"](this.focusWithinWatches, function (w) {
        if (w.focused && _this3.isAncestor(w.target, e.srcElement)) {
          w.focused = false;
          w.cb(w.focused, e);
        }
      });
    }
  }, {
    key: "isAncestor",
    value: function isAncestor(target, descendant) {
      var cur = descendant;

      while (cur) {
        if (cur === target) {
          return true;
        }

        cur = cur.parentElement;
      }

      return false;
    }
  }, {
    key: "getFocusableItems",
    value: function getFocusableItems(nativeElement) {
      var result = [];
      var elms = nativeElement.querySelectorAll('input,textarea,select,a,button');

      if (elms) {
        lodash["forEach"](elms, function (e) {
          var item = new TjipFocusableItem_TjipFocusableItem(e);

          if (item.canFocus()) {
            result.push(item);
          }
        });
      }

      return result;
    }
  }, {
    key: "focusFirstItem",
    value: function focusFirstItem(items) {
      var focusMobileInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (items.length) {
        // @types/lodash.sortBy not up to date !!
        items = lodash["sortBy"](items, [function (i) {
          // tslint:disable-next-line:no-string-literal
          return parseInt(i['element'].getAttribute('tabindex') || '0', 10);
        }]);
        var focusItem = items[0];

        if (focusItem.isRadio) {
          focusItem = lodash["find"](items, function (item) {
            return item.isCheckedRadio(focusItem);
          }) || focusItem;
        }

        return Promise.resolve().then(function () {
          // Vue.$log.debug('Focus', focusItem, items);
          if (focusMobileInput || !focusItem.isAnyText || !dist["isMobile"]) {
            focusItem.focus();
            return true;
          }

          return false;
        });
      }

      return Promise.resolve(false);
    }
  }, {
    key: "selfFocusableItem",
    value: function selfFocusableItem(nativeElement) {
      var result;

      if (lodash["includes"](['INPUT', 'TEXTAREA', 'SELECT', 'A', 'BUTTON'], nativeElement.tagName)) {
        result = [];
        var item = new TjipFocusableItem_TjipFocusableItem(nativeElement);

        if (item.canFocus()) {
          result.push(item);
        }
      }

      return result;
    }
  }]);

  return TjipFocusService;
}();

var tjipFocusService = new tjipFocusService_TjipFocusService();
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/tjipRouterService.ts



var tjipRouterService_TjipRouterService =
/*#__PURE__*/
function () {
  function TjipRouterService() {
    _classCallCheck(this, TjipRouterService);
  }

  _createClass(TjipRouterService, [{
    key: "fixHashRoutes",
    value: function fixHashRoutes(router) {
      var _this = this;

      var result = !!router._tjipHashRoutesFixed;

      if (!result) {
        router.afterEach(this.onRouteChanged.bind(this));
        router._tjipHashRoutesFixed = true;
        setTimeout(function () {
          _this.scrollHash(router.currentRoute.hash);
        });
      }

      return result;
    }
  }, {
    key: "onRouteChanged",
    value: function onRouteChanged(to, from) {
      this.scrollHash(to.hash);
    }
  }, {
    key: "scrollHash",
    value: function scrollHash(hash) {
      if (hash) {
        var el = document.getElementById(hash.slice(1));

        if (el) {
          window.scrollTo(0, this.getHashTop(el));
        }
      }
    }
  }, {
    key: "getHashTop",
    value: function getHashTop(el) {
      var result = 0;
      var cur = el;

      while (cur) {
        result += cur.offsetTop || 0;
        cur = cur.offsetParent;
      }

      return result;
    }
  }]);

  return TjipRouterService;
}();

var tjipRouterService = new tjipRouterService_TjipRouterService();
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/form/TjipInitialFocusComponent.ts?vue&type=script&lang=ts&











var TjipInitialFocusComponentvue_type_script_lang_ts_TjipInitialFocusComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipInitialFocusComponent, _Vue);

  function TjipInitialFocusComponent() {
    _classCallCheck(this, TjipInitialFocusComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipInitialFocusComponent).apply(this, arguments));
  }

  _createClass(TjipInitialFocusComponent, [{
    key: "focus",
    value: function focus() {
      var _this = this;

      var samePage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Give radio-group time to render
      setTimeout(function () {
        if (!_this.ignoreRouteHash && _this.$route.hash) {
          var el = _this.$el.querySelector(_this.$route.hash);

          if (el) {
            tjipFocusService.focus(el, _this.focusMobileInput);
          }
        } else {
          tjipFocusService.focus(_this.$el, _this.focusMobileInput);
        }
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      tjipRouterService.fixHashRoutes(this.$router);
      this.focus();
      document.body.addEventListener('click', this.onClick.bind(this), true);
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      if (this.$route && this.$route.hash) {
        var src = event.srcElement;

        if (src) {
          // // test if the link to the current url hash is clicked, in that case re-focus
          // // as it will not generate a route changed event
          var lnk = src.closest('a.router-link-exact-active');

          if (lnk) {
            this.focus();
          }
        }
      }
    }
  }, {
    key: "onRouteChanged",
    value: function onRouteChanged(to, from) {
      this.focus();
    }
  }]);

  return TjipInitialFocusComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  default: false
})], TjipInitialFocusComponentvue_type_script_lang_ts_TjipInitialFocusComponent.prototype, "focusMobileInput", void 0);

__decorate([Prop({
  default: false
})], TjipInitialFocusComponentvue_type_script_lang_ts_TjipInitialFocusComponent.prototype, "ignoreRouteHash", void 0);

__decorate([Watch('$route')], TjipInitialFocusComponentvue_type_script_lang_ts_TjipInitialFocusComponent.prototype, "onRouteChanged", null);

TjipInitialFocusComponentvue_type_script_lang_ts_TjipInitialFocusComponent = __decorate([vue_class_component_esm({})], TjipInitialFocusComponentvue_type_script_lang_ts_TjipInitialFocusComponent);

/* harmony default export */ var TjipInitialFocusComponentvue_type_script_lang_ts_ = (TjipInitialFocusComponentvue_type_script_lang_ts_TjipInitialFocusComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipInitialFocusComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var form_TjipInitialFocusComponentvue_type_script_lang_ts_ = (TjipInitialFocusComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipInitialFocusComponent.vue





/* normalize component */

var TjipInitialFocusComponent_component = normalizeComponent(
  form_TjipInitialFocusComponentvue_type_script_lang_ts_,
  TjipInitialFocusComponentvue_type_template_id_4585cd70_render,
  TjipInitialFocusComponentvue_type_template_id_4585cd70_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var form_TjipInitialFocusComponent = (TjipInitialFocusComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFormComponent.ts








var TjipFormComponent_TjipFormComponent_1;





var TjipFormComponent_TjipFormComponent = TjipFormComponent_TjipFormComponent_1 =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormComponent, _Vue);

  function TjipFormComponent() {
    var _this;

    _classCallCheck(this, TjipFormComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormComponent).apply(this, arguments));
    _this.name = undefined;
    _this.isValid = true;
    _this.formSubmitted = false;
    return _this;
  }

  _createClass(TjipFormComponent, [{
    key: "submit",
    value: function submit() {
      this.onSubmit(new Event('submit'));
    }
  }, {
    key: "onSubmit",
    value: function onSubmit(event) {
      this.formSubmitted = true;

      if (this.errors) {
        this.touch();

        if (!this.isValid) {
          event.stopImmediatePropagation();
          event.preventDefault();
          this.$log.info('ERRORS; no submit', this.errors);
          return false;
        }
      }

      this.$emit('tjipSubmit', event);
      return true;
    }
  }, {
    key: "onKeypress",
    value: function onKeypress(event) {
      var key = event.key || String.fromCharCode(event.keyCode || event.charCode || event.which);

      if (key === 'Enter' && this.preventSubmitOnEnter) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    }
  }, {
    key: "touch",
    value: function touch() {
      this.errors.$touch();
      TjipFormComponent_TjipFormComponent_1.touchRecursive(this);
    }
  }, {
    key: "reset",
    value: function reset() {
      this.formSubmitted = false;
      this.errors.$reset();
      TjipFormComponent_TjipFormComponent_1.resetRecursive(this);
    }
  }, {
    key: "onReset",
    value: function onReset(event) {
      this.reset(); // user should reset data in tjipReset event handler

      this.$emit('tjipReset', event); // prevent the default form reset behavior (clearing fields, breaks binding)

      event.stopImmediatePropagation();
      event.preventDefault();
      return false;
    }
  }, {
    key: "watchErrors",
    value: function watchErrors() {
      var _this2 = this;

      Promise.resolve().then(function () {
        _this2.isValid = _this2.getIsValid(_this2);
      });
    }
  }, {
    key: "getIsValid",
    value: function getIsValid(comp) {
      var _this3 = this;

      var result = comp.$v ? !comp.$v.$invalid : true;

      if (result) {
        if (comp.$children) {
          result = !lodash["find"](comp.$children, function (c) {
            return !_this3.getIsValid(c);
          });
        }
      }

      return result;
    }
  }, {
    key: "submitted",
    get: function get() {
      return this.formSubmitted;
    }
  }], [{
    key: "touchRecursive",
    value: function touchRecursive(comp) {
      if (comp.$v) {
        comp.$v.$touch();
      }

      if (comp.$children) {
        lodash["forEach"](comp.$children, function (child) {
          TjipFormComponent_TjipFormComponent_1.touchRecursive(child);
        });
      }
    }
  }, {
    key: "resetRecursive",
    value: function resetRecursive(comp) {
      if (comp.$v) {
        comp.$v.$reset();
      }

      if (comp.$children) {
        lodash["forEach"](comp.$children, function (child) {
          TjipFormComponent_TjipFormComponent_1.resetRecursive(child);
        });
      }
    }
  }]);

  return TjipFormComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormComponent_TjipFormComponent.prototype, "name", void 0);

__decorate([Prop()], TjipFormComponent_TjipFormComponent.prototype, "errorMode", void 0);

__decorate([Prop()], TjipFormComponent_TjipFormComponent.prototype, "hideFormGroupMessages", void 0);

__decorate([Prop()], TjipFormComponent_TjipFormComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop()], TjipFormComponent_TjipFormComponent.prototype, "preventSubmitOnEnter", void 0);

__decorate([Prop()], TjipFormComponent_TjipFormComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormComponent_TjipFormComponent.prototype, "autocomplete", void 0);

__decorate([Watch('errors', {
  deep: true
})], TjipFormComponent_TjipFormComponent.prototype, "watchErrors", null);

TjipFormComponent_TjipFormComponent = TjipFormComponent_TjipFormComponent_1 = __decorate([vue_class_component_esm], TjipFormComponent_TjipFormComponent);

/* harmony default export */ var src_form_TjipFormComponent = (TjipFormComponent_TjipFormComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipFormHorizontalComponent.ts











var TjipFormHorizontalComponent_TjipFormHorizontalComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormHorizontalComponent, _Vue);

  function TjipFormHorizontalComponent() {
    var _this;

    _classCallCheck(this, TjipFormHorizontalComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormHorizontalComponent).apply(this, arguments));
    _this.resolvedEnabled = true;
    return _this;
  }

  _createClass(TjipFormHorizontalComponent, [{
    key: "onVisibility",
    value: function onVisibility(isVisible) {
      if (isVisible) {
        this.resolveEnabled();
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: "updated",
    value: function updated() {
      this.resolveEnabled();
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      this.resolveEnabled();
    }
  }, {
    key: "resolveEnabled",
    value: function resolveEnabled() {
      this.resolvedEnabled = (lodash["isUndefined"](this.resolvedMinHorizontalWidth) || this.$el.offsetWidth >= this.resolvedMinHorizontalWidth) && (lodash["isUndefined"](this.enabled) || !!this.enabled);
    }
  }, {
    key: "resolveFormGroupAlign",
    value: function resolveFormGroupAlign(align) {
      return this.resolvedEnabled && align ? "text-".concat(align) : undefined;
    }
  }, {
    key: "resolvedLabelWidth",
    get: function get() {
      var w = this.labelWidth || 6;
      var result = w ? Math.max(Math.min(Math.round(w), 12), 1) : 12;
      return result;
    }
  }, {
    key: "controlWidth",
    get: function get() {
      var w = this.resolvedLabelWidth;
      return w >= 12 ? 12 : 12 - w;
    }
  }, {
    key: "labelClass",
    get: function get() {
      var align = this.resolveFormGroupAlign(this.labelAlign);
      var result = this.resolvedEnabled ? this.isAuto ? 'col' : "col-".concat(this.resolvedLabelWidth) : 'col-12';
      return align ? "".concat(result, " ").concat(align) : result;
    }
  }, {
    key: "controlClass",
    get: function get() {
      var align = this.resolveFormGroupAlign(this.controlAlign);
      var result = this.resolvedEnabled ? this.isAuto ? 'col-auto' : "col-".concat(this.controlWidth) : 'col-12';
      return align ? "".concat(result, " ").concat(align) : result;
    }
  }, {
    key: "isAuto",
    get: function get() {
      return this.labelWidth === 'auto';
    }
  }, {
    key: "resolvedMinHorizontalWidth",
    get: function get() {
      if (!this.minHorizontalWidth) {
        return 0;
      }

      var match = /^\s*([0-9]+)(em|px)?\s*$/.exec(this.minHorizontalWidth || '');

      if (match) {
        var size = parseInt(match[1], 10);

        if (match[2] === 'em') {
          size = size * parseFloat(window.getComputedStyle(this.$el).fontSize);
        }

        return size;
      } else {
        this.$log.error("Can not parse minHorizontalWidth '".concat(this.minHorizontalWidth, "'."));
        return 0;
      }
    }
  }]);

  return TjipFormHorizontalComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormHorizontalComponent_TjipFormHorizontalComponent.prototype, "enabled", void 0);

__decorate([Prop()], TjipFormHorizontalComponent_TjipFormHorizontalComponent.prototype, "labelWidth", void 0);

__decorate([Prop()], TjipFormHorizontalComponent_TjipFormHorizontalComponent.prototype, "minHorizontalWidth", void 0);

__decorate([Prop()], TjipFormHorizontalComponent_TjipFormHorizontalComponent.prototype, "labelAlign", void 0);

__decorate([Prop()], TjipFormHorizontalComponent_TjipFormHorizontalComponent.prototype, "controlAlign", void 0);

TjipFormHorizontalComponent_TjipFormHorizontalComponent = __decorate([vue_class_component_esm({
  directives: {
    'observe-visibility': vue_observe_visibility_esm["a" /* ObserveVisibility */]
  }
})], TjipFormHorizontalComponent_TjipFormHorizontalComponent);

/* harmony default export */ var src_form_TjipFormHorizontalComponent = (TjipFormHorizontalComponent_TjipFormHorizontalComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/TjipInitialFocusComponent.ts











var TjipInitialFocusComponent_TjipInitialFocusComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipInitialFocusComponent, _Vue);

  function TjipInitialFocusComponent() {
    _classCallCheck(this, TjipInitialFocusComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipInitialFocusComponent).apply(this, arguments));
  }

  _createClass(TjipInitialFocusComponent, [{
    key: "focus",
    value: function focus() {
      var _this = this;

      var samePage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      // Give radio-group time to render
      setTimeout(function () {
        if (!_this.ignoreRouteHash && _this.$route.hash) {
          var el = _this.$el.querySelector(_this.$route.hash);

          if (el) {
            tjipFocusService.focus(el, _this.focusMobileInput);
          }
        } else {
          tjipFocusService.focus(_this.$el, _this.focusMobileInput);
        }
      });
    }
  }, {
    key: "mounted",
    value: function mounted() {
      tjipRouterService.fixHashRoutes(this.$router);
      this.focus();
      document.body.addEventListener('click', this.onClick.bind(this), true);
    }
  }, {
    key: "onClick",
    value: function onClick(event) {
      if (this.$route && this.$route.hash) {
        var src = event.srcElement;

        if (src) {
          // // test if the link to the current url hash is clicked, in that case re-focus
          // // as it will not generate a route changed event
          var lnk = src.closest('a.router-link-exact-active');

          if (lnk) {
            this.focus();
          }
        }
      }
    }
  }, {
    key: "onRouteChanged",
    value: function onRouteChanged(to, from) {
      this.focus();
    }
  }]);

  return TjipInitialFocusComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop({
  default: false
})], TjipInitialFocusComponent_TjipInitialFocusComponent.prototype, "focusMobileInput", void 0);

__decorate([Prop({
  default: false
})], TjipInitialFocusComponent_TjipInitialFocusComponent.prototype, "ignoreRouteHash", void 0);

__decorate([Watch('$route')], TjipInitialFocusComponent_TjipInitialFocusComponent.prototype, "onRouteChanged", null);

TjipInitialFocusComponent_TjipInitialFocusComponent = __decorate([vue_class_component_esm({})], TjipInitialFocusComponent_TjipInitialFocusComponent);

/* harmony default export */ var src_form_TjipInitialFocusComponent = (TjipInitialFocusComponent_TjipInitialFocusComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/form/index.ts








function TjipVueForm(Vue) {
  Vue.component('tjip-form', form_TjipFormComponent);
  Vue.component('tjip-form-horizontal', form_TjipFormHorizontalComponent);
  Vue.component('tjip-initial-focus', form_TjipInitialFocusComponent);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/dropdown/TjipFormControlDropdownComponent.ts?vue&type=script&lang=ts&














var TjipFormControlDropdownComponentvue_type_script_lang_ts_TjipFormControlDropdownComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlDropdownComponent, _Mixins);

  function TjipFormControlDropdownComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlDropdownComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlDropdownComponent).apply(this, arguments));
    _this.hasFocusWithin = false;
    return _this;
  }

  _createClass(TjipFormControlDropdownComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      var el = this.$refs.dropdown.$el;
      this.observeDom(el, function () {
        _this2.registerForwardEvents();
      });
      this.unwatchFocusWithin = tjipFocusService.watchFocusWithin(this.$el, function (focused, e) {
        _this2.hasFocusWithin = focused; // delay to allow for focus change inside this element

        setTimeout(function () {
          if (_this2.hasFocusWithin === focused) {
            if (_this2.hasFocusWithin) {
              _this2.$emit('focus', e);
            } else {
              _this2.$emit('blur', e);

              _this2.touch();
            }
          }
        });
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.unwatchFocusWithin) {
        this.unwatchFocusWithin();
      }
    }
  }, {
    key: "registerForwardEvents",
    value: function registerForwardEvents() {
      this.unregisterForwardEvents();
      var el = this.$refs.dropdown.$el;
      var buttons = el.querySelectorAll('button.btn-outline-base');
      this.registeredEvents = new TjipForwardDomEvents_TjipForwardDomEvents(buttons, lodash["without"](domInputEvents, 'blur', 'focus'), this);
    }
  }, {
    key: "unregisterForwardEvents",
    value: function unregisterForwardEvents() {
      if (this.registeredEvents) {
        this.registeredEvents.destroy();
      }
    }
  }, {
    key: "resolvedPlaceholder",
    get: function get() {
      return this.placeholder || 'Select';
    }
  }]);

  return TjipFormControlDropdownComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemDropdownMixin_TjipFormItemDropdownMixin));

TjipFormControlDropdownComponentvue_type_script_lang_ts_TjipFormControlDropdownComponent = __decorate([vue_class_component_esm({})], TjipFormControlDropdownComponentvue_type_script_lang_ts_TjipFormControlDropdownComponent);

/* harmony default export */ var TjipFormControlDropdownComponentvue_type_script_lang_ts_ = (TjipFormControlDropdownComponentvue_type_script_lang_ts_TjipFormControlDropdownComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormControlDropdownComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var dropdown_TjipFormControlDropdownComponentvue_type_script_lang_ts_ = (TjipFormControlDropdownComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormControlDropdownComponent.scss?vue&type=style&index=0&id=4b02f81c&scoped=true&lang=scss&
var TjipFormControlDropdownComponentvue_type_style_index_0_id_4b02f81c_scoped_true_lang_scss_ = __webpack_require__("c243");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormControlDropdownComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlDropdownComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("0f66");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormControlDropdownComponent.vue







/* normalize component */

var TjipFormControlDropdownComponent_component = normalizeComponent(
  dropdown_TjipFormControlDropdownComponentvue_type_script_lang_ts_,
  TjipFormControlDropdownComponentvue_type_template_id_4b02f81c_scoped_true_render,
  TjipFormControlDropdownComponentvue_type_template_id_4b02f81c_scoped_true_staticRenderFns,
  false,
  null,
  "4b02f81c",
  null
  
)

/* harmony default export */ var dropdown_TjipFormControlDropdownComponent = (TjipFormControlDropdownComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormControlDropdownComponent.ts














var TjipFormControlDropdownComponent_TjipFormControlDropdownComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlDropdownComponent, _Mixins);

  function TjipFormControlDropdownComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlDropdownComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlDropdownComponent).apply(this, arguments));
    _this.hasFocusWithin = false;
    return _this;
  }

  _createClass(TjipFormControlDropdownComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      var el = this.$refs.dropdown.$el;
      this.observeDom(el, function () {
        _this2.registerForwardEvents();
      });
      this.unwatchFocusWithin = tjipFocusService.watchFocusWithin(this.$el, function (focused, e) {
        _this2.hasFocusWithin = focused; // delay to allow for focus change inside this element

        setTimeout(function () {
          if (_this2.hasFocusWithin === focused) {
            if (_this2.hasFocusWithin) {
              _this2.$emit('focus', e);
            } else {
              _this2.$emit('blur', e);

              _this2.touch();
            }
          }
        });
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.unwatchFocusWithin) {
        this.unwatchFocusWithin();
      }
    }
  }, {
    key: "registerForwardEvents",
    value: function registerForwardEvents() {
      this.unregisterForwardEvents();
      var el = this.$refs.dropdown.$el;
      var buttons = el.querySelectorAll('button.btn-outline-base');
      this.registeredEvents = new TjipForwardDomEvents_TjipForwardDomEvents(buttons, lodash["without"](domInputEvents, 'blur', 'focus'), this);
    }
  }, {
    key: "unregisterForwardEvents",
    value: function unregisterForwardEvents() {
      if (this.registeredEvents) {
        this.registeredEvents.destroy();
      }
    }
  }, {
    key: "resolvedPlaceholder",
    get: function get() {
      return this.placeholder || 'Select';
    }
  }]);

  return TjipFormControlDropdownComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemDropdownMixin_TjipFormItemDropdownMixin));

TjipFormControlDropdownComponent_TjipFormControlDropdownComponent = __decorate([vue_class_component_esm({})], TjipFormControlDropdownComponent_TjipFormControlDropdownComponent);

/* harmony default export */ var controls_dropdown_TjipFormControlDropdownComponent = (TjipFormControlDropdownComponent_TjipFormControlDropdownComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/dropdown/TjipFormGroupDropdownComponent.vue?vue&type=template&id=97ea2018&scoped=true&
var TjipFormGroupDropdownComponentvue_type_template_id_97ea2018_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-dropdown",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-dropdown',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"errorMode":_vm.errorMode,"controlWidth":_vm.controlWidth,"splitButton":_vm.splitButton,"placeholder":_vm.placeholder,"dropUp":_vm.dropUp,"dropLeft":_vm.dropLeft,"dropRight":_vm.dropRight,"noFlip":_vm.noFlip},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},[_vm._t("tjip-form-control-options")],2)]},proxy:true}],null,true)},[_vm._t("default")],2)}
var TjipFormGroupDropdownComponentvue_type_template_id_97ea2018_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormGroupDropdownComponent.vue?vue&type=template&id=97ea2018&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/dropdown/TjipFormGroupDropdownComponent.ts?vue&type=script&lang=ts&











var TjipFormGroupDropdownComponentvue_type_script_lang_ts_TjipFormGroupDropdownComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupDropdownComponent, _Mixins);

  function TjipFormGroupDropdownComponent() {
    _classCallCheck(this, TjipFormGroupDropdownComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupDropdownComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupDropdownComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupDropdownComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormGroupMixin_TjipFormGroupMixin, TjipFormItemDropdownMixin_TjipFormItemDropdownMixin));

TjipFormGroupDropdownComponentvue_type_script_lang_ts_TjipFormGroupDropdownComponent = __decorate([vue_class_component_esm({})], TjipFormGroupDropdownComponentvue_type_script_lang_ts_TjipFormGroupDropdownComponent);

/* harmony default export */ var TjipFormGroupDropdownComponentvue_type_script_lang_ts_ = (TjipFormGroupDropdownComponentvue_type_script_lang_ts_TjipFormGroupDropdownComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormGroupDropdownComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var dropdown_TjipFormGroupDropdownComponentvue_type_script_lang_ts_ = (TjipFormGroupDropdownComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormGroupDropdownComponent.scss?vue&type=style&index=0&id=97ea2018&scoped=true&lang=scss&
var TjipFormGroupDropdownComponentvue_type_style_index_0_id_97ea2018_scoped_true_lang_scss_ = __webpack_require__("aacc");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormGroupDropdownComponent.vue






/* normalize component */

var TjipFormGroupDropdownComponent_component = normalizeComponent(
  dropdown_TjipFormGroupDropdownComponentvue_type_script_lang_ts_,
  TjipFormGroupDropdownComponentvue_type_template_id_97ea2018_scoped_true_render,
  TjipFormGroupDropdownComponentvue_type_template_id_97ea2018_scoped_true_staticRenderFns,
  false,
  null,
  "97ea2018",
  null
  
)

/* harmony default export */ var dropdown_TjipFormGroupDropdownComponent = (TjipFormGroupDropdownComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/dropdown/TjipFormGroupDropdownComponent.ts











var TjipFormGroupDropdownComponent_TjipFormGroupDropdownComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupDropdownComponent, _Mixins);

  function TjipFormGroupDropdownComponent() {
    _classCallCheck(this, TjipFormGroupDropdownComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupDropdownComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupDropdownComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupDropdownComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormGroupMixin_TjipFormGroupMixin, TjipFormItemDropdownMixin_TjipFormItemDropdownMixin));

TjipFormGroupDropdownComponent_TjipFormGroupDropdownComponent = __decorate([vue_class_component_esm({})], TjipFormGroupDropdownComponent_TjipFormGroupDropdownComponent);

/* harmony default export */ var controls_dropdown_TjipFormGroupDropdownComponent = (TjipFormGroupDropdownComponent_TjipFormGroupDropdownComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioGroupComponent.vue?vue&type=template&id=1e0250bc&scoped=true&
var TjipFormControlRadioGroupComponentvue_type_template_id_1e0250bc_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-radio-group form-control",class:( _obj = {'tjip-form-control-radio-group-vertical': _vm.alignVertical,
    'tjip-form-control-radio-group-justified': _vm.justify,
    'has-error': _vm.showErrors,
    'has-success': _vm.isValid,
    'focus-within': _vm.hasFocusWithin}, _obj[_vm.controlWidthClass] = true, _obj )},[_c('tjip-form-control-options',{attrs:{"name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var options = ref.options;
return [_vm._l((options),function(option){return _c('tjip-form-control-radio-button',{key:option._uid,ref:"radio",refInFor:true,attrs:{"name":_vm.resolvedName,"ctrlId":_vm.resolvedId + option._uid,"itemValue":option.value,"tabindex":_vm.tabindex,"disabled":option.disabled,"appearance":_vm.appearance},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},[_c('tjip-form-control-option-content',{attrs:{"option":option}})],1)}),_vm._t("default")]}}],null,true),model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)}
var TjipFormControlRadioGroupComponentvue_type_template_id_1e0250bc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioGroupComponent.vue?vue&type=template&id=1e0250bc&scoped=true&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormItemRadioGroupMixin.ts









var TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormItemRadioGroupMixin, _Vue);

  function TjipFormItemRadioGroupMixin() {
    _classCallCheck(this, TjipFormItemRadioGroupMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemRadioGroupMixin).apply(this, arguments));
  }

  return TjipFormItemRadioGroupMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin.prototype, "alignVertical", void 0);

__decorate([Prop()], TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin.prototype, "justify", void 0);

__decorate([Prop()], TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin.prototype, "appearance", void 0);

TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin = __decorate([vue_class_component_esm], TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioGroupComponent.ts?vue&type=script&lang=ts&












var TjipFormControlRadioGroupComponentvue_type_script_lang_ts_TjipFormControlRadioGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlRadioGroupComponent, _Mixins);

  function TjipFormControlRadioGroupComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlRadioGroupComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlRadioGroupComponent).apply(this, arguments));
    _this.hasFocusWithin = false;
    return _this;
  }

  _createClass(TjipFormControlRadioGroupComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.unwatchFocusWithin = tjipFocusService.watchFocusWithin(this.$el, function (focused, e) {
        _this2.hasFocusWithin = focused; // delay to allow for focus change inside this element

        setTimeout(function () {
          if (_this2.hasFocusWithin === focused) {
            if (_this2.hasFocusWithin) {
              _this2.$emit('focus', e);
            } else {
              _this2.$emit('blur', e);

              _this2.touch();
            }
          }
        });
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.unwatchFocusWithin) {
        this.unwatchFocusWithin();
      }
    }
  }, {
    key: "forwardRefEventsSource",
    get: function get() {
      return 'radio';
    }
  }, {
    key: "forwardRefEventsIsDomSource",
    get: function get() {
      return false;
    }
  }, {
    key: "forwardRefEvents",
    get: function get() {
      return lodash["without"](this.allDomEvents, 'blur', 'focus', 'input');
    }
  }]);

  return TjipFormControlRadioGroupComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin));

TjipFormControlRadioGroupComponentvue_type_script_lang_ts_TjipFormControlRadioGroupComponent = __decorate([vue_class_component_esm({})], TjipFormControlRadioGroupComponentvue_type_script_lang_ts_TjipFormControlRadioGroupComponent);

/* harmony default export */ var TjipFormControlRadioGroupComponentvue_type_script_lang_ts_ = (TjipFormControlRadioGroupComponentvue_type_script_lang_ts_TjipFormControlRadioGroupComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioGroupComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var radio_TjipFormControlRadioGroupComponentvue_type_script_lang_ts_ = (TjipFormControlRadioGroupComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioGroupComponent.scss?vue&type=style&index=0&id=1e0250bc&scoped=true&lang=scss&
var TjipFormControlRadioGroupComponentvue_type_style_index_0_id_1e0250bc_scoped_true_lang_scss_ = __webpack_require__("36b1");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioGroupComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlRadioGroupComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("a78a");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioGroupComponent.vue







/* normalize component */

var TjipFormControlRadioGroupComponent_component = normalizeComponent(
  radio_TjipFormControlRadioGroupComponentvue_type_script_lang_ts_,
  TjipFormControlRadioGroupComponentvue_type_template_id_1e0250bc_scoped_true_render,
  TjipFormControlRadioGroupComponentvue_type_template_id_1e0250bc_scoped_true_staticRenderFns,
  false,
  null,
  "1e0250bc",
  null
  
)

/* harmony default export */ var radio_TjipFormControlRadioGroupComponent = (TjipFormControlRadioGroupComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioGroupComponent.ts












var TjipFormControlRadioGroupComponent_TjipFormControlRadioGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlRadioGroupComponent, _Mixins);

  function TjipFormControlRadioGroupComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlRadioGroupComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlRadioGroupComponent).apply(this, arguments));
    _this.hasFocusWithin = false;
    return _this;
  }

  _createClass(TjipFormControlRadioGroupComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.unwatchFocusWithin = tjipFocusService.watchFocusWithin(this.$el, function (focused, e) {
        _this2.hasFocusWithin = focused; // delay to allow for focus change inside this element

        setTimeout(function () {
          if (_this2.hasFocusWithin === focused) {
            if (_this2.hasFocusWithin) {
              _this2.$emit('focus', e);
            } else {
              _this2.$emit('blur', e);

              _this2.touch();
            }
          }
        });
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.unwatchFocusWithin) {
        this.unwatchFocusWithin();
      }
    }
  }, {
    key: "forwardRefEventsSource",
    get: function get() {
      return 'radio';
    }
  }, {
    key: "forwardRefEventsIsDomSource",
    get: function get() {
      return false;
    }
  }, {
    key: "forwardRefEvents",
    get: function get() {
      return lodash["without"](this.allDomEvents, 'blur', 'focus', 'input');
    }
  }]);

  return TjipFormControlRadioGroupComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin));

TjipFormControlRadioGroupComponent_TjipFormControlRadioGroupComponent = __decorate([vue_class_component_esm({})], TjipFormControlRadioGroupComponent_TjipFormControlRadioGroupComponent);

/* harmony default export */ var controls_radio_TjipFormControlRadioGroupComponent = (TjipFormControlRadioGroupComponent_TjipFormControlRadioGroupComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/radio/TjipFormGroupRadioGroupComponent.vue?vue&type=template&id=7079bab7&
var TjipFormGroupRadioGroupComponentvue_type_template_id_7079bab7_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-radio-group",class:{
  'tjip-form-group-radio-group-normal': _vm.appearance === 'normal' || !_vm.appearance,
  'tjip-form-group-radio-group-btn': _vm.appearance === 'btn',
  'tjip-form-group-radio-group-btn-group': _vm.appearance === 'btn-group',
  'tjip-form-group-radio-group-icon': _vm.appearance === 'icon',

  },attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-radio-group',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"tabindex":_vm.tabindex,"errorMode":_vm.errorMode,"controlWidth":_vm.controlWidth,"disabled":_vm.disabled,"alignVertical":_vm.alignVertical,"justify":_vm.justify,"appearance":_vm.appearance},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},[_vm._t("tjip-form-control-options")],2)]},proxy:true}],null,true)},[_vm._t("default")],2)}
var TjipFormGroupRadioGroupComponentvue_type_template_id_7079bab7_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormGroupRadioGroupComponent.vue?vue&type=template&id=7079bab7&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/radio/TjipFormGroupRadioGroupComponent.ts?vue&type=script&lang=ts&











var TjipFormGroupRadioGroupComponentvue_type_script_lang_ts_TjipFormGroupRadioGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupRadioGroupComponent, _Mixins);

  function TjipFormGroupRadioGroupComponent() {
    _classCallCheck(this, TjipFormGroupRadioGroupComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupRadioGroupComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupRadioGroupComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupRadioGroupComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormGroupMixin_TjipFormGroupMixin, TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin));

TjipFormGroupRadioGroupComponentvue_type_script_lang_ts_TjipFormGroupRadioGroupComponent = __decorate([vue_class_component_esm({})], TjipFormGroupRadioGroupComponentvue_type_script_lang_ts_TjipFormGroupRadioGroupComponent);

/* harmony default export */ var TjipFormGroupRadioGroupComponentvue_type_script_lang_ts_ = (TjipFormGroupRadioGroupComponentvue_type_script_lang_ts_TjipFormGroupRadioGroupComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormGroupRadioGroupComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var radio_TjipFormGroupRadioGroupComponentvue_type_script_lang_ts_ = (TjipFormGroupRadioGroupComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormGroupRadioGroupComponent.global.scss?vue&type=style&index=0&lang=scss&
var TjipFormGroupRadioGroupComponent_globalvue_type_style_index_0_lang_scss_ = __webpack_require__("7ab0");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormGroupRadioGroupComponent.vue






/* normalize component */

var TjipFormGroupRadioGroupComponent_component = normalizeComponent(
  radio_TjipFormGroupRadioGroupComponentvue_type_script_lang_ts_,
  TjipFormGroupRadioGroupComponentvue_type_template_id_7079bab7_render,
  TjipFormGroupRadioGroupComponentvue_type_template_id_7079bab7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var radio_TjipFormGroupRadioGroupComponent = (TjipFormGroupRadioGroupComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormGroupRadioGroupComponent.ts











var TjipFormGroupRadioGroupComponent_TjipFormGroupRadioGroupComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupRadioGroupComponent, _Mixins);

  function TjipFormGroupRadioGroupComponent() {
    _classCallCheck(this, TjipFormGroupRadioGroupComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupRadioGroupComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupRadioGroupComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupRadioGroupComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormGroupMixin_TjipFormGroupMixin, TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin));

TjipFormGroupRadioGroupComponent_TjipFormGroupRadioGroupComponent = __decorate([vue_class_component_esm({})], TjipFormGroupRadioGroupComponent_TjipFormGroupRadioGroupComponent);

/* harmony default export */ var controls_radio_TjipFormGroupRadioGroupComponent = (TjipFormGroupRadioGroupComponent_TjipFormGroupRadioGroupComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioButtonComponent.vue?vue&type=template&id=7d570323&scoped=true&
var TjipFormControlRadioButtonComponentvue_type_template_id_7d570323_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-radio-button",class:{
  'tjip-form-control-radio-button-normal': _vm.appearance === 'normal' || !_vm.appearance,
  'tjip-form-control-radio-button-btn': _vm.appearance === 'btn',
  'tjip-form-control-radio-button-btn-group': _vm.appearance === 'btn-group',
  'tjip-form-control-radio-button-icon': _vm.appearance === 'icon',
  'focus': _vm.hasFocus
}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],ref:"input",attrs:{"type":"radio","name":_vm.resolvedName,"id":_vm.resolvedId,"tabindex":_vm.tabindex,"disabled":_vm.disabled},domProps:{"value":_vm.itemValue,"checked":_vm._q(_vm.internalValue,_vm.itemValue)},on:{"change":function($event){_vm.internalValue=_vm.itemValue}}}),_c('label',{attrs:{"for":_vm.resolvedId}},[_vm._t("default",[_vm._v(_vm._s(_vm.resolvedLabel))])],2)])}
var TjipFormControlRadioButtonComponentvue_type_template_id_7d570323_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioButtonComponent.vue?vue&type=template&id=7d570323&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioButtonComponent.ts?vue&type=script&lang=ts&











var TjipFormControlRadioButtonComponentvue_type_script_lang_ts_TjipFormControlRadioButtonComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlRadioButtonComponent, _Mixins);

  function TjipFormControlRadioButtonComponent() {
    _classCallCheck(this, TjipFormControlRadioButtonComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlRadioButtonComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlRadioButtonComponent, [{
    key: "resolvedLabel",
    get: function get() {
      return !lodash["isNil"](this.label) ? this.label : lodash["isNil"](this.itemValue) ? '' : this.itemValue.toString();
    }
  }]);

  return TjipFormControlRadioButtonComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin));

__decorate([Prop()], TjipFormControlRadioButtonComponentvue_type_script_lang_ts_TjipFormControlRadioButtonComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlRadioButtonComponentvue_type_script_lang_ts_TjipFormControlRadioButtonComponent.prototype, "itemValue", void 0);

__decorate([Prop()], TjipFormControlRadioButtonComponentvue_type_script_lang_ts_TjipFormControlRadioButtonComponent.prototype, "appearance", void 0);

TjipFormControlRadioButtonComponentvue_type_script_lang_ts_TjipFormControlRadioButtonComponent = __decorate([vue_class_component_esm({})], TjipFormControlRadioButtonComponentvue_type_script_lang_ts_TjipFormControlRadioButtonComponent);

/* harmony default export */ var TjipFormControlRadioButtonComponentvue_type_script_lang_ts_ = (TjipFormControlRadioButtonComponentvue_type_script_lang_ts_TjipFormControlRadioButtonComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioButtonComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var radio_TjipFormControlRadioButtonComponentvue_type_script_lang_ts_ = (TjipFormControlRadioButtonComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioButtonComponent.scss?vue&type=style&index=0&id=7d570323&scoped=true&lang=scss&
var TjipFormControlRadioButtonComponentvue_type_style_index_0_id_7d570323_scoped_true_lang_scss_ = __webpack_require__("cf3d");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioButtonComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlRadioButtonComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("1793");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioButtonComponent.vue







/* normalize component */

var TjipFormControlRadioButtonComponent_component = normalizeComponent(
  radio_TjipFormControlRadioButtonComponentvue_type_script_lang_ts_,
  TjipFormControlRadioButtonComponentvue_type_template_id_7d570323_scoped_true_render,
  TjipFormControlRadioButtonComponentvue_type_template_id_7d570323_scoped_true_staticRenderFns,
  false,
  null,
  "7d570323",
  null
  
)

/* harmony default export */ var radio_TjipFormControlRadioButtonComponent = (TjipFormControlRadioButtonComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/radio/TjipFormControlRadioButtonComponent.ts











var TjipFormControlRadioButtonComponent_TjipFormControlRadioButtonComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlRadioButtonComponent, _Mixins);

  function TjipFormControlRadioButtonComponent() {
    _classCallCheck(this, TjipFormControlRadioButtonComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlRadioButtonComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlRadioButtonComponent, [{
    key: "resolvedLabel",
    get: function get() {
      return !lodash["isNil"](this.label) ? this.label : lodash["isNil"](this.itemValue) ? '' : this.itemValue.toString();
    }
  }]);

  return TjipFormControlRadioButtonComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin));

__decorate([Prop()], TjipFormControlRadioButtonComponent_TjipFormControlRadioButtonComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlRadioButtonComponent_TjipFormControlRadioButtonComponent.prototype, "itemValue", void 0);

__decorate([Prop()], TjipFormControlRadioButtonComponent_TjipFormControlRadioButtonComponent.prototype, "appearance", void 0);

TjipFormControlRadioButtonComponent_TjipFormControlRadioButtonComponent = __decorate([vue_class_component_esm({})], TjipFormControlRadioButtonComponent_TjipFormControlRadioButtonComponent);

/* harmony default export */ var controls_radio_TjipFormControlRadioButtonComponent = (TjipFormControlRadioButtonComponent_TjipFormControlRadioButtonComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/date/TjipFormControlDateComponent.vue?vue&type=template&id=51ec0f78&scoped=true&
var TjipFormControlDateComponentvue_type_template_id_51ec0f78_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-date"},[(_vm.datepickerIsOpen)?_c('tjip-backdrop',{on:{"click":_vm.backdropClicked}}):_vm._e(),(_vm.hasDatepicker)?_c('datepicker',{ref:"datepickerHost",staticClass:"datepicker-host",class:{disabled: _vm.disabled},attrs:{"bootstrap-styling":true,"language":_vm.datepickerLanguage,"full-month-name":_vm.datepicker.fullMonthName,"monday-first":_vm.datepicker.mondayFirst,"initial-view":_vm.initialView,"minimum-view":_vm.datepicker.minimumView,"maximum-view":_vm.datepicker.maximumView,"open-date":_vm.resolvedOpenDate,"disabled-dates":_vm.datepicker.disabledDates},on:{"opened":_vm.datepickerOpened,"closed":_vm.datepickerClosed},model:{value:(_vm.datepickerValue),callback:function ($$v) {_vm.datepickerValue=$$v},expression:"datepickerValue"}}):_vm._e(),_c('tjip-form-control-addin-wrapper',{class:( _obj = {'has-error': _vm.showErrors, 'has-success': _vm.isValid}, _obj[_vm.controlWidthClass] = true, _obj ),attrs:{"disabled":_vm.disabled},scopedSlots:_vm._u([(_vm.hasDatepicker)?{key:"addin-right",fn:function(){return [_c('div',{staticClass:"btn-calendar-host"},[_c('button',{staticClass:"btn btn-default btn-calendar",attrs:{"type":"button","disabled":_vm.disabled,"tabindex":_vm.resolvedButtonTabindex},on:{"click":_vm.toggleDatepicker}},[_c('div',{staticClass:"glyph-calendar"})])])]},proxy:true}:null],null,true)},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],ref:"input",attrs:{"type":"text","name":_vm.resolvedName,"id":_vm.resolvedId,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete},domProps:{"value":(_vm.internalValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.internalValue=$event.target.value}}})])],1)}
var TjipFormControlDateComponentvue_type_template_id_51ec0f78_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormControlDateComponent.vue?vue&type=template&id=51ec0f78&scoped=true&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/ParsedMomentFormat.ts



 // tslint:disable-next-line:max-line-length

var DATE_FORMATS_SPLIT = /^((?:[^YQMDXxgwedGWEHhkaAmsZ']+)|(?:[^\]]*])|(?:Y+|Q|M+|D+|X|x|g+|w+|e|d+|G+|W+|E|H+|h+|k+|a|A|m+|s+|S+|Z+))(.*)$/;
var DATE_SEPARATORS = /^[-:/. ]$/;
var ParsedMomentFormat_ParsedMomentFormat =
/*#__PURE__*/
function () {
  function ParsedMomentFormat(format) {
    _classCallCheck(this, ParsedMomentFormat);

    this.format = format;
    this.parts = [];
    var s = this.format;

    while (s) {
      var match = DATE_FORMATS_SPLIT.exec(s);

      if (match) {
        this.parts = this.parts.concat(match.slice(1));
        s = this.parts.pop();
      } else {
        this.parts.push(s);
        s = undefined;
      }
    }
  }

  _createClass(ParsedMomentFormat, [{
    key: "getTokens",
    value: function getTokens(patterns) {
      var _this = this;

      var ps = this.preparePatterns(patterns);
      var max = this.parts.length;
      var result = [];

      var _loop = function _loop(i1) {
        var part = _this.parts[i1];

        if (ps.some(function (p) {
          return p.test(part);
        })) {
          result.push(part);
        }
      };

      for (var i1 = 0; i1 < max; i1++) {
        _loop(i1);
      }

      return result;
    }
  }, {
    key: "hasAllTokens",
    value: function hasAllTokens(patterns) {
      var _this2 = this;

      var ps = this.preparePatterns(patterns);
      var result = true;
      var i1 = ps.length;

      var _loop2 = function _loop2() {
        var pattern = ps[i1];
        result = _this2.parts.some(function (part) {
          return pattern.test(part);
        });
      };

      while (result && i1--) {
        _loop2();
      }

      return result;
    }
  }, {
    key: "hasAnyToken",
    value: function hasAnyToken(patterns) {
      var _this3 = this;

      var ps = this.preparePatterns(patterns);
      return ps.some(function (pattern) {
        return _this3.parts.some(function (p) {
          return pattern.test(p);
        });
      });
    }
  }, {
    key: "hasExplicitTokens",
    value: function hasExplicitTokens(required, optional, allowSep) {
      var _this4 = this;

      var allowText = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var rs = this.preparePatterns(required);
      var requiredFound = rs.map(function () {
        return false;
      });
      var os = this.preparePatterns(optional);

      if (allowSep) {
        os.push(DATE_SEPARATORS);
      }

      if (allowText) {
        os.push(/^'/);
      }

      var result = true;
      var i1 = this.parts.length;

      var _loop3 = function _loop3() {
        var part = _this4.parts[i1];
        result = rs.some(function (r, ndx) {
          requiredFound[ndx] = requiredFound[ndx] || r.test(part);
          return requiredFound[ndx];
        }) || os.some(function (o) {
          return o.test(part);
        });
      };

      while (result && i1--) {
        _loop3();
      }

      result = result && !requiredFound.some(function (f) {
        return !f;
      });
      return result;
    }
  }, {
    key: "hasTextTokens",
    value: function hasTextTokens() {
      return this.hasAnyToken(/^\[/);
    }
  }, {
    key: "hasTextDateTimeTokens",
    value: function hasTextDateTimeTokens() {
      return this.hasAnyToken(['MMM+', 'ddd+', 'a', 'A']);
    }
  }, {
    key: "isDateOnly",
    value: function isDateOnly() {
      return this.hasExplicitTokens(['D+', 'M+', 'Y+'], null, true);
    }
  }, {
    key: "isTimeOnly",
    value: function isTimeOnly() {
      return this.hasExplicitTokens(['(H+|h+)', 'm+'], 's{1,2}', true);
    }
  }, {
    key: "hasSeparators",
    value: function hasSeparators() {
      return this.hasAnyToken(DATE_SEPARATORS);
    }
  }, {
    key: "getSeparators",
    value: function getSeparators() {
      return this.getTokens(DATE_SEPARATORS);
    }
  }, {
    key: "getSeparator",
    value: function getSeparator() {
      var separators = this.getTokens(DATE_SEPARATORS);
      var i1 = separators.length - 1;
      var prev;
      var cur = i1 < 0 ? null : separators[i1];

      while (i1--) {
        prev = cur;
        cur = separators[i1];

        if (prev !== cur) {
          return null;
        }
      }

      return cur;
    }
  }, {
    key: "preparePatterns",
    value: function preparePatterns(patterns) {
      if (!lodash["isArray"](patterns)) {
        patterns = patterns ? [patterns] : [];
      }

      return patterns.map(function (p) {
        if (!(p instanceof RegExp)) {
          p = new RegExp('^' + p + '$');
        }

        return p;
      });
    }
  }]);

  return ParsedMomentFormat;
}();
// CONCATENATED MODULE: ./node_modules/vuejs-datepicker/dist/vuejs-datepicker.esm.js
function vuejs_datepicker_esm_typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    vuejs_datepicker_esm_typeof = function (obj) {
      return typeof obj;
    };
  } else {
    vuejs_datepicker_esm_typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return vuejs_datepicker_esm_typeof(obj);
}

function vuejs_datepicker_esm_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function vuejs_datepicker_esm_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function vuejs_datepicker_esm_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) vuejs_datepicker_esm_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) vuejs_datepicker_esm_defineProperties(Constructor, staticProps);
  return Constructor;
}

function vuejs_datepicker_esm_defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      vuejs_datepicker_esm_defineProperty(target, key, source[key]);
    });
  }

  return target;
}

var Language =
/*#__PURE__*/
function () {
  function Language(language, months, monthsAbbr, days) {
    vuejs_datepicker_esm_classCallCheck(this, Language);

    this.language = language;
    this.months = months;
    this.monthsAbbr = monthsAbbr;
    this.days = days;
    this.rtl = false;
    this.ymd = false;
    this.yearSuffix = '';
  }

  vuejs_datepicker_esm_createClass(Language, [{
    key: "language",
    get: function get() {
      return this._language;
    },
    set: function set(language) {
      if (typeof language !== 'string') {
        throw new TypeError('Language must be a string');
      }

      this._language = language;
    }
  }, {
    key: "months",
    get: function get() {
      return this._months;
    },
    set: function set(months) {
      if (months.length !== 12) {
        throw new RangeError("There must be 12 months for ".concat(this.language, " language"));
      }

      this._months = months;
    }
  }, {
    key: "monthsAbbr",
    get: function get() {
      return this._monthsAbbr;
    },
    set: function set(monthsAbbr) {
      if (monthsAbbr.length !== 12) {
        throw new RangeError("There must be 12 abbreviated months for ".concat(this.language, " language"));
      }

      this._monthsAbbr = monthsAbbr;
    }
  }, {
    key: "days",
    get: function get() {
      return this._days;
    },
    set: function set(days) {
      if (days.length !== 7) {
        throw new RangeError("There must be 7 days for ".concat(this.language, " language"));
      }

      this._days = days;
    }
  }]);

  return Language;
}(); // eslint-disable-next-line

var en = new Language('English', ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'], ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'], ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']) // eslint-disable-next-line
;

var utils = {
  /**
   * @type {Boolean}
   */
  useUtc: false,

  /**
   * Returns the full year, using UTC or not
   * @param {Date} date
   */
  getFullYear: function getFullYear(date) {
    return this.useUtc ? date.getUTCFullYear() : date.getFullYear();
  },

  /**
   * Returns the month, using UTC or not
   * @param {Date} date
   */
  getMonth: function getMonth(date) {
    return this.useUtc ? date.getUTCMonth() : date.getMonth();
  },

  /**
   * Returns the date, using UTC or not
   * @param {Date} date
   */
  getDate: function getDate(date) {
    return this.useUtc ? date.getUTCDate() : date.getDate();
  },

  /**
   * Returns the day, using UTC or not
   * @param {Date} date
   */
  getDay: function getDay(date) {
    return this.useUtc ? date.getUTCDay() : date.getDay();
  },

  /**
   * Returns the hours, using UTC or not
   * @param {Date} date
   */
  getHours: function getHours(date) {
    return this.useUtc ? date.getUTCHours() : date.getHours();
  },

  /**
   * Returns the minutes, using UTC or not
   * @param {Date} date
   */
  getMinutes: function getMinutes(date) {
    return this.useUtc ? date.getUTCMinutes() : date.getMinutes();
  },

  /**
   * Sets the full year, using UTC or not
   * @param {Date} date
   */
  setFullYear: function setFullYear(date, value, useUtc) {
    return this.useUtc ? date.setUTCFullYear(value) : date.setFullYear(value);
  },

  /**
   * Sets the month, using UTC or not
   * @param {Date} date
   */
  setMonth: function setMonth(date, value, useUtc) {
    return this.useUtc ? date.setUTCMonth(value) : date.setMonth(value);
  },

  /**
   * Sets the date, using UTC or not
   * @param {Date} date
   * @param {Number} value
   */
  setDate: function setDate(date, value, useUtc) {
    return this.useUtc ? date.setUTCDate(value) : date.setDate(value);
  },

  /**
   * Check if date1 is equivalent to date2, without comparing the time
   * @see https://stackoverflow.com/a/6202196/4455925
   * @param {Date} date1
   * @param {Date} date2
   */
  compareDates: function compareDates(date1, date2) {
    var d1 = new Date(date1.getTime());
    var d2 = new Date(date2.getTime());

    if (this.useUtc) {
      d1.setUTCHours(0, 0, 0, 0);
      d2.setUTCHours(0, 0, 0, 0);
    } else {
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);
    }

    return d1.getTime() === d2.getTime();
  },

  /**
   * Validates a date object
   * @param {Date} date - an object instantiated with the new Date constructor
   * @return {Boolean}
   */
  isValidDate: function isValidDate(date) {
    if (Object.prototype.toString.call(date) !== '[object Date]') {
      return false;
    }

    return !isNaN(date.getTime());
  },

  /**
   * Return abbreviated week day name
   * @param {Date}
   * @param {Array}
   * @return {String}
   */
  getDayNameAbbr: function getDayNameAbbr(date, days) {
    if (vuejs_datepicker_esm_typeof(date) !== 'object') {
      throw TypeError('Invalid Type');
    }

    return days[this.getDay(date)];
  },

  /**
   * Return name of the month
   * @param {Number|Date}
   * @param {Array}
   * @return {String}
   */
  getMonthName: function getMonthName(month, months) {
    if (!months) {
      throw Error('missing 2nd parameter Months array');
    }

    if (vuejs_datepicker_esm_typeof(month) === 'object') {
      return months[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return months[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Return an abbreviated version of the month
   * @param {Number|Date}
   * @return {String}
   */
  getMonthNameAbbr: function getMonthNameAbbr(month, monthsAbbr) {
    if (!monthsAbbr) {
      throw Error('missing 2nd paramter Months array');
    }

    if (vuejs_datepicker_esm_typeof(month) === 'object') {
      return monthsAbbr[this.getMonth(month)];
    }

    if (typeof month === 'number') {
      return monthsAbbr[month];
    }

    throw TypeError('Invalid type');
  },

  /**
   * Alternative get total number of days in month
   * @param {Number} year
   * @param {Number} m
   * @return {Number}
   */
  daysInMonth: function daysInMonth(year, month) {
    return /8|3|5|10/.test(month) ? 30 : month === 1 ? !(year % 4) && year % 100 || !(year % 400) ? 29 : 28 : 31;
  },

  /**
   * Get nth suffix for date
   * @param {Number} day
   * @return {String}
   */
  getNthSuffix: function getNthSuffix(day) {
    switch (day) {
      case 1:
      case 21:
      case 31:
        return 'st';

      case 2:
      case 22:
        return 'nd';

      case 3:
      case 23:
        return 'rd';

      default:
        return 'th';
    }
  },

  /**
   * Formats date object
   * @param {Date}
   * @param {String}
   * @param {Object}
   * @return {String}
   */
  formatDate: function formatDate(date, format, translation) {
    translation = !translation ? en : translation;
    var year = this.getFullYear(date);
    var month = this.getMonth(date) + 1;
    var day = this.getDate(date);
    var str = format.replace(/dd/, ('0' + day).slice(-2)).replace(/d/, day).replace(/yyyy/, year).replace(/yy/, String(year).slice(2)).replace(/MMMM/, this.getMonthName(this.getMonth(date), translation.months)).replace(/MMM/, this.getMonthNameAbbr(this.getMonth(date), translation.monthsAbbr)).replace(/MM/, ('0' + month).slice(-2)).replace(/M(?!a|ä|e)/, month).replace(/su/, this.getNthSuffix(this.getDate(date))).replace(/D(?!e|é|i)/, this.getDayNameAbbr(date, translation.days));
    return str;
  },

  /**
   * Creates an array of dates for each day in between two dates.
   * @param {Date} start
   * @param {Date} end
   * @return {Array}
   */
  createDateArray: function createDateArray(start, end) {
    var dates = [];

    while (start <= end) {
      dates.push(new Date(start));
      start = this.setDate(new Date(start), this.getDate(new Date(start)) + 1);
    }

    return dates;
  },

  /**
   * method used as a prop validator for input values
   * @param {*} val
   * @return {Boolean}
   */
  validateDateInput: function validateDateInput(val) {
    return val === null || val instanceof Date || typeof val === 'string' || typeof val === 'number';
  }
};
var makeDateUtils = function makeDateUtils(useUtc) {
  return _objectSpread({}, utils, {
    useUtc: useUtc
  });
};
var utils$1 = _objectSpread({}, utils) // eslint-disable-next-line
;

var script = {
  props: {
    selectedDate: Date,
    resetTypedDate: [Date],
    format: [String, Function],
    translation: Object,
    inline: Boolean,
    id: String,
    name: String,
    refName: String,
    openDate: Date,
    placeholder: String,
    inputClass: [String, Object, Array],
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    bootstrapStyling: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      input: null,
      typedDate: false,
      utils: constructedDateUtils
    };
  },
  computed: {
    formattedValue: function formattedValue() {
      if (!this.selectedDate) {
        return null;
      }

      if (this.typedDate) {
        return this.typedDate;
      }

      return typeof this.format === 'function' ? this.format(this.selectedDate) : this.utils.formatDate(new Date(this.selectedDate), this.format, this.translation);
    },
    computedInputClass: function computedInputClass() {
      if (this.bootstrapStyling) {
        if (typeof this.inputClass === 'string') {
          return [this.inputClass, 'form-control'].join(' ');
        }

        return _objectSpread({
          'form-control': true
        }, this.inputClass);
      }

      return this.inputClass;
    }
  },
  watch: {
    resetTypedDate: function resetTypedDate() {
      this.typedDate = false;
    }
  },
  methods: {
    showCalendar: function showCalendar() {
      this.$emit('showCalendar');
    },

    /**
     * Attempt to parse a typed date
     * @param {Event} event
     */
    parseTypedDate: function parseTypedDate(event) {
      // close calendar if escape or enter are pressed
      if ([27, // escape
      13 // enter
      ].includes(event.keyCode)) {
        this.input.blur();
      }

      if (this.typeable) {
        var typedDate = Date.parse(this.input.value);

        if (!isNaN(typedDate)) {
          this.typedDate = this.input.value;
          this.$emit('typedDate', new Date(this.typedDate));
        }
      }
    },

    /**
     * nullify the typed date to defer to regular formatting
     * called once the input is blurred
     */
    inputBlurred: function inputBlurred() {
      if (this.typeable && isNaN(Date.parse(this.input.value))) {
        this.clearDate();
        this.input.value = null;
        this.typedDate = null;
      }

      this.$emit('closeCalendar');
    },

    /**
     * emit a clearDate event
     */
    clearDate: function clearDate() {
      this.$emit('clearDate');
    }
  },
  mounted: function mounted() {
    this.input = this.$el.querySelector('input');
  }
} // eslint-disable-next-line
;

function vuejs_datepicker_esm_normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = vuejs_datepicker_esm_normalizeComponent;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { class: { "input-group": _vm.bootstrapStyling } },
    [
      _vm.calendarButton
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__calendar-button",
              class: { "input-group-prepend": _vm.bootstrapStyling },
              style: { "cursor:not-allowed;": _vm.disabled },
              on: { click: _vm.showCalendar }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.calendarButtonIcon }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.calendarButtonIconContent) +
                        "\n        "
                    ),
                    !_vm.calendarButtonIcon
                      ? _c("span", [_vm._v("…")])
                      : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("input", {
        ref: _vm.refName,
        class: _vm.computedInputClass,
        attrs: {
          type: _vm.inline ? "hidden" : "text",
          name: _vm.name,
          id: _vm.id,
          "open-date": _vm.openDate,
          placeholder: _vm.placeholder,
          "clear-button": _vm.clearButton,
          disabled: _vm.disabled,
          required: _vm.required,
          readonly: !_vm.typeable,
          autocomplete: "off"
        },
        domProps: { value: _vm.formattedValue },
        on: {
          click: _vm.showCalendar,
          keyup: _vm.parseTypedDate,
          blur: _vm.inputBlurred
        }
      }),
      _vm._v(" "),
      _vm.clearButton && _vm.selectedDate
        ? _c(
            "span",
            {
              staticClass: "vdp-datepicker__clear-button",
              class: { "input-group-append": _vm.bootstrapStyling },
              on: {
                click: function($event) {
                  return _vm.clearDate()
                }
              }
            },
            [
              _c(
                "span",
                { class: { "input-group-text": _vm.bootstrapStyling } },
                [
                  _c("i", { class: _vm.clearButtonIcon }, [
                    !_vm.clearButtonIcon ? _c("span", [_vm._v("×")]) : _vm._e()
                  ])
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("afterDateInput")
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var DateInput = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    undefined,
    undefined
  );

//
var script$1 = {
  props: {
    showDayView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    fullMonthName: Boolean,
    allowedToShowView: Function,
    dayCellContent: {
      type: Function,
      "default": function _default(day) {
        return day.date;
      }
    },
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    mondayFirst: Boolean,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    /**
     * Returns an array of day names
     * @return {String[]}
     */
    daysOfWeek: function daysOfWeek() {
      if (this.mondayFirst) {
        var tempDays = this.translation.days.slice();
        tempDays.push(tempDays.shift());
        return tempDays;
      }

      return this.translation.days;
    },

    /**
     * Returns the day number of the week less one for the first of the current month
     * Used to show amount of empty cells before the first in the day calendar layout
     * @return {Number}
     */
    blankDays: function blankDays() {
      var d = this.pageDate;
      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());

      if (this.mondayFirst) {
        return this.utils.getDay(dObj) > 0 ? this.utils.getDay(dObj) - 1 : 6;
      }

      return this.utils.getDay(dObj);
    },

    /**
     * @return {Object[]}
     */
    days: function days() {
      var d = this.pageDate;
      var days = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), d.getUTCMonth(), 1)) : new Date(d.getFullYear(), d.getMonth(), 1, d.getHours(), d.getMinutes());
      var daysInMonth = this.utils.daysInMonth(this.utils.getFullYear(dObj), this.utils.getMonth(dObj));

      for (var i = 0; i < daysInMonth; i++) {
        days.push({
          date: this.utils.getDate(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedDate(dObj),
          isDisabled: this.isDisabledDate(dObj),
          isHighlighted: this.isHighlightedDate(dObj),
          isHighlightStart: this.isHighlightStart(dObj),
          isHighlightEnd: this.isHighlightEnd(dObj),
          isToday: this.utils.compareDates(dObj, new Date()),
          isWeekend: this.utils.getDay(dObj) === 0 || this.utils.getDay(dObj) === 6,
          isSaturday: this.utils.getDay(dObj) === 6,
          isSunday: this.utils.getDay(dObj) === 0
        });
        this.utils.setDate(dObj, this.utils.getDate(dObj) + 1);
      }

      return days;
    },

    /**
     * Gets the name of the month the current page is on
     * @return {String}
     */
    currMonthName: function currMonthName() {
      var monthName = this.fullMonthName ? this.translation.months : this.translation.monthsAbbr;
      return this.utils.getMonthNameAbbr(this.utils.getMonth(this.pageDate), monthName);
    },

    /**
     * Gets the name of the year that current page is on
     * @return {Number}
     */
    currYearName: function currYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is this translation using year/month/day format?
     * @return {Boolean}
     */
    isYmd: function isYmd() {
      return this.translation.ymd && this.translation.ymd === true;
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextMonthDisabled(this.pageTimestamp) : this.isPreviousMonthDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousMonthDisabled(this.pageTimestamp) : this.isNextMonthDisabled(this.pageTimestamp);
    }
  },
  methods: {
    selectDate: function selectDate(date) {
      if (date.isDisabled) {
        this.$emit('selectedDisabled', date);
        return false;
      }

      this.$emit('selectDate', date);
    },

    /**
     * @return {Number}
     */
    getPageMonth: function getPageMonth() {
      return this.utils.getMonth(this.pageDate);
    },

    /**
     * Emit an event to show the month picker
     */
    showMonthCalendar: function showMonthCalendar() {
      this.$emit('showMonthCalendar');
    },

    /**
     * Change the page month
     * @param {Number} incrementBy
     */
    changeMonth: function changeMonth(incrementBy) {
      var date = this.pageDate;
      this.utils.setMonth(date, this.utils.getMonth(date) + incrementBy);
      this.$emit('changedMonth', date);
    },

    /**
     * Decrement the page month
     */
    previousMonth: function previousMonth() {
      if (!this.isPreviousMonthDisabled()) {
        this.changeMonth(-1);
      }
    },

    /**
     * Is the previous month disabled?
     * @return {Boolean}
     */
    isPreviousMonthDisabled: function isPreviousMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.to) >= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(d);
    },

    /**
     * Increment the current page month
     */
    nextMonth: function nextMonth() {
      if (!this.isNextMonthDisabled()) {
        this.changeMonth(+1);
      }
    },

    /**
     * Is the next month disabled?
     * @return {Boolean}
     */
    isNextMonthDisabled: function isNextMonthDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var d = this.pageDate;
      return this.utils.getMonth(this.disabledDates.from) <= this.utils.getMonth(d) && this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(d);
    },

    /**
     * Whether a day is selected
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedDate: function isSelectedDate(dObj) {
      return this.selectedDate && this.utils.compareDates(this.selectedDate, dObj);
    },

    /**
     * Whether a day is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledDate: function isDisabledDate(date) {
      var _this = this;

      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.dates !== 'undefined') {
        this.disabledDates.dates.forEach(function (d) {
          if (_this.utils.compareDates(date, d)) {
            disabledDates = true;
            return true;
          }
        });
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to && date < this.disabledDates.to) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from && date > this.disabledDates.from) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.ranges !== 'undefined') {
        this.disabledDates.ranges.forEach(function (range) {
          if (typeof range.from !== 'undefined' && range.from && typeof range.to !== 'undefined' && range.to) {
            if (date < range.to && date > range.from) {
              disabledDates = true;
              return true;
            }
          }
        });
      }

      if (typeof this.disabledDates.days !== 'undefined' && this.disabledDates.days.indexOf(this.utils.getDay(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.daysOfMonth !== 'undefined' && this.disabledDates.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        disabledDates = true;
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    },

    /**
     * Whether a day is highlighted (only if it is not disabled already except when highlighted.includeDisabled is true)
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightedDate: function isHighlightedDate(date) {
      var _this2 = this;

      if (!(this.highlighted && this.highlighted.includeDisabled) && this.isDisabledDate(date)) {
        return false;
      }

      var highlighted = false;

      if (typeof this.highlighted === 'undefined') {
        return false;
      }

      if (typeof this.highlighted.dates !== 'undefined') {
        this.highlighted.dates.forEach(function (d) {
          if (_this2.utils.compareDates(date, d)) {
            highlighted = true;
            return true;
          }
        });
      }

      if (this.isDefined(this.highlighted.from) && this.isDefined(this.highlighted.to)) {
        highlighted = date >= this.highlighted.from && date <= this.highlighted.to;
      }

      if (typeof this.highlighted.days !== 'undefined' && this.highlighted.days.indexOf(this.utils.getDay(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.daysOfMonth !== 'undefined' && this.highlighted.daysOfMonth.indexOf(this.utils.getDate(date)) !== -1) {
        highlighted = true;
      }

      if (typeof this.highlighted.customPredictor === 'function' && this.highlighted.customPredictor(date)) {
        highlighted = true;
      }

      return highlighted;
    },
    dayClasses: function dayClasses(day) {
      return {
        'selected': day.isSelected,
        'disabled': day.isDisabled,
        'highlighted': day.isHighlighted,
        'today': day.isToday,
        'weekend': day.isWeekend,
        'sat': day.isSaturday,
        'sun': day.isSunday,
        'highlight-start': day.isHighlightStart,
        'highlight-end': day.isHighlightEnd
      };
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightStart: function isHighlightStart(date) {
      return this.isHighlightedDate(date) && this.highlighted.from instanceof Date && this.utils.getFullYear(this.highlighted.from) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.from) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.from) === this.utils.getDate(date);
    },

    /**
     * Whether a day is highlighted and it is the first date
     * in the highlighted range of dates
     * @param {Date}
     * @return {Boolean}
     */
    isHighlightEnd: function isHighlightEnd(date) {
      return this.isHighlightedDate(date) && this.highlighted.to instanceof Date && this.utils.getFullYear(this.highlighted.to) === this.utils.getFullYear(date) && this.utils.getMonth(this.highlighted.to) === this.utils.getMonth(date) && this.utils.getDate(this.highlighted.to) === this.utils.getDate(date);
    },

    /**
     * Helper
     * @param  {mixed}  prop
     * @return {Boolean}
     */
    isDefined: function isDefined(prop) {
      return typeof prop !== 'undefined' && prop;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showDayView,
          expression: "showDayView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextMonth() : _vm.previousMonth();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "day__month_btn",
            class: _vm.allowedToShowView("month") ? "up" : "",
            on: { click: _vm.showMonthCalendar }
          },
          [
            _vm._v(
              _vm._s(_vm.isYmd ? _vm.currYearName : _vm.currMonthName) +
                " " +
                _vm._s(_vm.isYmd ? _vm.currMonthName : _vm.currYearName)
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousMonth() : _vm.nextMonth();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { class: _vm.isRtl ? "flex-rtl" : "" },
        [
          _vm._l(_vm.daysOfWeek, function(d) {
            return _c(
              "span",
              { key: d.timestamp, staticClass: "cell day-header" },
              [_vm._v(_vm._s(d))]
            )
          }),
          _vm._v(" "),
          _vm.blankDays > 0
            ? _vm._l(_vm.blankDays, function(d) {
                return _c("span", {
                  key: d.timestamp,
                  staticClass: "cell day blank"
                })
              })
            : _vm._e(),
          _vm._l(_vm.days, function(day) {
            return _c("span", {
              key: day.timestamp,
              staticClass: "cell day",
              class: _vm.dayClasses(day),
              domProps: { innerHTML: _vm._s(_vm.dayCellContent(day)) },
              on: {
                click: function($event) {
                  return _vm.selectDate(day)
                }
              }
            })
          })
        ],
        2
      )
    ],
    2
  )
};
var __vue_staticRenderFns__$1 = [];
__vue_render__$1._withStripped = true;

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerDay = normalizeComponent_1(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    undefined,
    undefined
  );

//
var script$2 = {
  props: {
    showMonthView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  computed: {
    months: function months() {
      var d = this.pageDate;
      var months = []; // set up a new date object to the beginning of the current 'page'

      var dObj = this.useUtc ? new Date(Date.UTC(d.getUTCFullYear(), 0, d.getUTCDate())) : new Date(d.getFullYear(), 0, d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 12; i++) {
        months.push({
          month: this.utils.getMonthName(i, this.translation.months),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedMonth(dObj),
          isDisabled: this.isDisabledMonth(dObj)
        });
        this.utils.setMonth(dObj, this.utils.getMonth(dObj) + 1);
      }

      return months;
    },

    /**
     * Get year name on current page.
     * @return {String}
     */
    pageYearName: function pageYearName() {
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(this.utils.getFullYear(this.pageDate)).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation disabled
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextYearDisabled(this.pageTimestamp) : this.isPreviousYearDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation disabled
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousYearDisabled(this.pageTimestamp) : this.isNextYearDisabled(this.pageTimestamp);
    }
  },
  methods: {
    /**
     * Emits a selectMonth event
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      if (month.isDisabled) {
        return false;
      }

      this.$emit('selectMonth', month);
    },

    /**
     * Changes the year up or down
     * @param {Number} incrementBy
     */
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedYear', date);
    },

    /**
     * Decrements the year
     */
    previousYear: function previousYear() {
      if (!this.isPreviousYearDisabled()) {
        this.changeYear(-1);
      }
    },

    /**
     * Checks if the previous year is disabled or not
     * @return {Boolean}
     */
    isPreviousYearDisabled: function isPreviousYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.to) >= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Increments the year
     */
    nextYear: function nextYear() {
      if (!this.isNextYearDisabled()) {
        this.changeYear(1);
      }
    },

    /**
     * Checks if the next year is disabled or not
     * @return {Boolean}
     */
    isNextYearDisabled: function isNextYearDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      return this.utils.getFullYear(this.disabledDates.from) <= this.utils.getFullYear(this.pageDate);
    },

    /**
     * Emits an event that shows the year calendar
     */
    showYearCalendar: function showYearCalendar() {
      this.$emit('showYearCalendar');
    },

    /**
     * Whether the selected date is in this month
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedMonth: function isSelectedMonth(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date) && this.utils.getMonth(this.selectedDate) === this.utils.getMonth(date);
    },

    /**
     * Whether a month is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledMonth: function isDisabledMonth(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined') {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getMonth(date) < this.utils.getMonth(this.disabledDates.to) && this.utils.getFullYear(date) <= this.utils.getFullYear(this.disabledDates.to) || this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getMonth(date) > this.utils.getMonth(this.disabledDates.from) && this.utils.getFullYear(date) >= this.utils.getFullYear(this.disabledDates.from) || this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showMonthView,
          expression: "showMonthView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextYear() : _vm.previousYear();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "month__year_btn",
            class: _vm.allowedToShowView("year") ? "up" : "",
            on: { click: _vm.showYearCalendar }
          },
          [_vm._v(_vm._s(_vm.pageYearName))]
        ),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousYear() : _vm.nextYear();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.months, function(month) {
        return _c(
          "span",
          {
            key: month.timestamp,
            staticClass: "cell month",
            class: { selected: month.isSelected, disabled: month.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectMonth(month)
              }
            }
          },
          [_vm._v(_vm._s(month.month))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$2 = [];
__vue_render__$2._withStripped = true;

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerMonth = normalizeComponent_1(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    undefined,
    undefined
  );

//
var script$3 = {
  props: {
    showYearView: Boolean,
    selectedDate: Date,
    pageDate: Date,
    pageTimestamp: Number,
    disabledDates: Object,
    highlighted: Object,
    calendarClass: [String, Object, Array],
    calendarStyle: Object,
    translation: Object,
    isRtl: Boolean,
    allowedToShowView: Function,
    useUtc: Boolean
  },
  computed: {
    years: function years() {
      var d = this.pageDate;
      var years = []; // set up a new date object to the beginning of the current 'page'7

      var dObj = this.useUtc ? new Date(Date.UTC(Math.floor(d.getUTCFullYear() / 10) * 10, d.getUTCMonth(), d.getUTCDate())) : new Date(Math.floor(d.getFullYear() / 10) * 10, d.getMonth(), d.getDate(), d.getHours(), d.getMinutes());

      for (var i = 0; i < 10; i++) {
        years.push({
          year: this.utils.getFullYear(dObj),
          timestamp: dObj.getTime(),
          isSelected: this.isSelectedYear(dObj),
          isDisabled: this.isDisabledYear(dObj)
        });
        this.utils.setFullYear(dObj, this.utils.getFullYear(dObj) + 1);
      }

      return years;
    },

    /**
     * @return {String}
     */
    getPageDecade: function getPageDecade() {
      var decadeStart = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10;
      var decadeEnd = decadeStart + 9;
      var yearSuffix = this.translation.yearSuffix;
      return "".concat(decadeStart, " - ").concat(decadeEnd).concat(yearSuffix);
    },

    /**
     * Is the left hand navigation button disabled?
     * @return {Boolean}
     */
    isLeftNavDisabled: function isLeftNavDisabled() {
      return this.isRtl ? this.isNextDecadeDisabled(this.pageTimestamp) : this.isPreviousDecadeDisabled(this.pageTimestamp);
    },

    /**
     * Is the right hand navigation button disabled?
     * @return {Boolean}
     */
    isRightNavDisabled: function isRightNavDisabled() {
      return this.isRtl ? this.isPreviousDecadeDisabled(this.pageTimestamp) : this.isNextDecadeDisabled(this.pageTimestamp);
    }
  },
  data: function data() {
    var constructedDateUtils = makeDateUtils(this.useUtc);
    return {
      utils: constructedDateUtils
    };
  },
  methods: {
    selectYear: function selectYear(year) {
      if (year.isDisabled) {
        return false;
      }

      this.$emit('selectYear', year);
    },
    changeYear: function changeYear(incrementBy) {
      var date = this.pageDate;
      this.utils.setFullYear(date, this.utils.getFullYear(date) + incrementBy);
      this.$emit('changedDecade', date);
    },
    previousDecade: function previousDecade() {
      if (this.isPreviousDecadeDisabled()) {
        return false;
      }

      this.changeYear(-10);
    },
    isPreviousDecadeDisabled: function isPreviousDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.to) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.to);
      var lastYearInPreviousPage = Math.floor(this.utils.getFullYear(this.pageDate) / 10) * 10 - 1;
      return disabledYear > lastYearInPreviousPage;
    },
    nextDecade: function nextDecade() {
      if (this.isNextDecadeDisabled()) {
        return false;
      }

      this.changeYear(10);
    },
    isNextDecadeDisabled: function isNextDecadeDisabled() {
      if (!this.disabledDates || !this.disabledDates.from) {
        return false;
      }

      var disabledYear = this.utils.getFullYear(this.disabledDates.from);
      var firstYearInNextPage = Math.ceil(this.utils.getFullYear(this.pageDate) / 10) * 10;
      return disabledYear < firstYearInNextPage;
    },

    /**
     * Whether the selected date is in this year
     * @param {Date}
     * @return {Boolean}
     */
    isSelectedYear: function isSelectedYear(date) {
      return this.selectedDate && this.utils.getFullYear(this.selectedDate) === this.utils.getFullYear(date);
    },

    /**
     * Whether a year is disabled
     * @param {Date}
     * @return {Boolean}
     */
    isDisabledYear: function isDisabledYear(date) {
      var disabledDates = false;

      if (typeof this.disabledDates === 'undefined' || !this.disabledDates) {
        return false;
      }

      if (typeof this.disabledDates.to !== 'undefined' && this.disabledDates.to) {
        if (this.utils.getFullYear(date) < this.utils.getFullYear(this.disabledDates.to)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.from !== 'undefined' && this.disabledDates.from) {
        if (this.utils.getFullYear(date) > this.utils.getFullYear(this.disabledDates.from)) {
          disabledDates = true;
        }
      }

      if (typeof this.disabledDates.customPredictor === 'function' && this.disabledDates.customPredictor(date)) {
        disabledDates = true;
      }

      return disabledDates;
    }
  } // eslint-disable-next-line

};

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showYearView,
          expression: "showYearView"
        }
      ],
      class: [_vm.calendarClass, "vdp-datepicker__calendar"],
      style: _vm.calendarStyle,
      on: {
        mousedown: function($event) {
          $event.preventDefault();
        }
      }
    },
    [
      _vm._t("beforeCalendarHeader"),
      _vm._v(" "),
      _c("header", [
        _c(
          "span",
          {
            staticClass: "prev",
            class: { disabled: _vm.isLeftNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.nextDecade() : _vm.previousDecade();
              }
            }
          },
          [_vm._v("<")]
        ),
        _vm._v(" "),
        _c("span", [_vm._v(_vm._s(_vm.getPageDecade))]),
        _vm._v(" "),
        _c(
          "span",
          {
            staticClass: "next",
            class: { disabled: _vm.isRightNavDisabled },
            on: {
              click: function($event) {
                _vm.isRtl ? _vm.previousDecade() : _vm.nextDecade();
              }
            }
          },
          [_vm._v(">")]
        )
      ]),
      _vm._v(" "),
      _vm._l(_vm.years, function(year) {
        return _c(
          "span",
          {
            key: year.timestamp,
            staticClass: "cell year",
            class: { selected: year.isSelected, disabled: year.isDisabled },
            on: {
              click: function($event) {
                $event.stopPropagation();
                return _vm.selectYear(year)
              }
            }
          },
          [_vm._v(_vm._s(year.year))]
        )
      })
    ],
    2
  )
};
var __vue_staticRenderFns__$3 = [];
__vue_render__$3._withStripped = true;

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  

  
  var PickerYear = normalizeComponent_1(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    undefined,
    undefined
  );

//
var script$4 = {
  components: {
    DateInput: DateInput,
    PickerDay: PickerDay,
    PickerMonth: PickerMonth,
    PickerYear: PickerYear
  },
  props: {
    value: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    name: String,
    refName: String,
    id: String,
    format: {
      type: [String, Function],
      "default": 'dd MMM yyyy'
    },
    language: {
      type: Object,
      "default": function _default() {
        return en;
      }
    },
    openDate: {
      validator: function validator(val) {
        return utils$1.validateDateInput(val);
      }
    },
    dayCellContent: Function,
    fullMonthName: Boolean,
    disabledDates: Object,
    highlighted: Object,
    placeholder: String,
    inline: Boolean,
    calendarClass: [String, Object, Array],
    inputClass: [String, Object, Array],
    wrapperClass: [String, Object, Array],
    mondayFirst: Boolean,
    clearButton: Boolean,
    clearButtonIcon: String,
    calendarButton: Boolean,
    calendarButtonIcon: String,
    calendarButtonIconContent: String,
    bootstrapStyling: Boolean,
    initialView: String,
    disabled: Boolean,
    required: Boolean,
    typeable: Boolean,
    useUtc: Boolean,
    minimumView: {
      type: String,
      "default": 'day'
    },
    maximumView: {
      type: String,
      "default": 'year'
    }
  },
  data: function data() {
    var startDate = this.openDate ? new Date(this.openDate) : new Date();
    var constructedDateUtils = makeDateUtils(this.useUtc);
    var pageTimestamp = constructedDateUtils.setDate(startDate, 1);
    return {
      /*
       * Vue cannot observe changes to a Date Object so date must be stored as a timestamp
       * This represents the first day of the current viewing month
       * {Number}
       */
      pageTimestamp: pageTimestamp,

      /*
       * Selected Date
       * {Date}
       */
      selectedDate: null,

      /*
       * Flags to show calendar views
       * {Boolean}
       */
      showDayView: false,
      showMonthView: false,
      showYearView: false,

      /*
       * Positioning
       */
      calendarHeight: 0,
      resetTypedDate: new Date(),
      utils: constructedDateUtils
    };
  },
  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  },
  computed: {
    computedInitialView: function computedInitialView() {
      if (!this.initialView) {
        return this.minimumView;
      }

      return this.initialView;
    },
    pageDate: function pageDate() {
      return new Date(this.pageTimestamp);
    },
    translation: function translation() {
      return this.language;
    },
    calendarStyle: function calendarStyle() {
      return {
        position: this.isInline ? 'static' : undefined
      };
    },
    isOpen: function isOpen() {
      return this.showDayView || this.showMonthView || this.showYearView;
    },
    isInline: function isInline() {
      return !!this.inline;
    },
    isRtl: function isRtl() {
      return this.translation.rtl === true;
    }
  },
  methods: {
    /**
     * Called in the event that the user navigates to date pages and
     * closes the picker without selecting a date.
     */
    resetDefaultPageDate: function resetDefaultPageDate() {
      if (this.selectedDate === null) {
        this.setPageDate();
        return;
      }

      this.setPageDate(this.selectedDate);
    },

    /**
     * Effectively a toggle to show/hide the calendar
     * @return {mixed}
     */
    showCalendar: function showCalendar() {
      if (this.disabled || this.isInline) {
        return false;
      }

      if (this.isOpen) {
        return this.close(true);
      }

      this.setInitialView();
    },

    /**
     * Sets the initial picker page view: day, month or year
     */
    setInitialView: function setInitialView() {
      var initialView = this.computedInitialView;

      if (!this.allowedToShowView(initialView)) {
        throw new Error("initialView '".concat(this.initialView, "' cannot be rendered based on minimum '").concat(this.minimumView, "' and maximum '").concat(this.maximumView, "'"));
      }

      switch (initialView) {
        case 'year':
          this.showYearCalendar();
          break;

        case 'month':
          this.showMonthCalendar();
          break;

        default:
          this.showDayCalendar();
          break;
      }
    },

    /**
     * Are we allowed to show a specific picker view?
     * @param {String} view
     * @return {Boolean}
     */
    allowedToShowView: function allowedToShowView(view) {
      var views = ['day', 'month', 'year'];
      var minimumViewIndex = views.indexOf(this.minimumView);
      var maximumViewIndex = views.indexOf(this.maximumView);
      var viewIndex = views.indexOf(view);
      return viewIndex >= minimumViewIndex && viewIndex <= maximumViewIndex;
    },

    /**
     * Show the day picker
     * @return {Boolean}
     */
    showDayCalendar: function showDayCalendar() {
      if (!this.allowedToShowView('day')) {
        return false;
      }

      this.close();
      this.showDayView = true;
      return true;
    },

    /**
     * Show the month picker
     * @return {Boolean}
     */
    showMonthCalendar: function showMonthCalendar() {
      if (!this.allowedToShowView('month')) {
        return false;
      }

      this.close();
      this.showMonthView = true;
      return true;
    },

    /**
     * Show the year picker
     * @return {Boolean}
     */
    showYearCalendar: function showYearCalendar() {
      if (!this.allowedToShowView('year')) {
        return false;
      }

      this.close();
      this.showYearView = true;
      return true;
    },

    /**
     * Set the selected date
     * @param {Number} timestamp
     */
    setDate: function setDate(timestamp) {
      var date = new Date(timestamp);
      this.selectedDate = date;
      this.setPageDate(date);
      this.$emit('selected', date);
      this.$emit('input', date);
    },

    /**
     * Clear the selected date
     */
    clearDate: function clearDate() {
      this.selectedDate = null;
      this.setPageDate();
      this.$emit('selected', null);
      this.$emit('input', null);
      this.$emit('cleared');
    },

    /**
     * @param {Object} date
     */
    selectDate: function selectDate(date) {
      this.setDate(date.timestamp);

      if (!this.isInline) {
        this.close(true);
      }

      this.resetTypedDate = new Date();
    },

    /**
     * @param {Object} date
     */
    selectDisabledDate: function selectDisabledDate(date) {
      this.$emit('selectedDisabled', date);
    },

    /**
     * @param {Object} month
     */
    selectMonth: function selectMonth(month) {
      var date = new Date(month.timestamp);

      if (this.allowedToShowView('day')) {
        this.setPageDate(date);
        this.$emit('changedMonth', month);
        this.showDayCalendar();
      } else {
        this.selectDate(month);
      }
    },

    /**
     * @param {Object} year
     */
    selectYear: function selectYear(year) {
      var date = new Date(year.timestamp);

      if (this.allowedToShowView('month')) {
        this.setPageDate(date);
        this.$emit('changedYear', year);
        this.showMonthCalendar();
      } else {
        this.selectDate(year);
      }
    },

    /**
     * Set the datepicker value
     * @param {Date|String|Number|null} date
     */
    setValue: function setValue(date) {
      if (typeof date === 'string' || typeof date === 'number') {
        var parsed = new Date(date);
        date = isNaN(parsed.valueOf()) ? null : parsed;
      }

      if (!date) {
        this.setPageDate();
        this.selectedDate = null;
        return;
      }

      this.selectedDate = date;
      this.setPageDate(date);
    },

    /**
     * Sets the date that the calendar should open on
     */
    setPageDate: function setPageDate(date) {
      if (!date) {
        if (this.openDate) {
          date = new Date(this.openDate);
        } else {
          date = new Date();
        }
      }

      this.pageTimestamp = this.utils.setDate(new Date(date), 1);
    },

    /**
     * Handles a month change from the day picker
     */
    handleChangedMonthFromDayPicker: function handleChangedMonthFromDayPicker(date) {
      this.setPageDate(date);
      this.$emit('changedMonth', date);
    },

    /**
     * Set the date from a typedDate event
     */
    setTypedDate: function setTypedDate(date) {
      this.setDate(date.getTime());
    },

    /**
     * Close all calendar layers
     * @param {Boolean} emitEvent - emit close event
     */
    close: function close(emitEvent) {
      this.showDayView = this.showMonthView = this.showYearView = false;

      if (!this.isInline) {
        if (emitEvent) {
          this.$emit('closed');
        }

        document.removeEventListener('click', this.clickOutside, false);
      }
    },

    /**
     * Initiate the component
     */
    init: function init() {
      if (this.value) {
        this.setValue(this.value);
      }

      if (this.isInline) {
        this.setInitialView();
      }
    }
  },
  mounted: function mounted() {
    this.init();
  }
} // eslint-disable-next-line
;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}
var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    {
      staticClass: "vdp-datepicker",
      class: [_vm.wrapperClass, _vm.isRtl ? "rtl" : ""]
    },
    [
      _c(
        "date-input",
        {
          attrs: {
            selectedDate: _vm.selectedDate,
            resetTypedDate: _vm.resetTypedDate,
            format: _vm.format,
            translation: _vm.translation,
            inline: _vm.inline,
            id: _vm.id,
            name: _vm.name,
            refName: _vm.refName,
            openDate: _vm.openDate,
            placeholder: _vm.placeholder,
            inputClass: _vm.inputClass,
            typeable: _vm.typeable,
            clearButton: _vm.clearButton,
            clearButtonIcon: _vm.clearButtonIcon,
            calendarButton: _vm.calendarButton,
            calendarButtonIcon: _vm.calendarButtonIcon,
            calendarButtonIconContent: _vm.calendarButtonIconContent,
            disabled: _vm.disabled,
            required: _vm.required,
            bootstrapStyling: _vm.bootstrapStyling,
            "use-utc": _vm.useUtc
          },
          on: {
            showCalendar: _vm.showCalendar,
            closeCalendar: _vm.close,
            typedDate: _vm.setTypedDate,
            clearDate: _vm.clearDate
          }
        },
        [_vm._t("afterDateInput", null, { slot: "afterDateInput" })],
        2
      ),
      _vm._v(" "),
      _vm.allowedToShowView("day")
        ? _c(
            "picker-day",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showDayView: _vm.showDayView,
                fullMonthName: _vm.fullMonthName,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                highlighted: _vm.highlighted,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                pageTimestamp: _vm.pageTimestamp,
                isRtl: _vm.isRtl,
                mondayFirst: _vm.mondayFirst,
                dayCellContent: _vm.dayCellContent,
                "use-utc": _vm.useUtc
              },
              on: {
                changedMonth: _vm.handleChangedMonthFromDayPicker,
                selectDate: _vm.selectDate,
                showMonthCalendar: _vm.showMonthCalendar,
                selectedDisabled: _vm.selectDisabledDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("month")
        ? _c(
            "picker-month",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showMonthView: _vm.showMonthView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: {
                selectMonth: _vm.selectMonth,
                showYearCalendar: _vm.showYearCalendar,
                changedYear: _vm.setPageDate
              }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.allowedToShowView("year")
        ? _c(
            "picker-year",
            {
              attrs: {
                pageDate: _vm.pageDate,
                selectedDate: _vm.selectedDate,
                showYearView: _vm.showYearView,
                allowedToShowView: _vm.allowedToShowView,
                disabledDates: _vm.disabledDates,
                calendarClass: _vm.calendarClass,
                calendarStyle: _vm.calendarStyle,
                translation: _vm.translation,
                isRtl: _vm.isRtl,
                "use-utc": _vm.useUtc
              },
              on: { selectYear: _vm.selectYear, changedDecade: _vm.setPageDate }
            },
            [
              _vm._t("beforeCalendarHeader", null, {
                slot: "beforeCalendarHeader"
              })
            ],
            2
          )
        : _vm._e()
    ],
    1
  )
};
var __vue_staticRenderFns__$4 = [];
__vue_render__$4._withStripped = true;

  /* style */
  const __vue_inject_styles__$4 = function (inject) {
    if (!inject) return
    inject("data-v-64ca2bb5_0", { source: ".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n", map: {"version":3,"sources":["Datepicker.vue"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,0BAA0B;EAC1B,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,4CAA4C;EAC5C,6BAA6B;AAC/B;AACA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,4BAA4B;AAC9B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,cAAc;EACd,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,cAAc;EACd,0BAA0B;EAC1B,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;AAC/B;AACA;;;EAGE,eAAe;AACjB;AACA;;;EAGE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,cAAc;AAChB;AACA;;EAEE,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,eAAe;AACjB","file":"Datepicker.vue","sourcesContent":[".rtl {\n  direction: rtl;\n}\n.vdp-datepicker {\n  position: relative;\n  text-align: left;\n}\n.vdp-datepicker * {\n  box-sizing: border-box;\n}\n.vdp-datepicker__calendar {\n  position: absolute;\n  z-index: 100;\n  background: #fff;\n  width: 300px;\n  border: 1px solid #ccc;\n}\n.vdp-datepicker__calendar header {\n  display: block;\n  line-height: 40px;\n}\n.vdp-datepicker__calendar header span {\n  display: inline-block;\n  text-align: center;\n  width: 71.42857142857143%;\n  float: left;\n}\n.vdp-datepicker__calendar header .prev,\n.vdp-datepicker__calendar header .next {\n  width: 14.285714285714286%;\n  float: left;\n  text-indent: -10000px;\n  position: relative;\n}\n.vdp-datepicker__calendar header .prev:after,\n.vdp-datepicker__calendar header .next:after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translateX(-50%) translateY(-50%);\n  border: 6px solid transparent;\n}\n.vdp-datepicker__calendar header .prev:after {\n  border-right: 10px solid #000;\n  margin-left: -5px;\n}\n.vdp-datepicker__calendar header .prev.disabled:after {\n  border-right: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .next:after {\n  border-left: 10px solid #000;\n  margin-left: 5px;\n}\n.vdp-datepicker__calendar header .next.disabled:after {\n  border-left: 10px solid #ddd;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled),\n.vdp-datepicker__calendar header .next:not(.disabled),\n.vdp-datepicker__calendar header .up:not(.disabled) {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar header .prev:not(.disabled):hover,\n.vdp-datepicker__calendar header .next:not(.disabled):hover,\n.vdp-datepicker__calendar header .up:not(.disabled):hover {\n  background: #eee;\n}\n.vdp-datepicker__calendar .disabled {\n  color: #ddd;\n  cursor: default;\n}\n.vdp-datepicker__calendar .flex-rtl {\n  display: flex;\n  width: inherit;\n  flex-wrap: wrap;\n}\n.vdp-datepicker__calendar .cell {\n  display: inline-block;\n  padding: 0 5px;\n  width: 14.285714285714286%;\n  height: 40px;\n  line-height: 40px;\n  text-align: center;\n  vertical-align: middle;\n  border: 1px solid transparent;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year {\n  cursor: pointer;\n}\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,\n.vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {\n  border: 1px solid #4bd;\n}\n.vdp-datepicker__calendar .cell.selected {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected:hover {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.selected.highlighted {\n  background: #4bd;\n}\n.vdp-datepicker__calendar .cell.highlighted {\n  background: #cae5ed;\n}\n.vdp-datepicker__calendar .cell.highlighted.disabled {\n  color: #a3a3a3;\n}\n.vdp-datepicker__calendar .cell.grey {\n  color: #888;\n}\n.vdp-datepicker__calendar .cell.grey:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header {\n  font-size: 75%;\n  white-space: nowrap;\n  cursor: inherit;\n}\n.vdp-datepicker__calendar .cell.day-header:hover {\n  background: inherit;\n}\n.vdp-datepicker__calendar .month,\n.vdp-datepicker__calendar .year {\n  width: 33.333%;\n}\n.vdp-datepicker__clear-button,\n.vdp-datepicker__calendar-button {\n  cursor: pointer;\n  font-style: normal;\n}\n.vdp-datepicker__clear-button.disabled,\n.vdp-datepicker__calendar-button.disabled {\n  color: #999;\n  cursor: default;\n}\n"]}, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject SSR */
  

  
  var Datepicker = normalizeComponent_1(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    browser,
    undefined
  );

/* harmony default export */ var vuejs_datepicker_esm = (Datepicker);

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormItemDateMixin.ts










var TjipFormItemDateMixin_TjipFormItemDateMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormItemDateMixin, _Vue);

  function TjipFormItemDateMixin() {
    _classCallCheck(this, TjipFormItemDateMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemDateMixin).apply(this, arguments));
  }

  _createClass(TjipFormItemDateMixin, [{
    key: "resolvedFormat",
    get: function get() {
      return this.format || 'DD-MM-YYYY';
    }
  }, {
    key: "resolvedErrorFormat",
    get: function get() {
      return this.errorFormat || this.resolvedFormat;
    }
  }]);

  return TjipFormItemDateMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormItemDateMixin_TjipFormItemDateMixin.prototype, "format", void 0);

__decorate([Prop()], TjipFormItemDateMixin_TjipFormItemDateMixin.prototype, "errorFormat", void 0);

__decorate([Prop()], TjipFormItemDateMixin_TjipFormItemDateMixin.prototype, "twoDigitBaseYear", void 0);

__decorate([Prop()], TjipFormItemDateMixin_TjipFormItemDateMixin.prototype, "buttonTabindex", void 0);

__decorate([Prop()], TjipFormItemDateMixin_TjipFormItemDateMixin.prototype, "locale", void 0);

__decorate([Prop({
  default: undefined
})], TjipFormItemDateMixin_TjipFormItemDateMixin.prototype, "datepicker", void 0);

TjipFormItemDateMixin_TjipFormItemDateMixin = __decorate([vue_class_component_esm], TjipFormItemDateMixin_TjipFormItemDateMixin);

// EXTERNAL MODULE: ./node_modules/vuejs-datepicker/dist/locale/index.js
var dist_locale = __webpack_require__("2430");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/date/TjipFormControlDateComponent.ts?vue&type=script&lang=ts&




















var TjipFormControlDateComponentvue_type_script_lang_ts_moment = external_moment_default.a;

var TjipFormControlDateComponentvue_type_script_lang_ts_TjipFormControlDateComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlDateComponent, _Mixins);

  function TjipFormControlDateComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlDateComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlDateComponent).apply(this, arguments));
    _this.datepickerIsOpen = false;
    _this.initialView = 'day';
    _this.resolvedOpenDate = new Date(); // Need to initialize in order to be observed, init undone in mounted

    _this.resolvedDatepickerValue = new Date();
    return _this;
  }

  _createClass(TjipFormControlDateComponent, [{
    key: "toggleDatepicker",
    value: function toggleDatepicker() {
      var host = this.$refs.datepickerHost;

      if (host && !host.isOpen) {
        host.showCalendar();
        this.datepickerIsOpen = true;
        this.$refs.input.focus();
      }
    }
  }, {
    key: "datepickerOpened",
    value: function datepickerOpened() {
      this.datepickerIsOpen = true;
    }
  }, {
    key: "datepickerClosed",
    value: function datepickerClosed() {
      this.datepickerIsOpen = false;
    }
  }, {
    key: "backdropClicked",
    value: function backdropClicked(event) {
      this.closeDatepicker();
    }
  }, {
    key: "allowKey",
    value: function allowKey(key) {
      var allowedKeys = '1234567890./:- ';
      var result = allowedKeys.indexOf(key) >= 0 || this.parsedFormat.hasTextTokens() || this.parsedFormat.hasTextDateTimeTokens(); // this.$log.debug(`'${key}': ${result}`);

      return result;
    }
  }, {
    key: "allowValue",
    value: function allowValue(value) {
      var numbersToken = '[0-9]*';
      var sepratorToken = '[-:/. ]';
      var regex = new RegExp("".concat(numbersToken).concat(sepratorToken).concat(numbersToken).concat(sepratorToken).concat(numbersToken));
      return regex.test(value);
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      return TjipMomentFilter(value, this.resolvedFormat, this.resolvedLocale);
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      if (value instanceof Date) {
        var val = TjipFormControlDateComponentvue_type_script_lang_ts_moment(value).startOf('day').toDate();
        return {
          value: val,
          revert: false,
          invalid: false,
          viewValue: this.formatValue(value)
        };
      }

      var DATE_SEPARATORS = /[-:/. ]/g;
      var maxSeparatorCount = this.parsedFormat.getSeparators().length;
      var parseValue = value;

      if (value !== '') {
        var allowNumericOnly = !this.parsedFormat.hasTextTokens() && !this.parsedFormat.hasTextDateTimeTokens();
        var isDateOnly = this.parsedFormat.isDateOnly();
        var isTimeOnly = this.parsedFormat.isTimeOnly();
        var separatorChar = allowNumericOnly && maxSeparatorCount && (isDateOnly || isTimeOnly) ? this.parsedFormat.getSeparator() : null;

        if (separatorChar) {
          parseValue = value.replace(DATE_SEPARATORS, separatorChar);
        }
      }

      var match = parseValue && parseValue.match(DATE_SEPARATORS);
      var revert = match && match.length > maxSeparatorCount; // noinspection SpellCheckingInspection

      var m = this.parseDate(parseValue);
      var result = {
        value: m.isValid() ? m.toDate() : value ? TjipFormControlDateComponentvue_type_script_lang_ts_moment.invalid().toDate() : undefined,
        revert: revert,
        invalid: !m.isValid(),
        viewValue: value !== parseValue ? parseValue : undefined
      };
      return result;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.resolveOpenDate();
      this.resolvedDatepickerValue = undefined;
      this.resolveInitialView();
      this.resolveDatepickerValue();
      var host = this.$refs.datepickerHost;

      if (host) {
        var hostInput = host.$el.querySelector('input');

        if (hostInput) {
          hostInput.setAttribute('tabindex', '-1');
        }
      }
    }
  }, {
    key: "parseDate",
    value: function parseDate(value) {
      var baseYear = lodash["isUndefined"](this.twoDigitBaseYear) ? TjipFormControlDateComponentvue_type_script_lang_ts_moment().subtract(50, 'years').year() : this.twoDigitBaseYear;
      var cutOffYear = baseYear % 100;
      var baseCentury = baseYear - cutOffYear;
      var savedParseTwoDigitYear = TjipFormControlDateComponentvue_type_script_lang_ts_moment.parseTwoDigitYear;

      TjipFormControlDateComponentvue_type_script_lang_ts_moment.parseTwoDigitYear = function (yearString) {
        var year = parseInt(yearString, 10);
        return baseCentury + year + (year < cutOffYear ? 100 : 0);
      };

      try {
        return TjipFormControlDateComponentvue_type_script_lang_ts_moment(value, 'DD-MM-YYYY').startOf('day');
      } finally {
        TjipFormControlDateComponentvue_type_script_lang_ts_moment.parseTwoDigitYear = savedParseTwoDigitYear;
      }
    }
  }, {
    key: "updated",
    value: function updated() {
      this.resolveParsedFormat();
    }
  }, {
    key: "resolveParsedFormat",
    value: function resolveParsedFormat() {
      this.parsedFormat = new ParsedMomentFormat_ParsedMomentFormat(this.resolvedFormat);
    }
  }, {
    key: "closeDatepicker",
    value: function closeDatepicker() {
      var host = this.$refs.datepickerHost;

      if (host) {
        host.close(true);
      }
    }
  }, {
    key: "watchDatepicker",
    value: function watchDatepicker() {
      var _this2 = this;

      this.resolveOpenDate();
      this.resolveInitialView();
      Promise.resolve().then(function () {
        _this2.closeDatepicker();
      });
    }
  }, {
    key: "resolveInitialView",
    value: function resolveInitialView() {
      var _this3 = this;

      if (this.datepicker) {
        if (!this.datepicker.alwaysInitialView) {
          var newVal = lodash["isUndefined"](this.value) ? this.datepicker.initialView : this.datepicker.maximumView;

          if (newVal !== this.initialView) {
            this.initialView = newVal;
            Promise.resolve().then(function () {
              _this3.closeDatepicker();
            });
          }
        } else {
          this.initialView = this.datepicker.initialView;
        }
      }
    }
  }, {
    key: "resolveDatepickerValue",
    value: function resolveDatepickerValue() {
      this.resolvedDatepickerValue = this.value instanceof Date && !isNaN(this.value.getTime()) ? this.value : undefined;
    }
  }, {
    key: "resolveOpenDate",
    value: function resolveOpenDate() {
      var value = this.datepicker && this.datepicker.openDate;
      this.resolvedOpenDate = value instanceof Date && !isNaN(value.getTime()) ? value : undefined;
    }
  }, {
    key: "watchValue",
    value: function watchValue(val, oldVal) {
      this.resolveInitialView();
      this.resolveDatepickerValue();
    }
  }, {
    key: "datepickerValue",
    get: function get() {
      return this.resolvedDatepickerValue;
    },
    set: function set(value) {
      this.internalValue = value;
      this.$emit('selected', value);
    }
  }, {
    key: "hasDatepicker",
    get: function get() {
      return !lodash["isUndefined"](this.datepicker);
    }
  }, {
    key: "resolvedLocale",
    get: function get() {
      var i18n = this._i18n;
      var result = this.locale || i18n && i18n.locale || 'en';
      return result;
    }
  }, {
    key: "datepickerLanguage",
    get: function get() {
      switch (this.resolvedLocale) {
        case 'nl':
          {
            return dist_locale["nl"];
          }

        default:
          {
            return dist_locale["en"];
          }
      }
    }
  }, {
    key: "resolvedButtonTabindex",
    get: function get() {
      return lodash["isUndefined"](this.buttonTabindex) ? '-1' : this.buttonTabindex;
    }
  }, {
    key: "syntaxValidatorKey",
    get: function get() {
      return 'syntaxDate';
    }
  }]);

  return TjipFormControlDateComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormItemDateMixin_TjipFormItemDateMixin));

__decorate([Watch('datepicker', {
  deep: true
})], TjipFormControlDateComponentvue_type_script_lang_ts_TjipFormControlDateComponent.prototype, "watchDatepicker", null);

__decorate([Watch('value')], TjipFormControlDateComponentvue_type_script_lang_ts_TjipFormControlDateComponent.prototype, "watchValue", null);

TjipFormControlDateComponentvue_type_script_lang_ts_TjipFormControlDateComponent = __decorate([vue_class_component_esm({
  components: {
    datepicker: vuejs_datepicker_esm
  }
})], TjipFormControlDateComponentvue_type_script_lang_ts_TjipFormControlDateComponent);

/* harmony default export */ var TjipFormControlDateComponentvue_type_script_lang_ts_ = (TjipFormControlDateComponentvue_type_script_lang_ts_TjipFormControlDateComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormControlDateComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var date_TjipFormControlDateComponentvue_type_script_lang_ts_ = (TjipFormControlDateComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormControlDateComponent.scss?vue&type=style&index=0&id=51ec0f78&scoped=true&lang=scss&
var TjipFormControlDateComponentvue_type_style_index_0_id_51ec0f78_scoped_true_lang_scss_ = __webpack_require__("10a7");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormControlDateComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlDateComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("92f2");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormControlDateComponent.vue







/* normalize component */

var TjipFormControlDateComponent_component = normalizeComponent(
  date_TjipFormControlDateComponentvue_type_script_lang_ts_,
  TjipFormControlDateComponentvue_type_template_id_51ec0f78_scoped_true_render,
  TjipFormControlDateComponentvue_type_template_id_51ec0f78_scoped_true_staticRenderFns,
  false,
  null,
  "51ec0f78",
  null
  
)

/* harmony default export */ var date_TjipFormControlDateComponent = (TjipFormControlDateComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormControlDateComponent.ts




















var TjipFormControlDateComponent_moment = external_moment_default.a;

var TjipFormControlDateComponent_TjipFormControlDateComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlDateComponent, _Mixins);

  function TjipFormControlDateComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlDateComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlDateComponent).apply(this, arguments));
    _this.datepickerIsOpen = false;
    _this.initialView = 'day';
    _this.resolvedOpenDate = new Date(); // Need to initialize in order to be observed, init undone in mounted

    _this.resolvedDatepickerValue = new Date();
    return _this;
  }

  _createClass(TjipFormControlDateComponent, [{
    key: "toggleDatepicker",
    value: function toggleDatepicker() {
      var host = this.$refs.datepickerHost;

      if (host && !host.isOpen) {
        host.showCalendar();
        this.datepickerIsOpen = true;
        this.$refs.input.focus();
      }
    }
  }, {
    key: "datepickerOpened",
    value: function datepickerOpened() {
      this.datepickerIsOpen = true;
    }
  }, {
    key: "datepickerClosed",
    value: function datepickerClosed() {
      this.datepickerIsOpen = false;
    }
  }, {
    key: "backdropClicked",
    value: function backdropClicked(event) {
      this.closeDatepicker();
    }
  }, {
    key: "allowKey",
    value: function allowKey(key) {
      var allowedKeys = '1234567890./:- ';
      var result = allowedKeys.indexOf(key) >= 0 || this.parsedFormat.hasTextTokens() || this.parsedFormat.hasTextDateTimeTokens(); // this.$log.debug(`'${key}': ${result}`);

      return result;
    }
  }, {
    key: "allowValue",
    value: function allowValue(value) {
      var numbersToken = '[0-9]*';
      var sepratorToken = '[-:/. ]';
      var regex = new RegExp("".concat(numbersToken).concat(sepratorToken).concat(numbersToken).concat(sepratorToken).concat(numbersToken));
      return regex.test(value);
    }
  }, {
    key: "formatValue",
    value: function formatValue(value) {
      return TjipMomentFilter(value, this.resolvedFormat, this.resolvedLocale);
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      if (value instanceof Date) {
        var val = TjipFormControlDateComponent_moment(value).startOf('day').toDate();
        return {
          value: val,
          revert: false,
          invalid: false,
          viewValue: this.formatValue(value)
        };
      }

      var DATE_SEPARATORS = /[-:/. ]/g;
      var maxSeparatorCount = this.parsedFormat.getSeparators().length;
      var parseValue = value;

      if (value !== '') {
        var allowNumericOnly = !this.parsedFormat.hasTextTokens() && !this.parsedFormat.hasTextDateTimeTokens();
        var isDateOnly = this.parsedFormat.isDateOnly();
        var isTimeOnly = this.parsedFormat.isTimeOnly();
        var separatorChar = allowNumericOnly && maxSeparatorCount && (isDateOnly || isTimeOnly) ? this.parsedFormat.getSeparator() : null;

        if (separatorChar) {
          parseValue = value.replace(DATE_SEPARATORS, separatorChar);
        }
      }

      var match = parseValue && parseValue.match(DATE_SEPARATORS);
      var revert = match && match.length > maxSeparatorCount; // noinspection SpellCheckingInspection

      var m = this.parseDate(parseValue);
      var result = {
        value: m.isValid() ? m.toDate() : value ? TjipFormControlDateComponent_moment.invalid().toDate() : undefined,
        revert: revert,
        invalid: !m.isValid(),
        viewValue: value !== parseValue ? parseValue : undefined
      };
      return result;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.resolveOpenDate();
      this.resolvedDatepickerValue = undefined;
      this.resolveInitialView();
      this.resolveDatepickerValue();
      var host = this.$refs.datepickerHost;

      if (host) {
        var hostInput = host.$el.querySelector('input');

        if (hostInput) {
          hostInput.setAttribute('tabindex', '-1');
        }
      }
    }
  }, {
    key: "parseDate",
    value: function parseDate(value) {
      var baseYear = lodash["isUndefined"](this.twoDigitBaseYear) ? TjipFormControlDateComponent_moment().subtract(50, 'years').year() : this.twoDigitBaseYear;
      var cutOffYear = baseYear % 100;
      var baseCentury = baseYear - cutOffYear;
      var savedParseTwoDigitYear = TjipFormControlDateComponent_moment.parseTwoDigitYear;

      TjipFormControlDateComponent_moment.parseTwoDigitYear = function (yearString) {
        var year = parseInt(yearString, 10);
        return baseCentury + year + (year < cutOffYear ? 100 : 0);
      };

      try {
        return TjipFormControlDateComponent_moment(value, 'DD-MM-YYYY').startOf('day');
      } finally {
        TjipFormControlDateComponent_moment.parseTwoDigitYear = savedParseTwoDigitYear;
      }
    }
  }, {
    key: "updated",
    value: function updated() {
      this.resolveParsedFormat();
    }
  }, {
    key: "resolveParsedFormat",
    value: function resolveParsedFormat() {
      this.parsedFormat = new ParsedMomentFormat_ParsedMomentFormat(this.resolvedFormat);
    }
  }, {
    key: "closeDatepicker",
    value: function closeDatepicker() {
      var host = this.$refs.datepickerHost;

      if (host) {
        host.close(true);
      }
    }
  }, {
    key: "watchDatepicker",
    value: function watchDatepicker() {
      var _this2 = this;

      this.resolveOpenDate();
      this.resolveInitialView();
      Promise.resolve().then(function () {
        _this2.closeDatepicker();
      });
    }
  }, {
    key: "resolveInitialView",
    value: function resolveInitialView() {
      var _this3 = this;

      if (this.datepicker) {
        if (!this.datepicker.alwaysInitialView) {
          var newVal = lodash["isUndefined"](this.value) ? this.datepicker.initialView : this.datepicker.maximumView;

          if (newVal !== this.initialView) {
            this.initialView = newVal;
            Promise.resolve().then(function () {
              _this3.closeDatepicker();
            });
          }
        } else {
          this.initialView = this.datepicker.initialView;
        }
      }
    }
  }, {
    key: "resolveDatepickerValue",
    value: function resolveDatepickerValue() {
      this.resolvedDatepickerValue = this.value instanceof Date && !isNaN(this.value.getTime()) ? this.value : undefined;
    }
  }, {
    key: "resolveOpenDate",
    value: function resolveOpenDate() {
      var value = this.datepicker && this.datepicker.openDate;
      this.resolvedOpenDate = value instanceof Date && !isNaN(value.getTime()) ? value : undefined;
    }
  }, {
    key: "watchValue",
    value: function watchValue(val, oldVal) {
      this.resolveInitialView();
      this.resolveDatepickerValue();
    }
  }, {
    key: "datepickerValue",
    get: function get() {
      return this.resolvedDatepickerValue;
    },
    set: function set(value) {
      this.internalValue = value;
      this.$emit('selected', value);
    }
  }, {
    key: "hasDatepicker",
    get: function get() {
      return !lodash["isUndefined"](this.datepicker);
    }
  }, {
    key: "resolvedLocale",
    get: function get() {
      var i18n = this._i18n;
      var result = this.locale || i18n && i18n.locale || 'en';
      return result;
    }
  }, {
    key: "datepickerLanguage",
    get: function get() {
      switch (this.resolvedLocale) {
        case 'nl':
          {
            return dist_locale["nl"];
          }

        default:
          {
            return dist_locale["en"];
          }
      }
    }
  }, {
    key: "resolvedButtonTabindex",
    get: function get() {
      return lodash["isUndefined"](this.buttonTabindex) ? '-1' : this.buttonTabindex;
    }
  }, {
    key: "syntaxValidatorKey",
    get: function get() {
      return 'syntaxDate';
    }
  }]);

  return TjipFormControlDateComponent;
}(mixins(TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormItemDateMixin_TjipFormItemDateMixin));

__decorate([Watch('datepicker', {
  deep: true
})], TjipFormControlDateComponent_TjipFormControlDateComponent.prototype, "watchDatepicker", null);

__decorate([Watch('value')], TjipFormControlDateComponent_TjipFormControlDateComponent.prototype, "watchValue", null);

TjipFormControlDateComponent_TjipFormControlDateComponent = __decorate([vue_class_component_esm({
  components: {
    datepicker: vuejs_datepicker_esm
  }
})], TjipFormControlDateComponent_TjipFormControlDateComponent);

/* harmony default export */ var controls_date_TjipFormControlDateComponent = (TjipFormControlDateComponent_TjipFormControlDateComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/date/TjipFormGroupDateComponent.vue?vue&type=template&id=e0d9f486&scoped=true&
var TjipFormGroupDateComponentvue_type_template_id_e0d9f486_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-date",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-date',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete,"errorMode":_vm.errorMode,"format":_vm.format,"errorFormat":_vm.errorFormat,"controlWidth":_vm.controlWidth,"twoDigitBaseYear":_vm.twoDigitBaseYear,"buttonTabindex":_vm.buttonTabindex,"locale":_vm.locale,"datepicker":_vm.datepicker},on:{"selected":_vm.selected},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})]},proxy:true}],null,true)},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"syntaxDate"}},[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" voldoet niet aan het formaat '"+_vm._s(_vm.resolvedErrorFormat)+"'")]),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet minimaal "+_vm._s(_vm._f("tjipMoment")(params.min,_vm.resolvedFormat))+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet groter dan "+_vm._s(_vm._f("tjipMoment")(params.min,_vm.resolvedFormat))+" zijn.")]:_vm._e()]}}])}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" mag maximaal "+_vm._s(_vm._f("tjipMoment")(params.max,_vm.resolvedFormat))+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet kleiner dan "+_vm._s(_vm._f("tjipMoment")(params.max,_vm.resolvedFormat))+" zijn.")]:_vm._e()]}}])})],2)}
var TjipFormGroupDateComponentvue_type_template_id_e0d9f486_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormGroupDateComponent.vue?vue&type=template&id=e0d9f486&scoped=true&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/filters/index.ts






// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/date/TjipFormGroupDateComponent.ts?vue&type=script&lang=ts&













var TjipFormGroupDateComponentvue_type_script_lang_ts_TjipFormGroupDateComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupDateComponent, _Mixins);

  function TjipFormGroupDateComponent() {
    _classCallCheck(this, TjipFormGroupDateComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupDateComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupDateComponent, [{
    key: "selected",
    value: function selected(value) {
      this.$emit('selected', value);
    }
  }, {
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupDateComponent;
}(mixins(TjipFiltersMixin_TjipFiltersMixin, TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormItemDateMixin_TjipFormItemDateMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupDateComponentvue_type_script_lang_ts_TjipFormGroupDateComponent = __decorate([vue_class_component_esm({})], TjipFormGroupDateComponentvue_type_script_lang_ts_TjipFormGroupDateComponent);

/* harmony default export */ var TjipFormGroupDateComponentvue_type_script_lang_ts_ = (TjipFormGroupDateComponentvue_type_script_lang_ts_TjipFormGroupDateComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormGroupDateComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var date_TjipFormGroupDateComponentvue_type_script_lang_ts_ = (TjipFormGroupDateComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormGroupDateComponent.scss?vue&type=style&index=0&id=e0d9f486&scoped=true&lang=scss&
var TjipFormGroupDateComponentvue_type_style_index_0_id_e0d9f486_scoped_true_lang_scss_ = __webpack_require__("0c44");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormGroupDateComponent.vue






/* normalize component */

var TjipFormGroupDateComponent_component = normalizeComponent(
  date_TjipFormGroupDateComponentvue_type_script_lang_ts_,
  TjipFormGroupDateComponentvue_type_template_id_e0d9f486_scoped_true_render,
  TjipFormGroupDateComponentvue_type_template_id_e0d9f486_scoped_true_staticRenderFns,
  false,
  null,
  "e0d9f486",
  null
  
)

/* harmony default export */ var date_TjipFormGroupDateComponent = (TjipFormGroupDateComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/date/TjipFormGroupDateComponent.ts













var TjipFormGroupDateComponent_TjipFormGroupDateComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupDateComponent, _Mixins);

  function TjipFormGroupDateComponent() {
    _classCallCheck(this, TjipFormGroupDateComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupDateComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupDateComponent, [{
    key: "selected",
    value: function selected(value) {
      this.$emit('selected', value);
    }
  }, {
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupDateComponent;
}(mixins(TjipFiltersMixin_TjipFiltersMixin, TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormItemDateMixin_TjipFormItemDateMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupDateComponent_TjipFormGroupDateComponent = __decorate([vue_class_component_esm({})], TjipFormGroupDateComponent_TjipFormGroupDateComponent);

/* harmony default export */ var controls_date_TjipFormGroupDateComponent = (TjipFormGroupDateComponent_TjipFormGroupDateComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/addin-wrapper/TjipFormControlAddinWrapperComponent.vue?vue&type=template&id=6d001e8e&scoped=true&
var TjipFormControlAddinWrapperComponentvue_type_template_id_6d001e8e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-addin-wrapper form-control",class:{ disabled: _vm.disabled, 'focus-within': _vm.hasFocusWithin }},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-auto col-addin"},[_c('tjip-when-empty',{staticClass:"addin-left"},[_vm._t("addin-left",[_vm._v(_vm._s(_vm.addinLeft))])],2)],1),_c('div',{staticClass:"col col-addin wrapped-content"},[_vm._t("default")],2),_c('div',{staticClass:"col-auto col-addin"},[_c('tjip-when-empty',{staticClass:"addin-right"},[_vm._t("addin-right",[_vm._v(_vm._s(_vm.addinRight))])],2)],1)])])])}
var TjipFormControlAddinWrapperComponentvue_type_template_id_6d001e8e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/addin-wrapper/TjipFormControlAddinWrapperComponent.vue?vue&type=template&id=6d001e8e&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/addin-wrapper/TjipFormControlAddinWrapperComponent.ts?vue&type=script&lang=ts&









var TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_TjipFormControlAddinWrapperComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlAddinWrapperComponent, _Mixins);

  function TjipFormControlAddinWrapperComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlAddinWrapperComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlAddinWrapperComponent).apply(this, arguments));
    _this.hasFocusWithin = false;
    return _this;
  }

  _createClass(TjipFormControlAddinWrapperComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.unwatchFocusWithin = tjipFocusService.watchFocusWithin(this.$el, function (focused) {
        _this2.hasFocusWithin = focused;
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.unwatchFocusWithin) {
        this.unwatchFocusWithin();
      }
    }
  }]);

  return TjipFormControlAddinWrapperComponent;
}(mixins());

__decorate([Prop()], TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_TjipFormControlAddinWrapperComponent.prototype, "addinLeft", void 0);

__decorate([Prop()], TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_TjipFormControlAddinWrapperComponent.prototype, "addinRight", void 0);

__decorate([Prop()], TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_TjipFormControlAddinWrapperComponent.prototype, "disabled", void 0);

TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_TjipFormControlAddinWrapperComponent = __decorate([vue_class_component_esm({})], TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_TjipFormControlAddinWrapperComponent);

/* harmony default export */ var TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_ = (TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_TjipFormControlAddinWrapperComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/addin-wrapper/TjipFormControlAddinWrapperComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var addin_wrapper_TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_ = (TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/addin-wrapper/TjipFormControlAddinWrapperComponent.scss?vue&type=style&index=0&id=6d001e8e&scoped=true&lang=scss&
var TjipFormControlAddinWrapperComponentvue_type_style_index_0_id_6d001e8e_scoped_true_lang_scss_ = __webpack_require__("fad4");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/addin-wrapper/TjipFormControlAddinWrapperComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlAddinWrapperComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("a63e");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/addin-wrapper/TjipFormControlAddinWrapperComponent.vue







/* normalize component */

var TjipFormControlAddinWrapperComponent_component = normalizeComponent(
  addin_wrapper_TjipFormControlAddinWrapperComponentvue_type_script_lang_ts_,
  TjipFormControlAddinWrapperComponentvue_type_template_id_6d001e8e_scoped_true_render,
  TjipFormControlAddinWrapperComponentvue_type_template_id_6d001e8e_scoped_true_staticRenderFns,
  false,
  null,
  "6d001e8e",
  null
  
)

/* harmony default export */ var addin_wrapper_TjipFormControlAddinWrapperComponent = (TjipFormControlAddinWrapperComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/addin-wrapper/TjipFormControlAddinWrapperComponent.ts









var TjipFormControlAddinWrapperComponent_TjipFormControlAddinWrapperComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlAddinWrapperComponent, _Mixins);

  function TjipFormControlAddinWrapperComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlAddinWrapperComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlAddinWrapperComponent).apply(this, arguments));
    _this.hasFocusWithin = false;
    return _this;
  }

  _createClass(TjipFormControlAddinWrapperComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.unwatchFocusWithin = tjipFocusService.watchFocusWithin(this.$el, function (focused) {
        _this2.hasFocusWithin = focused;
      });
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      if (this.unwatchFocusWithin) {
        this.unwatchFocusWithin();
      }
    }
  }]);

  return TjipFormControlAddinWrapperComponent;
}(mixins());

__decorate([Prop()], TjipFormControlAddinWrapperComponent_TjipFormControlAddinWrapperComponent.prototype, "addinLeft", void 0);

__decorate([Prop()], TjipFormControlAddinWrapperComponent_TjipFormControlAddinWrapperComponent.prototype, "addinRight", void 0);

__decorate([Prop()], TjipFormControlAddinWrapperComponent_TjipFormControlAddinWrapperComponent.prototype, "disabled", void 0);

TjipFormControlAddinWrapperComponent_TjipFormControlAddinWrapperComponent = __decorate([vue_class_component_esm({})], TjipFormControlAddinWrapperComponent_TjipFormControlAddinWrapperComponent);

/* harmony default export */ var controls_addin_wrapper_TjipFormControlAddinWrapperComponent = (TjipFormControlAddinWrapperComponent_TjipFormControlAddinWrapperComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/currency/TjipFormControlCurrencyComponent.vue?vue&type=template&id=53ef32dc&scoped=true&
var TjipFormControlCurrencyComponentvue_type_template_id_53ef32dc_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-control-addin-wrapper',{staticClass:"tjip-form-control-currency",class:( _obj = {'has-error': _vm.showErrors, 'has-success': _vm.isValid}, _obj[_vm.controlWidthClass] = true, _obj ),attrs:{"disabled":_vm.disabled,"addinLeft":_vm.resolvedAddinLeft,"addinRight":_vm.resolvedAddinRight}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],ref:"input",class:{'align-left': _vm.alignLeft},attrs:{"type":"text","name":_vm.resolvedName,"id":_vm.resolvedId,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete},domProps:{"value":(_vm.internalValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.internalValue=$event.target.value}}})])}
var TjipFormControlCurrencyComponentvue_type_template_id_53ef32dc_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormControlCurrencyComponent.vue?vue&type=template&id=53ef32dc&scoped=true&

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-descriptor.js
var get_own_property_descriptor = __webpack_require__("268f");
var get_own_property_descriptor_default = /*#__PURE__*/__webpack_require__.n(get_own_property_descriptor);

// EXTERNAL MODULE: ./node_modules/@babel/runtime-corejs2/core-js/reflect/get.js
var reflect_get = __webpack_require__("8feb");
var get_default = /*#__PURE__*/__webpack_require__.n(reflect_get);

// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/superPropBase.js

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf_getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime-corejs2/helpers/esm/get.js



function get_get(target, property, receiver) {
  if (typeof Reflect !== "undefined" && get_default.a) {
    get_get = get_default.a;
  } else {
    get_get = function _get(target, property, receiver) {
      var base = _superPropBase(target, property);
      if (!base) return;

      var desc = get_own_property_descriptor_default()(base, property);

      if (desc.get) {
        return desc.get.call(receiver);
      }

      return desc.value;
    };
  }

  return get_get(target, property, receiver || target);
}
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormItemCurrencyMixin.ts














var TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormItemCurrencyMixin, _Mixins);

  function TjipFormItemCurrencyMixin() {
    var _this;

    _classCallCheck(this, TjipFormItemCurrencyMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemCurrencyMixin).apply(this, arguments));
    _this.defaultMinimumFractionDigits = 2;
    _this.defaultMaximumFractionDigits = 2;
    return _this;
  }

  _createClass(TjipFormItemCurrencyMixin, [{
    key: "isInteger",
    get: function get() {
      return lodash["includes"](['dash', 'dashes', 'zero'], this.decimalMode);
    }
  }, {
    key: "currencyMaximumFractionDigits",
    get: function get() {
      return this.isInteger ? 0 : this.resolvedMaximumFractionDigits;
    }
  }, {
    key: "currencyMinimumFractionDigits",
    get: function get() {
      return this.isInteger ? 0 : get_get(getPrototypeOf_getPrototypeOf(TjipFormItemCurrencyMixin.prototype), "resolvedMinimumFractionDigits", this);
    }
  }]);

  return TjipFormItemCurrencyMixin;
}(mixins(TjipFormItemNumberMixin_TjipFormItemNumberMixin));

__decorate([Prop()], TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin.prototype, "addinLeft", void 0);

__decorate([Prop()], TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin.prototype, "addinRight", void 0);

__decorate([Prop()], TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin.prototype, "currency", void 0);

__decorate([Prop()], TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin.prototype, "decimalMode", void 0);

__decorate([Prop()], TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin.prototype, "currencyDisplay", void 0);

__decorate([Prop()], TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin.prototype, "controlStyle", void 0);

TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin = __decorate([vue_class_component_esm], TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/currency/TjipFormControlCurrencyComponent.ts?vue&type=script&lang=ts&













var TjipFormControlCurrencyComponentvue_type_script_lang_ts_TjipFormControlCurrencyComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlCurrencyComponent, _Mixins);

  function TjipFormControlCurrencyComponent() {
    _classCallCheck(this, TjipFormControlCurrencyComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlCurrencyComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlCurrencyComponent, [{
    key: "currencyFormat",
    get: function get() {
      return Intl.NumberFormat(this.resolvedLocale, {
        style: 'currency',
        currency: this.currency || 'EUR',
        currencyDisplay: this.currencyDisplay || 'symbol'
      });
    }
  }, {
    key: "allowedMaximumFractionDigits",
    get: function get() {
      return this.currencyMaximumFractionDigits;
    }
  }, {
    key: "formatOptions",
    get: function get() {
      var result = {
        locale: this.resolvedLocale
      };

      if (!lodash["isUndefined"](this.useGrouping)) {
        result.useGrouping = this.useGrouping;
      }

      if (this.hasFocus) {
        result.useGrouping = false;
      }

      result.minimumFractionDigits = this.currencyMinimumFractionDigits;
      result.maximumFractionDigits = this.currencyMaximumFractionDigits;

      if (!this.hasFocus && this.controlStyle === 'inline') {
        Object.assign(result, {
          style: 'currency',
          currency: this.currency || 'EUR',
          currencyDisplay: this.currencyDisplay || 'symbol'
        });
      }

      return result;
    }
  }, {
    key: "resolvedAddinLeft",
    get: function get() {
      if (this.addinLeft) {
        return this.addinLeft;
      } else if (this.controlStyle !== 'inline' && this.currencyDisplay !== 'none') {
        var c = this.currencyFormat.format(0);
        var m1 = /([^0\s]*)\s?0/.exec(c);

        if (m1 && m1[1]) {
          return m1[1];
        } else {
          var m2 = /[.,]00\s?(.*)/.exec(c);

          if (m2 && m2[1]) {
            return m2[1];
          }
        }
      }

      return '';
    }
  }, {
    key: "resolvedAddinRight",
    get: function get() {
      if (this.addinRight) {
        return this.addinRight;
      } else {
        switch (this.decimalMode) {
          case 'dash':
            return "".concat(this.decimalSeparator, "-");

          case 'dashes':
            return "".concat(this.decimalSeparator, "--");

          case 'zero':
            return "".concat(this.decimalSeparator, "00");

          default:
            return '';
        }
      }
    }
  }]);

  return TjipFormControlCurrencyComponent;
}(mixins(TjipFormControlNumberMixin_TjipFormControlNumberMixin, TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin, TjipFormItemTextMixin_TjipFormItemTextMixin));

TjipFormControlCurrencyComponentvue_type_script_lang_ts_TjipFormControlCurrencyComponent = __decorate([vue_class_component_esm({})], TjipFormControlCurrencyComponentvue_type_script_lang_ts_TjipFormControlCurrencyComponent);

/* harmony default export */ var TjipFormControlCurrencyComponentvue_type_script_lang_ts_ = (TjipFormControlCurrencyComponentvue_type_script_lang_ts_TjipFormControlCurrencyComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormControlCurrencyComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var currency_TjipFormControlCurrencyComponentvue_type_script_lang_ts_ = (TjipFormControlCurrencyComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormControlCurrencyComponent.scss?vue&type=style&index=0&id=53ef32dc&scoped=true&lang=scss&
var TjipFormControlCurrencyComponentvue_type_style_index_0_id_53ef32dc_scoped_true_lang_scss_ = __webpack_require__("319b");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormControlCurrencyComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlCurrencyComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("6dff");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormControlCurrencyComponent.vue







/* normalize component */

var TjipFormControlCurrencyComponent_component = normalizeComponent(
  currency_TjipFormControlCurrencyComponentvue_type_script_lang_ts_,
  TjipFormControlCurrencyComponentvue_type_template_id_53ef32dc_scoped_true_render,
  TjipFormControlCurrencyComponentvue_type_template_id_53ef32dc_scoped_true_staticRenderFns,
  false,
  null,
  "53ef32dc",
  null
  
)

/* harmony default export */ var currency_TjipFormControlCurrencyComponent = (TjipFormControlCurrencyComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormControlCurrencyComponent.ts













var TjipFormControlCurrencyComponent_TjipFormControlCurrencyComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlCurrencyComponent, _Mixins);

  function TjipFormControlCurrencyComponent() {
    _classCallCheck(this, TjipFormControlCurrencyComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlCurrencyComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlCurrencyComponent, [{
    key: "currencyFormat",
    get: function get() {
      return Intl.NumberFormat(this.resolvedLocale, {
        style: 'currency',
        currency: this.currency || 'EUR',
        currencyDisplay: this.currencyDisplay || 'symbol'
      });
    }
  }, {
    key: "allowedMaximumFractionDigits",
    get: function get() {
      return this.currencyMaximumFractionDigits;
    }
  }, {
    key: "formatOptions",
    get: function get() {
      var result = {
        locale: this.resolvedLocale
      };

      if (!lodash["isUndefined"](this.useGrouping)) {
        result.useGrouping = this.useGrouping;
      }

      if (this.hasFocus) {
        result.useGrouping = false;
      }

      result.minimumFractionDigits = this.currencyMinimumFractionDigits;
      result.maximumFractionDigits = this.currencyMaximumFractionDigits;

      if (!this.hasFocus && this.controlStyle === 'inline') {
        Object.assign(result, {
          style: 'currency',
          currency: this.currency || 'EUR',
          currencyDisplay: this.currencyDisplay || 'symbol'
        });
      }

      return result;
    }
  }, {
    key: "resolvedAddinLeft",
    get: function get() {
      if (this.addinLeft) {
        return this.addinLeft;
      } else if (this.controlStyle !== 'inline' && this.currencyDisplay !== 'none') {
        var c = this.currencyFormat.format(0);
        var m1 = /([^0\s]*)\s?0/.exec(c);

        if (m1 && m1[1]) {
          return m1[1];
        } else {
          var m2 = /[.,]00\s?(.*)/.exec(c);

          if (m2 && m2[1]) {
            return m2[1];
          }
        }
      }

      return '';
    }
  }, {
    key: "resolvedAddinRight",
    get: function get() {
      if (this.addinRight) {
        return this.addinRight;
      } else {
        switch (this.decimalMode) {
          case 'dash':
            return "".concat(this.decimalSeparator, "-");

          case 'dashes':
            return "".concat(this.decimalSeparator, "--");

          case 'zero':
            return "".concat(this.decimalSeparator, "00");

          default:
            return '';
        }
      }
    }
  }]);

  return TjipFormControlCurrencyComponent;
}(mixins(TjipFormControlNumberMixin_TjipFormControlNumberMixin, TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin, TjipFormItemTextMixin_TjipFormItemTextMixin));

TjipFormControlCurrencyComponent_TjipFormControlCurrencyComponent = __decorate([vue_class_component_esm({})], TjipFormControlCurrencyComponent_TjipFormControlCurrencyComponent);

/* harmony default export */ var controls_currency_TjipFormControlCurrencyComponent = (TjipFormControlCurrencyComponent_TjipFormControlCurrencyComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/currency/TjipFormGroupCurrencyComponent.vue?vue&type=template&id=4470e19e&scoped=true&
var TjipFormGroupCurrencyComponentvue_type_template_id_4470e19e_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-currency",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-currency',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete,"errorMode":_vm.errorMode,"controlWidth":_vm.controlWidth,"minimumFractionDigits":_vm.minimumFractionDigits,"maximumFractionDigits":_vm.maximumFractionDigits,"useGrouping":_vm.useGrouping,"alignLeft":_vm.alignLeft,"locale":_vm.locale,"currency":_vm.currency,"currencyDisplay":_vm.currencyDisplay,"controlStyle":_vm.controlStyle,"decimalMode":_vm.decimalMode,"addinLeft":_vm.addinLeft,"addinRight":_vm.addinRight},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})]},proxy:true}],null,true)},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet minimaal "+_vm._s(_vm._f("tjipCurrency")(params.min,_vm.currencyFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet groter dan "+_vm._s(_vm._f("tjipCurrency")(params.min,_vm.currencyFilterOptions))+" zijn.")]:_vm._e()]}}])}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" mag maximaal "+_vm._s(_vm._f("tjipCurrency")(params.max,_vm.currencyFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet kleiner dan "+_vm._s(_vm._f("tjipCurrency")(params.max,_vm.currencyFilterOptions))+" zijn.")]:_vm._e()]}}])})],2)}
var TjipFormGroupCurrencyComponentvue_type_template_id_4470e19e_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormGroupCurrencyComponent.vue?vue&type=template&id=4470e19e&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/currency/TjipFormGroupCurrencyComponent.ts?vue&type=script&lang=ts&














var TjipFormGroupCurrencyComponentvue_type_script_lang_ts_TjipFormGroupCurrencyComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupCurrencyComponent, _Mixins);

  function TjipFormGroupCurrencyComponent() {
    _classCallCheck(this, TjipFormGroupCurrencyComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupCurrencyComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupCurrencyComponent, [{
    key: "currencyFilterOptions",
    get: function get() {
      return Object.assign({}, this.numberFilterOptions, {
        decimalMode: this.decimalMode,
        minimumFractionDigits: this.currencyMinimumFractionDigits,
        maximumFractionDigits: this.currencyMaximumFractionDigits
      });
    }
  }, {
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupCurrencyComponent;
}(mixins(TjipFiltersMixin_TjipFiltersMixin, TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupCurrencyComponentvue_type_script_lang_ts_TjipFormGroupCurrencyComponent = __decorate([vue_class_component_esm({})], TjipFormGroupCurrencyComponentvue_type_script_lang_ts_TjipFormGroupCurrencyComponent);

/* harmony default export */ var TjipFormGroupCurrencyComponentvue_type_script_lang_ts_ = (TjipFormGroupCurrencyComponentvue_type_script_lang_ts_TjipFormGroupCurrencyComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormGroupCurrencyComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var currency_TjipFormGroupCurrencyComponentvue_type_script_lang_ts_ = (TjipFormGroupCurrencyComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormGroupCurrencyComponent.scss?vue&type=style&index=0&id=4470e19e&scoped=true&lang=scss&
var TjipFormGroupCurrencyComponentvue_type_style_index_0_id_4470e19e_scoped_true_lang_scss_ = __webpack_require__("9949");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormGroupCurrencyComponent.vue






/* normalize component */

var TjipFormGroupCurrencyComponent_component = normalizeComponent(
  currency_TjipFormGroupCurrencyComponentvue_type_script_lang_ts_,
  TjipFormGroupCurrencyComponentvue_type_template_id_4470e19e_scoped_true_render,
  TjipFormGroupCurrencyComponentvue_type_template_id_4470e19e_scoped_true_staticRenderFns,
  false,
  null,
  "4470e19e",
  null
  
)

/* harmony default export */ var currency_TjipFormGroupCurrencyComponent = (TjipFormGroupCurrencyComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/currency/TjipFormGroupCurrencyComponent.ts














var TjipFormGroupCurrencyComponent_TjipFormGroupCurrencyComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupCurrencyComponent, _Mixins);

  function TjipFormGroupCurrencyComponent() {
    _classCallCheck(this, TjipFormGroupCurrencyComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupCurrencyComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupCurrencyComponent, [{
    key: "currencyFilterOptions",
    get: function get() {
      return Object.assign({}, this.numberFilterOptions, {
        decimalMode: this.decimalMode,
        minimumFractionDigits: this.currencyMinimumFractionDigits,
        maximumFractionDigits: this.currencyMaximumFractionDigits
      });
    }
  }, {
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupCurrencyComponent;
}(mixins(TjipFiltersMixin_TjipFiltersMixin, TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupCurrencyComponent_TjipFormGroupCurrencyComponent = __decorate([vue_class_component_esm({})], TjipFormGroupCurrencyComponent_TjipFormGroupCurrencyComponent);

/* harmony default export */ var controls_currency_TjipFormGroupCurrencyComponent = (TjipFormGroupCurrencyComponent_TjipFormGroupCurrencyComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/percent/TjipFormControlPercentComponent.vue?vue&type=template&id=95191cf0&scoped=true&
var TjipFormControlPercentComponentvue_type_template_id_95191cf0_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-control-addin-wrapper',{staticClass:"tjip-form-control-percent",class:( _obj = {'has-error': _vm.showErrors, 'has-success': _vm.isValid}, _obj[_vm.controlWidthClass] = true, _obj ),attrs:{"disabled":_vm.disabled,"addinLeft":_vm.addinLeft,"addinRight":_vm.resolvedAddinRight}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.internalValue),expression:"internalValue"}],ref:"input",class:{'align-left': _vm.alignLeft},attrs:{"type":"text","name":_vm.resolvedName,"id":_vm.resolvedId,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete},domProps:{"value":(_vm.internalValue)},on:{"input":function($event){if($event.target.composing){ return; }_vm.internalValue=$event.target.value}}})])}
var TjipFormControlPercentComponentvue_type_template_id_95191cf0_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormControlPercentComponent.vue?vue&type=template&id=95191cf0&scoped=true&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormItemPercentMixin.ts











var TjipFormItemPercentMixin_TjipFormItemPercentMixin =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormItemPercentMixin, _Mixins);

  function TjipFormItemPercentMixin() {
    var _this;

    _classCallCheck(this, TjipFormItemPercentMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemPercentMixin).apply(this, arguments));
    _this.defaultMinimumFractionDigits = 0;
    _this.defaultMaximumFractionDigits = 2;
    return _this;
  }

  _createClass(TjipFormItemPercentMixin, [{
    key: "percentFilterOptions",
    get: function get() {
      return Object.assign(this.numberFilterOptions, {
        baseValue: this.baseValue
      });
    }
  }]);

  return TjipFormItemPercentMixin;
}(mixins(TjipFormItemNumberMixin_TjipFormItemNumberMixin));

__decorate([Prop()], TjipFormItemPercentMixin_TjipFormItemPercentMixin.prototype, "addinLeft", void 0);

__decorate([Prop()], TjipFormItemPercentMixin_TjipFormItemPercentMixin.prototype, "addinRight", void 0);

__decorate([Prop()], TjipFormItemPercentMixin_TjipFormItemPercentMixin.prototype, "baseValue", void 0);

__decorate([Prop()], TjipFormItemPercentMixin_TjipFormItemPercentMixin.prototype, "controlStyle", void 0);

TjipFormItemPercentMixin_TjipFormItemPercentMixin = __decorate([vue_class_component_esm], TjipFormItemPercentMixin_TjipFormItemPercentMixin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/percent/TjipFormControlPercentComponent.ts?vue&type=script&lang=ts&












var TjipFormControlPercentComponentvue_type_script_lang_ts_moveDecimal = move_decimal_point;

var TjipFormControlPercentComponentvue_type_script_lang_ts_TjipFormControlPercentComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlPercentComponent, _Mixins);

  function TjipFormControlPercentComponent() {
    _classCallCheck(this, TjipFormControlPercentComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlPercentComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlPercentComponent, [{
    key: "formatValue",
    value: function formatValue(value) {
      if (typeof value === 'number') {
        var options = this.formatOptions;

        if (!this.hasFocus && this.controlStyle === 'inline') {
          if (value) {
            var decimalShift = this.baseValue === 100 ? -2 : 0;
            value = parseFloat(TjipFormControlPercentComponentvue_type_script_lang_ts_moveDecimal(value, decimalShift));
          }

          options.style = 'percent';
        } else {
          if (value) {
            var _decimalShift = this.baseValue === 100 ? 0 : 2;

            value = parseFloat(TjipFormControlPercentComponentvue_type_script_lang_ts_moveDecimal(value, _decimalShift));
          }

          options.style = 'decimal';
        }

        return this.$n(value, options);
      }

      return value;
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      var result = this.parseValueCore(value);

      if (!result.invalid && result.value) {
        var decimalShift = this.baseValue === 100 ? 0 : -2;
        result.value = parseFloat(TjipFormControlPercentComponentvue_type_script_lang_ts_moveDecimal(result.value, decimalShift));
      }

      return result;
    }
  }, {
    key: "syntaxValidatorKey",
    get: function get() {
      return 'syntaxCurrency';
    }
  }, {
    key: "resolvedAddinRight",
    get: function get() {
      return this.controlStyle === 'inline' ? '' : this.addinRight || '%';
    }
  }, {
    key: "formatOptions",
    get: function get() {
      var result = {
        locale: this.resolvedLocale
      };

      if (!lodash["isUndefined"](this.useGrouping)) {
        result.useGrouping = this.useGrouping;
      }

      if (this.hasFocus) {
        result.useGrouping = false;
      }

      result.minimumFractionDigits = this.resolvedMinimumFractionDigits;
      result.maximumFractionDigits = this.resolvedMaximumFractionDigits;
      result.baseValue = this.baseValue || 1;
      return result;
    }
  }]);

  return TjipFormControlPercentComponent;
}(mixins(TjipFormControlNumberMixin_TjipFormControlNumberMixin, TjipFormItemPercentMixin_TjipFormItemPercentMixin, TjipFormItemTextMixin_TjipFormItemTextMixin));

TjipFormControlPercentComponentvue_type_script_lang_ts_TjipFormControlPercentComponent = __decorate([vue_class_component_esm({})], TjipFormControlPercentComponentvue_type_script_lang_ts_TjipFormControlPercentComponent);

/* harmony default export */ var TjipFormControlPercentComponentvue_type_script_lang_ts_ = (TjipFormControlPercentComponentvue_type_script_lang_ts_TjipFormControlPercentComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormControlPercentComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var percent_TjipFormControlPercentComponentvue_type_script_lang_ts_ = (TjipFormControlPercentComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormControlPercentComponent.scss?vue&type=style&index=0&id=95191cf0&scoped=true&lang=scss&
var TjipFormControlPercentComponentvue_type_style_index_0_id_95191cf0_scoped_true_lang_scss_ = __webpack_require__("1715");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormControlPercentComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlPercentComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("062e");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormControlPercentComponent.vue







/* normalize component */

var TjipFormControlPercentComponent_component = normalizeComponent(
  percent_TjipFormControlPercentComponentvue_type_script_lang_ts_,
  TjipFormControlPercentComponentvue_type_template_id_95191cf0_scoped_true_render,
  TjipFormControlPercentComponentvue_type_template_id_95191cf0_scoped_true_staticRenderFns,
  false,
  null,
  "95191cf0",
  null
  
)

/* harmony default export */ var percent_TjipFormControlPercentComponent = (TjipFormControlPercentComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormControlPercentComponent.ts












var TjipFormControlPercentComponent_moveDecimal = move_decimal_point;

var TjipFormControlPercentComponent_TjipFormControlPercentComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlPercentComponent, _Mixins);

  function TjipFormControlPercentComponent() {
    _classCallCheck(this, TjipFormControlPercentComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlPercentComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlPercentComponent, [{
    key: "formatValue",
    value: function formatValue(value) {
      if (typeof value === 'number') {
        var options = this.formatOptions;

        if (!this.hasFocus && this.controlStyle === 'inline') {
          if (value) {
            var decimalShift = this.baseValue === 100 ? -2 : 0;
            value = parseFloat(TjipFormControlPercentComponent_moveDecimal(value, decimalShift));
          }

          options.style = 'percent';
        } else {
          if (value) {
            var _decimalShift = this.baseValue === 100 ? 0 : 2;

            value = parseFloat(TjipFormControlPercentComponent_moveDecimal(value, _decimalShift));
          }

          options.style = 'decimal';
        }

        return this.$n(value, options);
      }

      return value;
    }
  }, {
    key: "parseValue",
    value: function parseValue(value) {
      var result = this.parseValueCore(value);

      if (!result.invalid && result.value) {
        var decimalShift = this.baseValue === 100 ? 0 : -2;
        result.value = parseFloat(TjipFormControlPercentComponent_moveDecimal(result.value, decimalShift));
      }

      return result;
    }
  }, {
    key: "syntaxValidatorKey",
    get: function get() {
      return 'syntaxCurrency';
    }
  }, {
    key: "resolvedAddinRight",
    get: function get() {
      return this.controlStyle === 'inline' ? '' : this.addinRight || '%';
    }
  }, {
    key: "formatOptions",
    get: function get() {
      var result = {
        locale: this.resolvedLocale
      };

      if (!lodash["isUndefined"](this.useGrouping)) {
        result.useGrouping = this.useGrouping;
      }

      if (this.hasFocus) {
        result.useGrouping = false;
      }

      result.minimumFractionDigits = this.resolvedMinimumFractionDigits;
      result.maximumFractionDigits = this.resolvedMaximumFractionDigits;
      result.baseValue = this.baseValue || 1;
      return result;
    }
  }]);

  return TjipFormControlPercentComponent;
}(mixins(TjipFormControlNumberMixin_TjipFormControlNumberMixin, TjipFormItemPercentMixin_TjipFormItemPercentMixin, TjipFormItemTextMixin_TjipFormItemTextMixin));

TjipFormControlPercentComponent_TjipFormControlPercentComponent = __decorate([vue_class_component_esm({})], TjipFormControlPercentComponent_TjipFormControlPercentComponent);

/* harmony default export */ var controls_percent_TjipFormControlPercentComponent = (TjipFormControlPercentComponent_TjipFormControlPercentComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/percent/TjipFormGroupPercentComponent.vue?vue&type=template&id=246021da&scoped=true&
var TjipFormGroupPercentComponentvue_type_template_id_246021da_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-percent",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-percent',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete,"errorMode":_vm.errorMode,"controlWidth":_vm.controlWidth,"minimumFractionDigits":_vm.minimumFractionDigits,"maximumFractionDigits":_vm.maximumFractionDigits,"useGrouping":_vm.useGrouping,"alignLeft":_vm.alignLeft,"locale":_vm.locale,"baseValue":_vm.baseValue,"controlStyle":_vm.controlStyle,"addinLeft":_vm.addinLeft,"addinRight":_vm.addinRight},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})]},proxy:true}],null,true)},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet minimaal "+_vm._s(_vm._f("tjipPercent")(params.min,_vm.percentFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet groter dan "+_vm._s(_vm._f("tjipPercent")(params.min,_vm.percentFilterOptions))+" zijn.")]:_vm._e()]}}])}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" mag maximaal "+_vm._s(_vm._f("tjipPercent")(params.max,_vm.percentFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet kleiner dan "+_vm._s(_vm._f("tjipPercent")(params.max,_vm.percentFilterOptions))+" zijn.")]:_vm._e()]}}])})],2)}
var TjipFormGroupPercentComponentvue_type_template_id_246021da_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormGroupPercentComponent.vue?vue&type=template&id=246021da&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/percent/TjipFormGroupPercentComponent.ts?vue&type=script&lang=ts&














var TjipFormGroupPercentComponentvue_type_script_lang_ts_TjipFormGroupPercentComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupPercentComponent, _Mixins);

  function TjipFormGroupPercentComponent() {
    _classCallCheck(this, TjipFormGroupPercentComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupPercentComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupPercentComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupPercentComponent;
}(mixins(TjipFiltersMixin_TjipFiltersMixin, TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFormItemPercentMixin_TjipFormItemPercentMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupPercentComponentvue_type_script_lang_ts_TjipFormGroupPercentComponent = __decorate([vue_class_component_esm({})], TjipFormGroupPercentComponentvue_type_script_lang_ts_TjipFormGroupPercentComponent);

/* harmony default export */ var TjipFormGroupPercentComponentvue_type_script_lang_ts_ = (TjipFormGroupPercentComponentvue_type_script_lang_ts_TjipFormGroupPercentComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormGroupPercentComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var percent_TjipFormGroupPercentComponentvue_type_script_lang_ts_ = (TjipFormGroupPercentComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormGroupPercentComponent.scss?vue&type=style&index=0&id=246021da&scoped=true&lang=scss&
var TjipFormGroupPercentComponentvue_type_style_index_0_id_246021da_scoped_true_lang_scss_ = __webpack_require__("c3a9");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormGroupPercentComponent.vue






/* normalize component */

var TjipFormGroupPercentComponent_component = normalizeComponent(
  percent_TjipFormGroupPercentComponentvue_type_script_lang_ts_,
  TjipFormGroupPercentComponentvue_type_template_id_246021da_scoped_true_render,
  TjipFormGroupPercentComponentvue_type_template_id_246021da_scoped_true_staticRenderFns,
  false,
  null,
  "246021da",
  null
  
)

/* harmony default export */ var percent_TjipFormGroupPercentComponent = (TjipFormGroupPercentComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/percent/TjipFormGroupPercentComponent.ts














var TjipFormGroupPercentComponent_TjipFormGroupPercentComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupPercentComponent, _Mixins);

  function TjipFormGroupPercentComponent() {
    _classCallCheck(this, TjipFormGroupPercentComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupPercentComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupPercentComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupPercentComponent;
}(mixins(TjipFiltersMixin_TjipFiltersMixin, TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFormItemPercentMixin_TjipFormItemPercentMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupPercentComponent_TjipFormGroupPercentComponent = __decorate([vue_class_component_esm({})], TjipFormGroupPercentComponent_TjipFormGroupPercentComponent);

/* harmony default export */ var controls_percent_TjipFormGroupPercentComponent = (TjipFormGroupPercentComponent_TjipFormGroupPercentComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/search/TjipFormGroupSearchComponent.vue?vue&type=template&id=25a1239d&scoped=true&
var TjipFormGroupSearchComponentvue_type_template_id_25a1239d_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-group',{staticClass:"tjip-form-group-search",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"label":_vm.label,"messageLabel":_vm.messageLabel,"errors":_vm.$v.value,"errorMode":_vm.errorMode,"disabled":_vm.disabled,"hideMessages":_vm.hideMessages,"showSingleMessage":_vm.showSingleMessage},scopedSlots:_vm._u([{key:"tjip-form-label",fn:function(){return [_vm._t("tjip-form-label")]},proxy:true},{key:"tjip-form-control",fn:function(){return [_c('tjip-form-control-search',{ref:"control",attrs:{"ctrlId":_vm.ctrlId,"name":_vm.name,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":_vm.autocomplete,"errorMode":_vm.errorMode,"controlWidth":_vm.controlWidth,"hideSearchIcon":_vm.hideSearchIcon,"buttonTabindex":_vm.buttonTabindex,"suggestTimeout":_vm.suggestTimeout,"justifySuggests":_vm.justifySuggests,"suggests":_vm.suggests},on:{"suggest":_vm.onSuggest,"selectSuggest":_vm.onSelectSuggest,"search":_vm.onSearch},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})]},proxy:true}],null,true)},[_vm._t("default")],2)}
var TjipFormGroupSearchComponentvue_type_template_id_25a1239d_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormGroupSearchComponent.vue?vue&type=template&id=25a1239d&scoped=true&

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/core/TjipFormItemSearchMixin.ts










var TjipFormItemSearchMixin_TjipFormItemSearchMixin =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipFormItemSearchMixin, _Vue);

  function TjipFormItemSearchMixin() {
    _classCallCheck(this, TjipFormItemSearchMixin);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormItemSearchMixin).apply(this, arguments));
  }

  _createClass(TjipFormItemSearchMixin, [{
    key: "onSuggest",
    value: function onSuggest(value) {
      this.$emit('suggest', value);
    }
  }, {
    key: "onSelectSuggest",
    value: function onSelectSuggest(value) {
      this.$emit('selectSuggest', value);
    }
  }, {
    key: "onSearch",
    value: function onSearch(value) {
      this.$emit('search', value);
    }
  }]);

  return TjipFormItemSearchMixin;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

__decorate([Prop()], TjipFormItemSearchMixin_TjipFormItemSearchMixin.prototype, "hideSearchIcon", void 0);

__decorate([Prop()], TjipFormItemSearchMixin_TjipFormItemSearchMixin.prototype, "buttonTabindex", void 0);

__decorate([Prop()], TjipFormItemSearchMixin_TjipFormItemSearchMixin.prototype, "suggestTimeout", void 0);

__decorate([Prop()], TjipFormItemSearchMixin_TjipFormItemSearchMixin.prototype, "suggests", void 0);

__decorate([Prop()], TjipFormItemSearchMixin_TjipFormItemSearchMixin.prototype, "justifySuggests", void 0);

TjipFormItemSearchMixin_TjipFormItemSearchMixin = __decorate([vue_class_component_esm], TjipFormItemSearchMixin_TjipFormItemSearchMixin);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/search/TjipFormGroupSearchComponent.ts?vue&type=script&lang=ts&












var TjipFormGroupSearchComponentvue_type_script_lang_ts_TjipFormGroupSearchComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupSearchComponent, _Mixins);

  function TjipFormGroupSearchComponent() {
    _classCallCheck(this, TjipFormGroupSearchComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupSearchComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupSearchComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupSearchComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormItemSearchMixin_TjipFormItemSearchMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupSearchComponentvue_type_script_lang_ts_TjipFormGroupSearchComponent = __decorate([vue_class_component_esm({})], TjipFormGroupSearchComponentvue_type_script_lang_ts_TjipFormGroupSearchComponent);

/* harmony default export */ var TjipFormGroupSearchComponentvue_type_script_lang_ts_ = (TjipFormGroupSearchComponentvue_type_script_lang_ts_TjipFormGroupSearchComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormGroupSearchComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var search_TjipFormGroupSearchComponentvue_type_script_lang_ts_ = (TjipFormGroupSearchComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormGroupSearchComponent.scss?vue&type=style&index=0&id=25a1239d&scoped=true&lang=scss&
var TjipFormGroupSearchComponentvue_type_style_index_0_id_25a1239d_scoped_true_lang_scss_ = __webpack_require__("6676");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormGroupSearchComponent.vue






/* normalize component */

var TjipFormGroupSearchComponent_component = normalizeComponent(
  search_TjipFormGroupSearchComponentvue_type_script_lang_ts_,
  TjipFormGroupSearchComponentvue_type_template_id_25a1239d_scoped_true_render,
  TjipFormGroupSearchComponentvue_type_template_id_25a1239d_scoped_true_staticRenderFns,
  false,
  null,
  "25a1239d",
  null
  
)

/* harmony default export */ var search_TjipFormGroupSearchComponent = (TjipFormGroupSearchComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormGroupSearchComponent.ts












var TjipFormGroupSearchComponent_TjipFormGroupSearchComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormGroupSearchComponent, _Mixins);

  function TjipFormGroupSearchComponent() {
    _classCallCheck(this, TjipFormGroupSearchComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormGroupSearchComponent).apply(this, arguments));
  }

  _createClass(TjipFormGroupSearchComponent, [{
    key: "control",
    get: function get() {
      return this.$refs.control;
    }
  }]);

  return TjipFormGroupSearchComponent;
}(mixins(TjipFormGroupValueMixin_TjipFormGroupValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormItemSearchMixin_TjipFormItemSearchMixin, TjipFormGroupMixin_TjipFormGroupMixin));

TjipFormGroupSearchComponent_TjipFormGroupSearchComponent = __decorate([vue_class_component_esm({})], TjipFormGroupSearchComponent_TjipFormGroupSearchComponent);

/* harmony default export */ var controls_search_TjipFormGroupSearchComponent = (TjipFormGroupSearchComponent_TjipFormGroupSearchComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/controls/search/TjipFormControlSearchComponent.vue?vue&type=template&id=eaa91e14&scoped=true&
var TjipFormControlSearchComponentvue_type_template_id_eaa91e14_scoped_true_render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-search",class:{'has-error': _vm.showErrors, 'has-success': _vm.isValid}},[_c('tjip-form-control-addin-wrapper',{class:( _obj = {'has-error': _vm.showErrors, 'has-success': _vm.isValid}, _obj[_vm.controlWidthClass] = true, _obj ),attrs:{"disabled":_vm.disabled},scopedSlots:_vm._u([(!_vm.hideSearchIcon)?{key:"addin-right",fn:function(){return [_c('button',{staticClass:"btn btn-default btn-search",attrs:{"type":"button","disabled":_vm.disabled,"tabindex":_vm.resolvedButtonTabindex},on:{"click":_vm.doSearch}},[_c('div',{staticClass:"glyph-search"})])]},proxy:true}:null],null,true)},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchValue),expression:"searchValue"}],ref:"input",attrs:{"type":"search","name":_vm.resolvedName,"id":_vm.resolvedId,"placeholder":_vm.placeholder,"tabindex":_vm.tabindex,"disabled":_vm.disabled,"maxlength":_vm.maxlength,"autocomplete":"off"},domProps:{"value":(_vm.searchValue)},on:{"keydown":_vm.onKeydown,"input":function($event){if($event.target.composing){ return; }_vm.searchValue=$event.target.value}}})]),(_vm.showSuggests)?_c('ul',{staticClass:"suggests-menu",class:{'suggests-menu-justify': _vm.justifySuggests},attrs:{"id":"suggestsMenu","aria-labelledby":"suggestsInput"},on:{"mousedown":_vm.onMousedown,"mouseup":_vm.onMouseup}},_vm._l((_vm.suggests),function(s){return _c('li',{key:_vm.stringValue(s)},[_c('a',{staticClass:"suggest-item",class:{'active': _vm.isActiveSuggest(s)},attrs:{"href":"#","tabindex":-1},on:{"click":function($event){return _vm.select(s)}}},[_vm._t("suggest",[_vm._v(_vm._s(_vm.stringValue(s)))],{"suggest":s})],2)])}),0):_vm._e()],1)}
var TjipFormControlSearchComponentvue_type_template_id_eaa91e14_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormControlSearchComponent.vue?vue&type=template&id=eaa91e14&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/controls/search/TjipFormControlSearchComponent.ts?vue&type=script&lang=ts&













function suggestValue(suggest) {
  return suggest ? typeof suggest === 'string' ? suggest : suggest.value : undefined;
}

var TjipFormControlSearchComponentvue_type_script_lang_ts_TjipFormControlSearchComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlSearchComponent, _Mixins);

  function TjipFormControlSearchComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlSearchComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlSearchComponent).apply(this, arguments));
    _this.usedSuggests = [];
    _this.activeSuggest = null;
    return _this;
  }

  _createClass(TjipFormControlSearchComponent, [{
    key: "stringValue",
    value: function stringValue(suggest) {
      return suggestValue(suggest);
    }
  }, {
    key: "onMousedown",
    value: function onMousedown() {
      this.mouseDown = true;
    }
  }, {
    key: "onMouseup",
    value: function onMouseup() {
      this.mouseDown = false;
    }
  }, {
    key: "doSearch",
    value: function doSearch() {
      this.onSearch(this.value);
    }
  }, {
    key: "isActiveSuggest",
    value: function isActiveSuggest(suggest) {
      return this.activeSuggest === suggest;
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      // tslint:disable-next-line:deprecation
      var key = event.key || String.fromCharCode(event.keyCode || event.charCode || event.which);

      if (key === 'ArrowUp') {
        this.selectPrevSuggest();
        return false;
      } else if (key === 'ArrowDown') {
        this.selectNextSuggest();
        return false;
      } else if (key === 'Enter') {
        if (this.activeSuggest) {
          var result = this.select(this.activeSuggest);
          this.activeSuggest = null;
          return result;
        }
      }

      return true;
    }
  }, {
    key: "select",
    value: function select(suggest) {
      if (this.hasSelectSuggestObservers) {
        this.onSelectSuggest(suggest);
      } else {
        var newValue = suggestValue(suggest);

        if (!lodash["isUndefined"](newValue)) {
          this.searchValue = newValue;
          this.usedSuggests = this.suggests;
        }
      }

      this.mouseDown = false;
      this.$refs.input.focus();
      return false;
    }
  }, {
    key: "querySuggests",
    value: function querySuggests(value) {
      var _this2 = this;

      this.suggestValue = value;
      this.usedSuggests = this.suggests;

      if (this.suggestTimer) {
        clearTimeout(this.suggestTimer);
      }

      this.suggestTimer = setTimeout(function () {
        _this2.suggestTimer = undefined;

        _this2.onSuggest(_this2.suggestValue);
      }, this.suggestTimeout || 300);
    }
  }, {
    key: "activeSuggestIndex",
    value: function activeSuggestIndex() {
      return lodash["indexOf"](this.suggests, this.activeSuggest);
    }
  }, {
    key: "selectNextSuggest",
    value: function selectNextSuggest() {
      if (this.suggests) {
        var ndx = this.activeSuggestIndex() + 1;

        if (ndx < this.suggests.length) {
          this.activeSuggest = this.suggests[ndx];
        }
      }
    }
  }, {
    key: "selectPrevSuggest",
    value: function selectPrevSuggest() {
      if (this.suggests) {
        var ndx = this.activeSuggestIndex() - 1;

        if (ndx >= 0) {
          this.activeSuggest = this.suggests[ndx];
        } else {
          this.activeSuggest = null;
        }
      }
    }
  }, {
    key: "searchValue",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.internalValue = value;
      this.querySuggests(value);
    }
  }, {
    key: "resolvedButtonTabindex",
    get: function get() {
      return lodash["isUndefined"](this.buttonTabindex) ? -1 : this.buttonTabindex;
    }
  }, {
    key: "hasSuggests",
    get: function get() {
      return !!this.suggests && !!this.suggests.length;
    }
  }, {
    key: "showSuggests",
    get: function get() {
      return (this.hasFocus || this.mouseDown) && this.hasSuggests && this.suggests !== this.usedSuggests;
    }
  }, {
    key: "hasSelectSuggestObservers",
    get: function get() {
      var group = this.getAncestor(search_TjipFormGroupSearchComponent);
      var events = group ? group._events : this._events;
      return events && events.selectSuggest;
    }
  }]);

  return TjipFormControlSearchComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormItemSearchMixin_TjipFormItemSearchMixin));

TjipFormControlSearchComponentvue_type_script_lang_ts_TjipFormControlSearchComponent = __decorate([vue_class_component_esm({})], TjipFormControlSearchComponentvue_type_script_lang_ts_TjipFormControlSearchComponent);

/* harmony default export */ var TjipFormControlSearchComponentvue_type_script_lang_ts_ = (TjipFormControlSearchComponentvue_type_script_lang_ts_TjipFormControlSearchComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormControlSearchComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var search_TjipFormControlSearchComponentvue_type_script_lang_ts_ = (TjipFormControlSearchComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormControlSearchComponent.scss?vue&type=style&index=0&id=eaa91e14&scoped=true&lang=scss&
var TjipFormControlSearchComponentvue_type_style_index_0_id_eaa91e14_scoped_true_lang_scss_ = __webpack_require__("264e");

// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormControlSearchComponent.global.scss?vue&type=style&index=1&lang=scss&
var TjipFormControlSearchComponent_globalvue_type_style_index_1_lang_scss_ = __webpack_require__("166d");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormControlSearchComponent.vue







/* normalize component */

var TjipFormControlSearchComponent_component = normalizeComponent(
  search_TjipFormControlSearchComponentvue_type_script_lang_ts_,
  TjipFormControlSearchComponentvue_type_template_id_eaa91e14_scoped_true_render,
  TjipFormControlSearchComponentvue_type_template_id_eaa91e14_scoped_true_staticRenderFns,
  false,
  null,
  "eaa91e14",
  null
  
)

/* harmony default export */ var search_TjipFormControlSearchComponent = (TjipFormControlSearchComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/search/TjipFormControlSearchComponent.ts













function TjipFormControlSearchComponent_suggestValue(suggest) {
  return suggest ? typeof suggest === 'string' ? suggest : suggest.value : undefined;
}

var TjipFormControlSearchComponent_TjipFormControlSearchComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlSearchComponent, _Mixins);

  function TjipFormControlSearchComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlSearchComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlSearchComponent).apply(this, arguments));
    _this.usedSuggests = [];
    _this.activeSuggest = null;
    return _this;
  }

  _createClass(TjipFormControlSearchComponent, [{
    key: "stringValue",
    value: function stringValue(suggest) {
      return TjipFormControlSearchComponent_suggestValue(suggest);
    }
  }, {
    key: "onMousedown",
    value: function onMousedown() {
      this.mouseDown = true;
    }
  }, {
    key: "onMouseup",
    value: function onMouseup() {
      this.mouseDown = false;
    }
  }, {
    key: "doSearch",
    value: function doSearch() {
      this.onSearch(this.value);
    }
  }, {
    key: "isActiveSuggest",
    value: function isActiveSuggest(suggest) {
      return this.activeSuggest === suggest;
    }
  }, {
    key: "onKeydown",
    value: function onKeydown(event) {
      // tslint:disable-next-line:deprecation
      var key = event.key || String.fromCharCode(event.keyCode || event.charCode || event.which);

      if (key === 'ArrowUp') {
        this.selectPrevSuggest();
        return false;
      } else if (key === 'ArrowDown') {
        this.selectNextSuggest();
        return false;
      } else if (key === 'Enter') {
        if (this.activeSuggest) {
          var result = this.select(this.activeSuggest);
          this.activeSuggest = null;
          return result;
        }
      }

      return true;
    }
  }, {
    key: "select",
    value: function select(suggest) {
      if (this.hasSelectSuggestObservers) {
        this.onSelectSuggest(suggest);
      } else {
        var newValue = TjipFormControlSearchComponent_suggestValue(suggest);

        if (!lodash["isUndefined"](newValue)) {
          this.searchValue = newValue;
          this.usedSuggests = this.suggests;
        }
      }

      this.mouseDown = false;
      this.$refs.input.focus();
      return false;
    }
  }, {
    key: "querySuggests",
    value: function querySuggests(value) {
      var _this2 = this;

      this.suggestValue = value;
      this.usedSuggests = this.suggests;

      if (this.suggestTimer) {
        clearTimeout(this.suggestTimer);
      }

      this.suggestTimer = setTimeout(function () {
        _this2.suggestTimer = undefined;

        _this2.onSuggest(_this2.suggestValue);
      }, this.suggestTimeout || 300);
    }
  }, {
    key: "activeSuggestIndex",
    value: function activeSuggestIndex() {
      return lodash["indexOf"](this.suggests, this.activeSuggest);
    }
  }, {
    key: "selectNextSuggest",
    value: function selectNextSuggest() {
      if (this.suggests) {
        var ndx = this.activeSuggestIndex() + 1;

        if (ndx < this.suggests.length) {
          this.activeSuggest = this.suggests[ndx];
        }
      }
    }
  }, {
    key: "selectPrevSuggest",
    value: function selectPrevSuggest() {
      if (this.suggests) {
        var ndx = this.activeSuggestIndex() - 1;

        if (ndx >= 0) {
          this.activeSuggest = this.suggests[ndx];
        } else {
          this.activeSuggest = null;
        }
      }
    }
  }, {
    key: "searchValue",
    get: function get() {
      return this.value;
    },
    set: function set(value) {
      this.internalValue = value;
      this.querySuggests(value);
    }
  }, {
    key: "resolvedButtonTabindex",
    get: function get() {
      return lodash["isUndefined"](this.buttonTabindex) ? -1 : this.buttonTabindex;
    }
  }, {
    key: "hasSuggests",
    get: function get() {
      return !!this.suggests && !!this.suggests.length;
    }
  }, {
    key: "showSuggests",
    get: function get() {
      return (this.hasFocus || this.mouseDown) && this.hasSuggests && this.suggests !== this.usedSuggests;
    }
  }, {
    key: "hasSelectSuggestObservers",
    get: function get() {
      var group = this.getAncestor(search_TjipFormGroupSearchComponent);
      var events = group ? group._events : this._events;
      return events && events.selectSuggest;
    }
  }]);

  return TjipFormControlSearchComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormControlValueMixin_TjipFormControlValueMixin, TjipFormItemTextMixin_TjipFormItemTextMixin, TjipFormItemSearchMixin_TjipFormItemSearchMixin));

TjipFormControlSearchComponent_TjipFormControlSearchComponent = __decorate([vue_class_component_esm({})], TjipFormControlSearchComponent_TjipFormControlSearchComponent);

/* harmony default export */ var controls_search_TjipFormControlSearchComponent = (TjipFormControlSearchComponent_TjipFormControlSearchComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/controls/index.ts


































































 // workaround when re-exporting type: https://github.com/babel/babel-loader/issues/603


function TjipVueControls(Vue) {
  Vue.component('tjip-form-group', core_TjipFormGroupComponent);
  Vue.component('tjip-form-control-addin-wrapper', addin_wrapper_TjipFormControlAddinWrapperComponent);
  Vue.component('tjip-form-control-static-text', static_text_TjipFormControlStaticTextComponent);
  Vue.component('tjip-form-group-static-text', static_text_TjipFormGroupStaticTextComponent);
  Vue.component('tjip-form-control-text', text_TjipFormControlTextComponent);
  Vue.component('tjip-form-group-text', text_TjipFormGroupTextComponent);
  Vue.component('tjip-form-control-search', search_TjipFormControlSearchComponent);
  Vue.component('tjip-form-group-search', search_TjipFormGroupSearchComponent);
  Vue.component('tjip-form-control-checkbox', checkbox_TjipFormControlCheckboxComponent);
  Vue.component('tjip-form-group-checkbox', checkbox_TjipFormGroupCheckboxComponent);
  Vue.component('tjip-form-control-checkbox-group', checkbox_TjipFormControlCheckboxGroupComponent);
  Vue.component('tjip-form-group-checkbox-group', checkbox_TjipFormGroupCheckboxGroupComponent);
  Vue.component('tjip-form-control-number', number_TjipFormControlNumberComponent);
  Vue.component('tjip-form-group-number', number_TjipFormGroupNumberComponent);
  Vue.component('tjip-form-control-currency', currency_TjipFormControlCurrencyComponent);
  Vue.component('tjip-form-group-currency', currency_TjipFormGroupCurrencyComponent);
  Vue.component('tjip-form-control-percent', percent_TjipFormControlPercentComponent);
  Vue.component('tjip-form-group-percent', percent_TjipFormGroupPercentComponent);
  Vue.component('tjip-form-control-dropdown', dropdown_TjipFormControlDropdownComponent);
  Vue.component('tjip-form-group-dropdown', dropdown_TjipFormGroupDropdownComponent);
  Vue.component('tjip-form-control-radio-button', radio_TjipFormControlRadioButtonComponent);
  Vue.component('tjip-form-control-radio-group', radio_TjipFormControlRadioGroupComponent);
  Vue.component('tjip-form-group-radio-group', radio_TjipFormGroupRadioGroupComponent);
  Vue.component('tjip-form-control-date', date_TjipFormControlDateComponent);
  Vue.component('tjip-form-group-date', date_TjipFormGroupDateComponent);
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/utils/whenEmpty/TjipWhenEmptyComponent.vue?vue&type=template&id=471321b9&scoped=true&
var TjipWhenEmptyComponentvue_type_template_id_471321b9_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-when-empty",class:{'empty-placeholder': _vm.isEmpty},attrs:{"id":_vm.id}},[_c('div',{ref:"content",staticClass:"content"},[_vm._t("default")],2),(_vm.isEmpty)?_vm._t("empty"):_vm._e()],2)}
var TjipWhenEmptyComponentvue_type_template_id_471321b9_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/whenEmpty/TjipWhenEmptyComponent.vue?vue&type=template&id=471321b9&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.symbol.async-iterator.js
var es7_symbol_async_iterator = __webpack_require__("ac4d");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.symbol.js
var es6_symbol = __webpack_require__("8a81");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/utils/whenEmpty/TjipWhenEmptyComponent.ts?vue&type=script&lang=ts&












var TjipWhenEmptyComponentvue_type_script_lang_ts_TjipWhenEmptyComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipWhenEmptyComponent, _Mixins);

  function TjipWhenEmptyComponent() {
    var _this;

    _classCallCheck(this, TjipWhenEmptyComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipWhenEmptyComponent).apply(this, arguments));
    _this.isEmpty = true;
    _this.id = '';
    _this.content = null;
    return _this;
  }

  _createClass(TjipWhenEmptyComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.content = this.$refs.content;
      this.id = this._uid;
      this.observeDom(this.content, function (mutations) {
        _this2.resolveIsEmpty();
      });
      this.resolveIsEmpty();
    }
  }, {
    key: "resolveIsEmpty",
    value: function resolveIsEmpty() {
      // tslint:disable-next-line: no-console
      if (this.content) {
        var nodes = this.content.childNodes;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var node = _step.value;

            if (node.nodeType === 8 || // comment
            node.nodeType === 3 && node.textContent !== null && node.textContent.trim().length === 0) {
              // empty text
              continue;
            }

            if (this.isEmpty) {
              this.isEmpty = false; // this.$log.debug('resolveIsEmpty', this.isEmpty, this.id, this.content.outerHTML);
            }

            return;
          } // this.log.debug('isEmpty', true, this.element.nativeElement.parentNode.outerHTML, this);

        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (!this.isEmpty) {
        this.isEmpty = true;
      } // this.$log.debug('resolveIsEmpty', this.isEmpty, this.id, this.content && this.content.outerHTML);

    }
  }]);

  return TjipWhenEmptyComponent;
}(mixins(TjipDomObserverMixin_TjipDomObserverMixin));

TjipWhenEmptyComponentvue_type_script_lang_ts_TjipWhenEmptyComponent = __decorate([vue_class_component_esm({})], TjipWhenEmptyComponentvue_type_script_lang_ts_TjipWhenEmptyComponent);

/* harmony default export */ var TjipWhenEmptyComponentvue_type_script_lang_ts_ = (TjipWhenEmptyComponentvue_type_script_lang_ts_TjipWhenEmptyComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/whenEmpty/TjipWhenEmptyComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var whenEmpty_TjipWhenEmptyComponentvue_type_script_lang_ts_ = (TjipWhenEmptyComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/utils/whenEmpty/TjipWhenEmptyComponent.scss?vue&type=style&index=0&id=471321b9&scoped=true&lang=scss&
var TjipWhenEmptyComponentvue_type_style_index_0_id_471321b9_scoped_true_lang_scss_ = __webpack_require__("ad44");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/whenEmpty/TjipWhenEmptyComponent.vue






/* normalize component */

var TjipWhenEmptyComponent_component = normalizeComponent(
  whenEmpty_TjipWhenEmptyComponentvue_type_script_lang_ts_,
  TjipWhenEmptyComponentvue_type_template_id_471321b9_scoped_true_render,
  TjipWhenEmptyComponentvue_type_template_id_471321b9_scoped_true_staticRenderFns,
  false,
  null,
  "471321b9",
  null
  
)

/* harmony default export */ var whenEmpty_TjipWhenEmptyComponent = (TjipWhenEmptyComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/whenEmpty/TjipWhenEmptyComponent.ts












var TjipWhenEmptyComponent_TjipWhenEmptyComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipWhenEmptyComponent, _Mixins);

  function TjipWhenEmptyComponent() {
    var _this;

    _classCallCheck(this, TjipWhenEmptyComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipWhenEmptyComponent).apply(this, arguments));
    _this.isEmpty = true;
    _this.id = '';
    _this.content = null;
    return _this;
  }

  _createClass(TjipWhenEmptyComponent, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.content = this.$refs.content;
      this.id = this._uid;
      this.observeDom(this.content, function (mutations) {
        _this2.resolveIsEmpty();
      });
      this.resolveIsEmpty();
    }
  }, {
    key: "resolveIsEmpty",
    value: function resolveIsEmpty() {
      // tslint:disable-next-line: no-console
      if (this.content) {
        var nodes = this.content.childNodes;
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = nodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var node = _step.value;

            if (node.nodeType === 8 || // comment
            node.nodeType === 3 && node.textContent !== null && node.textContent.trim().length === 0) {
              // empty text
              continue;
            }

            if (this.isEmpty) {
              this.isEmpty = false; // this.$log.debug('resolveIsEmpty', this.isEmpty, this.id, this.content.outerHTML);
            }

            return;
          } // this.log.debug('isEmpty', true, this.element.nativeElement.parentNode.outerHTML, this);

        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (!this.isEmpty) {
        this.isEmpty = true;
      } // this.$log.debug('resolveIsEmpty', this.isEmpty, this.id, this.content && this.content.outerHTML);

    }
  }]);

  return TjipWhenEmptyComponent;
}(mixins(TjipDomObserverMixin_TjipDomObserverMixin));

TjipWhenEmptyComponent_TjipWhenEmptyComponent = __decorate([vue_class_component_esm({})], TjipWhenEmptyComponent_TjipWhenEmptyComponent);

/* harmony default export */ var utils_whenEmpty_TjipWhenEmptyComponent = (TjipWhenEmptyComponent_TjipWhenEmptyComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/utils/backdrop/TjipBackdropComponent.vue?vue&type=template&id=161f3114&scoped=true&
var TjipBackdropComponentvue_type_template_id_161f3114_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"backdrop",on:{"click":_vm.onClick}})}
var TjipBackdropComponentvue_type_template_id_161f3114_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/backdrop/TjipBackdropComponent.vue?vue&type=template&id=161f3114&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/utils/backdrop/TjipBackdropComponent.ts?vue&type=script&lang=ts&








var TjipBackdropComponentvue_type_script_lang_ts_TjipBackdropComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipBackdropComponent, _Vue);

  function TjipBackdropComponent() {
    _classCallCheck(this, TjipBackdropComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipBackdropComponent).apply(this, arguments));
  }

  _createClass(TjipBackdropComponent, [{
    key: "onClick",
    value: function onClick(event) {
      this.$emit('click', event);
    }
  }]);

  return TjipBackdropComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

TjipBackdropComponentvue_type_script_lang_ts_TjipBackdropComponent = __decorate([vue_class_component_esm({})], TjipBackdropComponentvue_type_script_lang_ts_TjipBackdropComponent);

/* harmony default export */ var TjipBackdropComponentvue_type_script_lang_ts_ = (TjipBackdropComponentvue_type_script_lang_ts_TjipBackdropComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/backdrop/TjipBackdropComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var backdrop_TjipBackdropComponentvue_type_script_lang_ts_ = (TjipBackdropComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/utils/backdrop/TjipBackdropComponent.scss?vue&type=style&index=0&id=161f3114&scoped=true&lang=scss&
var TjipBackdropComponentvue_type_style_index_0_id_161f3114_scoped_true_lang_scss_ = __webpack_require__("bede");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/backdrop/TjipBackdropComponent.vue






/* normalize component */

var TjipBackdropComponent_component = normalizeComponent(
  backdrop_TjipBackdropComponentvue_type_script_lang_ts_,
  TjipBackdropComponentvue_type_template_id_161f3114_scoped_true_render,
  TjipBackdropComponentvue_type_template_id_161f3114_scoped_true_staticRenderFns,
  false,
  null,
  "161f3114",
  null
  
)

/* harmony default export */ var backdrop_TjipBackdropComponent = (TjipBackdropComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/backdrop/TjipBackdropComponent.ts








var TjipBackdropComponent_TjipBackdropComponent =
/*#__PURE__*/
function (_Vue) {
  _inherits(TjipBackdropComponent, _Vue);

  function TjipBackdropComponent() {
    _classCallCheck(this, TjipBackdropComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipBackdropComponent).apply(this, arguments));
  }

  _createClass(TjipBackdropComponent, [{
    key: "onClick",
    value: function onClick(event) {
      this.$emit('click', event);
    }
  }]);

  return TjipBackdropComponent;
}(external_commonjs_vue_commonjs2_vue_root_Vue_default.a);

TjipBackdropComponent_TjipBackdropComponent = __decorate([vue_class_component_esm({})], TjipBackdropComponent_TjipBackdropComponent);

/* harmony default export */ var utils_backdrop_TjipBackdropComponent = (TjipBackdropComponent_TjipBackdropComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/index.ts







function TjipVueUtils(Vue) {
  Vue.component('tjip-when-empty', whenEmpty_TjipWhenEmptyComponent);
  Vue.component('tjip-backdrop', backdrop_TjipBackdropComponent);
  Vue.mixin(TjipAncestorMixin_TjipAncestorMixin);
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessagesComponent.vue?vue&type=template&id=25a58a68&
var TjipFormControlMessagesComponentvue_type_template_id_25a58a68_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showErrors)?_c('div',{staticClass:"tjip-form-control-messages",class:{ 'tjip-form-control-messages-single': _vm.showSingleMessage }},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"syntaxCurrency"}},[_vm._v(_vm._s(_vm.resolvedLabel)+" is geen geldige bedrag.")]),_c('tjip-form-control-message',{attrs:{"type":"syntaxDate"}},[_vm._v(_vm._s(_vm.resolvedLabel)+" is geen geldige datum.")]),_c('tjip-form-control-message',{attrs:{"type":"syntaxNumber"}},[_vm._v(_vm._s(_vm.resolvedLabel)+" is geen geldig getal.")]),_c('tjip-form-control-message',{attrs:{"type":"required"}},[_vm._v(_vm._s(_vm.resolvedLabel)+" is verplicht.")]),_c('tjip-form-control-message',{attrs:{"type":"minLength"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [_vm._v(_vm._s(_vm.resolvedLabel)+" moet minimaal "+_vm._s(params.min)+" karakters lang zijn.")]}}],null,false,1523283691)}),_c('tjip-form-control-message',{attrs:{"type":"maxLength"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [_vm._v(_vm._s(_vm.resolvedLabel)+" mag maximaal "+_vm._s(params.max)+" karakters lang zijn.")]}}],null,false,3733896371)}),_c('tjip-form-control-message',{attrs:{"type":"syntax"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [_vm._v(_vm._s(_vm.resolvedLabel)+" voldoet niet aan syntax '"+_vm._s(params.format)+"'.")]}}],null,false,1325782780)}),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedLabel)+" moet minimaal "+_vm._s(params.min)+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedLabel)+" moet groter dan "+_vm._s(params.min)+" zijn.")]:_vm._e()]}}],null,false,1982464373)}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedLabel)+" mag maximaal "+_vm._s(params.max)+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedLabel)+" moet kleiner dan "+_vm._s(params.max)+" zijn.")]:_vm._e()]}}],null,false,1247785656)})],2):_vm._e()}
var TjipFormControlMessagesComponentvue_type_template_id_25a58a68_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessagesComponent.vue?vue&type=template&id=25a58a68&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessagesComponent.ts?vue&type=script&lang=ts&












var TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlMessagesComponent, _Mixins);

  function TjipFormControlMessagesComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlMessagesComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlMessagesComponent).apply(this, arguments));
    _this.form = null;
    _this.internalIsValid = true;
    return _this;
  }

  _createClass(TjipFormControlMessagesComponent, [{
    key: "isFirstMessageForType",
    value: function isFirstMessageForType(msgComp) {
      return lodash["find"](this.$children, function (child) {
        var c = child;
        return c && c.type === msgComp.type;
      }) === msgComp;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.form = this.getAncestor(form_TjipFormComponent);
      this.resolveIsValid();
    }
  }, {
    key: "watchInvalid",
    value: function watchInvalid() {
      this.resolveIsValid();
    }
  }, {
    key: "resolveIsValid",
    value: function resolveIsValid() {
      this.internalIsValid = !(this.errors && this.errors.$invalid);
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.internalIsValid;
    }
  }, {
    key: "resolvedLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }, {
    key: "resolvedErrorMode",
    get: function get() {
      return this.errorMode || this.form && this.form.errorMode || 'touched';
    }
  }, {
    key: "submitted",
    get: function get() {
      return !!(this.form && this.form.submitted);
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return !!(this.errors && this.errors.$invalid);
    }
  }, {
    key: "showErrors",
    get: function get() {
      if (!this.isValid) {
        switch (this.resolvedErrorMode) {
          case 'touched':
            {
              return this.errors.$error || this.submitted;
            }

          case 'submit':
            {
              return this.submitted;
            }

          default:
            {
              return true;
            }
        }
      }

      return false;
    }
  }]);

  return TjipFormControlMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin));

__decorate([Prop()], TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([ProvideReactive('tjipFormControlErrors'), Prop({
  required: true
})], TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent.prototype, "errorMode", void 0);

__decorate([Provide('tjipFormControlMessagesIsFirstMessageForType')], TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent.prototype, "isFirstMessageForType", null);

__decorate([Watch('errors.$invalid')], TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent.prototype, "watchInvalid", null);

TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent);

/* harmony default export */ var TjipFormControlMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlMessagesComponentvue_type_script_lang_ts_TjipFormControlMessagesComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessagesComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var control_TjipFormControlMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlMessagesComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessagesComponent.global.scss?vue&type=style&index=0&lang=scss&
var TjipFormControlMessagesComponent_globalvue_type_style_index_0_lang_scss_ = __webpack_require__("aa50");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessagesComponent.vue






/* normalize component */

var TjipFormControlMessagesComponent_component = normalizeComponent(
  control_TjipFormControlMessagesComponentvue_type_script_lang_ts_,
  TjipFormControlMessagesComponentvue_type_template_id_25a58a68_render,
  TjipFormControlMessagesComponentvue_type_template_id_25a58a68_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var control_TjipFormControlMessagesComponent = (TjipFormControlMessagesComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessagesComponent.ts












var TjipFormControlMessagesComponent_TjipFormControlMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlMessagesComponent, _Mixins);

  function TjipFormControlMessagesComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlMessagesComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlMessagesComponent).apply(this, arguments));
    _this.form = null;
    _this.internalIsValid = true;
    return _this;
  }

  _createClass(TjipFormControlMessagesComponent, [{
    key: "isFirstMessageForType",
    value: function isFirstMessageForType(msgComp) {
      return lodash["find"](this.$children, function (child) {
        var c = child;
        return c && c.type === msgComp.type;
      }) === msgComp;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.form = this.getAncestor(form_TjipFormComponent);
      this.resolveIsValid();
    }
  }, {
    key: "watchInvalid",
    value: function watchInvalid() {
      this.resolveIsValid();
    }
  }, {
    key: "resolveIsValid",
    value: function resolveIsValid() {
      this.internalIsValid = !(this.errors && this.errors.$invalid);
    }
  }, {
    key: "isValid",
    get: function get() {
      return this.internalIsValid;
    }
  }, {
    key: "resolvedLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }, {
    key: "resolvedErrorMode",
    get: function get() {
      return this.errorMode || this.form && this.form.errorMode || 'touched';
    }
  }, {
    key: "submitted",
    get: function get() {
      return !!(this.form && this.form.submitted);
    }
  }, {
    key: "hasErrors",
    get: function get() {
      return !!(this.errors && this.errors.$invalid);
    }
  }, {
    key: "showErrors",
    get: function get() {
      if (!this.isValid) {
        switch (this.resolvedErrorMode) {
          case 'touched':
            {
              return this.errors.$error || this.submitted;
            }

          case 'submit':
            {
              return this.submitted;
            }

          default:
            {
              return true;
            }
        }
      }

      return false;
    }
  }]);

  return TjipFormControlMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin));

__decorate([Prop()], TjipFormControlMessagesComponent_TjipFormControlMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlMessagesComponent_TjipFormControlMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([ProvideReactive('tjipFormControlErrors'), Prop({
  required: true
})], TjipFormControlMessagesComponent_TjipFormControlMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlMessagesComponent_TjipFormControlMessagesComponent.prototype, "errorMode", void 0);

__decorate([Provide('tjipFormControlMessagesIsFirstMessageForType')], TjipFormControlMessagesComponent_TjipFormControlMessagesComponent.prototype, "isFirstMessageForType", null);

__decorate([Watch('errors.$invalid')], TjipFormControlMessagesComponent_TjipFormControlMessagesComponent.prototype, "watchInvalid", null);

TjipFormControlMessagesComponent_TjipFormControlMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlMessagesComponent_TjipFormControlMessagesComponent);

/* harmony default export */ var messages_control_TjipFormControlMessagesComponent = (TjipFormControlMessagesComponent_TjipFormControlMessagesComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/messages/control/TjipFormControlCurrencyMessagesComponent.vue?vue&type=template&id=1af13d7b&
var TjipFormControlCurrencyMessagesComponentvue_type_template_id_1af13d7b_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-control-messages',{attrs:{"label":_vm.label,"showSingleMessage":_vm.showSingleMessage,"errors":_vm.errors,"errorMode":_vm.errorMode}},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet minimaal "+_vm._s(_vm._f("tjipCurrency")(params.min,_vm.currencyFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet groter dan "+_vm._s(_vm._f("tjipCurrency")(params.min,_vm.currencyFilterOptions))+" zijn.")]:_vm._e()]}}])}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" mag maximaal "+_vm._s(_vm._f("tjipCurrency")(params.max,_vm.currencyFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet kleiner dan "+_vm._s(_vm._f("tjipCurrency")(params.max,_vm.currencyFilterOptions))+" zijn.")]:_vm._e()]}}])})],2)}
var TjipFormControlCurrencyMessagesComponentvue_type_template_id_1af13d7b_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlCurrencyMessagesComponent.vue?vue&type=template&id=1af13d7b&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/messages/control/TjipFormControlCurrencyMessagesComponent.ts?vue&type=script&lang=ts&












var TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlCurrencyMessagesComponent, _Mixins);

  function TjipFormControlCurrencyMessagesComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlCurrencyMessagesComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlCurrencyMessagesComponent).apply(this, arguments));
    _this.defaultMinimumFractionDigits = 2;
    _this.defaultMaximumFractionDigits = 2;
    return _this;
  }

  _createClass(TjipFormControlCurrencyMessagesComponent, [{
    key: "currencyFilterOptions",
    get: function get() {
      return Object.assign({}, this.numberFilterOptions, {
        decimalMode: this.decimalMode
      });
    }
  }, {
    key: "resolvedMessageLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }]);

  return TjipFormControlCurrencyMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFiltersMixin_TjipFiltersMixin));

__decorate([Prop()], TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop({
  required: true
})], TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent.prototype, "errorMode", void 0);

__decorate([Prop()], TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent.prototype, "decimalMode", void 0);

TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent);

/* harmony default export */ var TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_TjipFormControlCurrencyMessagesComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlCurrencyMessagesComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var control_TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlCurrencyMessagesComponent.vue





/* normalize component */

var TjipFormControlCurrencyMessagesComponent_component = normalizeComponent(
  control_TjipFormControlCurrencyMessagesComponentvue_type_script_lang_ts_,
  TjipFormControlCurrencyMessagesComponentvue_type_template_id_1af13d7b_render,
  TjipFormControlCurrencyMessagesComponentvue_type_template_id_1af13d7b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var control_TjipFormControlCurrencyMessagesComponent = (TjipFormControlCurrencyMessagesComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlCurrencyMessagesComponent.ts












var TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlCurrencyMessagesComponent, _Mixins);

  function TjipFormControlCurrencyMessagesComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlCurrencyMessagesComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlCurrencyMessagesComponent).apply(this, arguments));
    _this.defaultMinimumFractionDigits = 2;
    _this.defaultMaximumFractionDigits = 2;
    return _this;
  }

  _createClass(TjipFormControlCurrencyMessagesComponent, [{
    key: "currencyFilterOptions",
    get: function get() {
      return Object.assign({}, this.numberFilterOptions, {
        decimalMode: this.decimalMode
      });
    }
  }, {
    key: "resolvedMessageLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }]);

  return TjipFormControlCurrencyMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFiltersMixin_TjipFiltersMixin));

__decorate([Prop()], TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop({
  required: true
})], TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent.prototype, "errorMode", void 0);

__decorate([Prop()], TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent.prototype, "decimalMode", void 0);

TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent);

/* harmony default export */ var messages_control_TjipFormControlCurrencyMessagesComponent = (TjipFormControlCurrencyMessagesComponent_TjipFormControlCurrencyMessagesComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/messages/control/TjipFormControlDateMessagesComponent.vue?vue&type=template&id=52962f72&
var TjipFormControlDateMessagesComponentvue_type_template_id_52962f72_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-control-messages',{attrs:{"label":_vm.label,"showSingleMessage":_vm.showSingleMessage,"errors":_vm.errors,"errorMode":_vm.errorMode}},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"syntaxDate"}},[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" voldoet niet aan het formaat '"+_vm._s(_vm.resolvedErrorFormat)+"'")]),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet minimaal "+_vm._s(_vm._f("tjipMoment")(params.min,_vm.resolvedFormat))+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet groter dan "+_vm._s(_vm._f("tjipMoment")(params.min,_vm.resolvedFormat))+" zijn.")]:_vm._e()]}}])}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" mag maximaal "+_vm._s(_vm._f("tjipMoment")(params.max,_vm.resolvedFormat))+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet kleiner dan "+_vm._s(_vm._f("tjipMoment")(params.max,_vm.resolvedFormat))+" zijn.")]:_vm._e()]}}])})],2)}
var TjipFormControlDateMessagesComponentvue_type_template_id_52962f72_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlDateMessagesComponent.vue?vue&type=template&id=52962f72&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/messages/control/TjipFormControlDateMessagesComponent.ts?vue&type=script&lang=ts&










var TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlDateMessagesComponent, _Mixins);

  function TjipFormControlDateMessagesComponent() {
    _classCallCheck(this, TjipFormControlDateMessagesComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlDateMessagesComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlDateMessagesComponent, [{
    key: "resolvedFormat",
    get: function get() {
      return this.format || 'DD-MM-YYYY';
    }
  }, {
    key: "resolvedErrorFormat",
    get: function get() {
      return this.errorFormat || this.resolvedFormat;
    }
  }, {
    key: "resolvedMessageLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }]);

  return TjipFormControlDateMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFiltersMixin_TjipFiltersMixin));

__decorate([Prop()], TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop({
  required: true
})], TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent.prototype, "errorMode", void 0);

__decorate([Prop()], TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent.prototype, "format", void 0);

__decorate([Prop()], TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent.prototype, "errorFormat", void 0);

TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent);

/* harmony default export */ var TjipFormControlDateMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlDateMessagesComponentvue_type_script_lang_ts_TjipFormControlDateMessagesComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlDateMessagesComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var control_TjipFormControlDateMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlDateMessagesComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlDateMessagesComponent.vue





/* normalize component */

var TjipFormControlDateMessagesComponent_component = normalizeComponent(
  control_TjipFormControlDateMessagesComponentvue_type_script_lang_ts_,
  TjipFormControlDateMessagesComponentvue_type_template_id_52962f72_render,
  TjipFormControlDateMessagesComponentvue_type_template_id_52962f72_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var control_TjipFormControlDateMessagesComponent = (TjipFormControlDateMessagesComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlDateMessagesComponent.ts










var TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlDateMessagesComponent, _Mixins);

  function TjipFormControlDateMessagesComponent() {
    _classCallCheck(this, TjipFormControlDateMessagesComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlDateMessagesComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlDateMessagesComponent, [{
    key: "resolvedFormat",
    get: function get() {
      return this.format || 'DD-MM-YYYY';
    }
  }, {
    key: "resolvedErrorFormat",
    get: function get() {
      return this.errorFormat || this.resolvedFormat;
    }
  }, {
    key: "resolvedMessageLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }]);

  return TjipFormControlDateMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFiltersMixin_TjipFiltersMixin));

__decorate([Prop()], TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop({
  required: true
})], TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent.prototype, "errorMode", void 0);

__decorate([Prop()], TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent.prototype, "format", void 0);

__decorate([Prop()], TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent.prototype, "errorFormat", void 0);

TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent);

/* harmony default export */ var messages_control_TjipFormControlDateMessagesComponent = (TjipFormControlDateMessagesComponent_TjipFormControlDateMessagesComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/messages/control/TjipFormControlNumberMessagesComponent.vue?vue&type=template&id=9e40b68a&
var TjipFormControlNumberMessagesComponentvue_type_template_id_9e40b68a_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-control-messages',{attrs:{"label":_vm.label,"showSingleMessage":_vm.showSingleMessage,"errors":_vm.errors,"errorMode":_vm.errorMode}},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet minimaal "+_vm._s(_vm._f("tjipNumber")(params.min,_vm.numberFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet groter dan "+_vm._s(_vm._f("tjipNumber")(params.min,_vm.numberFilterOptions))+" zijn.")]:_vm._e()]}}])}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" mag maximaal "+_vm._s(_vm._f("tjipNumber")(params.max,_vm.numberFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet kleiner dan "+_vm._s(_vm._f("tjipNumber")(params.max,_vm.numberFilterOptions))+" zijn.")]:_vm._e()]}}])})],2)}
var TjipFormControlNumberMessagesComponentvue_type_template_id_9e40b68a_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlNumberMessagesComponent.vue?vue&type=template&id=9e40b68a&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/messages/control/TjipFormControlNumberMessagesComponent.ts?vue&type=script&lang=ts&











var TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_TjipFormControlNumberMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlNumberMessagesComponent, _Mixins);

  function TjipFormControlNumberMessagesComponent() {
    _classCallCheck(this, TjipFormControlNumberMessagesComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlNumberMessagesComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlNumberMessagesComponent, [{
    key: "resolvedMessageLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }]);

  return TjipFormControlNumberMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFiltersMixin_TjipFiltersMixin));

__decorate([Prop()], TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_TjipFormControlNumberMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_TjipFormControlNumberMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop({
  required: true
})], TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_TjipFormControlNumberMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_TjipFormControlNumberMessagesComponent.prototype, "errorMode", void 0);

TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_TjipFormControlNumberMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_TjipFormControlNumberMessagesComponent);

/* harmony default export */ var TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_TjipFormControlNumberMessagesComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlNumberMessagesComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var control_TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlNumberMessagesComponent.vue





/* normalize component */

var TjipFormControlNumberMessagesComponent_component = normalizeComponent(
  control_TjipFormControlNumberMessagesComponentvue_type_script_lang_ts_,
  TjipFormControlNumberMessagesComponentvue_type_template_id_9e40b68a_render,
  TjipFormControlNumberMessagesComponentvue_type_template_id_9e40b68a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var control_TjipFormControlNumberMessagesComponent = (TjipFormControlNumberMessagesComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlNumberMessagesComponent.ts











var TjipFormControlNumberMessagesComponent_TjipFormControlNumberMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlNumberMessagesComponent, _Mixins);

  function TjipFormControlNumberMessagesComponent() {
    _classCallCheck(this, TjipFormControlNumberMessagesComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlNumberMessagesComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlNumberMessagesComponent, [{
    key: "resolvedMessageLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }]);

  return TjipFormControlNumberMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFiltersMixin_TjipFiltersMixin));

__decorate([Prop()], TjipFormControlNumberMessagesComponent_TjipFormControlNumberMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlNumberMessagesComponent_TjipFormControlNumberMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop({
  required: true
})], TjipFormControlNumberMessagesComponent_TjipFormControlNumberMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlNumberMessagesComponent_TjipFormControlNumberMessagesComponent.prototype, "errorMode", void 0);

TjipFormControlNumberMessagesComponent_TjipFormControlNumberMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlNumberMessagesComponent_TjipFormControlNumberMessagesComponent);

/* harmony default export */ var messages_control_TjipFormControlNumberMessagesComponent = (TjipFormControlNumberMessagesComponent_TjipFormControlNumberMessagesComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/messages/control/TjipFormControlPercentMessagesComponent.vue?vue&type=template&id=0e724e21&
var TjipFormControlPercentMessagesComponentvue_type_template_id_0e724e21_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tjip-form-control-messages',{attrs:{"label":_vm.label,"showSingleMessage":_vm.showSingleMessage,"errors":_vm.errors,"errorMode":_vm.errorMode}},[_vm._t("default"),_c('tjip-form-control-message',{attrs:{"type":"minValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet minimaal "+_vm._s(_vm._f("tjipPercent")(params.min,_vm.percentFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMin)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet groter dan "+_vm._s(_vm._f("tjipPercent")(params.min,_vm.percentFilterOptions))+" zijn.")]:_vm._e()]}}])}),_c('tjip-form-control-message',{attrs:{"type":"maxValue"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var params = ref.params;
return [(!params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" mag maximaal "+_vm._s(_vm._f("tjipPercent")(params.max,_vm.percentFilterOptions))+" zijn.")]:_vm._e(),(params.excludeMax)?[_vm._v(_vm._s(_vm.resolvedMessageLabel)+" moet kleiner dan "+_vm._s(_vm._f("tjipPercent")(params.max,_vm.percentFilterOptions))+" zijn.")]:_vm._e()]}}])})],2)}
var TjipFormControlPercentMessagesComponentvue_type_template_id_0e724e21_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlPercentMessagesComponent.vue?vue&type=template&id=0e724e21&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/messages/control/TjipFormControlPercentMessagesComponent.ts?vue&type=script&lang=ts&












var TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlPercentMessagesComponent, _Mixins);

  function TjipFormControlPercentMessagesComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlPercentMessagesComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlPercentMessagesComponent).apply(this, arguments));
    _this.defaultMinimumFractionDigits = 0;
    _this.defaultMaximumFractionDigits = 2;
    return _this;
  }

  _createClass(TjipFormControlPercentMessagesComponent, [{
    key: "percentFilterOptions",
    get: function get() {
      return Object.assign(this.numberFilterOptions, {
        baseValue: this.baseValue
      });
    }
  }, {
    key: "resolvedMessageLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }]);

  return TjipFormControlPercentMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFiltersMixin_TjipFiltersMixin));

__decorate([Prop()], TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop({
  required: true
})], TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent.prototype, "errorMode", void 0);

__decorate([Prop()], TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent.prototype, "baseValue", void 0);

TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent);

/* harmony default export */ var TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_TjipFormControlPercentMessagesComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlPercentMessagesComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var control_TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_ = (TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlPercentMessagesComponent.vue





/* normalize component */

var TjipFormControlPercentMessagesComponent_component = normalizeComponent(
  control_TjipFormControlPercentMessagesComponentvue_type_script_lang_ts_,
  TjipFormControlPercentMessagesComponentvue_type_template_id_0e724e21_render,
  TjipFormControlPercentMessagesComponentvue_type_template_id_0e724e21_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var control_TjipFormControlPercentMessagesComponent = (TjipFormControlPercentMessagesComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlPercentMessagesComponent.ts












var TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlPercentMessagesComponent, _Mixins);

  function TjipFormControlPercentMessagesComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlPercentMessagesComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlPercentMessagesComponent).apply(this, arguments));
    _this.defaultMinimumFractionDigits = 0;
    _this.defaultMaximumFractionDigits = 2;
    return _this;
  }

  _createClass(TjipFormControlPercentMessagesComponent, [{
    key: "percentFilterOptions",
    get: function get() {
      return Object.assign(this.numberFilterOptions, {
        baseValue: this.baseValue
      });
    }
  }, {
    key: "resolvedMessageLabel",
    get: function get() {
      return this.label || 'Veld';
    }
  }]);

  return TjipFormControlPercentMessagesComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormItemNumberMixin_TjipFormItemNumberMixin, TjipFiltersMixin_TjipFiltersMixin));

__decorate([Prop()], TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent.prototype, "label", void 0);

__decorate([Prop()], TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent.prototype, "showSingleMessage", void 0);

__decorate([Prop({
  required: true
})], TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent.prototype, "errors", void 0);

__decorate([Prop()], TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent.prototype, "errorMode", void 0);

__decorate([Prop()], TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent.prototype, "baseValue", void 0);

TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent = __decorate([vue_class_component_esm({})], TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent);

/* harmony default export */ var messages_control_TjipFormControlPercentMessagesComponent = (TjipFormControlPercentMessagesComponent_TjipFormControlPercentMessagesComponent);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageTemplateComponent.vue?vue&type=template&id=3b884f10&
var TjipFormControlMessageTemplateComponentvue_type_template_id_3b884f10_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-message-template"},[_vm._t("default")],2)}
var TjipFormControlMessageTemplateComponentvue_type_template_id_3b884f10_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageTemplateComponent.vue?vue&type=template&id=3b884f10&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageTemplateComponent.ts?vue&type=script&lang=ts&










var TjipFormControlMessageTemplateComponentvue_type_script_lang_ts_TjipFormControlMessageTemplateComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlMessageTemplateComponent, _Mixins);

  function TjipFormControlMessageTemplateComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlMessageTemplateComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlMessageTemplateComponent).apply(this, arguments));

    _this.internalTemplate = function () {
      return undefined;
    };

    return _this;
  }

  _createClass(TjipFormControlMessageTemplateComponent, [{
    key: "mounted",
    value: function mounted() {
      this.resolveTemplate();
      this.parentTemplateComponent = this.getAncestor(control_TjipFormControlMessageTemplateComponent);
    }
  }, {
    key: "updated",
    value: function updated() {
      this.resolveTemplate();
    }
  }, {
    key: "resolveTemplate",
    value: function resolveTemplate() {
      this.internalTemplate = this.$scopedSlots['tjip-form-control-message-template'];
    }
  }, {
    key: "template",
    get: function get() {
      return this.internalTemplate || this.parentTemplateComponent && this.parentTemplateComponent.template;
    }
  }]);

  return TjipFormControlMessageTemplateComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin));

TjipFormControlMessageTemplateComponentvue_type_script_lang_ts_TjipFormControlMessageTemplateComponent = __decorate([vue_class_component_esm({})], TjipFormControlMessageTemplateComponentvue_type_script_lang_ts_TjipFormControlMessageTemplateComponent);

/* harmony default export */ var TjipFormControlMessageTemplateComponentvue_type_script_lang_ts_ = (TjipFormControlMessageTemplateComponentvue_type_script_lang_ts_TjipFormControlMessageTemplateComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageTemplateComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var control_TjipFormControlMessageTemplateComponentvue_type_script_lang_ts_ = (TjipFormControlMessageTemplateComponentvue_type_script_lang_ts_); 
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageTemplateComponent.vue





/* normalize component */

var TjipFormControlMessageTemplateComponent_component = normalizeComponent(
  control_TjipFormControlMessageTemplateComponentvue_type_script_lang_ts_,
  TjipFormControlMessageTemplateComponentvue_type_template_id_3b884f10_render,
  TjipFormControlMessageTemplateComponentvue_type_template_id_3b884f10_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var control_TjipFormControlMessageTemplateComponent = (TjipFormControlMessageTemplateComponent_component.exports);
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageComponent.scss
var control_TjipFormControlMessageComponent = __webpack_require__("8527");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageComponent.tsx












var TjipFormControlMessageComponent_TjipFormControlMessageComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlMessageComponent, _Mixins);

  function TjipFormControlMessageComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlMessageComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlMessageComponent).apply(this, arguments)); // @InjectReactive({
    //     from: 'tjipFormControlErrors',
    //     default: undefined,
    // })
    // private errors!: RuleDecl;

    _this.templateComponent = null;
    _this.messages = null;
    return _this;
  }

  _createClass(TjipFormControlMessageComponent, [{
    key: "renderContent",
    value: function renderContent() {
      var slot = this.getContentScopedSlot();
      return slot ? slot({
        type: this.type,
        params: this.params
      }) : undefined;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.templateComponent = this.getAncestor(control_TjipFormControlMessageTemplateComponent);
      this.messages = this.getAncestor(control_TjipFormControlMessagesComponent);
    }
  }, {
    key: "getContentScopedSlot",
    value: function getContentScopedSlot() {
      return this.$scopedSlots.default;
    }
  }, {
    key: "getContentSlot",
    value: function getContentSlot() {
      return this.$slots.default;
    }
  }, {
    key: "render",
    value: function render(h) {
      if (this.showError) {
        var template = this.messageTemplate || this.getContentScopedSlot();
        var nodes = template ? template({
          type: this.type,
          params: this.params
        }) : this.getContentSlot();
        var className = 'tjip-form-control-message' + (this.messageTemplate ? '' : ' tjip-form-control-message-default');
        return h('div', {
          class: className
        }, nodes);
      }

      return undefined;
    }
  }, {
    key: "errors",
    get: function get() {
      return this.messages && this.messages.errors || undefined;
    }
  }, {
    key: "showError",
    get: function get() {
      return !!this.errors && this.type in this.errors && !this.errors[this.type] && this.isFirstMessageForType(this);
    }
  }, {
    key: "params",
    get: function get() {
      var result = !!this.errors && this.type in this.errors && this.errors.$params[this.type] || {};

      if (result.type === 'tjipValidateIf') {
        result = result.$sub[0];
      }

      return result;
    }
  }, {
    key: "messageTemplate",
    get: function get() {
      return this.templateComponent ? this.templateComponent.template : undefined;
    }
  }]);

  return TjipFormControlMessageComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin));

__decorate([Prop({
  required: true
})], TjipFormControlMessageComponent_TjipFormControlMessageComponent.prototype, "type", void 0);

__decorate([Inject('tjipFormControlMessagesIsFirstMessageForType')], TjipFormControlMessageComponent_TjipFormControlMessageComponent.prototype, "isFirstMessageForType", void 0);

TjipFormControlMessageComponent_TjipFormControlMessageComponent = __decorate([vue_class_component_esm({})], TjipFormControlMessageComponent_TjipFormControlMessageComponent);

/* harmony default export */ var messages_control_TjipFormControlMessageComponent = (TjipFormControlMessageComponent_TjipFormControlMessageComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageTemplateComponent.ts










var TjipFormControlMessageTemplateComponent_TjipFormControlMessageTemplateComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlMessageTemplateComponent, _Mixins);

  function TjipFormControlMessageTemplateComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlMessageTemplateComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlMessageTemplateComponent).apply(this, arguments));

    _this.internalTemplate = function () {
      return undefined;
    };

    return _this;
  }

  _createClass(TjipFormControlMessageTemplateComponent, [{
    key: "mounted",
    value: function mounted() {
      this.resolveTemplate();
      this.parentTemplateComponent = this.getAncestor(control_TjipFormControlMessageTemplateComponent);
    }
  }, {
    key: "updated",
    value: function updated() {
      this.resolveTemplate();
    }
  }, {
    key: "resolveTemplate",
    value: function resolveTemplate() {
      this.internalTemplate = this.$scopedSlots['tjip-form-control-message-template'];
    }
  }, {
    key: "template",
    get: function get() {
      return this.internalTemplate || this.parentTemplateComponent && this.parentTemplateComponent.template;
    }
  }]);

  return TjipFormControlMessageTemplateComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin));

TjipFormControlMessageTemplateComponent_TjipFormControlMessageTemplateComponent = __decorate([vue_class_component_esm({})], TjipFormControlMessageTemplateComponent_TjipFormControlMessageTemplateComponent);

/* harmony default export */ var messages_control_TjipFormControlMessageTemplateComponent = (TjipFormControlMessageTemplateComponent_TjipFormControlMessageTemplateComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/control/TjipFormControlMessageContentComponent.tsx










var TjipFormControlMessageContentComponent_TjipFormControlMessageContentComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlMessageContentComponent, _Mixins);

  function TjipFormControlMessageContentComponent() {
    _classCallCheck(this, TjipFormControlMessageContentComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlMessageContentComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlMessageContentComponent, [{
    key: "render",
    value: function render(h) {
      var msg = this.getAncestor(messages_control_TjipFormControlMessageComponent);
      return h('div', msg ? msg.renderContent() : undefined);
    }
  }]);

  return TjipFormControlMessageContentComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin));

TjipFormControlMessageContentComponent_TjipFormControlMessageContentComponent = __decorate([vue_class_component_esm({})], TjipFormControlMessageContentComponent_TjipFormControlMessageContentComponent);

/* harmony default export */ var control_TjipFormControlMessageContentComponent = (TjipFormControlMessageContentComponent_TjipFormControlMessageContentComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/messages/index.ts















function TjipVueMessages(Vue) {
  Vue.component('tjip-form-control-message-template', control_TjipFormControlMessageTemplateComponent);
  Vue.component('tjip-form-control-message-content', control_TjipFormControlMessageContentComponent);
  Vue.component('tjip-form-control-messages', control_TjipFormControlMessagesComponent);
  Vue.component('tjip-form-control-currency-messages', control_TjipFormControlCurrencyMessagesComponent);
  Vue.component('tjip-form-control-date-messages', control_TjipFormControlDateMessagesComponent);
  Vue.component('tjip-form-control-number-messages', control_TjipFormControlNumberMessagesComponent);
  Vue.component('tjip-form-control-percent-messages', control_TjipFormControlPercentMessagesComponent);
  Vue.component('tjip-form-control-message', messages_control_TjipFormControlMessageComponent);
}
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/validate/TjipValidationDescendantMixin.ts






var TjipValidationDescendantMixin_1;





var TjipValidationDescendantMixin_TjipValidationDescendantMixin = TjipValidationDescendantMixin_1 =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipValidationDescendantMixin, _Mixins);

  function TjipValidationDescendantMixin() {
    var _this;

    _classCallCheck(this, TjipValidationDescendantMixin);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipValidationDescendantMixin).apply(this, arguments));
    _this.isValidationDescendantMixin = true;
    return _this;
  }

  _createClass(TjipValidationDescendantMixin, [{
    key: "value",
    get: function get() {
      var expr = this.ancestorValuePath;
      var ancestor = this.validationAncestor;
      var result = expr ? TjipValidationDescendantMixin_1.getExpression(ancestor, expr) : {};
      return result;
    }
  }, {
    key: "ancestorValuePath",
    get: function get() {
      throw new Error('derived classes must implement property ancestorValuePath');
    }
  }, {
    key: "descendantValuePropertyName",
    get: function get() {
      return 'value';
    }
  }, {
    key: "modelExpression",
    get: function get() {
      return this.ancestorValuePath;
    }
  }], [{
    key: "getExpression",
    value: function getExpression(root, expression) {
      var result = root;
      var tokens = expression.split('.');
      var i1 = 0;

      while (result && i1 < tokens.length) {
        var token = tokens[i1++];
        var matches = /^(.*)\[(.*)\]$/.exec(token);

        if (matches) {
          result = result[matches[1]][matches[2]];
        } else {
          result = result[token];
        }
      }

      return result || {};
    }
  }]);

  return TjipValidationDescendantMixin;
}(mixins(TjipValidationMixin_TjipValidationMixin));

TjipValidationDescendantMixin_TjipValidationDescendantMixin = TjipValidationDescendantMixin_1 = __decorate([vue_class_component_esm], TjipValidationDescendantMixin_TjipValidationDescendantMixin);

// EXTERNAL MODULE: external "vuelidate"
var external_vuelidate_ = __webpack_require__("25bc");
var external_vuelidate_default = /*#__PURE__*/__webpack_require__.n(external_vuelidate_);

// EXTERNAL MODULE: external "vuelidate/lib/validators"
var validators_ = __webpack_require__("1abc");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/validate/tjipRequiredDate.ts


/* harmony default export */ var tjipRequiredDate = (Object(external_vuelidate_["withParams"])({
  type: 'tjipRequiredDate'
}, function (value) {
  // Do not qualify an 'Invalid Date' as failing the required validation
  // In that case the 'syntaxDate' validation fails
  var args = [value];
  var result = value instanceof Date && isNaN(value.getTime()) ? true : validators_["required"].apply(null, args);
  return result;
}));
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/validate/tjipMinValue.ts





function validateNumber(val, min, excludeMin) {
  if (lodash["isNil"](val)) {
    return true;
  }

  if (isNaN(val) || /[^0-9.-]/.test(val.toString())) {
    return false;
  } else if (!isNaN(min)) {
    return !(excludeMin ? val <= min : val < min);
  }

  return true;
}

function validateDate(val, min, excludeMin) {
  if (lodash["isNil"](val) || val instanceof Date && isNaN(val.getTime())) {
    return true;
  }

  if (isNaN(val)) {
    return false;
  } else if (!lodash["isUndefined"](min)) {
    return !(excludeMin ? val <= min : val < min);
  }

  return true;
}

function validateString(val, min, excludeMin) {
  if (lodash["isNil"](val)) {
    return true;
  }

  if (!lodash["isString"](val)) {
    return false;
  } else if (!lodash["isUndefined"](min)) {
    return !(excludeMin ? val <= min : val < min);
  }

  return true;
}

/* harmony default export */ var tjipMinValue = (function (min) {
  var excludeMin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Object(external_vuelidate_["withParams"])({
    type: 'minValue',
    min: min,
    excludeMin: excludeMin
  }, function (value) {
    var toString = {}.toString;

    var type = typeof_typeof(min);

    if (type === 'number') {
      return validateNumber(value, min, excludeMin);
    } else if (type === 'string') {
      return validateString(value, min, excludeMin);
    } else if (toString.call(min) === '[object Date]') {
      return validateDate(value, min, excludeMin);
    }

    return true;
  });
});
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/validate/tjipMaxValue.ts





function tjipMaxValue_validateNumber(val, max, excludeMax) {
  if (lodash["isNil"](val)) {
    return true;
  }

  if (isNaN(val) || /[^0-9.\-]/.test(val.toString())) {
    return false;
  } else if (!isNaN(max) && !lodash["isNil"](max)) {
    return !(excludeMax ? val >= max : val > max);
  }

  return true;
}

function tjipMaxValue_validateDate(val, max, excludeMax) {
  if (lodash["isNil"](val) || val instanceof Date && isNaN(val.getTime())) {
    return true;
  }

  if (isNaN(val)) {
    return false;
  } else if (!lodash["isNil"](max)) {
    return !(excludeMax ? val >= max : val > max);
  }

  return true;
}

function tjipMaxValue_validateString(val, max, excludeMax) {
  if (lodash["isNil"](val)) {
    return true;
  }

  if (!lodash["isString"](val)) {
    return false;
  } else if (!lodash["isUndefined"](max)) {
    return !(excludeMax ? val >= max : val > max);
  }

  return true;
}

/* harmony default export */ var tjipMaxValue = (function (max) {
  var excludeMax = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return Object(external_vuelidate_["withParams"])({
    type: 'maxValue',
    max: max,
    excludeMax: excludeMax
  }, function (value) {
    var toString = {}.toString;

    var type = typeof_typeof(max);

    if (type === 'number') {
      return tjipMaxValue_validateNumber(value, max, excludeMax);
    } else if (type === 'string') {
      return tjipMaxValue_validateString(value, max, excludeMax);
    } else if (toString.call(max) === '[object Date]') {
      return tjipMaxValue_validateDate(value, max, excludeMax);
    }

    return true;
  });
});
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/validate/tjipValidateIf.ts
 // resolve referenced value

var ref = function ref(reference, vm, parentVm) {
  var result = typeof reference === 'boolean' ? reference : typeof reference === 'function' ? reference.call(vm, parentVm) : parentVm[reference];
  return result;
};

/* harmony default export */ var tjipValidateIf = (function (condition, validation) {
  return Object(external_vuelidate_["withParams"])({
    type: 'tjipValidateIf',
    condition: condition
  }, function (value, parentVm) {
    return !ref(condition, this, parentVm) || validation.call(this, value, parentVm);
  });
});
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/validate/index.ts








function TjipVueValidation(Vue) {
  if (Vue._installedPlugins.indexOf(external_vuelidate_default.a) >= 0) {
    // order is important here! Tjip validate mixin must be registered before Vuelidate's validationMixin
    // tslint:disable-next-line:no-console
    console.error('Load @tjip/vuejs before vuelidate');
  }

  Vue.mixin(TjipValidationMixin_TjipValidationMixin);
}
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"ebd5ba72-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./projects/@tjip/vuejs/src/options/TjipFormControlOptionsComponent.vue?vue&type=template&id=337cb5bb&scoped=true&
var TjipFormControlOptionsComponentvue_type_template_id_337cb5bb_scoped_true_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tjip-form-control-options"},[_vm._t("default",null,{"options":_vm.options,"selected":_vm.selected,"select":_vm.select,"unselect":_vm.unselect})],2)}
var TjipFormControlOptionsComponentvue_type_template_id_337cb5bb_scoped_true_staticRenderFns = []


// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/options/TjipFormControlOptionsComponent.vue?vue&type=template&id=337cb5bb&scoped=true&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/ts-loader??ref--13-1!./projects/@tjip/vuejs/src/options/TjipFormControlOptionsComponent.ts?vue&type=script&lang=ts&














var TjipFormControlOptionsComponentvue_type_script_lang_ts_TjipFormControlOptionsComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlOptionsComponent, _Mixins);

  function TjipFormControlOptionsComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlOptionsComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlOptionsComponent).apply(this, arguments));
    _this.options = [];
    _this.pSelected = null;
    return _this;
  }

  _createClass(TjipFormControlOptionsComponent, [{
    key: "isSelected",
    value: function isSelected(option) {
      if (this.isMultiSelect) {
        var selected = this.pSelected;
        return selected && selected.indexOf(option) >= 0;
      } else {
        return this.pSelected === option;
      }
    }
  }, {
    key: "select",
    value: function select(option) {
      if (this.isMultiSelect) {
        if (option) {
          this.pSelected = this.pSelected || [];
          var selected = this.pSelected;

          if (selected.indexOf(option) < 0) {
            selected.push(option);
            this.internalValue = selected.map(function (o) {
              return o.value;
            });
          }
        }
      } else {
        this.pSelected = option;

        if (option) {
          this.internalValue = option.value;
        } else {
          this.internalValue = undefined;
        }
      }
    }
  }, {
    key: "unselect",
    value: function unselect(option) {
      if (this.isMultiSelect) {
        if (this.pSelected) {
          var selected = this.pSelected;
          var ndx = selected.indexOf(option);

          if (ndx >= 0) {
            selected.splice(ndx, 1);
          }

          if (!selected.length) {
            this.pSelected = null;
            this.internalValue = undefined;
          } else {
            this.internalValue = selected.map(function (o) {
              return o.value;
            });
          }
        }
      } else {
        if (this.pSelected === option) {
          this.internalValue = undefined;
        }
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.resolveOptions();
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val, oldVal) {
      this.updateSelected();
    }
  }, {
    key: "updateSelected",
    value: function updateSelected() {
      if (this.isMultiSelect) {
        var values = this.value;

        if (values && lodash["isArray"](values)) {
          var newSelected = [];
          var options = this.options || [];

          lodash["forEach"](values, function (value) {
            var option = lodash["find"](options, {
              value: value
            });

            if (option) {
              newSelected.push(option);
            }
          });

          if (!lodash["isEqual"](this.pSelected, newSelected)) {
            if (newSelected.length) {
              this.pSelected = newSelected;
              this.internalValue = newSelected.map(function (o) {
                return o.value;
              });
            } else {
              this.pSelected = null;
              this.internalValue = undefined;
            }
          }
        } else {
          this.pSelected = null;
        }
      } else {
        var _options = this.options || [];

        var option = lodash["find"](_options, {
          value: this.value
        });

        this.select(option);
      }
    }
  }, {
    key: "resolveOptions",
    value: function resolveOptions() {
      var result = [];

      if (this.$el && this.$el.childNodes) {
        lodash["forEach"](this.$el.childNodes, function (node) {
          if (node.nodeType === 8 && node.__vue__ instanceof options_TjipFormControlOptionComponent) {
            result.push(node.__vue__);
          }
        });
      }

      if (!lodash["isEqual"](this.options, result)) {
        this.options = result;
        this.updateSelected();
      }
    }
  }, {
    key: "updated",
    value: function updated() {
      this.resolveOptions();
    }
  }, {
    key: "selected",
    get: function get() {
      return this.pSelected;
    }
  }, {
    key: "isMultiSelect",
    get: function get() {
      return !lodash["isUndefined"](this.multiSelect) && this.multiSelect !== false;
    }
  }]);

  return TjipFormControlOptionsComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormControlValueMixin_TjipFormControlValueMixin));

__decorate([Prop()], TjipFormControlOptionsComponentvue_type_script_lang_ts_TjipFormControlOptionsComponent.prototype, "multiSelect", void 0);

__decorate([Watch('value')], TjipFormControlOptionsComponentvue_type_script_lang_ts_TjipFormControlOptionsComponent.prototype, "onValueChanged", null);

TjipFormControlOptionsComponentvue_type_script_lang_ts_TjipFormControlOptionsComponent = __decorate([vue_class_component_esm({})], TjipFormControlOptionsComponentvue_type_script_lang_ts_TjipFormControlOptionsComponent);

/* harmony default export */ var TjipFormControlOptionsComponentvue_type_script_lang_ts_ = (TjipFormControlOptionsComponentvue_type_script_lang_ts_TjipFormControlOptionsComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/options/TjipFormControlOptionsComponent.ts?vue&type=script&lang=ts&
 /* harmony default export */ var options_TjipFormControlOptionsComponentvue_type_script_lang_ts_ = (TjipFormControlOptionsComponentvue_type_script_lang_ts_); 
// EXTERNAL MODULE: ./projects/@tjip/vuejs/src/options/TjipFormControlOptionsComponent.scss?vue&type=style&index=0&id=337cb5bb&scoped=true&lang=scss&
var TjipFormControlOptionsComponentvue_type_style_index_0_id_337cb5bb_scoped_true_lang_scss_ = __webpack_require__("9c46");

// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/options/TjipFormControlOptionsComponent.vue






/* normalize component */

var TjipFormControlOptionsComponent_component = normalizeComponent(
  options_TjipFormControlOptionsComponentvue_type_script_lang_ts_,
  TjipFormControlOptionsComponentvue_type_template_id_337cb5bb_scoped_true_render,
  TjipFormControlOptionsComponentvue_type_template_id_337cb5bb_scoped_true_staticRenderFns,
  false,
  null,
  "337cb5bb",
  null
  
)

/* harmony default export */ var options_TjipFormControlOptionsComponent = (TjipFormControlOptionsComponent_component.exports);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/options/TjipFormControlOptionComponent.tsx










var TjipFormControlOptionComponent_TjipFormControlOptionComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlOptionComponent, _Mixins);

  function TjipFormControlOptionComponent() {
    _classCallCheck(this, TjipFormControlOptionComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlOptionComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlOptionComponent, [{
    key: "getScopedSlot",
    value: function getScopedSlot(slotName) {
      return this.$scopedSlots[slotName] || this.$scopedSlots.default;
    }
  }, {
    key: "select",
    value: function select(event) {
      if (!this.disabled) {
        var host = this.getHost();

        if (host) {
          host.select(this);
        }

        if (event) {
          // event.stopPropagation();
          event.preventDefault();
        }
      }

      return false;
    }
  }, {
    key: "render",
    value: function render(h) {
      return undefined;
    }
  }, {
    key: "updated",
    value: function updated() {
      if (this.disabled) {
        var host = this.getHost();

        if (host) {
          host.unselect(this);
        }
      }
    }
  }, {
    key: "getHost",
    value: function getHost() {
      return this.getAncestor(options_TjipFormControlOptionsComponent);
    }
  }, {
    key: "selected",
    get: function get() {
      var host = this.getHost();
      return !!(host && host.isSelected(this));
    }
  }]);

  return TjipFormControlOptionComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin));

__decorate([Prop({
  required: true
})], TjipFormControlOptionComponent_TjipFormControlOptionComponent.prototype, "value", void 0);

__decorate([Prop()], TjipFormControlOptionComponent_TjipFormControlOptionComponent.prototype, "title", void 0);

__decorate([Prop()], TjipFormControlOptionComponent_TjipFormControlOptionComponent.prototype, "disabled", void 0);

TjipFormControlOptionComponent_TjipFormControlOptionComponent = __decorate([vue_class_component_esm({})], TjipFormControlOptionComponent_TjipFormControlOptionComponent);

/* harmony default export */ var options_TjipFormControlOptionComponent = (TjipFormControlOptionComponent_TjipFormControlOptionComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/options/TjipFormControlOptionContentComponent.tsx









var TjipFormControlOptionContentComponent_TjipFormControlOptionContentComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlOptionContentComponent, _Mixins);

  function TjipFormControlOptionContentComponent() {
    _classCallCheck(this, TjipFormControlOptionContentComponent);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlOptionContentComponent).apply(this, arguments));
  }

  _createClass(TjipFormControlOptionContentComponent, [{
    key: "render",
    value: function render(h) {
      var scopedSlot = this.option && this.option.getScopedSlot(this.slotName);
      return scopedSlot ? h('div', {
        class: 'tjip-form-control-option',
        attrs: {
          title: this.option.title
        }
      }, scopedSlot({
        option: this.option
      })) : undefined;
    }
  }]);

  return TjipFormControlOptionContentComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin));

__decorate([Prop()], TjipFormControlOptionContentComponent_TjipFormControlOptionContentComponent.prototype, "option", void 0);

__decorate([Prop()], TjipFormControlOptionContentComponent_TjipFormControlOptionContentComponent.prototype, "slotName", void 0);

TjipFormControlOptionContentComponent_TjipFormControlOptionContentComponent = __decorate([vue_class_component_esm({})], TjipFormControlOptionContentComponent_TjipFormControlOptionContentComponent);

/* harmony default export */ var options_TjipFormControlOptionContentComponent = (TjipFormControlOptionContentComponent_TjipFormControlOptionContentComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/options/TjipFormControlOptionsComponent.ts














var TjipFormControlOptionsComponent_TjipFormControlOptionsComponent =
/*#__PURE__*/
function (_Mixins) {
  _inherits(TjipFormControlOptionsComponent, _Mixins);

  function TjipFormControlOptionsComponent() {
    var _this;

    _classCallCheck(this, TjipFormControlOptionsComponent);

    _this = _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipFormControlOptionsComponent).apply(this, arguments));
    _this.options = [];
    _this.pSelected = null;
    return _this;
  }

  _createClass(TjipFormControlOptionsComponent, [{
    key: "isSelected",
    value: function isSelected(option) {
      if (this.isMultiSelect) {
        var selected = this.pSelected;
        return selected && selected.indexOf(option) >= 0;
      } else {
        return this.pSelected === option;
      }
    }
  }, {
    key: "select",
    value: function select(option) {
      if (this.isMultiSelect) {
        if (option) {
          this.pSelected = this.pSelected || [];
          var selected = this.pSelected;

          if (selected.indexOf(option) < 0) {
            selected.push(option);
            this.internalValue = selected.map(function (o) {
              return o.value;
            });
          }
        }
      } else {
        this.pSelected = option;

        if (option) {
          this.internalValue = option.value;
        } else {
          this.internalValue = undefined;
        }
      }
    }
  }, {
    key: "unselect",
    value: function unselect(option) {
      if (this.isMultiSelect) {
        if (this.pSelected) {
          var selected = this.pSelected;
          var ndx = selected.indexOf(option);

          if (ndx >= 0) {
            selected.splice(ndx, 1);
          }

          if (!selected.length) {
            this.pSelected = null;
            this.internalValue = undefined;
          } else {
            this.internalValue = selected.map(function (o) {
              return o.value;
            });
          }
        }
      } else {
        if (this.pSelected === option) {
          this.internalValue = undefined;
        }
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.resolveOptions();
    }
  }, {
    key: "onValueChanged",
    value: function onValueChanged(val, oldVal) {
      this.updateSelected();
    }
  }, {
    key: "updateSelected",
    value: function updateSelected() {
      if (this.isMultiSelect) {
        var values = this.value;

        if (values && lodash["isArray"](values)) {
          var newSelected = [];
          var options = this.options || [];

          lodash["forEach"](values, function (value) {
            var option = lodash["find"](options, {
              value: value
            });

            if (option) {
              newSelected.push(option);
            }
          });

          if (!lodash["isEqual"](this.pSelected, newSelected)) {
            if (newSelected.length) {
              this.pSelected = newSelected;
              this.internalValue = newSelected.map(function (o) {
                return o.value;
              });
            } else {
              this.pSelected = null;
              this.internalValue = undefined;
            }
          }
        } else {
          this.pSelected = null;
        }
      } else {
        var _options = this.options || [];

        var option = lodash["find"](_options, {
          value: this.value
        });

        this.select(option);
      }
    }
  }, {
    key: "resolveOptions",
    value: function resolveOptions() {
      var result = [];

      if (this.$el && this.$el.childNodes) {
        lodash["forEach"](this.$el.childNodes, function (node) {
          if (node.nodeType === 8 && node.__vue__ instanceof options_TjipFormControlOptionComponent) {
            result.push(node.__vue__);
          }
        });
      }

      if (!lodash["isEqual"](this.options, result)) {
        this.options = result;
        this.updateSelected();
      }
    }
  }, {
    key: "updated",
    value: function updated() {
      this.resolveOptions();
    }
  }, {
    key: "selected",
    get: function get() {
      return this.pSelected;
    }
  }, {
    key: "isMultiSelect",
    get: function get() {
      return !lodash["isUndefined"](this.multiSelect) && this.multiSelect !== false;
    }
  }]);

  return TjipFormControlOptionsComponent;
}(mixins(TjipAncestorMixin_TjipAncestorMixin, TjipFormControlValueMixin_TjipFormControlValueMixin));

__decorate([Prop()], TjipFormControlOptionsComponent_TjipFormControlOptionsComponent.prototype, "multiSelect", void 0);

__decorate([Watch('value')], TjipFormControlOptionsComponent_TjipFormControlOptionsComponent.prototype, "onValueChanged", null);

TjipFormControlOptionsComponent_TjipFormControlOptionsComponent = __decorate([vue_class_component_esm({})], TjipFormControlOptionsComponent_TjipFormControlOptionsComponent);

/* harmony default export */ var src_options_TjipFormControlOptionsComponent = (TjipFormControlOptionsComponent_TjipFormControlOptionsComponent);
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/options/index.ts





function TjipVueOptions(Vue) {
  Vue.component('tjip-form-control-option', options_TjipFormControlOptionComponent);
  Vue.component('tjip-form-control-option-content', TjipFormControlOptionContentComponent_TjipFormControlOptionContentComponent);
  Vue.component('tjip-form-control-options', options_TjipFormControlOptionsComponent);
}
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/store/TjipNameValueStoreItem.ts


var TjipNameValueStoreItem_TjipNameValueStoreItem =
/*#__PURE__*/
function () {
  function TjipNameValueStoreItem(store, pKey) {
    _classCallCheck(this, TjipNameValueStoreItem);

    this.store = store;
    this.pKey = pKey;
  }

  _createClass(TjipNameValueStoreItem, [{
    key: "get",
    value: function get() {
      return this.store.get(this.pKey);
    }
  }, {
    key: "set",
    value: function set(value) {
      this.store.set(this.pKey, value);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.store.remove(this.pKey);
    }
  }, {
    key: "key",
    get: function get() {
      return this.pKey;
    }
  }]);

  return TjipNameValueStoreItem;
}();
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/utils/JsonHelper.ts







// credits to: http://stackoverflow.com/questions/8111446/turning-json-strings-into-objects-with-methods
var JsonHelper_JsonHelper =
/*#__PURE__*/
function () {
  function JsonHelper() {
    _classCallCheck(this, JsonHelper);
  }

  _createClass(JsonHelper, null, [{
    key: "toJSON",
    // A generic "toJSON" function that creates the data expected
    // by Reviver.
    // `ctorName`  The name of the constructor to use to revive it
    // `obj`       The object being serialized
    // `keys`      (Optional) Array of the properties to serialize,
    //             if not given then all of the objects "own" properties
    //             that don't have function values will be serialized.
    //             (Note: If you list a property in `keys`, it will be serialized
    //             regardless of whether it's an "own" property.)
    // Returns:    The structure (which will then be turned into a string
    //             as part of the JSON.stringify algorithm)
    value: function toJSON(ctorKey, obj, keys) {
      var data = {};
      var index;
      var key;

      if (!keys) {
        keys = Object.keys(obj); // Only "own" properties are included
      }

      for (index = 0; index < keys.length; ++index) {
        key = keys[index];
        data[key] = obj[key];
      }

      return {
        ctor: ctorKey,
        data: data
      };
    } // A generic "fromJSON" function for use with Reviver: Just calls the
    // constructor function with no arguments, then applies all of the
    // key/value pairs from the raw data to the instance. Only useful for
    // constructors that can be reasonably called without arguments!
    // `ctor`      The constructor to call
    // `data`      The data to apply
    // Returns:    The object

  }, {
    key: "fromJSON",
    value: function fromJSON(ctor, data) {
      var obj;
      var name;
      obj = new ctor();

      for (name in data) {
        if (obj.hasOwnProperty(name)) {
          obj[name] = data[name];
        }
      }

      return obj;
    } // A generic "smart reviver" function.
    // Looks for object values with a `ctor` property and
    // a `data` property. If it finds them, and finds a matching
    // constructor that has a `fromJSON` property on it, it hands
    // off to that `fromJSON` fuunction, passing in the value.

  }, {
    key: "reviver",
    value: function reviver(key, value) {
      if (value && typeof_typeof(value) === 'object' && typeof value.ctor === 'string' && typeof value.data !== 'undefined') {
        var ctor = JsonHelper.constructors[value.ctor] || window[value.ctor];

        if (typeof ctor === 'function') {
          if (typeof ctor.fromJSON === 'function') {
            return ctor.fromJSON(value);
          } else {
            return JsonHelper.fromJSON(ctor, value.data);
          }
        }
      }

      if (value && value.type === 'date') {
        return new Date(value.value);
      }

      return value;
    }
  }, {
    key: "replacer",
    value: function replacer(key, value) {
      if (this[key] instanceof Date) {
        return {
          type: 'date',
          value: value
        };
      }

      return value;
    }
  }, {
    key: "registerClass",
    value: function registerClass(clazz, key) {
      JsonHelper.constructors[key] = clazz;
    }
  }, {
    key: "stringify",
    value: function stringify(value) {
      var result = JSON.stringify(value, JsonHelper.replacer);
      return result;
    }
  }, {
    key: "parse",
    value: function parse(str) {
      var result = JSON.parse(str, JsonHelper.reviver);
      return result;
    }
  }]);

  return JsonHelper;
}();
JsonHelper_JsonHelper.constructors = {};
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/store/TjipNameValueStore.ts





var TjipNameValueStore_TjipNameValueStore =
/*#__PURE__*/
function () {
  function TjipNameValueStore(container) {
    var jsonSerialize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, TjipNameValueStore);

    this.jsonSerialize = jsonSerialize;
    this.container = {};

    if (container) {
      if (!lodash["isObject"](container)) {
        throw new Error('parameter \'container\' is not an object');
      }

      this.container = container;
    }
  }

  _createClass(TjipNameValueStore, [{
    key: "get",
    value: function get(key) {
      if (lodash["isUndefined"](key)) {
        throw new Error('parameter \'key\' not specified');
      }

      var result = this.container[key];

      if (result && this.jsonSerialize) {
        result = JsonHelper_JsonHelper.parse(result);
      }

      return result;
    }
  }, {
    key: "set",
    value: function set(key, value) {
      if (lodash["isUndefined"](key)) {
        throw new Error('parameter \'key\' not specified');
      }

      if (value && this.jsonSerialize) {
        value = JsonHelper_JsonHelper.stringify(value);
      }

      this.container[key] = value;
    }
  }, {
    key: "remove",
    value: function remove(key) {
      if (lodash["isUndefined"](key)) {
        throw new Error('parameter \'key\' not specified');
      }

      delete this.container[key];
    }
  }, {
    key: "item",
    value: function item(key) {
      if (lodash["isUndefined"](key)) {
        throw new Error('parameter \'key\' not specified');
      }

      return new TjipNameValueStoreItem_TjipNameValueStoreItem(this, key);
    }
  }]);

  return TjipNameValueStore;
}();
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/store/TjipLocalStore.ts






var TjipLocalStore_TjipLocalStore =
/*#__PURE__*/
function (_TjipNameValueStore) {
  _inherits(TjipLocalStore, _TjipNameValueStore);

  function TjipLocalStore() {
    _classCallCheck(this, TjipLocalStore);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipLocalStore).call(this, localStorage, true));
  }

  return TjipLocalStore;
}(TjipNameValueStore_TjipNameValueStore);

var tjipLocalStore = new TjipLocalStore_TjipLocalStore();
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/store/TjipSessionStore.ts






var TjipSessionStore_TjipSessionStore =
/*#__PURE__*/
function (_TjipNameValueStore) {
  _inherits(TjipSessionStore, _TjipNameValueStore);

  function TjipSessionStore() {
    _classCallCheck(this, TjipSessionStore);

    return _possibleConstructorReturn(this, getPrototypeOf_getPrototypeOf(TjipSessionStore).call(this, sessionStorage, true));
  }

  return TjipSessionStore;
}(TjipNameValueStore_TjipNameValueStore);

var tjipSessionStore = new TjipSessionStore_TjipSessionStore();
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/store/index.ts




// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/vuex/addVuexItem.ts

// This allows vuex actions and mutations to be overriden in derived classes
function addVuexItem(target, type, key, value) {
  if (!target.constructor.prototype.hasOwnProperty(type)) {
    Object.defineProperty(target, type, {
      get: function myProperty() {
        var result = {};
        var p = this.constructor.prototype;

        while (p.__proto__) {
          var prop = Object.getOwnPropertyDescriptor(p, type) || {};

          if (prop && prop.get) {
            var items = prop.get[type];

            if (items) {
              result = Object.assign({}, items, result);
            }
          }

          p = p.__proto__.constructor.prototype;
        }

        return result;
      }
    });
  }

  var typeProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, type) || {};
  var typeItems = typeProp.get[type] = typeProp.get[type] || {};
  typeItems[key] = value;
}
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/vuex/TjipVuexAction.ts

function TjipVuexAction(target, propertyKey, descriptor) {
  var action = descriptor.value;

  if (action) {
    addVuexItem(target, 'actions', propertyKey, action);
  }
}
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/vuex/TjipVuexModule.ts
function TjipVuexModule(target, propertyKey, descriptor) {
  var module = descriptor.value.apply(target);

  if (module) {
    if (!target.modules) {
      target.modules = {};
    }

    var modules = target.modules;
    modules[propertyKey] = module;
  }
}
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/vuex/TjipVuexMutation.ts

function TjipVuexMutation(target, propertyKey, descriptor) {
  var mutation = descriptor.value;

  if (mutation) {
    addVuexItem(target, 'mutations', propertyKey, mutation);
  }
}
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/vuex/TjipVuexPlugin.ts
function TjipVuexPlugin(target, propertyKey, descriptor) {
  var plugin = descriptor.value.apply(target);

  if (plugin) {
    if (!target.plugins) {
      target.plugins = [];
    }

    var plugins = target.plugins;
    plugins.push(plugin);
  }
}
// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/vuex/index.ts




// CONCATENATED MODULE: ./projects/@tjip/vuejs/src/index.ts















function TjipVue(Vue) {
  Vue.use(TjipVueControls);
  Vue.use(TjipVueForm);
  Vue.use(TjipVueMessages);
  Vue.use(TjipVueOptions);
  Vue.use(TjipVueUtils);
  Vue.use(TjipVueValidation);
}
/* harmony default export */ var src = (TjipVue);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
/* concated harmony reexport TjipVue */__webpack_require__.d(__webpack_exports__, "TjipVue", function() { return TjipVue; });
/* concated harmony reexport TjipDomObserverMixin */__webpack_require__.d(__webpack_exports__, "TjipDomObserverMixin", function() { return TjipDomObserverMixin_TjipDomObserverMixin; });
/* concated harmony reexport TjipFormControlTextComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlTextComponentVue", function() { return text_TjipFormControlTextComponent; });
/* concated harmony reexport TjipFormControlTextComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlTextComponent", function() { return controls_text_TjipFormControlTextComponent; });
/* concated harmony reexport TjipFormGroupTextComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupTextComponentVue", function() { return text_TjipFormGroupTextComponent; });
/* concated harmony reexport TjipFormGroupTextComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupTextComponent", function() { return controls_text_TjipFormGroupTextComponent; });
/* concated harmony reexport TjipFormGroupComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupComponentVue", function() { return core_TjipFormGroupComponent; });
/* concated harmony reexport TjipFormGroupComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupComponent", function() { return controls_core_TjipFormGroupComponent; });
/* concated harmony reexport TjipForwardRefEventsMixin */__webpack_require__.d(__webpack_exports__, "TjipForwardRefEventsMixin", function() { return TjipForwardRefEventsMixin_TjipForwardRefEventsMixin; });
/* concated harmony reexport TjipFormItemMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemMixin", function() { return TjipFormItemMixin_TjipFormItemMixin; });
/* concated harmony reexport TjipFormItemCurrencyMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemCurrencyMixin", function() { return TjipFormItemCurrencyMixin_TjipFormItemCurrencyMixin; });
/* concated harmony reexport TjipFormItemDateMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemDateMixin", function() { return TjipFormItemDateMixin_TjipFormItemDateMixin; });
/* concated harmony reexport TjipFormItemDropdownMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemDropdownMixin", function() { return TjipFormItemDropdownMixin_TjipFormItemDropdownMixin; });
/* concated harmony reexport TjipFormItemNumberMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemNumberMixin", function() { return TjipFormItemNumberMixin_TjipFormItemNumberMixin; });
/* concated harmony reexport TjipFormItemPercentMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemPercentMixin", function() { return TjipFormItemPercentMixin_TjipFormItemPercentMixin; });
/* concated harmony reexport TjipFormItemRadioGroupMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemRadioGroupMixin", function() { return TjipFormItemRadioGroupMixin_TjipFormItemRadioGroupMixin; });
/* concated harmony reexport TjipFormItemTextMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemTextMixin", function() { return TjipFormItemTextMixin_TjipFormItemTextMixin; });
/* concated harmony reexport TjipFormItemValueMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemValueMixin", function() { return TjipFormItemValueMixin_TjipFormItemValueMixin; });
/* concated harmony reexport TjipFormGroupMixin */__webpack_require__.d(__webpack_exports__, "TjipFormGroupMixin", function() { return TjipFormGroupMixin_TjipFormGroupMixin; });
/* concated harmony reexport TjipFormGroupValueMixin */__webpack_require__.d(__webpack_exports__, "TjipFormGroupValueMixin", function() { return TjipFormGroupValueMixin_TjipFormGroupValueMixin; });
/* concated harmony reexport TjipFormControlNumberMixin */__webpack_require__.d(__webpack_exports__, "TjipFormControlNumberMixin", function() { return TjipFormControlNumberMixin_TjipFormControlNumberMixin; });
/* concated harmony reexport TjipFormControlValueMixin */__webpack_require__.d(__webpack_exports__, "TjipFormControlValueMixin", function() { return TjipFormControlValueMixin_TjipFormControlValueMixin; });
/* concated harmony reexport TjipFormControlCheckboxComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlCheckboxComponentVue", function() { return checkbox_TjipFormControlCheckboxComponent; });
/* concated harmony reexport TjipFormControlCheckboxComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlCheckboxComponent", function() { return controls_checkbox_TjipFormControlCheckboxComponent; });
/* concated harmony reexport TjipFormGroupCheckboxComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupCheckboxComponentVue", function() { return checkbox_TjipFormGroupCheckboxComponent; });
/* concated harmony reexport TjipFormGroupCheckboxComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupCheckboxComponent", function() { return controls_checkbox_TjipFormGroupCheckboxComponent; });
/* concated harmony reexport TjipFormControlCheckboxGroupComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlCheckboxGroupComponentVue", function() { return checkbox_TjipFormControlCheckboxGroupComponent; });
/* concated harmony reexport TjipFormControlCheckboxGroupComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlCheckboxGroupComponent", function() { return controls_checkbox_TjipFormControlCheckboxGroupComponent; });
/* concated harmony reexport TjipFormGroupCheckboxGroupComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupCheckboxGroupComponentVue", function() { return checkbox_TjipFormGroupCheckboxGroupComponent; });
/* concated harmony reexport TjipFormGroupCheckboxGroupComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupCheckboxGroupComponent", function() { return controls_checkbox_TjipFormGroupCheckboxGroupComponent; });
/* concated harmony reexport TjipFormGroupNumberComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupNumberComponentVue", function() { return number_TjipFormGroupNumberComponent; });
/* concated harmony reexport TjipFormGroupNumberComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupNumberComponent", function() { return controls_number_TjipFormGroupNumberComponent; });
/* concated harmony reexport TjipFormControlNumberComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlNumberComponentVue", function() { return number_TjipFormControlNumberComponent; });
/* concated harmony reexport TjipFormControlNumberComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlNumberComponent", function() { return controls_number_TjipFormControlNumberComponent; });
/* concated harmony reexport TjipFormControlStaticTextComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlStaticTextComponentVue", function() { return static_text_TjipFormControlStaticTextComponent; });
/* concated harmony reexport TjipFormControlStaticTextComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlStaticTextComponent", function() { return controls_static_text_TjipFormControlStaticTextComponent; });
/* concated harmony reexport TjipFormGroupStaticTextComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupStaticTextComponentVue", function() { return static_text_TjipFormGroupStaticTextComponent; });
/* concated harmony reexport TjipFormGroupStaticTextComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupStaticTextComponent", function() { return controls_static_text_TjipFormGroupStaticTextComponent; });
/* concated harmony reexport TjipFormControlDropdownComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlDropdownComponentVue", function() { return dropdown_TjipFormControlDropdownComponent; });
/* concated harmony reexport TjipFormControlDropdownComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlDropdownComponent", function() { return controls_dropdown_TjipFormControlDropdownComponent; });
/* concated harmony reexport TjipFormGroupDropdownComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupDropdownComponentVue", function() { return dropdown_TjipFormGroupDropdownComponent; });
/* concated harmony reexport TjipFormGroupDropdownComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupDropdownComponent", function() { return controls_dropdown_TjipFormGroupDropdownComponent; });
/* concated harmony reexport TjipFormControlRadioGroupComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlRadioGroupComponentVue", function() { return radio_TjipFormControlRadioGroupComponent; });
/* concated harmony reexport TjipFormControlRadioGroupComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlRadioGroupComponent", function() { return controls_radio_TjipFormControlRadioGroupComponent; });
/* concated harmony reexport TjipFormGroupRadioGroupComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupRadioGroupComponentVue", function() { return radio_TjipFormGroupRadioGroupComponent; });
/* concated harmony reexport TjipFormGroupRadioGroupComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupRadioGroupComponent", function() { return controls_radio_TjipFormGroupRadioGroupComponent; });
/* concated harmony reexport TjipFormControlRadioButtonComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlRadioButtonComponentVue", function() { return radio_TjipFormControlRadioButtonComponent; });
/* concated harmony reexport TjipFormControlRadioButtonComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlRadioButtonComponent", function() { return controls_radio_TjipFormControlRadioButtonComponent; });
/* concated harmony reexport TjipFormControlDateComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlDateComponentVue", function() { return date_TjipFormControlDateComponent; });
/* concated harmony reexport TjipFormControlDateComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlDateComponent", function() { return controls_date_TjipFormControlDateComponent; });
/* concated harmony reexport TjipFormGroupDateComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupDateComponentVue", function() { return date_TjipFormGroupDateComponent; });
/* concated harmony reexport TjipFormGroupDateComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupDateComponent", function() { return controls_date_TjipFormGroupDateComponent; });
/* concated harmony reexport TjipFormControlAddinWrapperComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlAddinWrapperComponentVue", function() { return addin_wrapper_TjipFormControlAddinWrapperComponent; });
/* concated harmony reexport TjipFormControlAddinWrapperComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlAddinWrapperComponent", function() { return controls_addin_wrapper_TjipFormControlAddinWrapperComponent; });
/* concated harmony reexport TjipFormControlCurrencyComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlCurrencyComponentVue", function() { return currency_TjipFormControlCurrencyComponent; });
/* concated harmony reexport TjipFormControlCurrencyComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlCurrencyComponent", function() { return controls_currency_TjipFormControlCurrencyComponent; });
/* concated harmony reexport TjipFormGroupCurrencyComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupCurrencyComponentVue", function() { return currency_TjipFormGroupCurrencyComponent; });
/* concated harmony reexport TjipFormGroupCurrencyComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupCurrencyComponent", function() { return controls_currency_TjipFormGroupCurrencyComponent; });
/* concated harmony reexport TjipFormControlPercentComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlPercentComponentVue", function() { return percent_TjipFormControlPercentComponent; });
/* concated harmony reexport TjipFormControlPercentComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlPercentComponent", function() { return controls_percent_TjipFormControlPercentComponent; });
/* concated harmony reexport TjipFormGroupPercentComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupPercentComponentVue", function() { return percent_TjipFormGroupPercentComponent; });
/* concated harmony reexport TjipFormGroupPercentComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupPercentComponent", function() { return controls_percent_TjipFormGroupPercentComponent; });
/* concated harmony reexport TjipFormGroupSearchComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormGroupSearchComponentVue", function() { return search_TjipFormGroupSearchComponent; });
/* concated harmony reexport TjipFormGroupSearchComponent */__webpack_require__.d(__webpack_exports__, "TjipFormGroupSearchComponent", function() { return controls_search_TjipFormGroupSearchComponent; });
/* concated harmony reexport TjipFormControlSearchComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlSearchComponentVue", function() { return search_TjipFormControlSearchComponent; });
/* concated harmony reexport TjipFormControlSearchComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlSearchComponent", function() { return controls_search_TjipFormControlSearchComponent; });
/* concated harmony reexport domInputEvents */__webpack_require__.d(__webpack_exports__, "domInputEvents", function() { return domInputEvents; });
/* concated harmony reexport TjipFormComponent */__webpack_require__.d(__webpack_exports__, "TjipFormComponent", function() { return src_form_TjipFormComponent; });
/* concated harmony reexport TjipFormComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormComponentVue", function() { return form_TjipFormComponent; });
/* concated harmony reexport TjipFormHorizontalComponent */__webpack_require__.d(__webpack_exports__, "TjipFormHorizontalComponent", function() { return src_form_TjipFormHorizontalComponent; });
/* concated harmony reexport TjipFormHorizontalComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormHorizontalComponentVue", function() { return form_TjipFormHorizontalComponent; });
/* concated harmony reexport TjipInitialFocusComponent */__webpack_require__.d(__webpack_exports__, "TjipInitialFocusComponent", function() { return src_form_TjipInitialFocusComponent; });
/* concated harmony reexport TjipInitialFocusComponentVue */__webpack_require__.d(__webpack_exports__, "TjipInitialFocusComponentVue", function() { return form_TjipInitialFocusComponent; });
/* concated harmony reexport tjipFocusService */__webpack_require__.d(__webpack_exports__, "tjipFocusService", function() { return tjipFocusService; });
/* concated harmony reexport TjipAncestorMixin */__webpack_require__.d(__webpack_exports__, "TjipAncestorMixin", function() { return TjipAncestorMixin_TjipAncestorMixin; });
/* concated harmony reexport TjipWhenEmptyComponentVue */__webpack_require__.d(__webpack_exports__, "TjipWhenEmptyComponentVue", function() { return whenEmpty_TjipWhenEmptyComponent; });
/* concated harmony reexport TjipWhenEmptyComponent */__webpack_require__.d(__webpack_exports__, "TjipWhenEmptyComponent", function() { return utils_whenEmpty_TjipWhenEmptyComponent; });
/* concated harmony reexport TjipBackdropComponentVue */__webpack_require__.d(__webpack_exports__, "TjipBackdropComponentVue", function() { return backdrop_TjipBackdropComponent; });
/* concated harmony reexport TjipBackdropComponent */__webpack_require__.d(__webpack_exports__, "TjipBackdropComponent", function() { return utils_backdrop_TjipBackdropComponent; });
/* concated harmony reexport tjipRouterService */__webpack_require__.d(__webpack_exports__, "tjipRouterService", function() { return tjipRouterService; });
/* concated harmony reexport TjipFormControlMessageComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlMessageComponent", function() { return messages_control_TjipFormControlMessageComponent; });
/* concated harmony reexport TjipFormControlMessageContentComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlMessageContentComponent", function() { return control_TjipFormControlMessageContentComponent; });
/* concated harmony reexport TjipFormControlMessagesComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlMessagesComponentVue", function() { return control_TjipFormControlMessagesComponent; });
/* concated harmony reexport TjipFormControlMessagesComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlMessagesComponent", function() { return messages_control_TjipFormControlMessagesComponent; });
/* concated harmony reexport TjipFormControlCurrencyMessagesComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlCurrencyMessagesComponentVue", function() { return control_TjipFormControlCurrencyMessagesComponent; });
/* concated harmony reexport TjipFormControlCurrencyMessagesComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlCurrencyMessagesComponent", function() { return messages_control_TjipFormControlCurrencyMessagesComponent; });
/* concated harmony reexport TjipFormControlDateMessagesComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlDateMessagesComponentVue", function() { return control_TjipFormControlDateMessagesComponent; });
/* concated harmony reexport TjipFormControlDateMessagesComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlDateMessagesComponent", function() { return messages_control_TjipFormControlDateMessagesComponent; });
/* concated harmony reexport TjipFormControlNumberMessagesComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlNumberMessagesComponentVue", function() { return control_TjipFormControlNumberMessagesComponent; });
/* concated harmony reexport TjipFormControlNumberMessagesComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlNumberMessagesComponent", function() { return messages_control_TjipFormControlNumberMessagesComponent; });
/* concated harmony reexport TjipFormControlPercentMessagesComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlPercentMessagesComponentVue", function() { return control_TjipFormControlPercentMessagesComponent; });
/* concated harmony reexport TjipFormControlPercentMessagesComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlPercentMessagesComponent", function() { return messages_control_TjipFormControlPercentMessagesComponent; });
/* concated harmony reexport TjipFormControlMessageTemplateComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlMessageTemplateComponentVue", function() { return control_TjipFormControlMessageTemplateComponent; });
/* concated harmony reexport TjipFormControlMessageTemplateComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlMessageTemplateComponent", function() { return messages_control_TjipFormControlMessageTemplateComponent; });
/* concated harmony reexport TjipValidationMixin */__webpack_require__.d(__webpack_exports__, "TjipValidationMixin", function() { return TjipValidationMixin_TjipValidationMixin; });
/* concated harmony reexport TjipValidationDescendantMixin */__webpack_require__.d(__webpack_exports__, "TjipValidationDescendantMixin", function() { return TjipValidationDescendantMixin_TjipValidationDescendantMixin; });
/* concated harmony reexport tjipRequiredDate */__webpack_require__.d(__webpack_exports__, "tjipRequiredDate", function() { return tjipRequiredDate; });
/* concated harmony reexport tjipMinValue */__webpack_require__.d(__webpack_exports__, "tjipMinValue", function() { return tjipMinValue; });
/* concated harmony reexport tjipMaxValue */__webpack_require__.d(__webpack_exports__, "tjipMaxValue", function() { return tjipMaxValue; });
/* concated harmony reexport tjipValidateIf */__webpack_require__.d(__webpack_exports__, "tjipValidateIf", function() { return tjipValidateIf; });
/* concated harmony reexport TjipFormControlOptionComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlOptionComponent", function() { return options_TjipFormControlOptionComponent; });
/* concated harmony reexport TjipFormControlOptionContentComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlOptionContentComponent", function() { return TjipFormControlOptionContentComponent_TjipFormControlOptionContentComponent; });
/* concated harmony reexport TjipFormControlOptionsComponentVue */__webpack_require__.d(__webpack_exports__, "TjipFormControlOptionsComponentVue", function() { return options_TjipFormControlOptionsComponent; });
/* concated harmony reexport TjipFormControlOptionsComponent */__webpack_require__.d(__webpack_exports__, "TjipFormControlOptionsComponent", function() { return src_options_TjipFormControlOptionsComponent; });
/* concated harmony reexport tjipMomentFilter */__webpack_require__.d(__webpack_exports__, "tjipMomentFilter", function() { return TjipMomentFilter; });
/* concated harmony reexport tjipNumberFilter */__webpack_require__.d(__webpack_exports__, "tjipNumberFilter", function() { return TjipNumberFilter; });
/* concated harmony reexport tjipCurrencyFilter */__webpack_require__.d(__webpack_exports__, "tjipCurrencyFilter", function() { return TjipCurrencyFilter; });
/* concated harmony reexport tjipPercentFilter */__webpack_require__.d(__webpack_exports__, "tjipPercentFilter", function() { return TjipPercentFilter; });
/* concated harmony reexport TjipFiltersMixin */__webpack_require__.d(__webpack_exports__, "TjipFiltersMixin", function() { return TjipFiltersMixin_TjipFiltersMixin; });
/* concated harmony reexport TjipNameValueStoreItem */__webpack_require__.d(__webpack_exports__, "TjipNameValueStoreItem", function() { return TjipNameValueStoreItem_TjipNameValueStoreItem; });
/* concated harmony reexport tjipLocalStore */__webpack_require__.d(__webpack_exports__, "tjipLocalStore", function() { return tjipLocalStore; });
/* concated harmony reexport tjipSessionStore */__webpack_require__.d(__webpack_exports__, "tjipSessionStore", function() { return tjipSessionStore; });
/* concated harmony reexport TjipVuexAction */__webpack_require__.d(__webpack_exports__, "TjipVuexAction", function() { return TjipVuexAction; });
/* concated harmony reexport TjipVuexModule */__webpack_require__.d(__webpack_exports__, "TjipVuexModule", function() { return TjipVuexModule; });
/* concated harmony reexport TjipVuexMutation */__webpack_require__.d(__webpack_exports__, "TjipVuexMutation", function() { return TjipVuexMutation; });
/* concated harmony reexport TjipVuexPlugin */__webpack_require__.d(__webpack_exports__, "TjipVuexPlugin", function() { return TjipVuexPlugin; });
/* concated harmony reexport TjipFormItemSearchMixin */__webpack_require__.d(__webpack_exports__, "TjipFormItemSearchMixin", function() { return TjipFormItemSearchMixin_TjipFormItemSearchMixin; });


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ }),

/***/ "fbff":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxComponent_scss_vue_type_style_index_0_id_816ded66_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("5c68");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxComponent_scss_vue_type_style_index_0_id_816ded66_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxComponent_scss_vue_type_style_index_0_id_816ded66_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormControlCheckboxComponent_scss_vue_type_style_index_0_id_816ded66_scoped_true_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "fde4":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("bf90");
var $Object = __webpack_require__("584a").Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),

/***/ "ff21":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormHorizontalComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0100");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormHorizontalComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormHorizontalComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_dist_cjs_js_ref_8_oneOf_1_3_TjipFormHorizontalComponent_global_scss_vue_type_style_index_1_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ffba":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ })

/******/ });
});
//# sourceMappingURL=tjip-vuejs.umd.js.map